'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var accessibility = {
	id: "accessibility",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "accessibility",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accessibility",
					name: "",
					type: "text",
					value: "Accessibility icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accessibility",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M87.7 301.5c32.5 0 61.1-17.1 77.1-42.8l1.7-2.7-1.7-2.7c-16.1-25.7-44.6-42.8-77.1-42.8s-61.1 17.1-77.1 42.8L8.9 256l1.7 2.7c16.1 25.7 44.6 42.8 77.1 42.8zm0-80.8c27.8 0 52.2 14 66.8 35.4-14.6 21.3-39 35.4-66.8 35.4-27.8 0-52.2-14-66.8-35.4 14.6-21.4 39-35.4 66.8-35.4z"
			},
			children: [
			]
		},
		{
			id: "accessibility",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M87.7 290.6c19.1 0 34.5-15.4 34.5-34.5s-15.4-34.5-34.5-34.5-34.5 15.4-34.5 34.5c0 19 15.5 34.5 34.5 34.5zm-17.2-51.8c4.4-4.4 10.5-7.2 17.3-7.2 6.8 0 12.8 2.7 17.3 7.2 4.4 4.4 7.2 10.5 7.2 17.3 0 6.8-2.7 12.8-7.2 17.3-4.4 4.4-10.5 7.2-17.3 7.2-6.8 0-12.8-2.7-17.3-7.2-4.4-4.4-7.2-10.5-7.2-17.3 0-6.8 2.7-12.9 7.2-17.3z"
			},
			children: [
			]
		},
		{
			id: "accessibility",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M75.9 256.1c0-3.3 1.3-6.2 3.5-8.4 2.1-2.1 5.1-3.5 8.4-3.5 2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6c-10.5 0-19 8.5-19 19 0 2 1.6 3.6 3.6 3.6 1.9.1 3.5-1.5 3.5-3.5z"
			},
			children: [
			]
		},
		{
			id: "accessibility",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accessibility",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M259.9 295.4c-1.5 0-2.8-1.2-3-2.6-.8-5.5-8.4-18.6-22.4-18.6-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 12.8 0 21.4 8.6 25.5 16.3 6.4-10.4 20.4-13.2 25.1-13.9 1.6-.2 3 .9 3.3 2.4.2 1.6-.9 3-2.4 3.3-4.8.7-20.5 3.9-23.1 16.4-.3 1.5-1.5 2.5-3 2.5z"
					},
					children: [
					]
				},
				{
					id: "accessibility",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M229.2 339v-24.2c-9.3-7-14.6-17.6-14.6-30.3v-68.9c0-7.3 5.9-13.2 13.2-13.2 2.3 0 4.4.6 6.3 1.6v-8.9c0-7.3 5.9-13.2 13.2-13.2 2.3 0 4.4.6 6.3 1.6 0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v.5c2.4-1.3 5.2-1.8 8-1.4 6.5.9 11.6 6.8 11.6 13.4v62.6l9.5-11.1.2-.2c9.5-9.7 21.9-6.8 27.7-1.7 4.3 3.9 4.2 8.2 2.1 10.7l-35.7 44.5c-.9 1.4-6.9 10-17.8 16.3V339c0 1.9-1.5 3.5-3.5 3.5-1.9 0-3.5-1.5-3.5-3.5v-18.5c-2.3.9-4.7 1.7-7.3 2.3-.3.1-.5.1-.8.1-1.6 0-3-1.1-3.4-2.7-.4-1.9.8-3.7 2.6-4.1 17.9-4 27.7-18.9 27.8-19 .1-.1.1-.2.2-.3l35.7-44.4c-.3-.8-2-2.6-5.3-3.7-2.4-.8-8.5-2-14 3.5l-13.5 15.7c-.4.4-.9.8-1.4 1-1.5.6-4.3.9-6.4-3.3-.2-.5-.4-1-.4-1.5v-68c0-3.3-2.5-6.2-5.6-6.6-1.8-.2-3.6.3-5 1.5-1.2 1-1.9 2.5-2.1 4v43.9c0 1.9-1.5 3.5-3.5 3.5s-3.5-1.5-3.5-3.5v-43.2c0-.5 0-.9.1-1.4v-10.7c0-3.5-2.8-6.3-6.3-6.3s-6.3 2.8-6.3 6.3v52c0 1.9-1.5 3.5-3.5 3.5-1.9 0-3.5-1.5-3.5-3.5v-40.4c0-3.5-2.8-6.3-6.3-6.3s-6.3 2.8-6.3 6.3v49.5c0 1.9-1.5 3.5-3.5 3.5s-3.5-1.5-3.5-3.5v-29.1c0-3.5-2.8-6.3-6.3-6.3s-6.3 2.8-6.3 6.3v68.9c0 15.3 8.9 26.5 24.3 30.7 1.8.5 2.9 2.4 2.4 4.2-.4 1.5-1.8 2.6-3.3 2.6-.3 0-.6 0-.9-.1-2.9-.8-5.5-1.8-8-3V339c0 1.9-1.5 3.5-3.5 3.5s-2.8-1.5-2.8-3.5z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "accessibility",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accessibility",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M391.9 236.7c2.4 0 4.4-2 4.4-4.4 0-26.9 21.9-48.7 48.7-48.7 26.9 0 48.7 21.9 48.7 48.7 0 19.9-12.4 32.5-25.4 45.8-10.4 10.5-21.1 21.4-25.4 36.3-3.3 11.3-13.9 17.8-24.7 15.2-10.9-2.7-17.7-13.7-15-24.6.7-2.9 2-5.5 3.8-7.8 1.5-1.9 1.2-4.7-.7-6.2s-4.7-1.2-6.2.7c-2.6 3.3-4.5 7.1-5.5 11.3-1.8 7.6-.6 15.4 3.4 22.1 4.1 6.7 10.5 11.4 18.1 13.2 2.2.5 4.5.8 6.7.8 12.8 0 24.7-8.8 28.6-22.1 3.7-12.7 13.2-22.4 23.2-32.6 13.8-14 28-28.5 28-52 0-31.8-25.8-57.6-57.6-57.6s-57.6 25.8-57.6 57.6c.1 2.3 2.1 4.3 4.5 4.3z"
					},
					children: [
					]
				},
				{
					id: "accessibility",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M444.9 212.6c7.8 0 13.8 1.9 17.8 5.5 4.1 3.7 6.1 9.2 6.1 16.4 0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8 0-9.5-2.9-16.9-8.6-22-5.5-5-13.2-7.5-22.9-7.5-8.6 0-16.7 3.7-22.9 10.4-9.4 10.1-13.7 26.1-12.3 45.1 0 .2.1.4.1.6.9 10.3 8.8 18.4 18.4 18.4 10.2 0 18.5-9.2 18.5-20.4s-8.3-20.4-18.5-20.4c-3.8 0-7.3 1.3-10.3 3.4 1.5-8.9 4.7-16.2 9.6-21.5 4.8-5.2 11-8 17.4-8zm-16.7 33.6c6 0 10.9 5.7 10.9 12.8 0 7.1-4.9 12.8-10.9 12.8s-10.9-5.7-10.9-12.8c0-7.1 4.9-12.8 10.9-12.8z"
					},
					children: [
					]
				}
			]
		}
	]
};
var android = {
	id: "android",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 431.867 511.81"
	},
	children: [
		{
			id: "android",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "android",
					name: "",
					type: "text",
					value: "Android icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "android",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M300.078 406.983c-.03 1.552-.07 2.71-.07 3.87-.005 22.14-.006 44.28-.002 66.418 0 4.235-.405 8.415-1.732 12.456-2.133 6.494-5.76 11.972-11.23 16.147-11.203 8.548-26.364 7.75-36.567-1.978-6.3-6.007-9.634-13.453-10.306-22.1-.128-1.658-.117-3.33-.118-4.993-.007-21.943-.005-43.886-.005-65.83v-3.296c-.914-.965-1.85-.674-2.685-.677-6.76-.027-13.518-.016-20.278-.016H192.3c-.128.725-.278 1.27-.308 1.823-.048.88-.017 1.763-.017 2.644 0 22.238-.01 44.475.005 66.712.004 5.98-1.188 11.675-3.964 16.99-3.783 7.242-9.335 12.655-17.188 15.138-11.49 3.633-21.466.672-29.716-7.953-4.956-5.18-7.692-11.52-8.58-18.625-.265-2.13-.4-4.293-.403-6.44-.03-22.14-.018-44.278-.022-66.417 0-1.16-.043-2.317-.066-3.483-1.16-.607-2.257-.374-3.3-.377-9.306-.02-18.613-.082-27.918.02-4.07.043-7.74-1.015-11.11-3.192-5.313-3.433-9.336-8.012-11.98-13.774-1.117-2.436-1.737-4.987-1.695-7.682.01-.783-.002-1.567-.002-2.35 0-67.887 0-135.773.002-203.66 0-1.26.026-2.522.04-3.887.735-.14 1.283-.3 1.838-.334.88-.052 1.762-.02 2.644-.02 90.32 0 180.638 0 270.957.01 1.347 0 2.727-.208 4.206.292.067.585.163 1.14.186 1.7.032.783.01 1.568.01 2.352 0 67.788-.03 135.576.03 203.365.01 12.416-6.73 20.174-16.952 25.678-2.16 1.163-4.622 1.495-7.12 1.485-9.405-.038-18.81-.015-28.212-.014h-3.59zM354.796 155.832c-.83.078-1.3.16-1.774.16-91.76.007-183.52.007-275.08.007-.957-.755-.72-1.59-.716-2.337.042-8.66 1.195-17.19 3.336-25.567 6.566-25.697 20.44-46.8 40.475-63.98C129.1 57.2 137.903 51.378 147.34 46.51c.773-.4 1.52-.85 2.45-1.375-.5-.946-.925-1.807-1.403-2.638-6.877-11.97-13.763-23.933-20.643-35.9-.536-.933-1.117-1.848-1.554-2.827-.61-1.365-.212-2.697.88-3.357 1.257-.76 2.688-.467 3.61.815.512.712.92 1.502 1.36 2.265 7.063 12.2 14.123 24.402 21.19 36.6.486.84 1.01 1.66 1.582 2.592.61-.142 1.187-.193 1.693-.408 8.85-3.768 17.958-6.715 27.37-8.71 6.037-1.277 12.12-2.22 18.267-2.793 4.983-.463 9.97-.582 14.965-.57 19.73.046 38.682 3.94 56.902 11.475.896.37 1.8.73 2.612 1.06 1.143-.496 1.426-1.494 1.903-2.318 7.023-12.11 14.033-24.228 21.052-36.34.588-1.016 1.197-2.02 1.838-3.004.46-.703 1.185-1.033 2-1.073 1.836-.09 3.144 1.622 2.536 3.366-.254.73-.685 1.404-1.075 2.082-6.83 11.882-13.67 23.76-20.504 35.64-.725 1.262-1.443 2.528-2.112 3.7.634 1.148 1.66 1.343 2.493 1.776 16.905 8.795 31.518 20.424 43.473 35.295 12.365 15.38 20.65 32.7 24.485 52.103 1.2 6.065 1.81 12.196 2.082 18.365.046 1.067.006 2.136.006 3.502zm-204.503-71.71c-7.854-.29-13.298 6.26-13.534 12.58-.28 7.51 5.917 13.383 12.852 13.547 6.493.152 13.24-4.683 13.524-12.577.27-7.57-5.895-13.552-12.843-13.55zm131.472 26.088c6.136.315 13.37-4.37 13.41-12.932.037-8.027-6.535-13.106-12.936-13.192-8.043-.108-13.377 6.698-13.422 13.01-.052 7.243 6.023 13.176 12.947 13.114zM59.872 263.18c0 20.66-.02 41.322.012 61.982.01 6.61-1.433 12.818-4.8 18.523-3.597 6.096-8.572 10.722-15.234 13.215-9.418 3.525-18.35 2.22-26.43-3.692-7.58-5.546-11.7-13.26-13.003-22.5-.272-1.932-.394-3.9-.395-5.853C0 283.828.008 242.8 0 201.772c0-5.555.927-10.91 3.285-15.972 2.713-5.827 6.686-10.57 12.198-13.936 10.03-6.126 22.37-5.415 31.635 1.84 6.606 5.175 10.492 12.01 12.116 20.192.518 2.608.644 5.24.643 7.89-.01 20.464-.005 40.93-.005 61.394zM431.86 263.357c0 20.954-.013 41.908.006 62.862.006 6.33-1.647 12.203-4.853 17.612-3.828 6.46-9.214 11.19-16.41 13.518-9.348 3.025-18.032 1.36-25.766-4.6-7.26-5.595-11.192-13.197-12.422-22.215-.264-1.933-.343-3.905-.344-5.858-.018-40.93-.004-81.857-.024-122.786-.003-6.38 1.172-12.454 4.27-18.083 3.937-7.16 9.595-12.455 17.485-14.78 11.573-3.408 21.496-.18 29.52 8.624 5.766 6.328 8.512 13.988 8.527 22.55.036 21.053.012 42.105.012 63.157z"
			},
			children: [
			]
		}
	]
};
var apps = {
	id: "apps",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "apps",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "apps",
					name: "",
					type: "text",
					value: "Apps Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "apps",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M14 1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1zm-2 11H2V2h10v10zM32 1a1 1 0 0 0-1-1H19a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1zM14 19a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V19zm18 0a1 1 0 0 0-1-1H19a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V19zm-2 11H20V20h10v10z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var atm = {
	id: "atm",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 363.357 512.56"
	},
	children: [
		{
			id: "atm",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "atm",
					name: "",
					type: "text",
					value: "ATM icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "atm",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M363.34 153.486c-.004-24.093-12.748-36.893-36.763-37.016-15.31-.078-30.633.375-45.927-.12-16.364-.53-27.26 6.34-34.41 21.094-19.267 39.74-39.124 79.196-58.525 118.872-1.985 4.06-3.51 8.85-3.512 13.3-.043 78.75.167 157.496.33 236.244.008 3.393 2.76 6.14 6.153 6.14h166.516c3.398 0 6.152-2.756 6.152-6.153 0-117.453.013-234.907-.013-352.36zm-32.56 268.006c-1.542 19.05-11.567 32.655-29.8 40.437-2.606 1.112-5.22 1.92-7.987 2.774-.684.212-1.374.425-2.07.645-.205 1.728-.133 3.638-.058 5.63.243 6.468.546 14.516-9.54 19.24l-.59.275-4.25.044-.6-.27c-10.188-4.555-9.96-12.566-9.774-19.005.043-1.5.085-2.943.01-4.304-1.177-.256-2.356-.5-3.51-.74-4.07-.843-8.275-1.716-12.3-3.13-20.39-7.166-31.573-21.37-33.237-42.22-.707-8.853 3.695-14.995 11.213-15.647 3.425-.303 6.493.63 8.87 2.68 2.792 2.41 4.416 6.17 4.698 10.872.626 10.45 5.702 17.204 15.517 20.646 12.058 4.23 24.164 3.86 35.98-1.095 8.97-3.762 12.535-12.796 12.882-19.995.405-8.417-3.258-15.75-9.56-19.14-7.632-4.103-15.463-8.17-23.035-12.1-5.017-2.604-10.032-5.208-15.032-7.842l-2.752-1.447c-5.374-2.82-10.932-5.738-16.267-8.903-16.792-9.963-24.305-25.255-22.33-45.453 1.904-19.487 12.535-33.063 31.597-40.353 4.12-1.574 8.354-2.48 12.838-3.44 1.44-.31 2.915-.626 4.406-.97.167-1.423.122-3.047.075-4.737-.166-5.967-.395-14.14 10.076-18.29l.623-.247 4.44.277.576.31c6.667 3.58 9.7 9.222 9.014 16.772-.195 2.156-.142 4.41-.09 6.59l.02.853c1.02.366 2.027.718 3.015 1.062 3.538 1.232 6.88 2.396 10.106 4.033 17.043 8.646 25.905 22.837 26.342 42.18.163 7.168-4.432 12.63-11.174 13.28-6.626.634-12.184-3.83-13.523-10.864-4.028-21.166-16.03-29.464-37.805-26.11-4.346.67-8.83 1.98-13.33 3.89-7.35 3.12-12.363 10.993-12.77 20.055-.385 8.58 3.405 15.854 10.14 19.456 7.277 3.895 14.745 7.75 21.967 11.476 5.223 2.695 10.446 5.39 15.648 8.125l2.434 1.276c5.653 2.962 11.5 6.024 17.08 9.404 16.054 9.723 23.395 24.534 21.82 44.022zM169.005 194.643c-6.862-3.304-13.734-6.968-21.015-8.946-14.624-3.973-22.14-13.567-26.8-27.46-5.38-16.033-12.084-31.652-18.83-47.183-7.263-16.726-22.46-25.598-39.533-24.017C46.72 88.527 35.625 99 31.24 117.213c-8.428 35-17.28 69.912-24.84 105.1C2.95 238.374.58 254.99.424 271.38-.21 337.98.562 404.59.003 471.192c-.172 20.493 7.22 34.528 28.83 41.367l5.057-.06c20.495-6.984 27.934-20.853 27.737-40.538-.484-48.36.723-96.747-.418-145.084-1.162-49.183 18.675-93.794 26.08-140.72 8.2 9.666 14.115 20.685 23.317 26.516 13.052 8.272 28.41 13.016 43 18.715 11.69 4.566 22.55.38 26.996-9.55 4.702-10.505.13-21.55-11.598-27.197z"
			},
			children: [
			]
		},
		{
			id: "atm",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "106.593",
				cy: "41.553",
				r: "41.553"
			},
			children: [
			]
		}
	]
};
var audio = {
	id: "audio",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 472 507",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "audio",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "audio",
					name: "",
					type: "text",
					value: "Audio icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "audio",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "audio",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M463.74 329.156l-14.766-11.104v-104.49c0-117.764-95.77-213.566-213.48-213.566C117.79-.004 22.03 95.798 22.03 213.56v104.503l-14.655 11.07C2.753 332.55 0 338.023 0 343.8v93.128c0 5.754 2.766 11.194 7.328 14.532l22.218 16.758c5.338 3.956 12.205 4.91 19.105 1.674 6.25-3.17 10.126-9.418 10.126-16.32l-.18-240.01c0-97.6 79.353-176.994 176.9-176.994 97.59 0 176.977 79.393 176.977 176.982l-.214 240.023c0 6.867 3.865 13.116 10.25 16.398 2.583 1.226 5.36 1.867 8.01 1.867 3.968 0 7.767-1.248 11.003-3.653l22.173-16.69c4.597-3.394 7.34-8.834 7.34-14.566V343.8c0-5.743-2.732-11.216-7.295-14.644"
					},
					children: [
					]
				},
				{
					id: "audio",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M311.45 327.224c0-19.972 16.15-36.123 36.12-36.123h9.507c19.936 0 36.12 16.152 36.12 36.124v142.872c0 19.983-16.184 36.134-36.12 36.134h-9.507c-19.97 0-36.12-16.15-36.12-36.134V327.224zM77.465 327.14c0-19.982 16.15-36.122 36.12-36.122h9.507c19.936 0 36.12 16.14 36.12 36.123v142.873c0 19.983-16.184 36.133-36.12 36.133h-9.507c-19.97 0-36.12-16.15-36.12-36.133V327.14z"
					},
					children: [
					]
				}
			]
		}
	]
};
var ballpark = {
	id: "ballpark",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "ballpark",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "ballpark",
					name: "",
					type: "text",
					value: "Ballpark Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "ballpark",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#444"
			},
			children: [
				{
					id: "ballpark",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M31.888 16.374c-.096-.111-1.541-1.79-5.599-3.026V9.812l4.393-1.57-5.422-2.584v7.402c-2.219-.571-5.089-.992-8.747-1.02V5.777l5.731-2.352-6.76-3.271v11.89c-3.311.052-6.045.5-8.232 1.09V9.787l4.232-1.54-5.261-2.602v7.789C2.359 14.643.417 16.213.293 16.32c-.114.098-.244.24-.244.39v15.135h1.029V16.962c1.029-.711 5.767-3.896 14.921-3.896 10.236 0 14.407 3.183 14.921 3.857v14.923h1.029V16.711c0-.124.02-.243-.061-.337z"
					},
					children: [
					]
				},
				{
					id: "ballpark",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M16.191 16.41a2.251 2.251 0 0 0-2.251 2.251v13.185h4.631V18.79a2.38 2.38 0 0 0-2.38-2.38zM8.18 23.099a2.48 2.48 0 0 0-2.472 2.472v6.275h4.631v-6.588a2.16 2.16 0 0 0-2.159-2.159zm15.886 0a2.414 2.414 0 0 0-2.407 2.407v6.34h4.631v-6.523a2.224 2.224 0 0 0-2.224-2.224z"
					},
					children: [
					]
				}
			]
		}
	]
};
var billing = {
	id: "billing",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 504 347",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "billing",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(-548 -3689)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "billing",
					name: "title",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							id: "billing",
							name: "",
							type: "text",
							value: "Billing icon",
							attributes: {
							},
							children: [
							]
						}
					]
				},
				{
					id: "billing",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M843.924 3956.284c-20.975 0-41.95.002-62.926-.004-1.747 0-3.52.125-5.236-.128-4.57-.674-8.078-4.83-8.07-9.33.01-4.42 3.698-8.337 8.453-8.87 1.344-.152 2.716-.07 4.075-.07 42.922-.003 85.843-.004 128.765 0 1.36 0 2.738-.092 4.073.102 4.464.648 7.836 4.36 8.025 8.684.195 4.494-3.202 8.716-7.836 9.45-1.9.3-3.874.18-5.815.18-21.17.01-42.34.006-63.508.006m-216.452-75.375c1.12-.075 1.96.053 2.66-.2 11.46-4.17 23.12-7.886 34.26-12.783 6.307-2.77 8.703-10.4 6.624-17.007-2.21-7.02-4.638-14-7.455-20.8-3.26-7.87-11.045-11.568-19.124-8.942-9.952 3.234-19.81 6.807-29.536 10.672-7.846 3.12-11.54 11.197-8.99 19.125 2.195 6.823 4.693 13.563 7.374 20.213 2.582 6.407 7.63 9.54 14.188 9.72zm256.525 154.816c-42.147 0-84.303-.434-126.44.18-21.427.314-41.303-15.62-41.07-41.58.426-47.195.076-94.397.175-141.596.01-4.814.265-9.787 1.464-14.413 4.457-17.198 19.403-28.656 37.23-28.668 85.854-.06 171.705-.073 257.556-.003 22.15.018 38.872 16.482 38.947 38.53.165 49.53.165 99.06.04 148.59-.06 22.73-16.682 38.906-39.71 38.94-42.73.064-85.462.02-128.194.02zm-141.027-122.44c0 28.685-.082 56.632.077 84.578.027 4.773 2.626 8.72 7.207 10.403 2.82 1.036 6.072 1.23 9.13 1.23 83.13.076 166.264.08 249.396.072 2.322 0 4.668-.104 6.962-.44 4.428-.654 7.52-3.358 8.966-7.416.886-2.485.997-5.34 1.005-8.03.07-25.055.05-50.11.026-75.167-.003-1.69-.246-3.382-.39-5.23H742.97zm-.02-47.878h282.805c0-4.617-.214-9.047.043-13.45.61-10.463-4.66-16.228-16.152-16.13-43.116.368-86.238.147-129.358.148-40.985 0-81.967-.017-122.952.015-8.736.008-13.88 4.166-14.323 11.86-.324 5.59-.064 11.217-.064 17.557zm149.14-77.18c-18.59 0-36.447-.006-54.303 0-27.974.01-55.952-.277-83.92.13-27.537.402-50.386 18.987-56.794 45.73-1.298 5.417-1.785 11.127-1.88 16.716-.254 14.746-.086 29.5-.086 44.695-9.75 3.57-19.354 7.095-28.968 10.6-8.747 3.183-17.53 6.27-26.243 9.537-6.664 2.5-9.265 8.208-6.497 13.792 2.393 4.826 7.18 6.336 13.528 4.056 13.687-4.915 27.34-9.927 41.013-14.88 2.157-.78 4.348-1.462 6.945-2.33v59.83c-16.176 5.76-32.14 12.49-48.7 17.07-19.286 5.334-38.07-5.59-45.117-24.646-8.138-22.004-16.032-44.1-24.06-66.145-8.692-23.868-17.457-47.71-26.112-71.59-8.245-22.752 1.51-43.706 24.303-52.017 79.426-28.96 158.87-57.878 238.323-86.762 23.433-8.52 44.21 1.257 52.774 24.702 8.116 22.22 16.19 44.458 24.27 66.692.457 1.256.81 2.55 1.523 4.82z"
					},
					children: [
					]
				}
			]
		}
	]
};
var blackout = {
	id: "blackout",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 506 418",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "blackout",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(-1 -.428)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "blackout",
					name: "title",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							id: "blackout",
							name: "",
							type: "text",
							value: "Blackout icon",
							attributes: {
							},
							children: [
							]
						}
					]
				},
				{
					id: "blackout",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M486.32 325.002H22.555V20.752h464.38v304.25h-.616zM494.327.428H13.933C6.543.428 1 5.97 1 13.364v321.493c0 7.39 5.543 12.935 12.934 12.935h206.323l-9.24 41.263c-3.078 14.166-16.013 23.404-30.178 22.173h-.62c-1.846 0-3.693 1.85-3.693 3.695 0 1.85 1.234 3.08 2.463 3.08h149.043c1.233-.615 2.464-1.85 2.464-3.08 0-1.848-1.85-3.695-3.696-3.695h-.614c-14.164.616-27.1-8.622-30.176-22.172l-9.24-41.262h206.322c7.39 0 12.935-5.543 12.935-12.934V13.36c1.233-7.39-4.31-12.93-11.7-12.93V.426z"
					},
					children: [
					]
				},
				{
					id: "blackout",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M171.47 255.722c4.64 4.627 12.165 4.627 16.792 0L254 189.984l65.738 65.738c4.627 4.627 12.164 4.627 16.79 0 4.628-4.626 4.628-12.164 0-16.79l-65.737-65.74 65.74-65.737c4.627-4.627 4.627-12.153 0-16.79-4.627-4.628-12.164-4.628-16.79 0L254 156.4l-65.738-65.738c-4.627-4.627-12.153-4.627-16.79 0-4.628 4.638-4.628 12.164 0 16.79l65.737 65.74-65.74 65.737c-4.627 4.627-4.627 12.164 0 16.79"
					},
					children: [
					]
				}
			]
		}
	]
};
var binoculars = {
	id: "binoculars",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 508 413.528"
	},
	children: [
		{
			id: "binoculars",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "binoculars",
					name: "",
					type: "text",
					value: "Binoculars icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "binoculars",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M504.04 274.974c-.556-2.178-1.29-4.315-2.034-6.44-12.908-36.864-25.82-73.728-38.754-110.584-6.895-19.65-13.186-39.542-20.927-58.853-8.594-21.44-24.628-34.28-48.104-37.175-11.62-1.433-23.147-1.992-34.377 1.828-16.138 5.49-28.946 15.637-39.774 28.684-5.554 6.69-11.68 12.95-17.937 18.997-4.788 4.628-8.72 4.207-13.59-.518-6.22-6.032-14.206-8.333-22.286-9.955-13.597-2.728-26.836-.908-39.428 4.888-2.61 1.2-5.04 3.02-7.176 4.964-5.5 5.005-9.412 5.247-14.71-.25-8.767-9.1-16.892-18.84-25.942-27.637-11.57-11.247-25.055-20.118-41.426-21.657-18.883-1.775-37.672-.136-53.61 11.868-9.442 7.113-15.603 16.943-19.463 28.103-8.178 23.65-16.07 47.398-24.436 70.98-9.818 27.676-20.327 55.11-29.895 82.87-3.984 11.56-6.31 23.69-9.42 35.553-.06.23-.494.364-.752.543v28.773c1.903 7.08 3.5 14.258 5.772 21.217 4.542 13.915 12.16 25.983 21.955 36.932 15.245 17.043 34.167 27.784 56.118 32.722 23.144 5.207 45.93 2.87 67.747-6.896 14.038-6.283 26.353-15.05 36.496-26.585 12.862-14.627 21.816-31.47 25.05-50.75 1.67-9.942 2.728-20.293 1.907-30.28-1.67-20.313-8.357-39.2-20.946-55.545-14.028-18.21-31.72-31.41-53.902-38.204-.874-.268-1.656-.835-2.224-2.177 7.868 2.163 15.946 3.764 23.555 6.62 12.403 4.655 24.11 11.076 32.76 21.278 7.197 8.486 13.53 17.817 19.297 27.348 2.45 4.05 2.104 9.694 3.684 14.394 4.774 14.194 15.012 22.17 29.502 25.14 21.018 4.306 41.61-9.196 45.314-29.21 3.015-16.288 12.518-27.99 23.032-39.052 13.328-14.024 30.654-21.302 49.494-25.03.937-.186 1.84-.557 2.78-.706.257-.04.514-.07.763-.105-10.256 5.47-20.98 10.264-30.474 16.837-20.818 14.413-34.44 34.208-41.178 58.887-3.418 12.522-4.794 25.156-3.63 37.836 1.965 21.39 9.548 40.837 23.024 57.817 17.358 21.87 40.06 35.194 67.327 39.525 30.196 4.797 58.165-1.962 82.746-20.73 22.085-16.86 35.32-39.26 40.972-66.31.347-1.66.705-3.316 1.058-4.974V291.18c-1.313-5.402-2.584-10.818-3.96-16.206zm-328.783 30.042c.077 38.918-29.604 68.28-68.286 68.172-37.424-.104-66.654-29.43-67.282-67.48-.373-36.993 30.75-69.62 70.213-68.035 36.225 1.455 65.282 29.537 65.357 67.343zM254 191.456c-18.248 0-33.042-7.504-33.042-16.762 0-9.257 14.793-16.762 33.042-16.762s33.042 7.505 33.042 16.762c0 9.258-14.794 16.762-33.042 16.762zm146.985 181.732c-38.766.072-68.234-29.375-68.27-68.217-.036-36.743 29.292-68.37 70.384-67.294 34.724.91 65.34 30.157 65.213 68.076-.653 38.06-29.92 67.366-67.328 67.436z"
			},
			children: [
			]
		},
		{
			id: "binoculars",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M430.81 54.323c-43.083-19.865-82.626-16.168-118.674 15.792-3.02-25.514 3.217-46.173 24.363-59.557C357.956-3.024 380.672-3.64 402.732 9.51c16.557 9.873 23.64 26.224 28.078 44.813zM193.946 71.65C159.43 36.398 120.172 35.623 78.133 53.78c-1.664-7.19 10.474-30.402 19.94-37.737 21.19-16.418 44.266-18.33 67.453-5.962 23.782 12.687 31.636 34.278 28.42 61.57z"
			},
			children: [
			]
		}
	]
};
var bike = {
	id: "bike",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 510.008 331.987"
	},
	children: [
		{
			id: "bike",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "bike",
					name: "",
					type: "text",
					value: "Bike icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "bike",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M84.584 220.188c0-15.495 12.53-28.114 28.023-28.114 15.48 0 28.023 12.62 28.023 28.114 0 15.498-12.544 28.042-28.023 28.042-15.494 0-28.023-12.544-28.023-28.042zM367.625 220.188c0-15.495 12.525-28.114 28.038-28.114 15.46 0 28.042 12.62 28.042 28.114 0 15.498-12.582 28.042-28.042 28.042-15.513 0-28.038-12.544-28.038-28.042z"
			},
			children: [
			]
		},
		{
			id: "bike",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M397.288 106.62c-7.322 0-14.482.738-21.49 2.068l-8.173-40.885.162-37.817 27.6.22v3.467l53.168.295.076-19.518-53.133-.257-.072 3.91-14.943-.11v-.038l-59.72-.255v-3.506l-53.167-.332-.09 19.594 53.186.22.035-3.91 27.362.075v.073h.238l-.204 31.14H194.93l-10.39-26.712-1.715.704-3.797-9.374s58.166-7.86 57.482-19.41c-.718-11.583-20.954-3.54-49.423-3.54-24.85 0-43.78-7.16-46.488 3.027-2.694 10.145 16.768 8.705 25.496 29.924.48 1.403 1.236 3.137 1.99 5.166l-1.752.552 18.36 47.266-20.35 30.55c-15.536-8.005-33.135-12.58-51.656-12.58C50.474 106.62 0 157.093 0 219.303c0 62.28 50.474 112.683 112.683 112.683 54.645 0 100.177-38.852 110.47-90.508 6.18 4.945 14.04 7.896 22.415 7.896 19.98 0 36.177-16.122 36.177-36.048 0-11.033-5.018-20.848-12.69-27.415L350.5 81.94l6.457 32.137c-42.265 16.23-72.317 57.226-72.317 105.228 0 62.28 50.436 112.683 112.645 112.683s112.72-50.402 112.72-112.683c0-62.21-50.51-112.684-112.72-112.684zM112.683 312.47c-51.452 0-93.164-41.693-93.164-93.164 0-51.433 41.71-93.164 93.163-93.164 14.554 0 28.466 3.393 40.77 9.408l-31.73 47.708c6.587 1.625 12.45 4.908 17.173 9.408l31.125-46.748c19.278 15.128 32.543 37.635 35.237 63.278h-56.25c1.034 3.582 1.714 7.16 1.714 10.995 0 2.954-.366 5.83-1.03 8.56h55.658c-4.685 47.043-44.477 83.718-92.665 83.718zm108.07-125.155c-6.972-23.32-21.087-43.352-39.903-57.705l12.434-18.634 29.02 74.866c-.554.48-1.053.922-1.552 1.473zm24.815 38.078c-6.642 0-12.03-5.35-12.03-12.063 0-6.68 5.388-12.14 12.03-12.14 6.714 0 12.12 5.46 12.12 12.14 0 6.714-5.406 12.064-12.12 12.064zm5.165-47.74c-1.696-.224-3.393-.37-5.165-.37-1.81 0-3.653.222-5.497.44l-33.52-86.67 6.97-10.48h113.167l-75.954 97.08zm146.555 134.818c-51.415 0-93.164-41.693-93.164-93.164 0-38.482 23.448-71.58 56.82-85.748l11.438 57.192c5.203-4.28 11.384-7.084 18.32-8.157l-11.032-54.716c5.72-1.183 11.622-1.734 17.618-1.734 51.49 0 93.22 41.73 93.22 93.164 0 51.47-41.73 93.164-93.22 93.164z"
			},
			children: [
			]
		}
	]
};
var baseball = {
	id: "baseball",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "baseball",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "baseball",
					name: "",
					type: "text",
					value: "Baseball icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "baseball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M511.17 266.2c.17-4.266.23-8.535.19-12.8-.02-1.87-.057-3.738-.12-5.613-.08-2.537-.198-5.075-.357-7.616-.203-3.25-.454-6.494-.777-9.737-.392-3.896-.86-7.782-1.426-11.66-7.694-52.614-31.783-103.3-72.27-143.79-43.766-43.767-99.442-68.375-156.597-73.82-2.915-.278-5.834-.49-8.753-.667-1.097-.067-2.207-.145-3.326-.198-.85-.042-1.69-.063-2.522-.09-.588-.026-1.176-.046-1.764-.066-4.774-.147-9.55-.177-14.33-.064C185.71 1.62 122.76 26.59 74.37 74.98 26.98 122.373 2.064 183.73-.393 245.8c-.167 4.264-.228 8.53-.185 12.8.022 1.87.055 3.736.116 5.606.082 2.54.202 5.076.36 7.61.198 3.254.453 6.507.775 9.757.388 3.895.865 7.78 1.427 11.66C9.787 345.843 33.88 396.53 74.37 437.02c43.766 43.766 99.436 68.373 156.588 73.82 2.914.28 5.837.49 8.754.666 1.102.07 2.207.145 3.326.2.853.035 1.697.057 2.53.094.584.02 1.174.044 1.762.062 4.777.145 9.55.18 14.327.065 63.41-1.55 126.358-26.514 174.75-74.907C483.8 389.628 508.71 328.27 511.17 266.2zM247.276 499.527c-.412-7.34-.484-14.7-.218-22.046 6.208 4.745 12.61 9.166 19.018 13.198l1.334.844-.047-1.576c-.083-2.88.16-5.803.216-8.776l.003-.46-.375-.255c-6.72-4.532-13.11-9.477-19.456-14.786.58-6.83 1.456-13.643 2.625-20.415l.422.422c5.484 5.485 11.033 10.655 16.97 15.51l1.2.978.17-1.536c.322-2.9.804-5.773 1.356-8.65l.09-.475-.354-.315c-3.017-2.685-5.936-5.46-8.8-8.325-2.965-2.964-5.87-6.026-8.754-9.184 1.77-7.907 3.95-15.743 6.536-23.477 4.895 6.454 9.95 12.588 15.37 18.414l1.01 1.088.413-1.426c.828-2.854 1.506-5.703 2.478-8.41l.17-.46-.317-.37c-5.334-6.26-10.39-12.89-15.157-19.833 2.45-6.292 5.186-12.503 8.193-18.61 3.967 7.046 8.242 13.83 12.755 20.28l.856 1.224 4.368-9.84-.236-.375c-4.323-6.838-8.533-14.122-12.323-21.608 3.272-5.885 6.803-11.664 10.61-17.314 2.982 7.483 6.377 14.8 9.866 21.69l.668 1.328 5.723-9.11-.195-.41c-3.422-7.376-6.567-15.107-9.316-23.028 4.015-5.38 8.3-10.63 12.838-15.735 1.952 7.81 4.226 15.417 6.88 22.817l.536 1.492.934-1.276c1.704-2.324 3.697-4.46 5.6-6.73l.298-.356-.14-.442c-2.523-7.863-4.443-15.784-6.15-24.047.636-.663 1.27-1.322 1.91-1.96 4.192-4.188 8.5-8.183 12.922-11.992.892 8.03 2.072 15.843 3.762 23.615l.313 1.458 1.085-1.032c2.145-2.032 4.202-4.103 6.43-5.933l.38-.31-.084-.48c-1.38-8.095-2.32-16.356-2.853-24.742 5.386-4.21 10.917-8.156 16.575-11.84-.205 8.08.012 16.146.544 23.954l.097 1.49 8.816-6.19-.012-.45c-.186-8.086-.096-16.558.495-24.943 5.893-3.438 11.9-6.605 18.005-9.502-1.255 8.01-2.164 15.93-2.62 23.85l-.098 1.58 1.365-.807c2.482-1.48 5.155-2.668 7.803-4.015l.414-.212.042-.462c.762-8.26 2.09-16.35 3.753-24.66 6.276-2.604 12.643-4.924 19.077-6.97-2.312 7.742-4.26 15.434-5.745 23.23l-.28 1.442 1.388-.495c2.81-1.003 5.485-2.187 8.24-2.974l.47-.136.115-.48c1.893-7.935 4.23-15.928 7.002-23.837 6.56-1.74 13.18-3.192 19.84-4.36-3.326 7.322-6.257 14.788-8.795 22.137l-.49 1.406 10.517-2.24.164-.417c2.96-7.486 6.342-15.19 10.146-22.636 7.566-.95 15.177-1.53 22.79-1.757-4.396 6.96-8.414 14.152-12 21.247l-.67 1.318 10.73-.758.222-.4c4.006-7.342 8.483-14.427 13.36-21.475 2.95.054 5.892.152 8.833.318.226 6.775.187 13.562-.145 20.33-.005.127-.018.268-.028.423-2.958 58.21-26.606 115.54-70.962 159.897-49.58 49.592-115.39 73.294-180.495 71.145zM83.003 428.39c-43.088-43.088-66.632-98.42-70.66-154.902 2.957.154 5.917.256 8.88.3 4.8 6.872 9.987 13.693 15.59 20.198l.282.32.423-.03c3.578-.255 7.205-.375 10.84-.772l1.646-.184-1.115-1.22c-5.538-6.06-10.7-12.13-15.53-18.423 7.678-.25 15.353-.847 22.98-1.807 2.44 2.67 4.94 5.28 7.514 7.843 3.526 3.526 7.182 6.984 10.983 10.46l.323.292 12.728-2.715-1.336-1.107c-6.457-5.373-12.52-10.845-18.267-16.584 6.947-1.217 13.85-2.738 20.692-4.553 6.575 5.48 13.477 10.666 20.768 15.603l.336.226.377-.115c3.53-1.047 6.878-2.472 10.247-3.69l1.646-.6-1.493-.913c-7.048-4.3-13.814-9.01-20.268-13.89 6.72-2.133 13.367-4.564 19.92-7.287 7.195 4.462 14.778 8.832 22.585 12.613l.375.18.37-.185c3.197-1.624 6.505-3.13 9.667-4.983l1.416-.832-1.5-.66c-7.537-3.356-14.847-7.095-21.872-11.047 6.35-3.012 12.593-6.313 18.716-9.895 7.766 3.54 15.695 6.605 24.042 9.55l.413.14 10.64-7.464-1.66-.5c-8-2.41-15.67-5.06-23.17-8.073 5.87-3.83 11.61-7.93 17.2-12.304 8.178 2.473 16.56 4.58 25.155 6.243l.395.076.303-.257c2.815-2.344 5.396-4.904 8.004-7.386l1.252-1.19-1.707-.25c-8.153-1.2-16.244-2.926-24.09-4.896 4.574-3.948 9.04-8.085 13.378-12.422.685-.684 1.354-1.377 2.024-2.06 8.398 1.302 17.14 2.372 25.847 2.8l.42.023.268-.32c2.313-2.74 4.767-5.43 6.965-8.38l.978-1.316-1.64-.027c-8.313-.135-16.54-.71-24.602-1.62 4.732-5.328 9.202-10.802 13.395-16.42 8.55.202 17.166-.043 25.963-.68l.426-.034 6.904-11.015-1.72.188c-8.4.895-16.497 1.506-24.602 1.68 3.97-5.905 7.662-11.936 11.07-18.085 8.493-.94 16.932-2.354 25.604-4.132l.424-.088 5.296-11.876-1.684.428c-8.046 2.05-16.038 3.696-24.025 4.952 3.134-6.366 5.975-12.84 8.53-19.398 8.258-2.07 16.51-4.554 24.733-7.513l.376-.136.132-.376c1.22-3.45 2.088-6.98 3.086-10.43l.482-1.664-1.607.655c-7.618 3.126-15.4 5.787-23.122 8.11 2.65-7.938 4.89-15.982 6.71-24.1 7.914-3.18 15.927-6.734 23.67-10.807l.358-.188.08-.395c.68-3.565 1.273-7.142 1.69-10.76l.19-1.667-1.45.84c-7.197 4.18-14.736 7.903-22.2 11.27 1.222-6.996 2.137-14.034 2.752-21.098 7.54-4.24 15.114-8.898 22.34-14.028l.345-.245.008-.423c.08-3.58.34-7.21.256-10.87l-.04-1.64-1.31.986c-6.866 5.192-13.77 9.967-20.86 14.35.302-7.614.258-15.238-.138-22.847 56.527 4 111.91 27.548 155.032 70.67 43.085 43.086 66.632 98.408 70.656 154.884-2.96-.153-5.92-.256-8.887-.3-4.798-6.863-9.984-13.68-15.583-20.184l-.275-.322-.424.03c-3.58.26-7.208.375-10.842.774l-1.645.18 1.114 1.223c5.535 6.054 10.694 12.12 15.518 18.41-7.683.248-15.35.846-22.985 1.806-2.437-2.67-4.937-5.277-7.51-7.85-3.522-3.522-7.173-6.977-10.974-10.44l-.318-.286-12.722 2.705 1.324 1.11c6.456 5.372 12.52 10.84 18.265 16.57-6.95 1.22-13.856 2.737-20.7 4.557-6.576-5.48-13.47-10.656-20.758-15.594l-.326-.223-.386.114c-3.523 1.048-6.87 2.472-10.24 3.693l-1.648.59 1.496.92c7.04 4.3 13.8 9.003 20.247 13.877-6.72 2.138-13.363 4.57-19.912 7.29-7.194-4.457-14.776-8.82-22.577-12.605l-.377-.185-.37.19c-3.2 1.622-6.512 3.125-9.674 4.983l-1.407.826 1.495.666c7.53 3.353 14.837 7.086 21.858 11.037-6.35 3.013-12.592 6.313-18.713 9.892-7.764-3.532-15.687-6.592-24.036-9.538l-.41-.143-10.635 7.455 1.655.506c7.995 2.417 15.66 5.058 23.157 8.073-5.865 3.832-11.607 7.933-17.198 12.302-8.18-2.472-16.55-4.574-25.14-6.244l-.392-.07-.306.257c-2.823 2.343-5.395 4.907-8.01 7.384l-1.253 1.194 1.71.25c8.144 1.196 16.235 2.92 24.077 4.89-4.57 3.947-9.035 8.08-13.373 12.416-.68.688-1.356 1.383-2.024 2.075-8.4-1.302-17.133-2.372-25.843-2.805l-.408-.023-.274.32c-2.313 2.745-4.767 5.433-6.962 8.38l-.98 1.316 1.643.027c8.315.14 16.538.712 24.596 1.625-4.733 5.324-9.203 10.8-13.394 16.418-8.554-.203-17.164.042-25.958.686l-.426.03-6.907 11.007 1.726-.18c8.388-.893 16.486-1.507 24.592-1.68-3.976 5.9-7.665 11.938-11.07 18.083-8.492.94-16.922 2.356-25.6 4.13l-.423.086-5.3 11.88 1.692-.43c8.04-2.042 16.032-3.69 24.017-4.95-3.134 6.373-5.982 12.845-8.53 19.404-8.26 2.068-16.51 4.55-24.728 7.506l-.375.132-.13.377c-1.224 3.458-2.094 6.986-3.09 10.43l-.487 1.674 1.613-.662c7.616-3.123 15.397-5.785 23.112-8.103-2.647 7.94-4.884 15.98-6.706 24.1-7.91 3.176-15.92 6.732-23.663 10.798l-.36.187-.077.398c-.682 3.567-1.273 7.145-1.696 10.764l-.194 1.668 1.453-.85c7.202-4.172 14.738-7.896 22.197-11.262-1.222 7.002-2.135 14.04-2.75 21.096-7.538 4.246-15.108 8.896-22.338 14.033l-.345.242-.008.422c-.08 3.58-.338 7.21-.255 10.872l.035 1.636 1.315-.986c6.864-5.188 13.764-9.962 20.855-14.347-.297 7.616-.26 15.236.14 22.847-56.515-4-111.898-27.543-155.02-70.664zM12.033 243.5C15 185.3 38.648 127.97 83.004 83.614c49.584-49.585 115.388-73.287 180.5-71.14.41 7.337.477 14.693.215 22.042-6.21-4.747-12.608-9.166-19.015-13.198l-1.336-.843.047 1.576c.086 2.877-.163 5.803-.218 8.777l-.006.456.378.258c6.72 4.527 13.107 9.468 19.45 14.78-.58 6.83-1.455 13.643-2.62 20.413l-.433-.433c-5.48-5.48-11.03-10.644-16.96-15.49l-1.196-.977-.172 1.54c-.326 2.892-.806 5.765-1.358 8.643l-.09.47.357.32c3.018 2.685 5.944 5.46 8.81 8.326 2.962 2.96 5.858 6.018 8.74 9.173-1.774 7.91-3.952 15.748-6.54 23.482-4.89-6.454-9.946-12.586-15.366-18.414l-1.005-1.08-.416 1.423c-.828 2.853-1.505 5.705-2.482 8.41l-.165.46.32.373c5.325 6.256 10.382 12.883 15.15 19.825-2.452 6.292-5.185 12.5-8.19 18.61-3.97-7.036-8.244-13.825-12.757-20.276l-.85-1.218-4.375 9.83.242.38c4.323 6.84 8.532 14.115 12.316 21.605-3.266 5.88-6.8 11.657-10.605 17.308-2.985-7.48-6.372-14.79-9.86-21.68l-.673-1.33-5.723 9.108.192.416c3.418 7.367 6.565 15.102 9.315 23.02-4.016 5.38-8.303 10.63-12.837 15.733-1.957-7.805-4.22-15.41-6.882-22.813l-.532-1.483-.937 1.268c-1.7 2.324-3.69 4.46-5.598 6.73l-.3.357.142.443c2.515 7.858 4.443 15.783 6.15 24.037-.64.66-1.277 1.318-1.92 1.96-4.19 4.185-8.5 8.178-12.914 11.992-.896-8.028-2.075-15.838-3.765-23.603l-.313-1.462-1.084 1.03c-2.145 2.036-4.2 4.107-6.433 5.935l-.376.305.08.488c1.38 8.092 2.32 16.348 2.858 24.728-5.386 4.21-10.918 8.153-16.576 11.843.205-8.08-.008-16.14-.54-23.944l-.105-1.487-8.808 6.184.01.455c.185 8.08.088 16.545-.498 24.927-5.893 3.438-11.897 6.604-18.007 9.504 1.26-8.006 2.167-15.927 2.624-23.84l.09-1.577-1.36.81c-2.474 1.475-5.153 2.663-7.802 4.007l-.412.21-.044.465c-.765 8.26-2.09 16.348-3.754 24.655-6.28 2.602-12.643 4.924-19.08 6.966 2.31-7.736 4.256-15.42 5.74-23.213l.273-1.443-1.38.494c-2.807 1.003-5.483 2.18-8.24 2.973l-.472.136-.113.478c-1.894 7.93-4.232 15.924-7 23.827-6.558 1.736-13.18 3.193-19.84 4.364 3.326-7.323 6.254-14.78 8.796-22.13l.487-1.41-10.518 2.242-.17.422c-2.958 7.48-6.335 15.182-10.133 22.62-7.573.956-15.175 1.532-22.792 1.76 4.392-6.954 8.406-14.144 11.99-21.23l.67-1.328-10.723.754-.226.406c-4 7.34-8.478 14.425-13.36 21.47-2.942-.058-5.887-.158-8.832-.317-.226-6.775-.185-13.555.144-20.323.005-.127.023-.272.026-.438z"
			},
			children: [
			]
		},
		{
			id: "baseball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.39 510.777c-68.054 0-132.035-26.502-180.156-74.622C27.114 388.035.61 324.055.61 256c0-68.053 26.502-132.034 74.624-180.155S187.334 1.223 255.39 1.223c68.053 0 132.033 26.5 180.154 74.623 48.12 48.12 74.622 112.102 74.622 180.155 0 68.055-26.502 132.035-74.622 180.156-48.12 48.12-112.102 74.62-180.155 74.62zm0-489.554c-62.712 0-121.67 24.42-166.014 68.765C45.033 134.33 20.61 193.288 20.61 256c0 62.71 24.422 121.67 68.766 166.013 44.344 44.344 103.3 68.765 166.013 68.765 62.71 0 121.668-24.42 166.012-68.765l7.07 7.07-7.07-7.07C465.746 377.67 490.167 318.71 490.167 256c0-62.71-24.42-121.67-68.765-166.013C377.058 45.644 318.1 21.223 255.39 21.223z"
			},
			children: [
			]
		}
	]
};
var blog = {
	id: "blog",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "blog",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "blog",
					name: "",
					type: "text",
					value: "Blog icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "blog",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M416.026 0C470.413 0 512 41.587 512 96.026v54.335l-3.187-3.187c-9.561-6.426-19.174-12.8-28.787-12.8v-38.4c0-35.213-28.787-64-64-64h-320c-35.213 0-64 28.787-64 64v320c0 35.213 28.787 64 64 64h319.948c35.213 0 64-28.787 64-64v-128L512 256v160.026C512 470.413 470.413 512 416.026 512h-320C41.587 512 0 470.413 0 416.026v-320C0 41.587 41.587 0 96.026 0zM473.6 166.4h1.217c5.625.014 8.604.208 11.583 3.187L508.813 192c3.187 6.426 3.187 16.039 0 22.413L339.226 384h-51.2v-44.826L460.8 169.587c3.187-3.187 9.613-3.187 12.8-3.187zM256 351.974V384H96.026v-32.026H256zm41.587-63.948L268.8 316.813 265.613 320H96.026v-31.974h201.561zm64-64.052L329.613 256H96.026v-32.026h265.561zm54.439-64v9.613L393.613 192H96.026v-32.026h320zm0-64V128h-320V95.974h320z"
			},
			children: [
			]
		}
	]
};
var bus = {
	id: "bus",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 388.943 359.724"
	},
	children: [
		{
			id: "bus",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "bus",
					name: "",
					type: "text",
					value: "Bus icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "bus",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M375.08 67.48h-.314v-7.05c0-14.177-11.554-25.73-25.77-25.73H332.31C323.97 14.372 303.995 0 280.652 0H108.29C84.948 0 64.974 14.373 56.632 34.7H39.948c-14.216 0-25.73 11.553-25.73 25.73v7.05h-.314C6.228 67.48 0 73.707 0 81.383v46.45c0 7.675 6.228 13.903 13.904 13.903h11.71c7.676 0 13.903-6.228 13.903-13.903v-46.45c0-7.676-6.227-13.903-13.903-13.903H25.3v-7.05c0-8.068 6.58-14.608 14.648-14.608H53.42c-.586 3.25-.94 6.58-.94 10.026v240.64c-.134 38.1.136 38.1 0 38.055v12.23c0 7.15 5.652 12.95 12.802 12.95H79.85c7.15 0 12.995-5.8 12.995-12.95v-21.2H296.1v21.2c0 7.15 5.8 12.95 12.95 12.95h14.568c7.15 0 12.845-5.8 12.845-12.95v-12.23c-.135.045.135.045 0-33.68V55.847c0-3.446-.353-6.776-.94-10.026h13.473c8.068 0 14.648 6.54 14.648 14.608v7.05h-.313c-7.676 0-13.902 6.227-13.902 13.903v46.45c0 7.675 6.227 13.903 13.903 13.903h11.75c7.676 0 13.865-6.228 13.865-13.903v-46.45c-.002-7.676-6.19-13.903-13.866-13.903zM116.6 285.154H87.077c-5.256 0-9.515-4.26-9.515-9.515v-4.91c0-5.257 4.26-9.516 9.516-9.516h27.57c3.898 0 7.4 2.376 8.84 5.996l1.955 4.91c2.49 6.248-2.114 13.034-8.84 13.034zm194.802-9.515c0 5.255-4.26 9.514-9.515 9.514H272.36c-6.724 0-11.327-6.786-8.84-13.034l1.955-4.91c1.44-3.62 4.944-5.996 8.84-5.996h27.572c5.255 0 9.515 4.26 9.515 9.515v4.91zm0-127.56v42.298c-.04 11.593-8.763 21.345-20.24 22.833-30.586 3.917-57.82 6.228-96.67 6.228-38.892 0-66.126-2.31-96.674-6.266-11.475-1.45-20.22-11.2-20.258-22.794V70.144c0-22.05 17.71-39.948 39.722-39.948H271.66c22.01 0 39.742 17.898 39.742 39.948v77.937z"
			},
			children: [
			]
		}
	]
};
var boat = {
	id: "boat",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 463.851 509.102"
	},
	children: [
		{
			id: "boat",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "boat",
					name: "",
					type: "text",
					value: "Boat icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "boat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M417.228 462.744c-32.03 0-64.06-10.958-92.717-30.344-56.472 39.616-128.96 39.616-185.434 0-28.658 20.23-60.688 30.344-92.717 30.344H0v46.36h46.36c32.03 0 63.215-7.587 92.716-22.76 58.16 30.345 127.276 30.345 185.435 0 29.502 15.173 60.69 22.76 92.718 22.76h46.36v-46.36h-46.36zm-372.555-46.36h1.686c37.086 0 69.958-20.228 92.716-46.358 22.758 26.13 55.63 46.36 92.717 46.36s69.96-20.23 92.717-46.36c22.758 26.13 55.63 46.36 92.717 46.36h1.686l43.83-155.092c1.686-5.9 1.686-12.643-1.686-17.7-2.53-5.9-7.586-10.116-13.486-11.8l-30.343-9.273V115.476c0-25.287-21.072-46.36-46.36-46.36h-69.116V0H161.835v69.117H92.717c-25.287 0-46.36 21.072-46.36 46.36V222.52l-29.5 10.115c-5.9 1.686-10.957 5.9-13.486 11.8-2.528 5.9-3.37 11.8-1.685 17.7l42.988 154.248zm48.044-300.91H370.87v91.875l-139.077-45.517L92.717 207.35v-91.875z"
			},
			children: [
			]
		}
	]
};
var calendar = {
	id: "calendar",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "calendar",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "calendar",
					name: "",
					type: "text",
					value: "Calendar icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "calendar",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M455.5 72H421V27c0-14.9-12.2-27-27.1-27h-56.2C322.9 0 310 12.2 310 27v45H201V27c0-14.9-11.5-27-26.4-27h-56.2C103.6 0 91 12.2 91 27v45H55.8C35 72 18 89.4 18 110.2v364.1C18 495 35 512 55.8 512h399.7c20.8 0 38.5-17 38.5-37.7V110.2c0-20.8-17.7-38.2-38.5-38.2zM384 127.3c0 5.4-4.4 9.7-9.7 9.7h-17.6c-5.4 0-9.7-4.4-9.7-9.7V45.7c0-5.4 4.4-9.7 9.7-9.7h17.6c5.4 0 9.7 4.4 9.7 9.7v81.6zm-219 0c0 5.4-4.4 9.7-9.7 9.7h-17.6c-5.4 0-9.7-4.4-9.7-9.7V45.7c0-5.4 4.4-9.7 9.7-9.7h17.6c5.4 0 9.7 4.4 9.7 9.7v81.6zM457 475H55V182h402v293z"
			},
			children: [
			]
		}
	]
};
var camera = {
	id: "camera",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 483.026 357.004"
	},
	children: [
		{
			id: "camera",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "camera",
					name: "",
					type: "text",
					value: "Camera icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "camera",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M242.365 132.004c-42.173-.05-75.806 33.278-75.846 75.16-.04 41.853 33.977 75.932 75.527 75.663 41.603-.27 75.285-34.16 75.137-75.604-.148-41.58-33.56-75.17-74.82-75.22z"
			},
			children: [
			]
		},
		{
			id: "camera",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M461.982 59.007c-39.16-.008-78.32-.003-117.48-.003h-5.605c-1.328-10.372-2.983-20.24-3.777-30.178C333.75 11.662 321.564.008 304.264.006 261.94 0 219.614-.004 177.287.008c-16.583.005-29.026 11.896-30.352 28.316-.816 10.104-2.433 20.143-3.748 30.68h-6.14c-38.994 0-77.988-.02-116.98.01C8.146 59.024-.002 67.238 0 79.11c.006 85.318.015 170.636.027 255.955.002 13.88 8.103 21.938 22.037 21.938h438.923c13.934 0 22.035-8.057 22.036-21.94.004-84.984.003-169.97 0-254.955 0-13.328-7.743-21.1-21.04-21.1zM241.686 330.495c-68.358.085-123.13-55.323-122.784-124.603.337-67.523 57.087-122.203 125.15-121.22 65.76.95 120.58 56.288 120.466 123.1-.115 67.585-55.22 122.64-122.832 122.723zM461.36 104.8c0 4.95-4.05 9-9 9h-79.854c-4.95 0-9-4.05-9-9V90.005c0-4.95 4.05-9 9-9h79.853c4.95 0 9 4.05 9 9V104.8z"
			},
			children: [
			]
		}
	]
};
var box = {
	id: "box",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "box",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "box",
					name: "",
					type: "text",
					value: "Box icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "box",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 10)",
				fill: "#666",
				stroke: "#666",
				strokeWidth: "2",
				fillRule: "evenodd",
				fillOpacity: ".2"
			},
			children: [
				{
					id: "box",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1 0h9v10H0V1c0-.5522847.4477153-1 1-1zM10 0h10v10H10zM20 0h9c.5522847 0 1 .4477153 1 1v9h0-10V0zM20 10h10v9c0 .5522847-.4477153 1-1 1h-9 0V10zM10 10h10v10H10zM0 10h10v10H1c-.5522847 0-1-.4477153-1-1v-9h0z"
					},
					children: [
					]
				}
			]
		}
	]
};
var car = {
	id: "car",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 509 372.144"
	},
	children: [
		{
			id: "car",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "car",
					name: "",
					type: "text",
					value: "Car icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "car",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M509 99.234c0-13.553-10.18-24.943-23.647-26.46l-27.847-3.14c-8.27-.93-15.508 5.538-15.508 13.86v22.932c-4.473-1.61-9.087-2.816-13.786-3.657l-.41-.78-27.596-52.562C386.824 23.942 361.38 7.028 332.7 4.555L311.66 2.74c-42.367-3.653-68.515-3.653-110.88 0l-21.042 1.815c-28.68 2.474-54.124 19.387-67.506 44.873l-27.597 52.56-.41.78c-5.918 1.06-11.688 2.742-17.224 5.017V83.493c0-8.32-7.238-14.79-15.506-13.858l-27.847 3.138C10.18 74.29 0 85.683 0 99.233c0 7.614 5.947 13.902 13.55 14.325l38.577 2.143c-1.804 1.227-3.562 2.527-5.27 3.904C22.65 139.126 8.59 168.546 8.59 199.624v130.634c0 23.133 18.752 41.886 41.885 41.886S92.36 353.39 92.36 330.257V317.98h327.718v12.277c0 23.133 18.753 41.886 41.885 41.886 23.132 0 41.885-18.753 41.885-41.886V199.625c0-31.078-14.06-60.5-38.268-80.02-1.793-1.446-3.648-2.8-5.547-4.078l35.418-1.968c7.602-.423 13.55-6.71 13.55-14.324zM126.596 56.97c10.864-20.692 31.25-34.245 54.536-36.253l21.04-1.815c41.283-3.56 66.81-3.56 108.092 0l21.04 1.815c23.286 2.008 43.673 15.56 54.538 36.253l23.143 44.09-98.283-4.855c-41.78-2.064-67.186-2.064-108.967 0l-98.283 4.855 23.144-44.09zm7.278 142.618c-1.597 9.846-10.56 16.764-20.49 15.816l-59.978-5.734c-10.533-1.007-18.196-10.452-17.01-20.967l.943-8.37c1.273-11.3 12.15-18.936 23.21-16.293l59.037 14.104c9.642 2.303 15.874 11.657 14.287 21.444zm181.657 35.638H196.154c-20.258 0-36.68-16.423-36.68-36.68 0-11.075 8.978-20.053 20.052-20.053H332.16c11.074 0 20.05 8.978 20.05 20.052 0 20.258-16.422 36.68-36.68 36.68zm158.815-54.892l.944 8.37c1.184 10.515-6.48 19.96-17.012 20.967l-59.98 5.735c-9.93.95-18.89-5.97-20.488-15.816-1.587-9.788 4.645-19.142 14.29-21.445l59.034-14.104c11.06-2.642 21.938 4.993 23.21 16.294z"
			},
			children: [
			]
		}
	]
};
var cheer = {
	id: "cheer",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 40 40",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "cheer",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "cheer",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						transform: "rotate(-25 37.4258654 11.2392915)",
						stroke: "#666",
						strokeWidth: "1.9354839"
					},
					children: [
						{
							id: "cheer",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M25.1428608 1.4053559c-.7317473 2.4585598-1.1006417 5.1735202-1.1006417 8.1461061 0 3.1190406.4056422 6.289555 1.2189048 9.5112712h0L2.7782556 13.7177494c-.8296871-1.2143909-1.2654784-2.4044346-1.2654784-3.581943 0-1.16164.4282213-2.294065 1.2464598-3.4090607h0z",
								fillOpacity: ".2",
								fill: "#666"
							},
							children: [
							]
						},
						{
							id: "cheer",
							name: "ellipse",
							type: "element",
							value: "",
							attributes: {
								fillOpacity: ".2",
								fill: "#666",
								cx: "26.5275142",
								cy: "10.2466793",
								rx: "2.4193548",
								ry: "9.1935484"
							},
							children: [
							]
						},
						{
							id: "cheer",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M11.801558 15.8547415c.7967617.1631193 1.4925056.2191705 1.849365.5805508.1868886.1892562.1135377.50795.021507.9065788-.2099255.9092871-.7770095 1.6445362-1.521775 2.099924-.7529722.4604056-1.6871922.6354188-2.6236421.4192223-.93645-.2161965-1.6994006-.7830324-2.174339-1.5269235-.469762-.7357836-.6571417-1.6452143-.4472162-2.5545014.0553427-.2397155.1263535-.4282603.2377935-.5615334.9168027-.333252 1.783619-.0496033 2.7263352.1913557.3150362.0805235.6377.1629082.9645592.2383696.336967.077795.6608327.1441917.9674124.2069571z"
							},
							children: [
							]
						}
					]
				},
				{
					id: "cheer",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						fill: "#666",
						transform: "rotate(-50 31.5 6)",
						x: "28.5",
						y: "5",
						width: "6",
						height: "2",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "cheer",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						fill: "#666",
						transform: "rotate(5 36.5 17)",
						x: "33.5",
						y: "16",
						width: "6",
						height: "2",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "cheer",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						fill: "#666",
						transform: "rotate(-25 34.5 11)",
						x: "31.5",
						y: "10",
						width: "6",
						height: "2",
						rx: "1"
					},
					children: [
					]
				}
			]
		}
	]
};
var checkmark = {
	id: "checkmark",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 11 8",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "checkmark",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "checkmark",
					name: "",
					type: "text",
					value: "Checkmark icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "checkmark",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.422 7.756a.833.833 0 0 1-1.178 0l-3-2.996a.833.833 0 0 1 1.178-1.177L3.83 5.986 9.577.244a.833.833 0 0 1 1.179 1.177L4.422 7.756z",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
};
var channels = {
	id: "channels",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "channels",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "channels",
					name: "",
					type: "text",
					value: "Channels icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "channels",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.654 0.441 C 1.286 0.516,0.895 0.789,0.669 1.129 C 0.399 1.536,0.400 1.524,0.400 4.000 C 0.400 6.476,0.399 6.464,0.669 6.871 C 0.889 7.203,1.221 7.445,1.587 7.540 C 1.929 7.629,6.073 7.629,6.416 7.539 C 6.942 7.402,7.403 6.941,7.540 6.413 C 7.629 6.071,7.629 1.927,7.539 1.584 C 7.422 1.134,7.086 0.751,6.617 0.531 L 6.380 0.420 4.100 0.413 C 2.846 0.410,1.745 0.422,1.654 0.441 M9.654 0.441 C 9.286 0.516,8.895 0.789,8.669 1.129 C 8.399 1.536,8.400 1.524,8.400 4.000 C 8.400 6.476,8.399 6.464,8.669 6.871 C 8.889 7.203,9.221 7.445,9.587 7.540 C 9.929 7.629,14.073 7.629,14.416 7.539 C 14.942 7.402,15.403 6.941,15.540 6.413 C 15.629 6.071,15.629 1.927,15.539 1.584 C 15.422 1.134,15.086 0.751,14.617 0.531 L 14.380 0.420 12.100 0.413 C 10.846 0.410,9.745 0.422,9.654 0.441 M17.654 0.441 C 17.115 0.550,16.602 1.042,16.461 1.584 C 16.371 1.929,16.371 6.071,16.461 6.416 C 16.598 6.942,17.059 7.403,17.587 7.540 C 17.929 7.629,22.073 7.629,22.416 7.539 C 22.866 7.422,23.249 7.086,23.469 6.617 L 23.580 6.380 23.592 4.107 C 23.604 1.566,23.602 1.537,23.335 1.136 C 23.159 0.870,22.931 0.678,22.617 0.531 L 22.380 0.420 20.100 0.413 C 18.846 0.410,17.745 0.422,17.654 0.441 M6.269 1.731 L 6.380 1.842 6.380 4.004 L 6.380 6.167 6.249 6.283 L 6.119 6.400 4.021 6.400 C 2.538 6.400,1.894 6.387,1.824 6.354 C 1.598 6.252,1.597 6.235,1.609 3.946 C 1.620 1.913,1.622 1.846,1.700 1.759 C 1.744 1.711,1.816 1.656,1.860 1.637 C 1.904 1.619,2.889 1.608,4.049 1.612 L 6.158 1.620 6.269 1.731 M14.269 1.731 L 14.380 1.842 14.380 4.004 L 14.380 6.167 14.249 6.283 L 14.119 6.400 12.021 6.400 C 10.538 6.400,9.894 6.387,9.824 6.354 C 9.598 6.252,9.597 6.235,9.609 3.946 C 9.620 1.913,9.622 1.846,9.700 1.759 C 9.744 1.711,9.816 1.656,9.860 1.637 C 9.904 1.619,10.889 1.608,12.049 1.612 L 14.158 1.620 14.269 1.731 M22.269 1.731 L 22.380 1.842 22.380 4.004 L 22.380 6.167 22.249 6.283 L 22.119 6.400 20.021 6.400 C 18.538 6.400,17.894 6.387,17.824 6.354 C 17.598 6.252,17.597 6.235,17.609 3.946 C 17.620 1.913,17.622 1.846,17.700 1.759 C 17.744 1.711,17.816 1.656,17.860 1.637 C 17.904 1.619,18.889 1.608,20.049 1.612 L 22.158 1.620 22.269 1.731 M1.654 8.441 C 1.286 8.516,0.895 8.789,0.669 9.129 C 0.399 9.536,0.400 9.524,0.400 12.000 C 0.400 14.476,0.399 14.464,0.669 14.871 C 0.889 15.203,1.221 15.445,1.587 15.540 C 1.929 15.629,6.073 15.629,6.416 15.539 C 6.866 15.422,7.249 15.086,7.469 14.617 L 7.580 14.380 7.592 12.107 C 7.604 9.566,7.602 9.537,7.335 9.136 C 7.159 8.870,6.931 8.678,6.617 8.531 L 6.380 8.420 4.100 8.413 C 2.846 8.410,1.745 8.422,1.654 8.441 M9.654 8.441 C 9.286 8.516,8.895 8.789,8.669 9.129 C 8.399 9.536,8.400 9.524,8.400 12.000 C 8.400 14.476,8.399 14.464,8.669 14.871 C 8.889 15.203,9.221 15.445,9.587 15.540 C 9.929 15.629,14.073 15.629,14.416 15.539 C 14.942 15.402,15.403 14.941,15.540 14.413 C 15.629 14.071,15.629 9.927,15.539 9.584 C 15.422 9.134,15.086 8.751,14.617 8.531 L 14.380 8.420 12.100 8.413 C 10.846 8.410,9.745 8.422,9.654 8.441 M17.654 8.441 C 17.115 8.550,16.602 9.042,16.461 9.584 C 16.371 9.929,16.371 14.071,16.461 14.416 C 16.598 14.942,17.059 15.403,17.587 15.540 C 17.929 15.629,22.073 15.629,22.416 15.539 C 22.942 15.402,23.403 14.941,23.540 14.413 C 23.629 14.071,23.629 9.927,23.539 9.584 C 23.422 9.134,23.086 8.751,22.617 8.531 L 22.380 8.420 20.100 8.413 C 18.846 8.410,17.745 8.422,17.654 8.441 M6.269 9.731 L 6.380 9.842 6.380 12.004 L 6.380 14.167 6.249 14.283 L 6.119 14.400 4.021 14.400 C 2.538 14.400,1.894 14.387,1.824 14.354 C 1.598 14.252,1.597 14.235,1.609 11.946 C 1.620 9.913,1.622 9.846,1.700 9.759 C 1.744 9.711,1.816 9.656,1.860 9.637 C 1.904 9.619,2.889 9.608,4.049 9.612 L 6.158 9.620 6.269 9.731 M14.269 9.731 L 14.380 9.842 14.380 12.004 L 14.380 14.167 14.249 14.283 L 14.119 14.400 12.021 14.400 C 10.538 14.400,9.894 14.387,9.824 14.354 C 9.598 14.252,9.597 14.235,9.609 11.946 C 9.620 9.913,9.622 9.846,9.700 9.759 C 9.744 9.711,9.816 9.656,9.860 9.637 C 9.904 9.619,10.889 9.608,12.049 9.612 L 14.158 9.620 14.269 9.731 M22.269 9.731 L 22.380 9.842 22.380 12.004 L 22.380 14.167 22.249 14.283 L 22.119 14.400 20.021 14.400 C 18.538 14.400,17.894 14.387,17.824 14.354 C 17.598 14.252,17.597 14.235,17.609 11.946 C 17.620 9.913,17.622 9.846,17.700 9.759 C 17.744 9.711,17.816 9.656,17.860 9.637 C 17.904 9.619,18.889 9.608,20.049 9.612 L 22.158 9.620 22.269 9.731 M1.677 16.439 C 1.301 16.505,0.902 16.778,0.669 17.129 C 0.399 17.536,0.400 17.524,0.400 20.000 C 0.400 22.476,0.399 22.464,0.669 22.871 C 0.889 23.203,1.221 23.445,1.587 23.540 C 1.929 23.629,6.073 23.629,6.416 23.539 C 6.942 23.402,7.403 22.941,7.540 22.413 C 7.629 22.071,7.629 17.927,7.539 17.584 C 7.422 17.134,7.086 16.751,6.617 16.531 L 6.380 16.420 4.120 16.414 C 2.877 16.410,1.778 16.422,1.677 16.439 M9.677 16.439 C 9.301 16.505,8.902 16.778,8.669 17.129 C 8.399 17.536,8.400 17.524,8.400 20.000 C 8.400 22.476,8.399 22.464,8.669 22.871 C 8.889 23.203,9.221 23.445,9.587 23.540 C 9.929 23.629,14.073 23.629,14.416 23.539 C 14.942 23.402,15.403 22.941,15.540 22.413 C 15.629 22.071,15.629 17.927,15.539 17.584 C 15.422 17.134,15.086 16.751,14.617 16.531 L 14.380 16.420 12.120 16.414 C 10.877 16.410,9.778 16.422,9.677 16.439 M17.677 16.439 C 17.132 16.535,16.605 17.031,16.461 17.584 C 16.371 17.929,16.371 22.071,16.461 22.416 C 16.598 22.942,17.059 23.403,17.587 23.540 C 17.929 23.629,22.073 23.629,22.416 23.539 C 22.942 23.402,23.403 22.941,23.540 22.413 C 23.629 22.071,23.629 17.927,23.539 17.584 C 23.422 17.134,23.086 16.751,22.617 16.531 L 22.380 16.420 20.120 16.414 C 18.877 16.410,17.778 16.422,17.677 16.439 M6.269 17.731 L 6.380 17.842 6.380 20.004 L 6.380 22.167 6.249 22.283 L 6.119 22.400 4.021 22.400 C 2.538 22.400,1.894 22.387,1.824 22.354 C 1.598 22.252,1.597 22.235,1.609 19.946 C 1.620 17.913,1.622 17.846,1.700 17.759 C 1.744 17.711,1.816 17.656,1.860 17.637 C 1.904 17.619,2.889 17.608,4.049 17.612 L 6.158 17.620 6.269 17.731 M14.269 17.731 L 14.380 17.842 14.380 20.004 L 14.380 22.167 14.249 22.283 L 14.119 22.400 12.021 22.400 C 10.538 22.400,9.894 22.387,9.824 22.354 C 9.598 22.252,9.597 22.235,9.609 19.946 C 9.620 17.913,9.622 17.846,9.700 17.759 C 9.744 17.711,9.816 17.656,9.860 17.637 C 9.904 17.619,10.889 17.608,12.049 17.612 L 14.158 17.620 14.269 17.731 M22.269 17.731 L 22.380 17.842 22.380 20.004 L 22.380 22.167 22.249 22.283 L 22.119 22.400 20.021 22.400 C 18.538 22.400,17.894 22.387,17.824 22.354 C 17.598 22.252,17.597 22.235,17.609 19.946 C 17.620 17.913,17.622 17.846,17.700 17.759 C 17.744 17.711,17.816 17.656,17.860 17.637 C 17.904 17.619,18.889 17.608,20.049 17.612 L 22.158 17.620 22.269 17.731"
			},
			children: [
			]
		}
	]
};
var close = {
	id: "close",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "close",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "close",
					name: "",
					type: "text",
					value: "Close icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "close",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.3 488.6c13.8 13.1 36.2 13.1 49.9 0l195.6-185.5 195.6 185.5c13.8 13.1 36.2 13.1 49.9 0 13.8-13.1 13.8-34.3 0-47.4L305.8 255.7 501.3 70.2c13.8-13.1 13.8-34.3 0-47.4-13.8-13.1-36.2-13.1-49.9 0L255.8 208.3 60.3 22.8c-13.8-13.1-36.2-13.1-49.9 0-13.8 13.1-13.8 34.3 0 47.4L206 255.7 10.3 441.2c-13.7 13.1-13.7 34.4 0 47.4z"
			},
			children: [
			]
		}
	]
};
var cocktail = {
	id: "cocktail",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 409.126 511.922"
	},
	children: [
		{
			id: "cocktail",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "cocktail",
					name: "",
					type: "text",
					value: "Local drink icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "cocktail",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M407.55 110.826c-2.98-6.07-8.393-7.54-14.547-7.547-32.836-.036-65.673.142-98.51.142H289.7c.9-3 1.45-3.88 2.125-5.336 3.995-8.616 8.136-17.25 11.967-25.937 1.26-2.86 2.53-3.718 5.79-3.044 11.102 2.296 21.3-.088 29.13-8.52 11.872-12.78 10.17-31.922-3.785-43.244-3.43-2.783-3.878-4.777-1.633-8.132 2.22-3.32 1.867-6.788-1.173-8.788h-3.27c-1.453 2-2.725 4.74-4.43 6.952-.9 1.166-2.538 2.32-3.876 2.36-3.763.11-7.548-.703-11.318-.652-10.316.14-21.215 7.93-24.9 17.56-5.05 13.207-.988 27 10.91 36.228 1.773 1.374 2.214 2.332 1.263 4.317-5.044 10.525-10.204 21-14.86 31.696-1.53 3.515-3.432 4.294-6.97 4.29-85.574-.097-171.147-.077-256.72-.077-1.364 0-2.74-.107-4.086.044-5.9.66-10.855 2.947-12.908 8.96-1.955 5.726-.968 10.946 3.567 15.338 2.536 2.456 4.776 5.215 7.22 7.77 29.905 31.287 59.805 62.578 89.743 93.832 29.092 30.37 58.215 60.714 87.367 91.027 2.213 2.3 3.203 4.73 3.182 7.99-.127 20.165-.062 40.332-.063 60.5-.002 31.476-.073 62.953.076 94.43.02 3.977-1.172 5.08-5.072 4.98-10.077-.258-20.165-.12-30.248-.072-6.264.03-12.543-.047-18.788.35-4.957.317-8.6 3.723-9.806 8.41-1.283 4.98.117 9.38 4.153 12.562 1.38 1.09 2.92 2.205 4.388 3.205h135.75c1.657-2 3.432-2.364 4.95-3.653 4.864-4.127 5.325-11.15 1.432-16.18-2.914-3.766-6.812-4.664-11.202-4.654-15.124.034-30.25-.173-45.37.103-4.228.076-5.284-1.28-5.276-5.296.102-51.64.02-103.286.193-154.924.008-2.534 1.347-5.593 3.068-7.503 7.19-7.975 14.767-15.602 22.19-23.365 29.91-31.277 59.81-62.567 89.727-93.837 24.28-25.378 48.58-50.737 72.87-76.103 4.38-4.577 5.332-10.5 2.542-16.186zm-141.473 20.596c-.336 1-.522 2.06-.96 2.992-5.094 10.817-10.425 21.48-15.22 32.428-1.008 2.304-2.31 2.863-3.94 3.01l-56.355-.187c-26.377-.005-52.754-.242-79.132-.242h-6.652c.024 0 .048.264.072.29l-20.614.216c-12.317-12.876-24.654-25.507-37.03-38.507h219.83zm59.88 38.35l-67.42.046c2.5-5.62 4.54-10.39 6.732-15.09 3.328-7.134 6.682-14.26 10.238-21.284.583-1.152 2.255-2.492 3.43-2.498 27.255-.135 54.513-.1 81.77-.08.363 0 .727.184 1.99.525-12.264 12.814-24.506 25.6-36.742 38.382z"
			},
			children: [
			]
		}
	]
};
var community = {
	id: "community",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "community",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "community",
					name: "",
					type: "text",
					value: "Community Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "community",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#444"
			},
			children: [
				{
					id: "community",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M20.745 10.596c.193.504.274.958.243 1.394-.037.529-.093 1.052-.143 1.531-.025.23-.012.38.044.51.106.249.137.523.093.797a7.565 7.565 0 0 1-.156.759c-.081.342-.218.784-.492 1.195a.708.708 0 0 0-.081.218c-.037.143-.062.292-.093.454-.012.081-.031.156-.044.236-.143.716-.367 1.537-.971 2.215a.588.588 0 0 0-.149.404c-.012.61-.012 1.101.006 1.556.006.18.081.292.249.367.217.099.439.186.666.261.865.286 1.842.61 2.788.983.647.255 1.325.572 1.979.884h7.249c-.006-.236-.006-.436-.006-.666-.062-.118-.031-.243-.037-.361-.025-.311-.056-.622-.075-.927-.019-.299-.162-.535-.373-.74-.261-.261-.573-.461-.89-.647-.703-.404-1.456-.722-2.209-1.021-.909-.361-1.842-.672-2.769-.983a7.347 7.347 0 0 1-.703-.28c-.305-.137-.473-.38-.479-.709a45.884 45.884 0 0 1-.006-1.574 1 1 0 0 1 .249-.653c.516-.585.734-1.294.884-2.035.05-.236.087-.473.143-.703.031-.118.068-.243.137-.342.218-.33.342-.691.436-1.07.059-.243.109-.487.149-.734.033-.198.01-.4-.068-.585-.1-.23-.1-.46-.075-.703.057-.505.105-1.011.143-1.518.031-.423-.062-.834-.218-1.226-.529-1.357-1.506-2.215-2.906-2.601a11.582 11.582 0 0 0-1.108-.199h-.797c-.131 0-.261.037-.392.056-.964.124-1.842.467-2.557 1.145a4.026 4.026 0 0 0-1.251 2.309c-.006.025-.006.056-.012.081.149.025.292.05.442.093 1.529.421 2.593 1.373 3.16 2.829zM8.225 23.918c1.195-.529 2.433-.952 3.379-1.263.342-.112.697-.243 1.07-.392.193-.075.224-.162.23-.193.037-.112.062-.224.062-.317.012-.355.012-.716.012-1.064v-.168a1.04 1.04 0 0 0-.261-.728 3.295 3.295 0 0 1-.597-1.039 8.301 8.301 0 0 1-.348-1.406c-.056-.317-.112-.535-.249-.716-.056-.075-.087-.149-.118-.212l-.006-.012c-.149-.324-.236-.66-.317-.983l-.031-.118c-.143-.548-.118-1.008.062-1.437a.262.262 0 0 0 .012-.068c-.044-.492-.093-.989-.137-1.469-.031-.33-.056-.622 0-.946a4.423 4.423 0 0 1 1.369-2.514c.66-.616 1.462-1.002 2.452-1.176a3.372 3.372 0 0 0-.205-.809c-.529-1.357-1.506-2.209-2.906-2.601-.292-.081-.884-.168-1.058-.193-.031-.006-.05-.006-.05-.006h-.797c-.131 0-.261.037-.392.056-.965.123-1.842.465-2.558 1.144a4.02 4.02 0 0 0-1.251 2.309c-.05.28-.025.566 0 .846.05.492.1.983.137 1.475a.52.52 0 0 1-.044.255c-.168.392-.149.79-.044 1.189.087.348.168.703.324 1.033.025.056.05.106.081.156.199.261.268.566.317.884.075.454.174.902.336 1.338.124.336.286.647.523.921.249.28.361.61.361.983 0 .417 0 .834-.012 1.245a1.43 1.43 0 0 1-.087.429c-.075.218-.255.349-.454.423-.361.143-.722.274-1.089.398-1.133.373-2.253.772-3.342 1.257-.548.243-1.089.498-1.581.84-.18.124-.342.261-.504.404-.23.205-.355.467-.373.778-.025.404-.044.809-.068 1.213v.05c-.006.224-.006.473-.006.66h7.2c.317-.188.64-.319.958-.456z"
					},
					children: [
					]
				},
				{
					id: "community",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.723 26.644c-.006-.118-.012-.236-.025-.361-.012-.18-.087-.336-.249-.492a3.733 3.733 0 0 0-.809-.585c-.697-.398-1.45-.716-2.159-.996a53.773 53.773 0 0 0-2.75-.977 7.626 7.626 0 0 1-.734-.292c-.436-.193-.697-.579-.709-1.045s-.012-.971-.006-1.593c.006-.342.124-.653.342-.902.479-.541.666-1.213.79-1.854.012-.075.031-.149.044-.23.031-.162.062-.324.1-.492.05-.199.106-.348.193-.467.162-.243.274-.523.38-.946.056-.218.1-.448.143-.703a.699.699 0 0 0-.037-.373c-.112-.33-.1-.647-.075-.89.05-.479.106-.989.143-1.506.025-.324-.037-.66-.193-1.058-.479-1.232-1.344-2.004-2.651-2.371-.286-.081-.585-.106-.921-.131-.025.006-.653 0-.653 0-.143 0-.479.012-.573.025-.971.124-1.736.46-2.346 1.027a3.646 3.646 0 0 0-1.139 2.091c-.037.224-.019.46.006.734.05.485.1.983.137 1.481a.969.969 0 0 1-.068.436c-.118.268-.124.56-.025.946l.031.118c.075.305.149.585.268.846l.006.019.031.068c.255.336.336.716.392 1.045.087.51.187.915.317 1.269.118.324.261.585.448.797.299.342.454.759.454 1.238v.168c0 .355 0 .722-.012 1.089-.01.187-.046.371-.106.548-.068.205-.249.492-.678.66-.386.156-.753.286-1.108.404-.927.305-2.141.728-3.31 1.245-.51.224-1.045.479-1.518.809-.143.1-.299.224-.467.373a.719.719 0 0 0-.249.516c-.012.218-.031.436-.056.647-.019.187-.037.38-.05.566-.006.05-.037.093-.037.137v.236h19.533v-.428c0-.1 0-.187-.006-.274a54.912 54.912 0 0 1-.039-.572z"
					},
					children: [
					]
				}
			]
		}
	]
};
var comments = {
	id: "comments",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "comments",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "comments",
					name: "",
					type: "text",
					value: "Comments icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "comments",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M481 36H32.2C14.8 36 0 49.6 0 67v290.9C0 375.3 14.8 390 32.2 390H91v82.5c0 1.9 1.8 3.5 3.8 3.5.8 0 1.7.1 2.3-.4.2-.1 93.7-85.6 93.7-85.6H481c17.4 0 31-14.7 31-32.1V67c0-17.4-13.6-31-31-31zM334 230h-58v57h-38v-57h-57v-36h57v-58h38v58h58v36z"
			},
			children: [
			]
		}
	]
};
var copyright = {
	id: "copyright",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "copyright",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "copyright",
					name: "",
					type: "text",
					value: "Copyright icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "copyright",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M256.327 512.634C115.05 512.636 0 397.59 0 256.31 0 114.737 115.084-.082 256.907 0c140.85.082 255.747 115.232 255.74 256.3-.008 141.28-115.054 256.333-256.32 256.334zM39.434 256.127c-.165 119.627 96.55 216.813 216.02 217.073 120.47.262 217.64-96.387 217.742-216.723.1-119.844-96.23-216.29-215.418-217.053C137.034 38.65 39.545 135.81 39.434 256.127z"
			},
			children: [
			]
		},
		{
			id: "copyright",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M258.594 118.178c50.404 2.54 89.456 24.658 116.398 67.674 2.292 3.66 4.24 7.426 4.343 11.864.21 8.995-6.436 17.148-15.896 19.538-8.673 2.19-16.607-1.273-21.18-9.324-7.284-12.828-16.863-23.61-28.937-32.074-20.595-14.436-43.495-20.354-68.453-17.404-41.85 4.947-75.338 34.275-84.397 75.317-8.46 38.33 2.247 71.37 31.812 97.423 20.322 17.91 44.643 25.545 71.623 23.29 33.417-2.793 58.954-18.976 76.802-47.275 3.32-5.262 7.17-9.678 13.558-10.8 8.327-1.46 15.22 1.436 20.362 7.987 4.904 6.246 5.328 13.24 1.58 20.15-6.956 12.82-16.128 23.954-26.915 33.735-17.51 15.88-37.692 26.957-60.765 32.17-43.703 9.872-83.51 1.075-118.596-26.817-26.912-21.395-43.635-49.42-49.434-83.326-7.147-41.787 2.945-79.455 29.923-112.19 20.748-25.177 47.51-40.783 79.487-47.288 9.416-1.916 18.975-2.746 28.684-2.652z"
			},
			children: [
			]
		}
	]
};
var discover = {
	id: "discover",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 576 512"
	},
	children: [
		{
			id: "discover",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "discover",
					name: "",
					type: "text",
					value: "Discover",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "discover",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16v-82zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428v-82zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2h17.5zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16v82zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160v145zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
			},
			children: [
			]
		}
	]
};
var desktop = {
	id: "desktop",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "desktop",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "desktop",
					name: "",
					type: "text",
					value: "Desktop icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "desktop",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M496.3 46.6H15.9C8.5 46.6 3 52.1 3 59.5V381c0 7.4 5.5 12.9 12.9 12.9h206.3l-9.2 41.3c-3.1 14.2-16 23.4-30.2 22.2h-.6c-1.8 0-3.7 1.8-3.7 3.7 0 1.8 1.2 3.1 2.5 3.1h149.1c1.2-.6 2.5-1.8 2.5-3.1 0-1.8-1.8-3.7-3.7-3.7h-.6c-14.2.6-27.1-8.6-30.2-22.2l-9.2-41.3h206.3c7.4 0 12.9-5.5 12.9-12.9V59.5c1.2-7.4-4.4-12.9-11.8-12.9zm-8 324.5H24.6V66.9H489v304.2h-.7z"
			},
			children: [
			]
		}
	]
};
var drag = {
	id: "drag",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 11 18"
	},
	children: [
		{
			id: "drag",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "drag",
					name: "",
					type: "text",
					value: "Drag icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "drag",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.4 15.75c0 1.238-.99 2.25-2.2 2.25C.99 18 0 16.988 0 15.75s.99-2.25 2.2-2.25c1.21 0 2.2 1.012 2.2 2.25zm-2.2-9C.99 6.75 0 7.762 0 9s.99 2.25 2.2 2.25c1.21 0 2.2-1.012 2.2-2.25s-.99-2.25-2.2-2.25zM2.2 0C.99 0 0 1.012 0 2.25S.99 4.5 2.2 4.5c1.21 0 2.2-1.012 2.2-2.25S3.41 0 2.2 0zm6.6 4.5c1.21 0 2.2-1.012 2.2-2.25S10.01 0 8.8 0C7.59 0 6.6 1.012 6.6 2.25S7.59 4.5 8.8 4.5zm0 2.25C7.59 6.75 6.6 7.762 6.6 9s.99 2.25 2.2 2.25c1.21 0 2.2-1.012 2.2-2.25s-.99-2.25-2.2-2.25zm0 6.75c-1.21 0-2.2 1.012-2.2 2.25S7.59 18 8.8 18c1.21 0 2.2-1.012 2.2-2.25s-.99-2.25-2.2-2.25z"
			},
			children: [
			]
		}
	]
};
var download = {
	id: "download",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 493.754 510.248"
	},
	children: [
		{
			id: "download",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "download",
					name: "",
					type: "text",
					value: "Download icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "download",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M290.742 0c4.77 2.22 5.615 6.206 5.606 11.056-.098 53.14-.06 106.278-.06 159.417v6.93h5.817c13.95 0 27.898-.006 41.847.008 1.825.003 3.66 0 5.472.183 8.43.854 10.36 4.748 5.193 11.457-30.79 39.978-61.556 79.976-92.676 119.696-10.13 12.93-15.05 12.475-25.574-.228-31.883-38.48-63.837-76.903-95.61-115.474-2.045-2.484-2.782-6.047-4.13-9.107 3.158-.967 6.3-2.71 9.476-2.77 15.604-.29 31.217-.132 46.826-.133h5.88c.095-2.122.24-3.873.24-5.625.01-54.967.08-109.932-.11-164.897-.017-5.15 1.33-8.586 6.098-10.513h85.706zM.29 325.35h68.037v115.865H425.15V325.433h68.6v5.544c0 47.004.016 94.007-.008 141.01-.013 24.29-14.05 38.256-38.384 38.257-139.35.004-278.7.007-418.05-.004-18.443-.002-31.315-9.11-35.842-25.567C.51 481.2.072 477.478.066 473.87c-.09-48.333-.06-96.665-.05-144.998-.003-.976.146-1.952.274-3.52z"
			},
			children: [
			]
		}
	]
};
var elevators = {
	id: "elevators",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 85.378 103.229"
	},
	children: [
		{
			id: "elevators",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "elevators",
					name: "",
					type: "text",
					value: "Elevators icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "elevators",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M59.327 28.83c.023 0 .04 0 .056-.007.017 0 .04 0 .056-.006.022 0 .044-.006.067-.006.017 0 .028-.005.045-.005.023-.006.045-.006.073-.01.01 0 .023-.007.04-.007.022-.006.05-.01.072-.017.01 0 .023-.005.034-.005.024-.006.046-.01.07-.017.01-.006.027-.006.038-.01.023-.007.045-.012.062-.024l.045-.017c.017-.006.04-.01.056-.023.018-.006.035-.01.052-.017.017-.006.034-.01.05-.023.018-.006.035-.017.057-.023.01-.005.027-.01.038-.022.023-.01.04-.023.056-.028.01-.006.023-.01.034-.017.023-.01.04-.023.062-.034.01-.007.023-.012.034-.024.023-.01.04-.028.062-.04.01-.005.023-.016.028-.022.023-.01.04-.028.056-.04.01-.01.023-.016.034-.027.017-.01.034-.028.05-.04.018-.01.03-.022.046-.038.01-.012.028-.024.04-.035.027-.023.055-.05.078-.08l9.55-9.554c.884-.884.884-2.316 0-3.2-.886-.886-2.318-.886-3.203 0l-5.682 5.68V2.267C61.486 1.016 60.47 0 59.22 0c-1.25 0-2.266 1.015-2.266 2.266V21.1l-5.682-5.682c-.885-.885-2.317-.885-3.202 0-.885.885-.885 2.317 0 3.202l9.55 9.544.078.08c.01.01.028.022.04.033.016.01.027.028.044.04.017.016.034.027.05.038.012.01.024.017.035.028.017.017.04.028.056.04.01.005.023.016.028.022.024.01.04.028.063.04l.034.016c.023.012.04.024.062.035.01.006.022.01.033.017.006.006.01.006.017.01.01.007.028.012.045.024.01.006.028.01.04.023.016.01.033.016.055.022.017.006.034.017.05.023.018.006.035.01.052.017l.056.023.045.017c.023.006.04.01.062.023.006 0 .006 0 .01.006.012 0 .018.007.03.007.022.006.044.01.067.017.01.006.023.006.034.006l.073.017h.005c.01 0 .023.006.028.006.023.006.045.01.073.01.017 0 .028.007.045.007.024 0 .046.006.07.006.016 0 .038.006.055.006s.034.006.05.006h.221M25.386.046c-.085.006-.096.01-.113.01-.023.007-.045.007-.073.013-.062.01-.09.016-.113.022-.056.01-.08.017-.1.023-.063.017-.086.023-.102.034-.063.02-.085.026-.102.037-.068.023-.085.028-.1.04-.07.027-.086.033-.097.044l-.09.046c-.073.04-.085.045-.096.056-.073.045-.085.056-.09.062-.068.05-.08.056-.09.068-.068.05-.08.062-.096.08-.068.055-.096.084-.118.112l-9.55 9.555c-.884.884-.884 2.316 0 3.2.886.886 2.318.886 3.203 0l5.68-5.68v18.827c0 1.25 1.016 2.266 2.267 2.266 1.25 0 2.266-1.015 2.266-2.266V7.764l5.682 5.682c.885.885 2.317.885 3.202 0 .885-.885.885-2.317 0-3.202L27.207.7l-.08-.08c-.055-.044-.067-.06-.084-.072-.062-.05-.073-.056-.085-.068-.068-.045-.08-.056-.085-.062-.073-.045-.085-.05-.096-.056-.073-.04-.085-.045-.096-.05-.072-.04-.09-.046-.1-.057-.073-.028-.09-.04-.107-.045-.068-.023-.09-.034-.107-.04-.068-.022-.085-.027-.107-.038L26.15.104c-.056-.01-.08-.017-.107-.023-.056-.01-.08-.016-.107-.016-.068-.006-.09-.01-.113-.01-.073-.007-.09-.012-.107-.012h-.113c-.034-.006-.068-.006-.107-.006-.073.005-.095.005-.112.01zM61.806 80.755C53.93 66.74 54.643 66.92 52.38 66.92H41.183l-.165-3.375h8.304c1.084 0 1.964-.877 1.964-1.96 0-1.08-.88-1.958-1.964-1.958h-8.497l-.176-3.592c0-2.253-1.832-4.082-4.09-4.082s-4.09 1.83-4.09 4.082l.654 13.39c0 2.252 1.833 4.08 4.09 4.08h14.728l5.63 9.684c.39.837 1.238 1.42 2.224 1.42 1.355 0 2.454-1.097 2.454-2.45 0-.343-.347-1.267-.444-1.405",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "elevators",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M85.378 103.23H0V31.62h85.378v71.61zM7 96.23h71.378V38.62H7v57.61z",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "elevators",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M40.325 46.564c0 2.253-1.833 4.082-4.09 4.082s-4.092-1.83-4.092-4.082c0-2.253 1.833-4.082 4.09-4.082s4.092 1.83 4.092 4.082M52.018 78.154C50.835 84.15 45.532 88.69 39.18 88.69c-7.218 0-13.09-5.86-13.09-13.062 0-3.767 1.608-7.164 4.173-9.55v-4.13c-4.478 2.918-7.445 7.958-7.445 13.68 0 9.004 7.34 16.33 16.363 16.33 6.754 0 12.56-4.106 15.055-9.945l-2.217-3.86z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
};
var email = {
	id: "email",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "email",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "email",
					name: "",
					type: "text",
					value: "Email icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "email",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.5 85.8c-7.9 0-14.4 6.5-14.4 14.4v313.3c0 7.9 6.5 14.4 14.4 14.4h477.8c7.9 0 14.4-6.5 14.4-14.4V100.2c0-7.9-6.5-14.4-14.4-14.4H17.5zm429.9 20.1c7.9 0 9.8 4.6 4.2 10.2L267.5 300.5c-5.6 5.6-14.8 5.6-20.4 0L61.8 116.1c-5.6-5.6-3.7-10.2 4.2-10.2h381.4zm-424 14.3c0-7.9 4.6-9.8 10.2-4.2l129.2 129.7c5.6 5.6 5.6 14.8.1 20.5L33.5 397.4c-5.6 5.6-10.1 3.8-10.1-4.1V120.2zM66 408.1c-7.9 0-9.8-4.6-4.2-10.2l116.7-117.1c5.6-5.6 14.7-5.6 20.3.1l48.4 49c5.6 5.6 14.7 5.7 20.3 0l48.8-49.1c5.6-5.6 14.7-5.6 20.3 0l115.2 117c5.6 5.6 3.6 10.3-4.3 10.3H66zm423.8-14.5c0 7.9-4.5 9.8-10.1 4.1L350.3 266.4c-5.6-5.6-5.5-14.9.1-20.5l129.2-129.7c5.6-5.6 10.2-3.7 10.2 4.2v273.2z"
			},
			children: [
			]
		},
		{
			id: "email",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M494.9 430.5H18c-9.6 0-17.4-7.8-17.4-17.4V100.6C.5 91 8.4 83.2 18 83.2h476.9c9.6 0 17.4 7.8 17.4 17.4V413c0 9.7-7.8 17.5-17.4 17.5zM18 88.4c-6.8 0-12.3 5.5-12.3 12.3v312.4c0 6.8 5.5 12.3 12.3 12.3h476.9c6.8 0 12.3-5.5 12.3-12.3V100.6c0-6.8-5.5-12.3-12.3-12.3H18zm428.9 322.2H66.5c-6.8 0-9.1-2.9-9.8-4.7-.7-1.7-1.2-5.4 3.6-10.2l116.1-116.5c3.3-3.3 7.6-5.1 12.2-5.1 4.7 0 9 1.8 12.3 5.1l47.8 48.4c2.3 2.3 5.3 3.6 8.6 3.6s6.3-1.3 8.6-3.6l48.1-48.5c3.3-3.3 7.6-5.1 12.2-5.1s9 1.8 12.3 5.1l114.6 116.4c4.8 4.9 4.3 8.5 3.5 10.3-.6 1.9-2.9 4.8-9.7 4.8zM188.7 279.3c-3.3 0-6.3 1.3-8.6 3.6L63.9 399.4c-2.5 2.5-2.7 4.1-2.5 4.6.2.6 1.5 1.5 5 1.5h380.4c3 0 4.7-.8 5-1.5.3-.8-.3-2.5-2.5-4.7L334.9 282.9c-2.3-2.3-5.3-3.6-8.6-3.6-3.2 0-6.3 1.3-8.6 3.6l-48.1 48.5c-3.3 3.3-7.6 5.1-12.2 5.1s-9-1.8-12.3-5.1L197.3 283c-2.3-2.4-5.3-3.7-8.6-3.7zm296.7 124c-2 0-4.6-.9-7.9-4.1L348.8 268.5c-6.7-6.8-6.7-17.9.1-24.7l128.6-129.1c4.8-4.8 8.5-4.4 10.2-3.6 1.7.7 4.7 2.9 4.7 9.8v272.2c0 6.8-2.9 9-4.7 9.8-.6.2-1.4.4-2.3.4zm-.1-287.5c-.8 0-2.2.5-4.2 2.6L352.5 247.5c-4.8 4.8-4.8 12.6 0 17.5l128.7 130.7c2.1 2.2 3.8 2.8 4.5 2.5.7-.3 1.5-2 1.5-5V120.9c0-3.5-.9-4.8-1.5-5-.1-.1-.2-.1-.4-.1zM27.8 403.1c-1 0-1.7-.2-2.3-.4-1.7-.7-4.7-2.9-4.7-9.8V120.6c0-6.8 2.9-9.1 4.7-9.8 1.7-.7 5.4-1.2 10.2 3.6l128.6 129.1c6.8 6.8 6.8 17.9.1 24.7L35.6 398.9c-3.2 3.3-5.9 4.2-7.8 4.2zm0-287.5c-.1 0-.3 0-.4.1-.7.3-1.5 2-1.5 5v272.2c0 3 .8 4.7 1.5 5 .7.3 2.4-.4 4.5-2.5l128.7-130.7c4.8-4.8 4.7-12.7 0-17.5L32 118.1c-1.8-1.8-3.3-2.5-4.2-2.5zm229.5 191.5c-4.5 0-8.9-1.7-12.3-5.1L60.3 118.2c-4.8-4.8-4.4-8.5-3.6-10.2.7-1.7 2.9-4.7 9.8-4.7H447c6.8 0 9.1 2.9 9.8 4.7.7 1.7 1.2 5.4-3.6 10.2L269.7 302c-3.4 3.4-7.9 5.1-12.4 5.1zM66.4 108.5c-3 0-4.7.8-5 1.5s.4 2.5 2.5 4.6l184.7 183.8c4.8 4.8 12.6 4.8 17.4 0l183.4-183.8c2.5-2.5 2.7-4.1 2.5-4.6-.2-.6-1.5-1.5-5-1.5H66.4z"
			},
			children: [
			]
		}
	]
};
var exclaimation = {
	id: "exclaimation",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "exclaimation",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exclaimation",
					name: "",
					type: "text",
					value: "Exclamation icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "exclaimation",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.0008 15.1998c-.6165 0-1.1327-.4671-1.1941-1.0806l-.99996-9.99999a1.20016 1.20016 0 0 1 .30426-.92461 1.20019 1.20019 0 0 1 .8898-.3948h2c.339 0 .6622.14342.8897.3948.2275.25138.3381.58726.3043.92461l-1 9.99999c-.0613.6135-.5775 1.0806-1.194 1.0806Zm0-1.2 1-10h-2l1 10ZM12.0008 18.9998c-.3314 0-.6-.2686-.6-.6s.2686-.6.6-.6.6.2686.6.6-.2686.6-.6.6Zm1.8-.6c0-.9941-.8059-1.8-1.8-1.8-.9941 0-1.8.8059-1.8 1.8 0 .9941.8059 1.8 1.8 1.8.9941 0 1.8-.8059 1.8-1.8Z",
				fill: "#000"
			},
			children: [
			]
		}
	]
};
var es = {
	id: "es",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "es",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "es",
					name: "",
					type: "text",
					value: "ES icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "es",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M7.571 24.905c-.761 0-1.42.011-2.08-.002-2.4-.049-3.73-1.411-3.731-3.813-.001-5.223-.002-10.446.001-15.668.001-2.232 1.397-3.655 3.63-3.658 7.168-.01 14.336-.009 21.504-.001 2.276.003 3.663 1.419 3.664 3.707.002 5.223.002 10.445 0 15.668-.001 2.374-1.359 3.747-3.781 3.762-3.277.021-6.555-.01-9.832.025a2.374 2.374 0 0 0-1.298.43c-2.126 1.56-4.202 3.187-6.331 4.743-.338.247-.921.436-1.265.31-.263-.097-.445-.729-.461-1.131-.054-1.408-.02-2.819-.02-4.372zm8.011-8.666h-5.116v-2.4h4.442v-1.665h-4.434v-1.946h4.822V8.652H8.552v9.203h7.031l-.001-1.616zm8.48-4.927c-.023-1.161-.499-1.973-1.442-2.478-1.323-.709-2.713-.727-4.094-.208-1.188.447-1.793 1.466-1.74 2.766.048 1.173.591 1.835 1.916 2.228.968.287 1.958.495 2.93.767.477.134.922.364.892.967-.031.628-.459.93-1.012 1.082-1.493.409-2.401-.001-3.082-1.362h-1.753c.036 1.308.65 2.169 1.779 2.657 1.14.492 2.341.518 3.529.257 1.534-.336 2.393-1.383 2.383-2.776-.011-1.431-.679-2.17-2.329-2.581-.877-.218-1.775-.383-2.62-.69-.326-.118-.757-.579-.739-.857.023-.351.386-.822.726-.984 1.201-.574 2.323-.075 2.97 1.211l1.686.001z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var explosion = {
	id: "explosion",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "explosion",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "explosion",
					name: "",
					type: "text",
					value: "Explosion icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "explosion",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.0376 3.37018L9.77425 6.26731C9.71267 6.9447 8.97999 7.33979 8.38019 7.01905L5.2999 5.37195L7.41359 8.52049C7.83728 9.15161 7.38499 9.99999 6.62485 9.99999H3.91992L6.11721 11.2085C6.68687 11.5218 6.78057 12.3019 6.30133 12.7412L4.2576 14.6146L8.63085 14.0419C9.26916 13.9583 9.80403 14.5204 9.68887 15.1538L9.25697 17.5293L10.2182 16.3545C10.6612 15.813 11.5178 15.9199 11.8141 16.5537L13.6377 20.4542L14.2183 16.729C14.3153 16.1066 14.9801 15.7492 15.5527 16.0116L18.7089 17.4582L16.6245 14.5921C16.1678 13.9642 16.6163 13.0833 17.3928 13.0833H20.0801L17.8828 11.8748C17.3131 11.5615 17.2194 10.7814 17.6987 10.3421L19.6749 8.53059L16.3831 9.0335C15.7483 9.13049 15.2021 8.58268 15.301 7.94811L15.9295 3.91542L13.1881 6.42836C12.7439 6.83549 12.0378 6.73164 11.7297 6.21385L10.0376 3.37018ZM8.69727 1.54603C8.78063 0.629101 9.98895 0.35501 10.4598 1.14625L12.673 4.86567L16.0726 1.74937C16.7347 1.1424 17.7915 1.70841 17.6532 2.59595L16.8987 7.43732L21.2365 6.7746C22.1645 6.63282 22.7139 7.77965 22.0219 8.414L19.2773 10.9299L22.6792 12.8009C23.54 13.2744 23.2038 14.5833 22.2214 14.5833H18.4728L21.1573 18.2745C21.7324 19.0652 20.882 20.1043 19.9932 19.6969L15.5884 17.6781L14.8421 22.4674C14.6976 23.3942 13.4401 23.5732 13.0428 22.7235L10.8255 17.981L9.07045 20.1261C8.4493 20.8852 7.22505 20.3196 7.40052 19.3545L8.07823 15.6271L2.72538 16.3281C1.8049 16.4486 1.27577 15.3131 1.96009 14.6858L4.7227 12.1534L1.32082 10.2824C0.459994 9.80894 0.796222 8.49999 1.77865 8.49999H5.59317L2.82456 4.37591C2.27292 3.55421 3.1885 2.54196 4.06127 3.00865L8.35555 5.3049L8.69727 1.54603Z"
			},
			children: [
			]
		}
	]
};
var embed = {
	id: "embed",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "embed",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "embed",
					name: "",
					type: "text",
					value: "Embed icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "embed",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M504.9 247.2L380.2 122.5c-9.2-9.2-24-9.2-33.1 0s-9.2 24 0 33.1l108.1 108.1-109.6 109.7c-9.2 9.2-9.2 24 0 33.1 9.2 9.2 24 9.2 33.1 0l124.7-124.7c.3-.3.5-.5.7-.8.3-.2.5-.5.8-.7 9.2-9.1 9.2-23.9 0-33.1zM56.6 263.8l108.1-108.1c9.2-9.2 9.2-24 0-33.1s-24-9.2-33.1 0L6.9 247.2c-9.2 9.2-9.2 24 0 33.1.3.3.5.5.8.7.2.3.5.5.7.8l124.7 124.7c9.2 9.2 24 9.2 33.1 0 9.2-9.2 9.2-24 0-33.1L56.6 263.8zM292.6 78.3c-12.5-2.5-24.8 5.6-27.3 18.1l-62 308c-2.5 12.5 5.6 24.8 18.1 27.3 12.5 2.5 24.8-5.6 27.3-18.1l62-308c2.5-12.6-5.6-24.8-18.1-27.3z"
			},
			children: [
			]
		}
	]
};
var family = {
	id: "family",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 320.863 511.823"
	},
	children: [
		{
			id: "family",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "family",
					name: "",
					type: "text",
					value: "Family icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "family",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 339c2.425-11.74 3.823-23.813 7.49-35.153 7.467-23.086 21.2-41.285 44.8-50.29 12-4.577 22.968-3.045 33.33 4.998 8.693 6.746 17.91 12.844 27.127 18.873 3.424 2.24 7.51 3.468 11.087 5.066 0-17.385-.65-34.198.138-50.944 1.546-32.78 10.25-63.363 31.606-89.125 15.944-19.233 35.984-32.342 61.364-34.3 27.894-2.15 49.934 10.696 68.62 30.23 17.28 18.066 25.363 40.373 30.037 64.435 5.36 27.607 6.612 55.307 3.82 83.25-1.063 10.623-7.468 17.15-16.7 16.76-8.907-.376-14.85-7.318-14.805-17.743.108-24.33-.322-48.615-7.424-72.167-2.11-7.005-5.086-13.75-9-20.176 3.275 27.002 6.227 54.05 9.943 80.99 2.344 16.997 1.484 33.13-7.35 48.335-1.31 2.254-1.433 5.37-1.56 8.114-2.517 53.942-4.943 107.887-7.41 161.83-.73 15.993-14.66 24.652-27.412 17.044-5.81-3.468-8.6-8.732-8.91-15.436-1.592-34.49-3.203-68.98-4.824-103.47-.158-3.358-.43-6.71-1.758-10.072-.53 10.6-1.1 21.2-1.583 31.803-1.22 26.872-2.37 53.748-3.61 80.62-.533 11.523-7.76 19.117-18.108 19.232-10.12.112-17.672-7.718-18.222-19.2-2.48-51.73-4.91-103.465-7.32-155.2-.336-7.22-1.016-14.09-4.75-20.76-8.443-15.08-6.343-31.398-4.287-47.634 3.224-25.455 6.23-50.938 9.33-76.41l-1.504-.534c-2.4 6.073-5.126 12.04-7.138 18.237-7.858 24.21-8.865 49.223-8.355 74.404.19 9.377-3.277 15.334-10.82 17.33-12.884 3.412-25.91 5.267-38.88.015-2.197-.89-4.525-1.456-7.47-2.385 0 1.974-.068 3.466.01 4.95.94 17.64 2.33 35.272 2.64 52.922.125 7.02-2.103 14.09-3.306 21.128-.335 1.958-1.12 3.874-1.217 5.833-1.694 34.286-3.31 68.575-4.956 102.862-.095 2.003-.145 4.022-.446 6-1.11 7.292-5.933 11.59-12.474 11.24-6.164-.33-10.642-5.034-11.085-12.08-.845-13.424-1.547-26.856-2.24-40.287-.633-12.227-1.175-24.458-2.48-36.792-.354 3.304-.875 6.6-1.035 9.914-.978 20.25-1.864 40.507-2.81 60.76-.123 2.605-.29 5.22-.67 7.797-.96 6.52-5.702 10.835-11.68 10.8-6.148-.038-11.16-4.81-11.62-11.532-.846-12.416-1.51-24.845-2.167-37.274-1.27-24.055-2.48-48.113-3.715-72.17-.03-.602.115-1.27-.095-1.796-7.244-18.18-2.466-36.875-2.396-55.366.003-.79-.082-1.58-1.475-2.618-1.464 7.498-2.99 14.985-4.36 22.5-.576 3.152-.93 6.356-1.192 9.552-.46 5.62-1.45 11.023-7.643 13.07-5.944 1.963-9.63-1.886-13.08-5.886C0 355.064 0 347.032 0 339zM274.825 52.824c-.157 28.648-24.147 52.05-53.025 51.727-28.36-.317-51.943-24.338-51.68-52.64.27-28.934 23.855-52.08 52.893-51.91 28.947.17 51.972 23.645 51.812 52.824z"
			},
			children: [
			]
		},
		{
			id: "family",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M98.144 212.21c-.423 19.152-15.922 34.123-34.976 33.785-17.97-.32-33.304-16.428-32.954-34.618.366-19.014 16.3-34.352 35.045-33.73 18.468.61 33.29 16.19 32.884 34.563z"
			},
			children: [
			]
		}
	]
};
var fans = {
	id: "fans",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "fans",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "fans",
					name: "",
					type: "text",
					value: "Fans Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "fans",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#444"
			},
			children: [
				{
					id: "fans",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M11.585 14.076c.009.036.025.069.032.106l.546 2.785c.089.312.284.584.569.77.31.202.676.277 1.034.216a2.166 2.166 0 0 1-.123-.178c-.294-.44-.527-1.045-.372-1.773.223-1.048.804-1.598 1.219-1.867l-.362-1.846a1.363 1.363 0 0 0-.551-.71 1.436 1.436 0 0 0-1.977.387 1.35 1.35 0 0 0-.226 1.037l.211 1.073zM8.5 18.8c.144.737.908 1.234 1.668 1.085s1.279-.898 1.135-1.635l-.21-1.071c-.009-.036-.025-.069-.032-.106l-.546-2.785a1.358 1.358 0 0 0-.569-.77 1.436 1.436 0 0 0-1.977.387 1.35 1.35 0 0 0-.226 1.037L8.5 18.8zm11.102-3.653l2.773 1.164V4.809c0-.754-.603-1.415-1.391-1.415-.774 0-1.408.661-1.408 1.415 0 .07.017 7.313.083 9.836.003.15-.035.335-.057.502zM15.2 12.083c.015.055.038.105.049.162l.295 1.572c.395-.017.79.041 1.164.171.484.168 1.317.499 1.899.734a.734.734 0 0 0-.007-.148l-.757-3.858c-.144-.737-.907-1.233-1.669-1.085-.37.073-.696.287-.909.598a1.35 1.35 0 0 0-.226 1.037l.161.817z"
					},
					children: [
					]
				},
				{
					id: "fans",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22.834 17.632l-.006-.004-.006-.001-6.477-2.612a1.994 1.994 0 0 0-.411-.095c-.035-.003-.069-.008-.104-.008l-.045-.003a1.4 1.4 0 0 0-.541.123c-.36.162-.642.458-.787.825-.143.354-.142.765.002 1.129.021.053.05.099.076.148.176.278.397.465.466.518.068.043.138.083.213.113l2.5 1.082.002.089h.002l3.523 1.347c.279.113.413.388.3.667a.527.527 0 0 1-.691.276l-.019-.009-3.522-1.439-2.499-.998c-.028-.011-.052-.031-.08-.044-.206.107-.487.236-.718.281-.55.107-1.12.027-1.619-.227a2.51 2.51 0 0 1-2.501 2.211c-.487 0-.994-.141-1.413-.414-.343-.223-.829-.522-.829-.862v8.891l14.727.002v-6.626c0-.104.069-.212.119-.295.035-.148.225-.265.37-.342.66-.351 1.194-1.123 1.295-1.922.042-.33.053-.947-.416-1.377-.093-.074-.514-.274-.911-.424z"
					},
					children: [
					]
				},
				{
					id: "fans",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25.648 15.633V4.409C25.648 1.813 23.873 0 21.342 0c-3.459 0-4.695 2.129-4.695 4.113l-.036 2.575a2.612 2.612 0 0 0-1.894.032c-1.066.429-1.512.998-1.687 1.476-.6-.163-1.514-.234-2.613.255-1.002.445-1.419 1.307-1.591 1.902-.52-.088-1.296-.124-2.033.207-1.574.708-2.34 1.925-2.34 3.73l.044 2.579.12 14.174c.001.537.517.957 1.066.957l19-.065c.547 0 .978-.411.978-.935l.012-7.839c.646-.361 1.872-1.374 1.872-3.887.001-2.303-1.352-3.286-1.897-3.641zm-2.182 6.548v6.651c0 .5-.264 1.013-.847 1.013H7.58c-.559 0-1.023-.505-1.023-1.013V14.423c0-.09.056-.171.095-.246a2.54 2.54 0 0 1 2.002-1.94 2.528 2.528 0 0 1 1.626.234c.046-.397.183-.782.421-1.125a2.528 2.528 0 0 1 1.597-1.046 2.534 2.534 0 0 1 1.672.255 2.528 2.528 0 0 1 4.594-.901c-.023-2.475-.035-4.801-.035-4.843 0-1.361 1.077-2.509 2.455-2.509 1.393 0 2.482 1.147 2.482 2.506v11.973c.545.134.718.31.894.471.616.565.934 1.388.816 2.319-.135 1.062-.619 2.055-1.71 2.61zm-5.778-14.57l.046-3.49c0-1.954 1.285-3.03 3.607-3.03-2.322 0-3.604 1.076-3.604 3.03l-.049 3.49c.001 0 0 0 0 0zm-3.89 1.804a.563.563 0 0 0 .224-.581c-.049-.225.128-.71 1.102-1.102h.001c-.974.392-1.151.877-1.102 1.102a.565.565 0 0 1-.225.581z"
					},
					children: [
					]
				}
			]
		}
	]
};
var fantasy = {
	id: "fantasy",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "fantasy",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "fantasy",
					name: "",
					type: "text",
					value: "Fantasy Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "fantasy",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21.932 12.365h1.672a.186.186 0 0 0 .186-.186v-1.677a.186.186 0 0 0-.186-.186h-1.672a.186.186 0 0 0-.186.186v1.677c0 .103.083.186.186.186zm3.06 2.857h1.672a.186.186 0 0 0 .186-.186v-1.677a.186.186 0 0 0-.186-.186h-1.672a.186.186 0 0 0-.186.186v1.677c0 .103.083.186.186.186zm-6.121 0h1.672a.186.186 0 0 0 .186-.186v-1.677a.186.186 0 0 0-.186-.186h-1.672a.186.186 0 0 0-.186.186v1.677c0 .103.083.186.186.186zM9.53 18.358a4.154 4.154 0 0 0 4.148-4.16v-.001a4.154 4.154 0 0 0-4.147-4.161H9.53a4.154 4.154 0 0 0-4.148 4.16v.001a4.154 4.154 0 0 0 4.147 4.161h.001zm0-6.651h.002a2.486 2.486 0 0 1 2.481 2.491 2.487 2.487 0 0 1-2.483 2.49 2.487 2.487 0 0 1-2.483-2.49 2.486 2.486 0 0 1 2.481-2.491h.002zm12.402 6.371h1.672a.186.186 0 0 0 .186-.186v-1.677a.186.186 0 0 0-.186-.186h-1.672a.186.186 0 0 0-.186.186v1.677c0 .103.083.186.186.186z",
				fill: "none"
			},
			children: [
			]
		},
		{
			id: "fantasy",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.53 16.688a2.487 2.487 0 0 0 2.483-2.49 2.486 2.486 0 0 0-2.481-2.491H9.53a2.486 2.486 0 0 0-2.483 2.489v.002a2.487 2.487 0 0 0 2.483 2.49z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "fantasy",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.25 26.742c3.467-.962 5.603-6.924 9.719-6.924 3.653 0 6.542 5.773 9.41 6.924 1.238.497 3.378.042 4.333-.931 1.843-1.878 1.393-6.009.589-9.596-.591-2.635-2.341-7.21-3.064-9.222-.544-1.513-1.548-2.205-3.504-1.543-3.469 1.172-2.78 2.289-7.763 2.289-4.457 0-6.056-1.643-7.819-2.4-1.264-.543-2.55-.425-3.324 1.438C4.049 8.646 1.448 15.04 1.111 19.6c-.128 1.739-.398 4.387.96 6.055 1.238 1.521 3.139 1.375 4.179 1.087zm18.556-13.383c0-.103.083-.186.186-.186h1.672c.103 0 .186.083.186.186v1.677a.186.186 0 0 1-.186.186h-1.672a.186.186 0 0 1-.186-.186v-1.677zm-3.06-2.857c0-.103.083-.186.186-.186h1.672c.103 0 .186.083.186.186v1.677a.186.186 0 0 1-.186.186h-1.672a.186.186 0 0 1-.186-.186v-1.677zm0 7.39v-1.677c0-.103.083-.186.186-.186h1.672c.103 0 .186.083.186.186v1.677a.186.186 0 0 1-.186.186h-1.672a.186.186 0 0 1-.186-.186zm-3.061-4.533c0-.103.083-.186.186-.186h1.672c.103 0 .186.083.186.186v1.677a.186.186 0 0 1-.186.186h-1.672a.186.186 0 0 1-.186-.186v-1.677zM9.53 10.036a4.154 4.154 0 0 1 4.148 4.16v.001a4.154 4.154 0 0 1-4.147 4.161H9.53a4.154 4.154 0 0 1-4.148-4.16v-.001a4.154 4.154 0 0 1 4.148-4.161z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var fantasy2 = {
	id: "fantasy2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "fantasy2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "fantasy2",
					name: "",
					type: "text",
					value: "Fantasy icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "fantasy2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.406 28.972c-.337-.344-.808-.434-1.202-.268-6.266-6.343-8.24-8.39-8.792-8.99-.565-.613-1.686-1.973-2.92-3.489 1.205-1.025 2.258-1.928 2.841-2.461 1.674-1.531 4.425-4.161 4.461-4.195l5.233-5.349c1.061-1.084.661-2.111.288-2.516L29.94.359a1.607 1.607 0 0 0-.743-.335c-.42-.073-1.065-.013-1.753.691l-5.242 5.357c-.025.028-2.594 2.835-4.089 4.543-.47.536-1.235 1.465-2.114 2.544a109.564 109.564 0 0 0-2.114-2.544C12.391 8.908 9.821 6.1 9.796 6.072L4.556.714C3.868.011 3.223-.049 2.803.024a1.607 1.607 0 0 0-.743.335L.684 1.705c-.373.404-.773 1.431.288 2.516L6.205 9.57c.036.034 2.786 2.664 4.461 4.195.583.532 1.636 1.435 2.841 2.461-1.235 1.516-2.356 2.876-2.92 3.489-.552.599-2.525 2.646-8.792 8.99-.394-.166-.865-.076-1.202.268-.2.204-.307.473-.304.758.003.285.118.551.322.751l1.24 1.214c.155.152.35.252.564.289h.001c.346.06.699-.054.974-.335a1.07 1.07 0 0 0 .213-1.177c1.176-1.214 7.483-7.725 8.796-8.986.624-.601 2.043-1.82 3.6-3.145 1.557 1.325 2.977 2.544 3.6 3.145 1.312 1.261 7.62 7.772 8.796 8.986-.17.389-.098.859.213 1.177.275.281.628.395.974.335h.001a1.07 1.07 0 0 0 .564-.289l1.24-1.214c.204-.2.319-.466.322-.751a1.05 1.05 0 0 0-.303-.759z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var favorite = {
	id: "favorite",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 95.04 95.04"
	},
	children: [
		{
			id: "favorite",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M50.37 4.874l11.92 24.152a3.174 3.174 0 0 0 2.392 1.738l26.653 3.873c2.606.379 3.647 3.582 1.761 5.42l-19.287 18.8a3.176 3.176 0 0 0-.914 2.812l4.553 26.546c.445 2.596-2.279 4.575-4.61 3.35l-23.84-12.533a3.175 3.175 0 0 0-2.957 0L22.202 91.565c-2.331 1.226-5.056-.754-4.61-3.35l4.553-26.546a3.176 3.176 0 0 0-.914-2.812l-19.287-18.8c-1.886-1.838-.845-5.041 1.761-5.42l26.653-3.873c1.035-.15 1.93-.8 2.392-1.738L44.67 4.874c1.167-2.362 4.535-2.362 5.7 0z",
				fill: "#333"
			},
			children: [
			]
		}
	]
};
var fx = {
	id: "fx",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "fx",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "fx",
					name: "",
					type: "text",
					value: "FX icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "fx",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M126.4 290.7v157.9h253.5v111.9H126.4v260.7H1V178.8h423.1v111.9H126.4zM854.5 821.2L730 597.4 606.4 821.2H462.9l199.4-329.3-186.7-313.1h142.5L730 386.3l112.8-207.5h141.6L797.7 491.9 998 821.2H854.5z"
			},
			children: [
			]
		}
	]
};
var gameday = {
	id: "gameday",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "gameday",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gameday",
					name: "",
					type: "text",
					value: "Gameday icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gameday",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M219.5 580c.3-.3.4-.7.6-1l237-237c23.2-23.2 61-23.2 84.2 0l237 237c1 1 1.3 2.4 2.3 3.4l38.1 38.1 179.9-179.9c-53.8-148-171.3-266.2-320-319.3-55.8-20.6-116.2-31.9-179.3-31.9-62.4 0-122.8 10.6-178.6 30.5C171.3 174.5 53.7 291.3 0 440.7l179.2 179.6 40.3-40.3z"
			},
			children: [
			]
		},
		{
			id: "gameday",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M743.1 693.7l-29.6-29.6c-.8-.9-1-2-1.9-2.8l-180-180.1c-17.7-17.7-46.4-17.7-64.1 0l-66.3 66.3-.3-.3-145.4 145.7 31.7 31.7c.2.2.2.4.4.6l180.1 180.1c17.6 17.6 46.4 17.6 64.1 0l180-180.1c.1-.1.1-.2.2-.3l31.1-31.2z"
			},
			children: [
			]
		}
	]
};
var gift = {
	id: "gift",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 480.008 512"
	},
	children: [
		{
			id: "gift",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gift",
					name: "",
					type: "text",
					value: "Gift icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gift",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M374.403 0c.79.333 1.55.845 2.372.974 37.664 5.92 57.63 51.744 37.686 84.895-7.994 13.287-19.125 23.27-31.998 31.497-18.79 12.007-39.41 19.523-61.032 24.518-1.68.388-3.35.823-4.965 2.11h7.084c45.86 0 91.722-.006 137.583.005 12.823.003 18.853 6.077 18.86 18.98.013 25.065.03 50.13-.01 75.192-.017 10.924-6.383 17.773-16.844 17.783-62.572.062-125.142.03-187.713.023-.872 0-1.744-.11-3.268-.214V144.302h-64.01V255.99h-6.34c-60.793 0-121.586.004-182.38-.003-13.553-.002-19.416-5.9-19.42-19.514-.008-24.708-.02-49.417.006-74.125.013-12.128 6.248-18.34 18.423-18.344 45.683-.018 91.366-.008 137.05-.008h7.982c.06-.283.118-.566.177-.85-3.08-.757-6.162-1.498-9.234-2.277-26.3-6.672-51.06-16.624-71.775-34.727-14.413-12.596-24.462-27.746-24.963-47.65-.716-28.496 17.66-51.522 45.576-57.49.817-.175 1.568-.66 2.35-1.003h18.132c6.144 1.622 12.44 2.815 18.408 4.935 40.476 14.373 70.665 41.39 93.826 76.93 1.22 1.874 2.388 3.783 3.97 6.295 2.594-4.057 4.648-7.525 6.944-10.824 23.878-34.31 54.085-60.537 94.508-73.574 4.858-1.567 9.913-2.522 14.876-3.76C362.314 0 368.358 0 374.403 0zM262.715 115.423c17.317.703 33.49-.93 49.477-4.47 21.307-4.72 41.91-11.456 59.327-25.064 6.15-4.806 11.576-11.065 15.854-17.625 8.296-12.72-.486-37.853-22.078-36.074-8.343.69-17.027 2.454-24.648 5.796-34.12 14.96-59.077 39.888-76.22 72.805-.63 1.208-.96 2.57-1.713 4.633zm-45.107.312c-1.25-2.894-1.937-4.845-2.894-6.654-15.492-29.273-37.77-51.97-67.093-67.272-8.37-4.368-17.805-7.15-27.073-9.23-12.29-2.76-21.64 1.478-26.83 10.41-6.23 10.725-5.648 21.44 2.608 31.143 4.33 5.09 9.236 10.03 14.767 13.705 31.803 21.13 67.552 27.682 106.516 27.9zM43.736 512c-8.944-4.19-11.93-11.165-11.885-21.006.305-63.953.157-127.907.157-191.86v-6.673h175.995V512H43.736zM272.003 512V292.545h175.995v6.05c0 64.13-.146 128.26.154 192.39.046 9.834-2.95 16.813-11.883 21.014H272.002z"
			},
			children: [
			]
		}
	]
};
var globe = {
	id: "globe",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "globe",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "globe",
					name: "",
					type: "text",
					value: "Globe icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "globe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 255.9C0 185 24.9 124.7 74.8 74.8S185 0 255.9 0 387.1 24.9 437 74.8c49.9 49.9 74.8 110.2 74.8 181.1 0 70.8-24.9 131.2-74.8 181.1-49.9 49.9-110.2 74.8-181.1 74.8-70.8 0-131.2-24.9-181.1-74.8S0 326.7 0 255.9zm33 8.2c2.8 58.5 24.8 108.3 66 149.6 18.6-13.1 37.8-23.7 57.8-32-15.1-37.1-23.4-76.4-24.8-117.6H33zm0-16.5h99.1c1.4-36.5 7.9-70.8 19.6-103.2-22-8.9-42.6-21-61.9-36.1C54 148.2 35.1 194.7 33 247.6zM101.1 96c17.9 13.8 36.8 24.8 56.7 33 15.1-35.8 35.8-66.7 61.9-92.9-46 7.6-85.6 27.5-118.6 59.9zm10.3 329.1c31 26.8 67.1 43.7 108.3 50.6-22.7-22.7-41.3-48.8-55.7-78.4-18.5 6.8-36.1 16.1-52.6 27.8zm37.2-161c1.4 39.2 9.3 76.7 23.7 112.5 24.1-7.6 49.2-12 75.3-13.4v-99.1h-99zm0-16.5h99.1v-82.5c-27.5-1.4-54.3-6.5-80.5-15.5-11.1 31-17.2 63.6-18.6 98zm24.7-113.5c24.1 8.3 48.8 13.1 74.3 14.4V33h-1c-31.6 26.8-56.1 60.5-73.3 101.1zm6.2 256.9c17.2 35.1 39.6 64.3 67.1 87.7h1v-99.1c-24 1.5-46.7 5.3-68.1 11.4zm84.6 87.7h1c27.5-23.4 49.9-52.6 67.1-87.7-21.3-6.2-44-10-68.1-11.3v99zm0-115.5c26.1 1.4 51.2 5.8 75.3 13.4 14.4-35.8 22.4-73.3 23.7-112.5H264v99.1zm0-115.6h99.1c-1.4-34.4-7.6-67.1-18.6-98-26.1 8.9-53 14.1-80.5 15.5v82.5zm0-99c25.5-1.4 50.2-6.2 74.3-14.4-17.2-40.7-41.6-74.4-73.2-101.2h-1v115.6zm27.9 327c41.3-6.9 77.4-23.7 108.3-50.6-16.5-11.7-34-21-52.6-27.9-14.4 29.7-33 55.9-55.7 78.5zm0-439.5c26.1 26.1 46.8 57.1 61.9 92.9 19.9-8.3 38.9-19.3 56.7-33-33-32.4-72.5-52.3-118.6-59.9zm62.9 345.7c19.9 8.3 39.2 18.9 57.8 32 41.3-41.3 63.3-91.1 66-149.6h-99.1c-1.3 41.2-9.5 80.4-24.7 117.6zm5.2-237.4c11.7 32.3 18.2 66.7 19.6 103.2h99.1c-2.1-53-21-99.4-56.7-139.3-19.4 15.2-40 27.2-62 36.1z"
			},
			children: [
			]
		}
	]
};
var gavel = {
	id: "gavel",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 510.487 447.313"
	},
	children: [
		{
			id: "gavel",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gavel",
					name: "",
					type: "text",
					value: "Gavel icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gavel",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			children: [
				{
					id: "gavel",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M337.237 10.22c5.643 9.77 2.293 22.27-7.48 27.913l-123.874 71.52c-9.773 5.642-22.27 2.292-27.915-7.48-5.64-9.774-2.293-22.273 7.48-27.916L309.322 2.742c9.776-5.643 22.272-2.297 27.915 7.478zM411.493 179.703l-123.874 71.52-71.52-123.875 123.876-71.523 71.517 123.878zM449.623 204.88c5.643 9.774 2.297 22.27-7.478 27.912l-123.876 71.52c-9.772 5.642-22.27 2.296-27.91-7.48-5.644-9.774-2.296-22.273 7.477-27.912l123.876-71.52c9.77-5.646 22.27-2.296 27.91 7.48z"
					},
					children: [
					]
				},
				{
					id: "gavel",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M262.077 206.98L45.984 343.545c-14.663 8.46-33.41 3.44-41.873-11.224-8.46-14.658-3.438-33.404 11.22-41.87l226.313-118.86 20.434 35.39zM490.052 426.878v-20.435c0-11.28-9.148-20.43-20.432-20.43H285.447c-11.284 0-20.432 9.148-20.432 20.43v20.435l-20.435 20.435H510.487l-20.435-20.435z"
					},
					children: [
					]
				}
			]
		}
	]
};
var grid = {
	id: "grid",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "grid",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "grid",
					name: "",
					type: "text",
					value: "Grid Icon icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "grid",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.4 48.5C6.4 25.1 25.5 6 48.8 6h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H48.8c-23.4 0-42.5-19.1-42.5-42.5V48.5h.1zm366.5 0C372.9 25.1 392 6 415.4 6h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H415.4c-23.4 0-42.5-19.1-42.5-42.5V48.5zm367.5 0c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H782.9c-23.4 0-42.5-19.1-42.5-42.5V48.5zm0 366.9c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H782.9c-23.4 0-42.5-19.1-42.5-42.5V415.4zm-366.9 0c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H416c-23.4 0-42.5-19.1-42.5-42.5V415.4zm-366.4 0c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H49.6c-23.4 0-42.5-19.1-42.5-42.5V415.4zm-.7 367.3c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5h-169c-23.4 0-42.5-19.1-42.5-42.5V782.7h.1zm734 0c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H782.9c-23.4 0-42.5-19.1-42.5-42.5V782.7zm-366.9 0c0-23.4 19.1-42.5 42.5-42.5h168.9c23.4 0 42.5 19.1 42.5 42.5v168.9c0 23.4-19.1 42.5-42.5 42.5H416c-23.4 0-42.5-19.1-42.5-42.5V782.7z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
};
var filter = {
	id: "filter",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22 13"
	},
	children: [
		{
			id: "filter",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "filter",
					name: "",
					type: "text",
					value: "Filter icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "filter",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1 2.5h20a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zM4 7.5h14a1 1 0 0 0 0-2H4a1 1 0 1 0 0 2zM7 12.5h8a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2z"
			},
			children: [
			]
		}
	]
};
var glove = {
	id: "glove",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "glove",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "glove",
					name: "",
					type: "text",
					value: "Glove icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "glove",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.393 0.998 C 13.246 1.038,13.012 1.123,12.873 1.188 L 12.619 1.307 12.374 1.197 C 11.405 0.765,10.363 0.943,9.546 1.682 C 9.329 1.878,9.260 1.915,8.960 1.996 C 7.504 2.386,5.808 3.105,4.430 3.916 L 3.880 4.240 3.590 4.241 C 2.935 4.242,2.351 4.487,1.880 4.959 C 1.537 5.304,1.367 5.572,1.163 6.093 L 1.020 6.460 1.022 7.400 C 1.033 11.645,2.688 15.927,5.366 18.640 C 7.516 20.819,10.282 21.973,13.360 21.975 C 14.316 21.976,14.856 21.914,15.629 21.717 C 18.534 20.974,20.626 18.632,21.640 14.988 C 22.127 13.237,22.337 11.479,22.337 9.160 C 22.337 7.688,22.307 7.145,22.157 5.880 C 21.992 4.498,21.941 4.342,21.439 3.680 C 20.752 2.775,19.978 2.317,19.117 2.305 L 18.734 2.300 18.520 2.108 C 18.233 1.849,17.847 1.627,17.460 1.497 C 17.041 1.356,16.368 1.321,15.920 1.416 L 15.621 1.480 15.451 1.358 C 14.894 0.958,14.078 0.816,13.393 0.998 M14.387 2.845 C 14.463 2.891,14.523 2.967,14.536 3.032 C 14.616 3.436,14.660 4.800,14.658 6.860 C 14.657 9.159,14.645 9.434,14.476 11.094 L 14.428 11.568 14.304 11.542 C 14.236 11.529,14.018 11.489,13.820 11.455 C 13.622 11.421,13.457 11.390,13.453 11.386 C 13.449 11.382,13.471 11.208,13.502 10.999 C 13.587 10.419,13.672 9.506,13.724 8.600 C 13.782 7.584,13.747 4.841,13.662 3.820 C 13.580 2.825,13.579 2.858,13.710 2.807 C 13.972 2.706,14.179 2.717,14.387 2.845 M11.621 2.858 C 11.698 2.890,11.760 2.940,11.760 2.969 C 11.760 2.998,11.788 3.354,11.822 3.761 C 11.947 5.248,11.958 8.050,11.843 9.380 C 11.781 10.096,11.640 11.214,11.607 11.248 C 11.592 11.264,11.355 11.295,11.080 11.318 C 10.805 11.341,10.511 11.371,10.426 11.386 L 10.272 11.412 10.334 11.291 C 10.530 10.913,10.766 9.875,10.887 8.860 C 10.972 8.150,10.958 5.216,10.864 4.007 C 10.781 2.940,10.774 2.990,11.020 2.863 C 11.171 2.785,11.441 2.782,11.621 2.858 M17.010 3.272 C 17.103 3.314,17.260 3.420,17.358 3.508 C 17.530 3.662,17.537 3.677,17.565 3.964 C 17.580 4.127,17.615 4.856,17.641 5.585 C 17.710 7.519,17.620 9.562,17.397 11.100 C 17.308 11.708,17.173 12.440,17.144 12.470 C 17.134 12.480,16.916 12.401,16.660 12.294 L 16.195 12.100 16.219 11.900 C 16.299 11.221,16.403 10.117,16.447 9.480 C 16.515 8.493,16.514 5.196,16.445 4.093 C 16.416 3.627,16.405 3.224,16.421 3.198 C 16.461 3.133,16.792 3.175,17.010 3.272 M7.855 5.346 C 7.605 6.021,7.393 6.581,7.383 6.590 C 7.354 6.620,5.683 5.343,5.694 5.300 C 5.720 5.198,8.054 4.128,8.265 4.121 C 8.290 4.121,8.105 4.672,7.855 5.346 M19.715 4.470 C 20.134 4.891,20.197 5.017,20.281 5.593 C 20.710 8.551,20.607 11.619,19.994 14.120 C 19.873 14.611,19.800 14.793,19.800 14.601 C 19.800 14.376,19.636 14.158,19.224 13.831 C 19.002 13.654,18.814 13.504,18.806 13.498 C 18.798 13.491,18.837 13.291,18.893 13.053 C 19.155 11.929,19.338 10.582,19.440 9.020 C 19.483 8.356,19.487 5.499,19.446 4.730 C 19.432 4.460,19.435 4.240,19.453 4.240 C 19.471 4.240,19.589 4.344,19.715 4.470 M9.140 7.306 C 9.124 7.668,9.097 7.958,9.079 7.952 C 9.061 7.945,8.912 7.819,8.748 7.672 L 8.450 7.403 8.775 6.545 L 9.100 5.686 9.135 6.167 C 9.154 6.431,9.156 6.944,9.140 7.306 M3.620 6.610 C 5.133 10.848,6.554 12.819,8.162 12.911 C 8.670 12.940,9.168 12.773,9.517 12.458 L 9.670 12.319 9.714 12.492 C 9.798 12.827,10.040 13.074,10.372 13.163 C 10.486 13.194,10.645 13.194,10.927 13.163 C 12.101 13.035,13.632 13.202,14.960 13.601 C 16.011 13.917,17.258 14.580,18.120 15.280 C 18.483 15.574,18.677 15.655,18.960 15.629 C 19.201 15.608,19.400 15.525,19.553 15.385 L 19.646 15.300 19.558 15.540 C 18.782 17.639,17.426 19.146,15.755 19.762 C 14.916 20.071,14.192 20.177,13.120 20.146 C 12.257 20.121,11.786 20.060,11.043 19.876 C 10.344 19.703,9.949 19.558,9.260 19.222 C 8.126 18.668,7.146 17.924,6.295 16.969 C 4.251 14.674,3.031 11.434,2.839 7.793 C 2.792 6.897,2.808 6.779,3.019 6.418 C 3.110 6.263,3.318 6.081,3.405 6.080 C 3.419 6.080,3.516 6.319,3.620 6.610 M6.390 7.369 C 6.725 7.608,7.000 7.820,7.000 7.839 C 7.000 7.858,6.916 8.103,6.814 8.382 C 6.642 8.852,6.623 8.885,6.569 8.816 C 6.455 8.669,5.680 7.008,5.680 6.911 C 5.680 6.863,5.691 6.870,6.390 7.369 M8.549 9.130 L 8.957 9.540 8.882 9.880 C 8.752 10.469,8.551 10.918,8.356 11.055 C 8.280 11.108,8.254 11.108,8.161 11.061 C 8.051 11.003,7.863 10.811,7.666 10.552 C 7.566 10.420,7.557 10.388,7.594 10.272 C 7.941 9.167,8.091 8.720,8.114 8.720 C 8.129 8.720,8.325 8.905,8.549 9.130"
			},
			children: [
			]
		}
	]
};
var group = {
	id: "group",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "group",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "group",
					name: "",
					type: "text",
					value: "Group icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "group",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M512 443.1c-1-1.9-.5-3.9-.6-5.8-.4-5-.9-10-1.2-14.9-.3-4.8-2.6-8.6-6-11.9-4.2-4.2-9.2-7.4-14.3-10.4-11.3-6.5-23.4-11.6-35.5-16.4-14.6-5.8-29.6-10.8-44.5-15.8-3.8-1.3-7.6-2.8-11.3-4.5-4.9-2.2-7.6-6.1-7.7-11.4-.2-8.4-.2-16.9-.1-25.3.1-3.9 1.4-7.6 4-10.5 8.3-9.4 11.8-20.8 14.2-32.7.8-3.8 1.4-7.6 2.3-11.3.5-1.9 1.1-3.9 2.2-5.5 3.5-5.3 5.5-11.1 7-17.2 1-3.9 1.7-7.8 2.4-11.8.5-3.2.2-6.4-1.1-9.4-1.6-3.7-1.6-7.4-1.2-11.3.9-8.1 1.7-16.3 2.3-24.4.5-6.8-1-13.4-3.5-19.7-8.5-21.8-24.2-35.6-46.7-41.8-5.5-1.5-17.5-3.2-17.8-3.2h-12.8c-2.1 0-4.2.6-6.3.9-15.5 2-29.6 7.5-41.1 18.4-10.8 10.1-17.6 22.5-20.1 37.1-.1.4-.1.9-.2 1.3 2.4.4 4.7.8 7.1 1.5 24.6 6.8 41.7 22.1 50.8 45.5 3.1 8.1 4.4 15.4 3.9 22.4-.6 8.5-1.5 16.9-2.3 24.6-.4 3.7-.2 6.1.7 8.2 1.7 4 2.2 8.4 1.5 12.8-.7 4.4-1.5 8.4-2.5 12.2-1.3 5.5-3.5 12.6-7.9 19.2-.5.7-.9 1.9-1.3 3.5-.6 2.3-1 4.7-1.5 7.3-.2 1.3-.5 2.5-.7 3.8-2.3 11.5-5.9 24.7-15.6 35.6-1.6 1.8-2.4 4-2.4 6.5-.2 9.8-.2 17.7.1 25 .1 2.9 1.3 4.7 4 5.9 4.1 1.8 7.5 3.2 10.7 4.2 13.9 4.6 29.6 9.8 44.8 15.8 10.4 4.1 21.3 9.2 31.8 14.2h116.5c-.1-3.8-.1-7-.1-10.7zM185.4 426.4c5.5-1.8 11.2-3.9 17.2-6.3 3.1-1.2 3.6-2.6 3.7-3.1.6-1.8 1-3.6 1-5.1.2-5.7.2-11.5.2-17.1v-2.7c0-4.7-1.3-8.4-4.2-11.7-4-4.6-7.1-10-9.6-16.7-2.3-6.5-4.1-13.7-5.6-22.6-.9-5.1-1.8-8.6-4-11.5-.9-1.2-1.4-2.4-1.9-3.4l-.1-.2c-2.4-5.2-3.8-10.6-5.1-15.8l-.5-1.9c-2.3-8.8-1.9-16.2 1-23.1.1-.3.2-.8.2-1.1-.7-7.9-1.5-15.9-2.2-23.6-.5-5.3-.9-10 0-15.2 2.8-15.8 10.2-29.4 22-40.4 10.6-9.9 23.5-16.1 39.4-18.9-.5-4.4-1.7-8.8-3.3-13-8.5-21.8-24.2-35.5-46.7-41.8-4.7-1.3-14.2-2.7-17-3.1-.5-.1-.8-.1-.8-.1h-12.8c-2.1 0-4.2.6-6.3.9-15.5 2-29.6 7.5-41.1 18.4-10.8 10.1-17.6 22.5-20.1 37.1-.8 4.5-.4 9.1 0 13.6.8 7.9 1.6 15.8 2.2 23.7.1 1.3-.1 2.8-.7 4.1-2.7 6.3-2.4 12.7-.7 19.1 1.4 5.6 2.7 11.3 5.2 16.6.4.9.8 1.7 1.3 2.5 3.2 4.2 4.3 9.1 5.1 14.2 1.2 7.3 2.8 14.5 5.4 21.5 2 5.4 4.6 10.4 8.4 14.8 4 4.5 5.8 9.8 5.8 15.8 0 6.7 0 13.4-.2 20-.1 2.3-.6 4.7-1.4 6.9-1.2 3.5-4.1 5.6-7.3 6.8-5.8 2.3-11.6 4.4-17.5 6.4-18.2 6-36.2 12.4-53.7 20.2-8.8 3.9-17.5 8-25.4 13.5-2.9 2-5.5 4.2-8.1 6.5-3.7 3.3-5.7 7.5-6 12.5-.4 6.5-.7 13-1.1 19.5v.8C0 447 0 451 0 454h115.7c5.1-3 10.3-5.1 15.4-7.3 19.2-8.5 39.1-15.3 54.3-20.3z"
			},
			children: [
			]
		},
		{
			id: "group",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M321.5 278.4c.8-7.7 1.7-15.9 2.3-24.2.4-5.2-.6-10.6-3.1-17-7.7-19.8-21.6-32.2-42.6-38.1-4.6-1.3-9.4-1.7-14.8-2.1-.4.1-10.5 0-10.5 0-2.3 0-7.7.2-9.2.4-15.6 2-27.9 7.4-37.7 16.5-10 9.3-15.9 20.3-18.3 33.6-.6 3.6-.3 7.4.1 11.8.8 7.8 1.6 15.8 2.2 23.8.2 2.3-.2 4.8-1.1 7-1.9 4.3-2 9-.4 15.2l.5 1.9c1.2 4.9 2.4 9.4 4.3 13.6l.1.3c.2.4.4.9.5 1.1 4.1 5.4 5.4 11.5 6.3 16.8 1.4 8.2 3 14.7 5.1 20.4 1.9 5.2 4.2 9.4 7.2 12.8 4.8 5.5 7.3 12.2 7.3 19.9v2.7c0 5.7 0 11.6-.2 17.5-.1 2.8-.7 5.7-1.7 8.8-1.1 3.3-4 7.9-10.9 10.6-6.2 2.5-12.1 4.6-17.8 6.5-14.9 4.9-34.4 11.7-53.2 20-8.2 3.6-16.8 7.7-24.4 13-2.3 1.6-4.8 3.6-7.5 6-2.5 2.2-3.8 5-4 8.3-.2 3.5-.5 7-.9 10.4-.3 3-.6 6.1-.8 9.1-.1.8-.6 1.5-.6 2.2v3.8h313.9v-6.9c0-1.6 0-3-.1-4.4-.2-3.1-.4-6.1-.6-9.2-.1-1.9-.2-3.8-.4-5.8-.2-2.9-1.4-5.4-4-7.9-4.1-4.1-9.1-7.2-13-9.4-11.2-6.4-23.3-11.5-34.7-16-14.9-5.9-30.4-11.1-44.2-15.7-3.6-1.2-7.4-2.7-11.8-4.7-7-3.1-11.2-9.3-11.4-16.8-.2-7.5-.2-15.6-.1-25.6.1-5.5 2-10.5 5.5-14.5 7.7-8.7 10.7-19.5 12.7-29.8.2-1.2.5-2.4.7-3.7.5-2.6 1-5.2 1.6-7.9.8-3.2 1.7-5.6 3.1-7.5 2.6-3.9 4.4-8.4 6.1-15.2.9-3.5 1.6-7.2 2.3-11.3.4-2.1.1-4.1-.6-6-1.8-5.3-1.6-10.4-1.2-14.3z"
			},
			children: [
			]
		},
		{
			id: "group",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M143.6 448.2c1-.4 2-.8 3-1.3-1 .5-2 .9-3 1.3zM157.9 442.6c.7-.2 1.3-.5 2-.7-.7.2-1.4.5-2 .7zM172.1 437.5c.4-.1.7-.2 1.1-.4-.4.1-.8.3-1.1.4zM179.2 435c.2-.1.3-.1.5-.2-.1.1-.3.1-.5.2zM164.9 440c.5-.2 1-.4 1.6-.6-.5.2-1 .4-1.6.6zM135.8 451.5c1.4-.6 2.9-1.3 4.3-1.9-1.4.7-2.9 1.3-4.3 1.9zM329.5 301.8c-.1.6-.2 1.2-.3 1.7.1-.5.2-1.1.3-1.7zM328.8 290.3c.9 2.2 1.4 4.6 1.3 7 .1-2.3-.3-4.7-1.3-7s-1.4-4.6-1.4-7c.1 2.4.5 4.7 1.4 7zM329.5 301.8c.1-.7.2-1.4.4-2.1.1-.8.2-1.6.2-2.4 0 .8-.1 1.6-.2 2.4-.1.7-.2 1.4-.4 2.1zM321 431.2c.7.2 1.5.5 2.2.7-.8-.2-1.5-.5-2.2-.7zM329.2 303.6c-.4 2.1-.9 4.3-1.3 6.4.5-2.2.9-4.3 1.3-6.4zM297.8 405.8v-1.1 1.1zM213.6 405.1v-1.7 1.7zM159.9 441.9c1.7-.6 3.4-1.2 5.1-1.9-1.8.6-3.5 1.2-5.1 1.9zM129.7 454.2z"
			},
			children: [
			]
		}
	]
};
var highlight = {
	id: "highlight",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 40 40",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "highlight",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 11)",
				fill: "#666",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "highlight",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M22 9.0000002l.027446-.6904532L29.5.3333337v17.333333l-7.4999998-8.1666665z"
					},
					children: [
					]
				},
				{
					id: "highlight",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						stroke: "#666",
						strokeWidth: "2",
						fillOpacity: ".2",
						x: "1",
						y: "1",
						width: "21.3333333",
						height: "16",
						rx: "1.6666667"
					},
					children: [
					]
				}
			]
		}
	]
};
var home = {
	id: "home",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "home",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "home",
					name: "",
					type: "text",
					value: "Home Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "home",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.164 30.641H.836V15.374L16 1.359l15.164 14.015v15.267z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var hotel = {
	id: "hotel",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "hotel",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "hotel",
					name: "",
					type: "text",
					value: "Hotel icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "hotel",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M139.6 267.2c38.5 0 69.8-31.3 69.8-69.8s-31.3-69.8-69.8-69.8-69.8 31.3-69.8 69.8 31.3 69.8 69.8 69.8zm279.3-139.7H232.7v162.9H46.5V81H0v349.1h46.5v-69.8h418.9v69.8H512V220.6c0-51.4-41.7-93.1-93.1-93.1z"
			},
			children: [
			]
		}
	]
};
var info = {
	id: "info",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 95.04 95.04"
	},
	children: [
		{
			id: "info",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M47.52 1.293C21.459 1.293.333 22.419.333 48.48c0 26.061 21.126 47.187 47.187 47.187S94.707 74.541 94.707 48.48c0-26.061-21.126-47.187-47.187-47.187zm-4.708 19.535c1.269-1.269 2.804-1.904 4.606-1.904 1.774 0 3.295.635 4.565 1.904 1.269 1.269 1.904 2.804 1.904 4.606s-.635 3.336-1.904 4.606-2.791 1.904-4.565 1.904c-1.801 0-3.336-.635-4.606-1.904s-1.904-2.804-1.904-4.606.635-3.336 1.904-4.606zm14.39 56.025H37.224v-2.006c1.474-.246 2.483-.614 3.03-1.105.819-.737 1.228-2.06 1.228-3.971V45.126c0-1.707-.287-2.869-.86-3.489-.573-.619-1.706-1.08-3.398-1.383v-2.006h16.089v31.85c0 1.829.273 3.003.819 3.521.546.519 1.569.928 3.07 1.228v2.006z",
				fill: "#333"
			},
			children: [
			]
		}
	]
};
var info2 = {
	id: "info2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 25 25"
	},
	children: [
		{
			id: "info2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "info2",
					name: "",
					type: "text",
					value: "Info icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "info2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				"class": "bg",
				fillRule: "evenodd",
				fill: "#333",
				d: "M12.51 6A1.43 1.43 0 0 0 11 7.51 1.42 1.42 0 0 0 12.51 9 1.41 1.41 0 0 0 14 7.51 1.42 1.42 0 0 0 12.51 6zm-1.26 13h2.5v-8h-2.5zM24 12.5A11.5 11.5 0 1 1 12.5 1 11.51 11.51 0 0 1 24 12.5z"
			},
			children: [
			]
		},
		{
			id: "info2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "transparent",
				"class": "fg",
				fillRule: "evenodd",
				d: "M12.51 6A1.42 1.42 0 0 1 14 7.51 1.41 1.41 0 0 1 12.51 9 1.42 1.42 0 0 1 11 7.51 1.43 1.43 0 0 1 12.51 6zm-1.26 13v-8h2.5v8z"
			},
			children: [
			]
		}
	]
};
var kebab = {
	id: "kebab",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 5 20"
	},
	children: [
		{
			id: "kebab",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "kebab",
					name: "",
					type: "text",
					value: "Kebab icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "kebab",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M2.5 5C3.875 5 5 3.875 5 2.5S3.875 0 2.5 0 0 1.125 0 2.5 1.125 5 2.5 5zm0 2.5C1.125 7.5 0 8.625 0 10s1.125 2.5 2.5 2.5S5 11.375 5 10 3.875 7.5 2.5 7.5zm0 7.5C1.125 15 0 16.125 0 17.5S1.125 20 2.5 20 5 18.875 5 17.5 3.875 15 2.5 15z"
			},
			children: [
			]
		}
	]
};
var instagram = {
	id: "instagram",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "-243 245 512 512"
	},
	children: [
		{
			id: "instagram",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "instagram",
					name: "",
					type: "text",
					value: "Instagram icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "instagram",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.92 294.55c67.266 0 75.234.257 101.798 1.47 24.562 1.12 37.9 5.223 46.778 8.673 11.76 4.57 20.15 10.03 28.966 18.845 8.816 8.815 14.275 17.207 18.845 28.966 3.45 8.877 7.554 22.216 8.674 46.778 1.213 26.564 1.47 34.532 1.47 101.797s-.257 75.233-1.47 101.797c-1.12 24.562-5.223 37.9-8.673 46.778-4.57 11.76-10.03 20.15-18.844 28.966-8.816 8.817-17.208 14.276-28.967 18.846-8.877 3.45-22.216 7.554-46.778 8.674-26.56 1.212-34.527 1.47-101.797 1.47s-75.236-.258-101.797-1.47c-24.562-1.12-37.9-5.224-46.778-8.674-11.76-4.57-20.15-10.03-28.966-18.844-8.816-8.816-14.276-17.208-18.846-28.967-3.45-8.877-7.554-22.216-8.674-46.778-1.212-26.564-1.47-34.532-1.47-101.798s.258-75.234 1.47-101.798c1.12-24.562 5.224-37.9 8.674-46.778 4.57-11.76 10.03-20.15 18.845-28.966 8.814-8.816 17.206-14.275 28.965-18.845 8.877-3.45 22.216-7.554 46.778-8.674 26.564-1.213 34.532-1.47 101.798-1.47m0-45.39c-68.417 0-76.996.29-103.866 1.515-26.814 1.223-45.127 5.482-61.15 11.71-16.567 6.437-30.616 15.05-44.622 29.056-14.005 14.007-22.62 28.056-29.056 44.622-6.228 16.024-10.487 34.337-11.71 61.15-1.226 26.87-1.516 35.45-1.516 103.867s.29 76.996 1.516 103.866c1.223 26.814 5.482 45.127 11.71 61.15 6.437 16.567 15.05 30.616 29.056 44.622 14.006 14.005 28.055 22.62 44.62 29.056 16.025 6.228 34.338 10.487 61.152 11.71C-64.076 752.71-55.496 753 12.92 753s76.997-.29 103.867-1.516c26.814-1.223 45.127-5.482 61.15-11.71 16.567-6.437 30.616-15.05 44.622-29.056 14.004-14.006 22.618-28.055 29.056-44.62 6.227-16.025 10.486-34.338 11.71-61.152 1.225-26.87 1.515-35.45 1.515-103.867s-.29-76.997-1.515-103.867c-1.223-26.814-5.482-45.127-11.71-61.15-6.437-16.567-15.05-30.616-29.056-44.622-14.007-14.004-28.056-22.618-44.622-29.056-16.024-6.227-34.337-10.486-61.15-11.71-26.87-1.225-35.45-1.515-103.867-1.515z"
			},
			children: [
			]
		},
		{
			id: "instagram",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.92 371.715c-71.446 0-129.364 57.918-129.364 129.364S-58.526 630.443 12.92 630.443s129.365-57.918 129.365-129.365S84.367 371.714 12.92 371.714zm0 213.338c-46.377 0-83.973-37.596-83.973-83.974s37.596-83.974 83.974-83.974 83.974 37.596 83.974 83.973-37.596 83.973-83.973 83.973z"
			},
			children: [
			]
		},
		{
			id: "instagram",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "147.396",
				cy: "366.604",
				r: "30.23"
			},
			children: [
			]
		}
	]
};
var link = {
	id: "link",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "link",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "link",
					name: "",
					type: "text",
					value: "Link icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "link",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M465 210.7c48-48 48-126 0-174s-126-48-174 0l-94.4 94.4c-15.5 15.5-26.5 34.8-32 55.8-5.6 23-5 46 1.7 68.2l.1.4c6 18.9 16.2 35.6 30.3 49.7 17.7 17.7 39.8 29.4 64.3 33.9 13.4-12.6 21-28.3 21.5-43.9-20.4-.1-40-8.2-54.6-22.8-11.4-11.4-19-26.1-21.7-41.9l-.4.1-.4-6.3v-.4l-.4-4.4.2-.2c-.4-16.8 2.4-33.3 13.4-47.9L322.2 67.8c14.7-14.7 34.2-22.7 55-22.7 20.8 0 40.3 8.1 55 22.8 30.3 30.3 30.3 79.7 0 110l-67.8 67.9c5.7 15.8 8.5 32.3 8.5 49.2 0 2.7-.1 5.4-.2 8l92.3-92.3z"
			},
			children: [
			]
		},
		{
			id: "link",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M220 476l94.4-94.4c15.5-15.5 26.5-34.8 32-55.8 5.6-22 3-54.1-2.7-71.2-.3-.8-.6-1.7-.9-2.6l-.1-.4c-6.2-16.6-15.7-31.4-28.3-44-18.2-18.2-41.1-30-66.4-34.3l-4.6 4.6c-10.2 10.2-15.9 23.8-16.3 38.1 20.4.1 40 8.2 54.5 22.7 11.7 11.7 19.3 26.4 21.8 43h.1l.9 10.3-.2.1c.4 18-5.4 35.5-16.5 49.6l.7.1-6.1 6.1-.9.9-1.2 1.2-.1.1-.2.2-92.9 92.9c-30.3 30.3-79.7 30.3-110 0-14.7-14.7-22.8-34.2-22.8-55 0-20.8 8.1-40.3 22.8-55l68.7-68.7c-5-15.3-7.6-31.3-7.6-46.7 0-2.6.1-5.5.3-8.4L46 302c-48 48-48 126 0 174s126 48 174 0z"
			},
			children: [
			]
		}
	]
};
var linkedin = {
	id: "linkedin",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "55 65 400 400"
	},
	children: [
		{
			id: "linkedin",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "linkedin",
					name: "",
					type: "text",
					value: "Linkedin icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "linkedin",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M155.592 428.587V198.083H78.976v230.504H155.6h-.008zM117.3 166.617c26.712 0 43.342-17.7 43.342-39.82-.5-22.624-16.63-39.83-42.834-39.83-26.222 0-43.348 17.206-43.348 39.828 0 22.12 16.624 39.82 42.338 39.82h.496l.006.002zm80.698 261.97h76.612v-128.71c0-6.88.5-13.778 2.524-18.692 5.536-13.77 18.142-28.024 39.312-28.024 27.716 0 38.81 21.136 38.81 52.126v123.3h76.608V296.423c0-70.798-37.792-103.744-88.198-103.744-41.326 0-59.476 23.098-69.56 38.83h.51v-33.418h-76.612c1 21.624-.006 230.504-.006 230.504v-.008z",
				fill: "#FFF"
			},
			children: [
			]
		}
	]
};
var live = {
	id: "live",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "live",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "live",
					name: "",
					type: "text",
					value: "Live icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "live",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.4 354.7V156.1h37v170h67.7v28.6H1.4zM132.8 156.1h37v198.6h-37V156.1zM304.7 354.7h-47.9L198 156.1h37l45.7 162.7 45.7-162.7h37.3l-59 198.6zM392 156.1h112.1v28.6H429v54.9h68.3v28.3H429v58.2h80.5v28.6H392V156.1z"
			},
			children: [
			]
		}
	]
};
var lock = {
	id: "lock",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 95 95"
	},
	children: [
		{
			id: "lock",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M84.8 40.9v-.6c0-3-3-5.4-6.8-5.4h-3.5v-7.5c0-14.9-12.1-27-27-27s-27 12.1-27 27v7.5H17c-3.7 0-6.8 2.4-6.8 5.4v49c0 3 3 5.4 6.8 5.4h61c3.7 0 6.8-2.4 6.8-5.4V40.9zM30.2 27.3c0-4.6 1.8-8.8 5-12s7.5-5 12.1-5c9.4 0 17 7.7 17 17v7.5H30.2v-7.5z",
				fill: "#333"
			},
			children: [
			]
		}
	]
};
var microphone = {
	id: "microphone",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 461.318 511.742"
	},
	children: [
		{
			id: "microphone",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "microphone",
					name: "",
					type: "text",
					value: "Microphone icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "microphone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M55.706 511.742c-6.38-1.343-12.737-2.794-19.14-4.008-19.313-3.662-42.08-28.354-35.365-57.27 3.365-14.48 11.27-26.415 21.004-37.265 3.165-3.53 6.994-6.457 10.24-9.922 1.11-1.187 2.046-3.236 1.905-4.785-.96-10.53 2.363-19.227 9.228-27.316 16.37-19.288 32.22-39.015 48.297-58.55 18.246-22.168 36.522-44.31 54.767-66.48 11.498-13.973 22.947-27.986 34.446-41.958 12.963-15.75 25.957-31.476 38.94-47.21 2.148-2.603 4.305-5.2 6.926-8.365 17.614 39.616 45.88 68.05 85.732 85.776-3.195 2.718-6.01 5.18-8.896 7.556-30.344 24.99-60.693 49.976-91.055 74.945-23.12 19.015-46.276 37.985-69.39 57.007-18.277 15.042-36.623 30.003-54.723 45.257-8.81 7.425-18.62 9.842-29.666 7.485-2.664-.57-4.255-.082-5.89 2.016-5.66 7.265-12.136 13.988-17.057 21.71-5.906 9.267-4.19 16.374 4.256 23.333 1.67 1.376 4.075 2.018 6.247 2.607 19.59 5.316 37.915 1.843 55.48-7.794 17.47-9.584 32.134-22.792 47.14-35.6 17.274-14.74 34.378-29.644 54.3-40.97 32.027-18.213 65.633-20.644 100.702-11.507 31.683 8.255 59.25 24.226 84.45 44.696 19.625 15.94 37 34.063 52.323 54.152 4.977 6.525 5.248 13.218 1.16 19.76-3.273 5.236-10.207 8.677-16.198 6.966-3.604-1.03-7.69-2.974-9.92-5.8-18.672-23.65-39.637-44.874-64.58-61.895-26.814-18.3-55.78-30.666-88.974-30.318-18.447.194-34.74 7.048-50.03 16.785-22.264 14.18-40.91 32.852-61.26 49.407-22.238 18.09-45.835 33.227-75.105 36.943-.515.065-.996.4-1.494.61h-18.8zM348.363 0c7.397 1.663 14.924 2.894 22.165 5.075 18.774 5.653 35.238 15.393 49.636 28.775 14.48 13.46 25.75 29.113 32.823 47.56 11.116 28.997 11.84 57.822-2.296 86.248-1.946 3.914-3.832 5.35-8.664 4.34-27.737-5.794-53.1-16.948-75.94-33.51-22.857-16.574-41.268-37.293-55.19-61.986-10.387-18.423-17.426-38.01-21.89-58.62-.65-3.005-.055-4.538 2.73-6.103 10.116-5.687 20.984-8.903 32.33-10.8 1.306-.217 2.576-.647 3.86-.978C334.74 0 341.552 0 348.364 0zM260.96 41.562c25.282 80.96 78.02 133.687 158.934 158.872-10.553 6.443-21.285 10.404-32.837 12.084-33.26 4.835-62.74-4.427-89.158-24.417-20.734-15.687-35.726-35.883-44.088-60.458-9.196-27.028-9.227-53.997 3.713-80.17.936-1.893 2.12-3.66 3.435-5.91z"
			},
			children: [
			]
		}
	]
};
var map = {
	id: "map",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "map",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "map",
					name: "",
					type: "text",
					value: "Map icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "map",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M485.2 65.2l-141.7-63-.3-.1-.3-.1c-4.7-1.1-9.7-1.1-14.2-.2l-.4.2-150.9 61.4L43.5 2.1l-.3-.1C32.9-.2 22 2.4 14 8.8c-8.2 6.6-13 16.4-13 27v378.6c0 15.9 11.3 30 26.8 33.6l141.3 63.1.3.1c4.7 1.1 9.8 1.1 14.3.2l.3-.1 151-61.4L469.2 511l.3.1.3.1c2.5.5 5 .8 7.5.8 7.8 0 15.6-2.7 21.7-7.6 8.2-6.6 13-16.4 13-26.9V98.9c0-16-11.3-30.1-26.8-33.7zM39 412.4v-76l10.8-4.9c-2.2-4.9-3.1-8.1-3.1-8.1l-7.7 2.1V40.4l120 53.7v281.7c-.1 0-.2.1-.3.1l.3.9v89.5L39 412.4zm158 54.1V365.2l4 4.3c5.2-4.9 10-10.5 14.1-16.7l-13.3-8.9c-1.5 2.3-3.1 4.4-4.8 6.5v-256l119-47.9v96.9c-5.6 2.4-11.1 5.2-16.4 8.2l8 13.8c2.7-1.6 5.5-3.1 8.3-4.5v257.7L197 466.5zm277 6.4l-120-53.5v-271c2.4-.5 4.9-.9 7.4-1.3l-2.4-15.8c-1.7.3-3.4.5-5 .8V47.4l120 53.4v372.1z"
			},
			children: [
			]
		},
		{
			id: "map",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M403.3 162.5c2.5 3.2 7.1 3.7 10.3 1.2l17.2-13.5 13.5 17.2c1.2 1.5 2.9 2.5 4.9 2.7.3 0 .6.1.9.1 1.6 0 3.2-.5 4.5-1.6 3.2-2.5 3.7-7.1 1.2-10.3l-13.5-17.2 17.2-13.5c3.2-2.5 3.7-7.1 1.2-10.3-1.2-1.5-2.9-2.5-4.9-2.7-1.9-.2-3.9.3-5.4 1.5l-17.2 13.5-13.5-17.2c-2.5-3.2-7.1-3.7-10.3-1.2-3.2 2.5-3.7 7.1-1.2 10.3l13.5 17.2-17.2 13.5c-3.2 2.6-3.7 7.2-1.2 10.3zM79.2 385.2c6.4 3.3 13.3 5.8 20.5 7.7l3.9-15.5c-6-1.5-11.8-3.7-17.1-6.4l-7.3 14.2zM127.7 380.1c-2 0-3.9-.1-5.8-.2l-.8 16c2.2.1 4.4.2 6.7.2 5 0 9.9-.3 14.6-.8l-1.7-15.9c-4.3.5-8.6.7-13 .7zM59.1 347.4l-12.9 9.5c4.4 6 9.4 11.4 14.8 16l10.5-12.1c-4.6-3.9-8.7-8.4-12.4-13.4zM210.4 327.6l14.8 6c2.7-6.6 4.7-13.5 6.2-20.6l-15.7-3.1c-1.2 6.1-3 12.1-5.3 17.7zM241.1 211.2l13.9 8c3.2-5.6 6.7-10.9 10.5-16l-12.8-9.6c-4.2 5.5-8.1 11.4-11.6 17.6zM224.5 249.6l15.3 4.7c1.8-6.1 4.1-12.1 6.6-18l-14.7-6.3c-2.8 6.3-5.2 13-7.2 19.6zM266.4 177.6l11.5 11.2c4.4-4.5 9.2-8.8 14.1-12.7l-9.9-12.6c-5.5 4.2-10.8 9-15.7 14.1zM217.7 290.1v1.2l16 .2v-1.4c0-5 .6-11 1.7-17.3l-15.8-2.7c-1.3 7.2-1.9 14.1-1.9 20zM390.3 145v-16c-3.5 0-7 .1-10.4.2l.7 16c3.3-.1 6.5-.2 9.7-.2z"
			},
			children: [
			]
		}
	]
};
var mastercard = {
	id: "mastercard",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 576 512"
	},
	children: [
		{
			id: "mastercard",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "mastercard",
					name: "",
					type: "text",
					value: "Mastercard",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "mastercard",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7s4.4-11.7 11.2-11.7c6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7S165 422 172.1 422c6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7s4.1 11.7 10.9 11.7 11.2-4.9 11.2-11.7c0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8s0-.5-.3-.8c-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23h-.2zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
			},
			children: [
			]
		}
	]
};
var more = {
	id: "more",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "more",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "more",
					name: "",
					type: "text",
					value: "More icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "more",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M268.1 288.7c.4-.4.7-.8 1.1-1.2 12.9-15.5 12.5-41-.8-57L86.2 12.3c-13.4-16-34.7-16.4-47.6-1s-12.5 41 .8 57l157.9 189.2L42.7 442.7c-12.9 15.5-12.5 41 .8 57 13.4 16 34.7 16.5 47.6 1L267 290c.4-.5.7-.9 1.1-1.3z"
			},
			children: [
			]
		},
		{
			id: "more",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M472.7 230.4L290.6 12.3c-13.4-16-34.7-16.4-47.6-1s-12.5 41 .8 57l157.9 189.2-154.6 185.2c-12.9 15.5-12.5 41 .8 57 13.4 16 34.7 16.5 47.6 1L471.4 290c.4-.4.7-.9 1-1.3.4-.4.7-.8 1.1-1.2 12.9-15.5 12.6-41.1-.8-57.1z"
			},
			children: [
			]
		}
	]
};
var login = {
	id: "login",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "login",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "login",
					name: "",
					type: "text",
					value: "Login icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "login",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M509 508s0-34.8-2.9-53c-2.4-14.4-22.3-33.3-106.9-64.4-83.3-30.6-78.1-15.7-78.1-71.9 0-36.5 18.6-15.3 30.4-84.6 4.6-27.3 8.3-9.1 18.3-52.8 5.3-22.9-3.6-24.6-2.5-35.6s2.1-20.7 4.1-43.1C373.8 74.9 348.1 2 256 2S138.2 74.9 140.7 102.7c2 22.3 3 32.2 4.1 43.1 1.1 10.9-7.8 12.7-2.5 35.6 10 43.6 13.7 25.4 18.3 52.8 11.9 69.3 30.4 48.1 30.4 84.6 0 56.4 5.1 41.5-78.1 71.9C28.3 421.7 8.3 440.8 6 455.2c-3 18-3 52.8-3 52.8h506z"
			},
			children: [
			]
		}
	]
};
var parking = {
	id: "parking",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 1000 1000",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "parking",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "parking",
					name: "",
					type: "text",
					value: "Parking icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "parking",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "parking",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M490.4 502.9h-87.9V279.3h87.9c72.8 0 109.2 37.3 109.2 111.8s-36.5 111.8-109.2 111.8z"
					},
					children: [
					]
				},
				{
					id: "parking",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M867.5 65h-735C95.4 65 65 95.4 65 132.5v735c0 37.1 30.4 67.5 67.5 67.5h735c37.1 0 67.5-30.4 67.5-67.5v-735c0-37.1-30.4-67.5-67.5-67.5zm33.1 773.4c0 34.2-28 62.2-62.2 62.2H161.6c-34.2 0-62.2-28-62.2-62.2V161.6c0-34.2 28-62.2 62.2-62.2h676.8c34.2 0 62.2 28 62.2 62.2v676.8z"
					},
					children: [
					]
				},
				{
					id: "parking",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M921.7.8H78.3C35.7.8.8 35.6.8 78.3v843.5c0 42.6 34.9 77.5 77.5 77.5h843.5c42.6 0 77.5-34.9 77.5-77.5V78.3C999.2 35.7 964.4.8 921.7.8zM935 867.5c0 37.1-30.4 67.5-67.5 67.5h-735C95.4 935 65 904.6 65 867.5v-735C65 95.4 95.4 65 132.5 65h735c37.1 0 67.5 30.4 67.5 67.5v735z",
						fill: "#000"
					},
					children: [
					]
				},
				{
					id: "parking",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M838.4 99.4H161.6c-34.2 0-62.2 28-62.2 62.2v676.8c0 34.2 28 62.2 62.2 62.2h676.8c34.2 0 62.2-28 62.2-62.2V161.6c0-34.2-28-62.2-62.2-62.2zM654.9 530.3c-33.3 41.7-90.7 62.5-172.1 62.5h-84.3v221.8h-96.8V189.4h181.2c81.4 0 138.8 20.6 172.1 61.7 29 37.1 43.5 83.9 43.5 140.5-.1 55.9-14.6 102.1-43.6 138.7z",
						fill: "#000"
					},
					children: [
					]
				},
				{
					id: "parking",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M486.4 279.3h-87.9v223.5h87.9c72.8 0 109.2-37.3 109.2-111.8s-36.5-111.7-109.2-111.7z",
						fill: "#000"
					},
					children: [
					]
				}
			]
		}
	]
};
var news = {
	id: "news",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "news",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "news",
					name: "",
					type: "text",
					value: "News Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "news",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#444"
			},
			children: [
				{
					id: "news",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.131 5.302h-2.189V3.404a.737.737 0 0 0-.737-.738H2.626a.737.737 0 0 0-.737.738v23.631c0 .408.33.738.737.738h2.189v1.899c0 .408.33.738.737.738h23.579c.407 0 .737-.33.737-.738V6.041a.738.738 0 0 0-.737-.739zm-.737 23.631H6.289V6.779h22.105v22.154z"
					},
					children: [
					]
				},
				{
					id: "news",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M9.667 12.267h14.737a.737.737 0 0 0 0-1.476H9.667a.737.737 0 0 0 0 1.476zm0 4.185h14.737a.737.737 0 0 0 0-1.476H9.667a.737.737 0 0 0 0 1.476zm0 4.184h14.737a.737.737 0 0 0 0-1.476H9.667a.737.737 0 0 0 0 1.476zm0 4.185h7.368a.737.737 0 0 0 0-1.476H9.667a.737.737 0 0 0 0 1.476z"
					},
					children: [
					]
				}
			]
		}
	]
};
var pdf = {
	id: "pdf",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 371.874 512.1"
	},
	children: [
		{
			id: "pdf",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pdf",
					name: "",
					type: "text",
					value: "PDF icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pdf",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M371.874 125.866c.014-4.785-1.305-8.513-4.5-12.144-31.6-35.905-63.038-71.953-94.606-107.886-1.987-2.26-4.677-3.905-7.04-5.836H16.724C7.712 2.628 2.472 8.83 0 17.653v476.64c.405 1.106.862 2.197 1.206 3.32 2.486 8.157 9.58 13.802 18.09 14.326 1.853.113 3.713.153 5.57.153 107.46.007 214.922.01 322.384-.013 2.932 0 5.93.047 8.783-.513 9.664-1.898 15.765-9.973 15.766-20.58.008-81.603.004-163.205.004-244.808 0-40.105-.054-80.21.07-120.314zm-271.33 311.64c-10.91 5.57-22.68 6.79-34.72 6.32-1.37-.054-2.734-.258-4.997-.48v43.273H33.858V366.794c20.125-2.033 40.115-4.722 59.98.474 15.5 4.053 25.456 15.87 26.897 30.76 1.7 17.558-5.63 32.042-20.192 39.475zm140.57 13.59c-8.168 20.363-24.4 30.444-44.994 34.573-18.093 3.627-36.342 2.655-54.55.932-1.076-.102-2.842-1.975-2.845-3.028-.104-38.54-.037-77.08.015-115.622 0-.137.133-.275.596-1.166 21.577-2.298 43.307-4.577 64.875.768 25.416 6.3 40.242 24.533 41.825 50.78.678 11.25-.704 22.25-4.92 32.76zm97.26-63.638h-46.28v28.135h43.254v22.137h-43.534v48.855h-27.07v-121h73.63v21.873zm16.474-43.453c-2.6 2.602-6.122 2.943-8.913 2.943h-.043c-89.707-.13-180.917-.126-269.123-.12l-55.83.003c-3.313 0-6-2.686-6-6V20.78c0-3.314 2.687-6 6-6h231.933c3.313 0 6 2.686 6 6v30.57c0 22.937-.002 45.873.003 68.81 0 6.15.706 6.856 6.857 6.858 19.233.005 38.467.004 57.7.004h28.232c3.313 0 6 2.687 6 6l-.004 44.105c-.006 51.753-.014 105.27.107 157.898.01 2.987-.332 6.39-2.92 8.982z"
			},
			children: [
			]
		},
		{
			id: "pdf",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M126.61 334.827c72.43 0 146.29.017 219.158.12-.12-52.61-.113-106.098-.106-157.823l.004-38.105h-22.23c-19.236 0-38.47 0-57.706-.004-12.86-.004-18.85-5.996-18.854-18.855-.005-22.937-.004-45.875-.004-68.812v-24.57H26.94v308.054l49.828-.002c16.518-.002 33.142-.003 49.84-.003zm-79.092-37.7c-.454-8.74 1.514-16.79 7.988-23.376 10.062-10.233 21.433-18.658 33.826-25.834 1.75-1.013 3.483-3.16 3.966-5.094 8.415-33.735 16.597-67.528 24.962-101.275.69-2.78.025-4.428-1.82-6.506-7.265-8.19-14.74-16.27-21.185-25.088-4.684-6.41-7.045-14.083-5.324-22.4 2.056-9.938 10.854-17.547 21.693-18.642 9.548-.965 17.415 4.19 21.384 14.323 4.566 11.66 5.48 23.984 3.717 36.09-1.45 9.95 1.224 16.457 8.996 22.835 27.737 22.76 54.945 46.163 82.3 69.387 2.75 2.337 5.607 3.278 9.246 3.163 8.196-.26 16.405-.08 24.608-.08l.07-.894c12.6 1.22 25.324 1.747 37.745 3.965 5.915 1.057 11.975 4.46 16.703 8.345 9.383 7.71 11.11 19.763 5.72 30.756-5.38 10.977-16.205 16.65-28.5 14.038-5.477-1.163-11.15-3.11-15.806-6.132-15.948-10.356-31.46-21.384-47.215-32.04-1.678-1.136-3.91-2.245-5.812-2.135-39.256 2.266-77.78 8.08-114.22 23.92-3.596 1.564-5.522 3.638-6.39 7.51-2.858 12.75-7.008 25.048-15.1 35.573-6.46 8.4-14.43 14.48-25.59 14.784-8.786.24-15.482-5.94-15.962-15.19zM201.152 390.86c-10.855-6.437-22.617-6.116-34.707-4.547v80.172c13.262.993 26.108.915 36.863-7.804 12.28-9.954 14.405-23.897 13.645-38.57-.63-12.16-4.747-22.695-15.8-29.25zM80.792 386.192c-5.676-1.05-11.664-.593-17.5-.413-.847.025-2.256 2.224-2.325 3.477-.27 4.938-.11 9.9-.11 14.853s-.157 9.914.105 14.854c.068 1.276 1.526 3.594 2.22 3.547 6.708-.45 13.705-.306 20-2.292 7.888-2.488 11.412-10.41 10.622-19.648-.613-7.176-5.165-12.926-13.012-14.378z"
			},
			children: [
			]
		},
		{
			id: "pdf",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M207.766 216.248c-33.22 3.094-65.554 8.967-97.077 21.438L132 151.168l75.766 65.08zM254.748 228.935c13.602 1.094 27.218 2.05 40.796 3.393 2.798.277 5.616 1.695 8.143 3.095 5.252 2.91 7.1 7.704 5.384 12.873-1.903 5.736-5.88 8.358-12.108 7.54-2.712-.356-5.692-.836-7.933-2.244-11.724-7.365-23.25-15.045-34.843-22.615l.56-2.042zM121.62 118.392c-7.285-7.042-13.224-13.77-16.208-22.615-1.374-4.072-.683-7.63 3.293-10.05 4.8-2.92 8.21-1.867 10.198 3.447 3.428 9.153 3.145 18.656 2.718 29.218zM85.943 268.792c-2.13 11.322-12.267 27.716-22.253 28.07-4.612-8.046 8.498-19.496 22.253-28.07z"
			},
			children: [
			]
		}
	]
};
var photo = {
	id: "photo",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "photo",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "photo",
					name: "",
					type: "text",
					value: "Photo icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "photo",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "255.6",
				cy: "270.5",
				r: "66.8"
			},
			children: [
			]
		},
		{
			id: "photo",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M480.8 97H375.3C372 74 352.5 54 329 54H182.1c-23.4 0-43 20-46.3 43H31c-17.1 0-31 13.9-31 31v298.3C0 443.4 13.8 457 31 457h449.9c17.1 0 31.2-13.6 31.2-30.7V128c-.1-17.1-14.1-31-31.3-31zM255.6 395.7c-69.1 0-125.2-56-125.2-125.2s56-125.2 125.2-125.2 125.2 56 125.2 125.2-56.1 125.2-125.2 125.2z"
			},
			children: [
			]
		}
	]
};
var periscope = {
	id: "periscope",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "periscope",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "periscope",
					name: "",
					type: "text",
					value: "Periscope icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "periscope",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M259.6 91c-10.3 0-20.3 1.2-29.7 3.5 15.2 7.1 25.8 22.6 25.8 40.5 0 24.7-20.1 44.8-44.8 44.8-24.5 0-44.4-19.7-44.8-44.1-15 19.5-23.8 44.1-23.8 71.3 0 59.1 51.1 109.7 117.3 109.7 59.7 0 110.8-50.5 110.8-109.7 0-65.5-51.1-116-110.8-116z"
			},
			children: [
			]
		},
		{
			id: "periscope",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M401.7 63.6C363.1 22.6 312.2 0 258.3 0 143.6 0 50.2 96.2 50.2 214.4c0 75.1 57.8 159.8 82.7 192.7C169.5 455.5 224.2 512 258.3 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.2-110.1-59.5-150.8zM258.3 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3 0 112.1-147.5 279.4-184.7 279.4z"
			},
			children: [
			]
		}
	]
};
var pet = {
	id: "pet",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 510.755 510.748"
	},
	children: [
		{
			id: "pet",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pet",
					name: "",
					type: "text",
					value: "Pet icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pet",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M161.836 510.748c-19.94 0-38.775-7.257-53.496-20.525h-.153l-2.972-2.926c-6.287-6.282-11.28-13.817-15.262-23.036-3.18-7.376-5.312-15.073-7.025-21.26-1.566-5.666-2.17-10.374-2.612-14.235-1.37-.14-3.523-.258-6.83-.207-9.03.14-18.088-1.975-26.928-6.257-8.124-3.92-15.9-9.56-23.1-16.762l-2.93-2.93v-.198c-6.082-6.756-10.92-14.43-14.413-22.862C2.057 369.748 0 359.442 0 348.915c0-10.53 2.057-20.835 6.115-30.63 3.49-8.433 8.33-16.107 14.414-22.865v-.156l2.927-2.973c15.123-15.126 35.23-23.457 56.62-23.457 23.268 0 37.017 3.688 46.115 6.127 10.063 2.7 11.875 3.185 18.366-1.245 9.767-6.668 26.43-24.253 52.716-52.422l.207-.215 1.704-1.718c44.97-45.394 67.54-68.18 77.295-81.697 6.92-9.59 6.39-10.843 2.28-20.585-3.23-7.646-7.648-18.117-9.845-35.77l-.076-.614v-.62c0-21.388 8.332-41.496 23.463-56.62C307.417 8.33 327.525 0 348.918 0c21.396 0 41.506 8.33 56.626 23.454 13.173 13.167 17.747 28.78 21.782 42.554l1.884 6.42c.992 3.46 2.204 7.685 2.976 8.67.287.154 1.713.77 6.73 1.11 8.88.6 17.654 2.968 26.074 7.04 5.51 2.668 10.735 6 15.61 9.954l.362-.29 6.333 6.292c4.81 4.808 8.947 10.154 12.366 15.972l.67-.373 4.306 10.347c4.06 9.783 6.118 20.105 6.118 30.68 0 10.534-2.056 20.84-6.11 30.633-2.627 6.342-6.02 12.258-10.135 17.682l.576.472-7.787 7.83c-15.123 15.132-35.233 23.465-56.627 23.465-19.467 0-30.37-4.12-38.334-7.13-8.632-3.26-10.684-4.035-20.956 2.968-14.72 10.038-40.078 34.29-81.72 75.533-27.914 27.555-43.283 42.728-49.632 52.418-4.638 7.08-4.145 9.88-2.068 21.664 1.668 9.467 3.952 22.43 3.952 43.304 0 21.394-8.332 41.503-23.46 56.625-15.12 15.124-35.23 23.455-56.62 23.455zm-43.457-38.6l1.018 1.003c11.348 11.35 26.42 17.598 42.438 17.598 16.048 0 31.135-6.25 42.48-17.597 11.35-11.345 17.6-26.43 17.6-42.48 0-19.124-2.108-31.094-3.648-39.833-5.28-29.963-1.743-33.454 57.333-91.773 48.968-48.496 70.297-68.14 84.517-77.835 17.603-12.003 26.586-9.954 39.292-5.153 6.883 2.6 15.45 5.838 31.264 5.838 15.48 0 30.062-5.815 41.256-16.41l1.204-1.21c5.623-5.626 10.008-12.18 13.033-19.48 3.044-7.354 4.588-15.086 4.588-22.98 0-7.574-1.408-14.975-4.188-22.02l-.413-.995c-2.83-6.826-6.81-12.97-11.842-18.28l-1.18-1.172c-5.085-5.087-10.756-9.162-16.853-12.113-6.1-2.95-12.397-4.663-18.713-5.088-20.067-1.36-23.4-9.644-27.566-24.17l-1.86-6.34c-3.694-12.612-7.18-24.503-16.737-34.058C380.058 26.247 364.97 20 348.918 20c-16.05 0-31.135 6.248-42.476 17.594-11.21 11.206-17.445 26.053-17.602 41.87 1.877 14.516 5.457 23 8.343 29.834 5.607 13.287 8.104 22.613-4.487 40.065-10.667 14.784-33.605 37.938-79.306 84.07l-1.598 1.613c-30.357 32.532-44.833 47.588-55.96 55.185-14.076 9.61-23.69 7.03-34.822 4.046-8.568-2.298-20.302-5.444-40.933-5.444-15.528 0-30.156 5.853-41.366 16.515l-1.11 1.13c-5.607 5.605-9.983 12.152-13.006 19.458-3.05 7.36-4.594 15.09-4.594 22.98 0 7.89 1.545 15.62 4.593 22.982 3.025 7.305 7.4 13.85 13.006 19.456l1.606 1.607c5.132 4.857 10.524 8.665 16.055 11.333 6.024 2.918 12.06 4.38 17.933 4.266 15.812-.24 25.268 2.475 26.886 16.997.394 3.5.843 7.48 2.123 12.11 1.97 7.112 3.672 13.007 6.112 18.67 2.782 6.437 6 11.5 10.064 15.81z"
			},
			children: [
			]
		}
	]
};
var pinterest = {
	id: "pinterest",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "pinterest",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pinterest",
					name: "",
					type: "text",
					value: "Pinterest icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pinterest",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm-.3 492.7c-24.4 0-47.9-3.7-70.1-10.6 9.6-15.7 24.1-41.5 29.4-62.1 2.9-11.1 14.7-56.3 14.7-56.3C237.5 378.5 260 391 284 391c71.4 0 122.8-65.7 122.8-147.2 0-78.2-63.8-136.7-145.9-136.7-102.1 0-156.4 68.6-156.4 143.2 0 34.7 18.5 77.9 48 91.7 4.5 2.1 6.9 1.2 7.9-3.2.8-3.3 4.8-19.4 6.6-26.8.6-2.4.3-4.4-1.6-6.8-9.8-11.9-17.6-33.7-17.6-54 0-52.2 39.5-102.7 106.9-102.7 58.1 0 98.9 39.6 98.9 96.3 0 64-32.3 108.4-74.4 108.4-23.2 0-40.6-19.2-35.1-42.8 6.7-28.1 19.6-58.5 19.6-78.8 0-18.2-9.8-33.3-29.9-33.3-23.8 0-42.8 24.6-42.8 57.5 0 21 7.1 35.1 7.1 35.1s-23.5 99.2-27.8 117.7c-4.8 20.4-2.9 49.2-.8 67.9C81.4 441.9 19 356.3 19 256 19 125.3 125 19.3 255.7 19.3s236.7 106 236.7 236.7-106 236.7-236.7 236.7z"
			},
			children: [
			]
		}
	]
};
var plane = {
	id: "plane",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "plane",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "plane",
					name: "",
					type: "text",
					value: "Plane icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "plane",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M1385.9 164.8c-17.4-31.4-66-31.6-123.7.2l-165.3 96.8L587.1 40.9l-93.7 51.9s267.9 197.8 402 297.1L613.6 564.3l-145.9-68.5-60.6 33.1 127.4 130.3 45 173.8 59.4-35.4 15.5-161.4 295.8-151c16.1 166.5 31.7 331.8 47.6 496.9l93.3-51.9 72.8-551.8 170.7-105.9c54-31.1 68.7-76.2 51.3-107.7z"
			},
			children: [
			]
		}
	]
};
var player = {
	id: "player",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "player",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "player",
					name: "",
					type: "text",
					value: "Player Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "player",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#444"
			},
			children: [
				{
					id: "player",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.56 10.637a4.073 4.073 0 0 0 4.067 4.07 4.074 4.074 0 0 0 4.071-4.07 4.073 4.073 0 0 0-4.071-4.067 4.072 4.072 0 0 0-4.067 4.067zm9.12 21.371v-14.58c0-1.908-1.91-1.824-1.91-1.824h-7.754s-.322-.047-.988.5l-4.514 2.634-4.711-4.715c-.768-.913-2.124-1.043-3.033-.276-.924.768-.975 2.159-.208 3.083l6.01 6.009c.408.435.972.729 1.605.729.468 0 .903-.154 1.258-.399l3.961-2.177L18.375 32M3.383 16.833l-.063.07a.538.538 0 0 0-.017.761l.007.007 1.187 1.21c.204.21.553.215.768 0l.073-.058a.555.555 0 0 0 0-.775l-1.177-1.205a.555.555 0 0 0-.778-.01z"
					},
					children: [
					]
				},
				{
					id: "player",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M21.587 0c-.35-.008-.65.127-.887.33l-4.952 4.896-6.942 7.506.84.857 7.744-6.678 5.147-4.745c.203-.227.337-.527.337-.852A1.31 1.31 0 0 0 21.587 0z"
					},
					children: [
					]
				}
			]
		}
	]
};
var play = {
	id: "play",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 381 431",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "play",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play",
					name: "",
					type: "text",
					value: "Play icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "play",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 32.736C0 3.513 20.638-8.358 45.843 6.253l315.97 182.276c25.203 14.61 25.203 38.353 0 52.965L46.025 423.953C20.82 438.563.183 426.693.183 397.47L0 32.736z",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
};
var preview = {
	id: "preview",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "preview",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "preview",
					name: "",
					type: "text",
					value: "Preview icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "preview",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(7.4 6)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "preview",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						strokeWidth: "2",
						fillOpacity: ".2",
						width: "25.2",
						height: "28",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "preview",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M3.2666667 3.2666667h5.6V7h-5.6zM7.2121065 9.977354h14v1.8666667h-14zM7.2121065 15.577354h14v1.8666667h-14zM7.2121065 21.177354h14v1.8666667h-14zM11.4625705 4.1158402h9.7415256v1.8666667h-9.7415256zM3.2666667 9.977354h1.8666667v1.8666667H3.2666667zM3.2666667 15.577354h1.8666667v1.8666667H3.2666667zM3.2666667 21.177354h1.8666667v1.8666667H3.2666667z"
					},
					children: [
					]
				}
			]
		}
	]
};
var printer = {
	id: "printer",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "printer",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "printer",
					name: "",
					type: "text",
					value: "Printer icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "printer",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M558.8 795.9h-121c-24.6 0-29.8-5.4-30.2-29.8 0-74.9-.4-150.1 0-225 .4-75.7 47.3-122.6 122.6-123H559v-21.5-289.4c0-46.1 21.1-67.2 66.9-67.2h376.2c45 0 83.6 15.9 115.3 48l74.9 74.9c31.7 31.7 47.3 70.7 47.3 115.7v139.9c13.6 0 25.4-.4 37.1 0 64.8 1.5 112.6 48 113.7 112.4 1.5 80.1.4 159.9.4 240.2 0 17.5-7.9 25.4-25.4 25.4-41.3-.4-82.8 0-125.9 0v82.8c0 47.3-20.8 68.4-67.2 68.4H625.9c-45.3 0-66.5-21.5-66.5-67.2-.6-27.9-.6-54.8-.6-84.6zm453.8-679.2h-377v376.2h527V266.8h-85.5c-42.3 0-64.4-21.9-64.8-64 .3-28.3.3-56.5.3-86.1zm150 754.5V722.3h-527v148.9h527zm114.2-377.4c-19.6 0-37.5 17.7-37.5 37.5 0 19.6 17.5 37.5 37.1 38.2 20 .4 38.6-18.1 38.2-38.6 0-19.8-18-37.1-37.8-37.1z"
			},
			children: [
			]
		}
	]
};
var popcorn = {
	id: "popcorn",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "popcorn",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "popcorn",
					name: "",
					type: "text",
					value: "Popcorn icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "popcorn",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1265.3 220.7c5.3-16 2.7-33.7-6.8-47.7 7.8-17.1 7.7-36.8-.6-53.7-.4-.8-.8-1.6-1.2-2.3.4-7.3-1.1-14.6-4.3-21.2-5.1-10.3-13.8-18-24.5-21.6-10.6-3.5-22-2.7-32 2.4-3.6 1.9-6.9 4.2-9.9 7-12.3-6.1-26.8-6.1-39.3.3-1.8.9-3.5 2-5.2 3.2-4.2-7.5-10.1-14-17.4-18.6-15.5-10-34.6-10.7-50.7-3-6.9-16.5-22.6-28.1-40.5-29.3-9.8-20.3-31.6-32.5-54-29.7-11.5 1.5-22 6.7-30.2 14.8-.9-.5-1.9-1-2.8-1.4-8.3-3.6-17.4-4.5-26.2-3.1-4.3-4.5-9.5-8.1-15.3-10.6-21.2-9.2-45.5-1.5-58 17.5-13.7-.9-27.3 3.6-38 13l-.4.4c-.9-.3-1.8-.7-2.7-.9-6.2-1.7-12.7-2-19.1-1.1-22.7 3.4-39.5 22.9-40.4 45.7-.3-1.1-.6-2.2-1-3.2-6.3-17.9-22.3-30.4-40.9-31.9-22.9-1.9-43.6 13.2-49.6 35.2-21.4 5.7-37.7 24.8-39.5 47.6-.3 4.3-.1 8.6.6 12.8-5.1 2.3-9.7 5.4-13.6 9.4-8-5.4-17.4-8.2-27.1-8-12.7.2-24.6 5.5-33.4 14.8-15.9 16.8-17.5 42.6-4.5 61.2-6.7 14.6-6.3 31.5.4 45.8 0 .2.1.3.1.5.1 1.1.3 2.3.8 3.3 12.2 51.3 98.4 412 164.4 678.9 4.9 19.8 50.3 26.5 50.3 26.5S692.7 422 673.4 334.6c14.1 4.4 29.3 8.7 45.7 12.6l57.6 634c35.4 18.8 66 14.1 66 14.1l-18.8-630.8c11.6 1.1 23.6 2 35.9 2.7 1.8 84.8 13.7 623 21.5 630.2 5.5 5.1 57 1.3 59.4-1.5 2.9-3.4 7.6-541.8 8.4-628.3 14.6-.6 28.6-1.5 42.2-2.8L976 992.3s34.5 2.7 69.2-15.4l57.1-629.9c16-3.9 30.8-8.1 44.5-12.4-19.6 91.4-79.1 636.2-79.1 636.2s51-20.1 52.5-26.5c57.5-250.6 136.4-599.9 152.4-671 8.1-17.4 5.4-38.2-7.3-52.6zm-134.3-57c.4-.6.8-1.1 1.3-1.6.8-.9 1.7-1.8 2.7-2.7.5-.4.9-.8 1.4-1.2 1.5-1.2 3.1-2.2 4.8-3.1l10-5-6.2-8.2c-1.2-1.5-2.2-3.1-3-4.8-4.8-9.8-3.6-21.8 3.1-30.4 2.6-3.3 5.7-5.9 9.3-7.7 3.8-2 8-2.9 12.2-2.9 5.7 0 11.3 1.8 16.1 5.3l6.9 5 5-6.9c2.4-3.3 5.4-5.9 9-7.7 5.9-3 12.6-3.5 18.9-1.4 6.4 2.1 11.6 6.7 14.7 12.9 2.2 4.5 3.1 9.6 2.5 14.6l-.3 2.9 1.5 2.5c.7 1.1 1.3 2.3 1.9 3.5 5 10.3 6 22 2.9 32.8-.2-.1-.3-.2-.5-.3-2.1-1.5-4.3-2.8-6.6-3.9-.3-.2-.7-.3-1.1-.5-2.3-1.1-4.6-2-7-2.7-.4-.1-.7-.2-1.1-.3-2.4-.7-4.8-1.2-7.3-1.5-.4 0-.7-.1-1.1-.1-2.5-.3-5-.4-7.5-.3-.3 0-.6 0-1 .1-2.5.1-5 .4-7.5.9-.3.1-.5.1-.8.2-2.5.5-5 1.2-7.5 2.2-.2.1-.4.2-.6.2-2.5 1-4.9 2.1-7.3 3.5-.1.1-.2.1-.3.2-2.4 1.4-4.7 3-6.9 4.9-20.5-1.5-40.6 7.6-53.1 24.2l-1.5 2.1c-.6.3-1.2.5-1.8.8-.2-1.1-.4-2.1-.5-3.2-.1-.5-.2-1-.2-1.5-.1-1.9 0-3.8.2-5.6 0-.4.1-.7.2-1 .2-1.5.5-3 1-4.4.2-.6.4-1.2.7-1.8.4-1.1.9-2.3 1.4-3.4.3-.6.7-1.2 1-1.8.6-1 1.3-2 2-2.9zm-65-70.8l2.7-3.2c1.4-1.7 3-3.3 4.8-4.7 11.9-9.7 28.5-10.6 41.3-2.4 6.4 4.1 11.3 10.2 14.1 17.5-.2.3-.3.6-.4.8-.4.7-.8 1.5-1.2 2.3-.5 1-1.1 2.1-1.5 3.2l-.9 2.4c-.4 1.1-.7 2.2-1 3.3-.2.8-.4 1.7-.6 2.6-.2 1.1-.4 2.2-.6 3.4-.1.9-.2 1.7-.3 2.6-.1 1.2-.1 2.3-.1 3.5v2.5c.1 1.2.2 2.4.4 3.6l.3 2.4c.2 1.3.6 2.6 1 4 .2.6.3 1.3.5 1.9.6 1.9 1.4 3.9 2.3 5.7-1.6 1.2-3.1 2.6-4.6 4l-.9.9c-1.4 1.4-2.6 2.9-3.8 4.4-.2.3-.4.6-.6.8-1.1 1.5-2 3-2.9 4.5-.1.2-.3.5-.4.7-.9 1.7-1.7 3.5-2.4 5.3-.2.4-.3.8-.5 1.2-.7 1.8-1.3 3.7-1.7 5.6 0 .2-.1.4-.1.6-.4 1.8-.7 3.6-.9 5.4 0 .4-.1.8-.1 1.2-.2 1.9-.2 3.8-.1 5.7 0 .4.1.8.1 1.3.1 1.8.3 3.6.6 5.5 0 .2 0 .3.1.5-3.4-.7-6.7-2.1-9.6-3.9l-9.6-6.3-3.7 9.9c-.7 1.8-1.5 3.5-2.5 5.1-5.8 9.4-16.2 14.2-26.8 12.8-.6-.1-1.3-.1-1.9-.2-3.4-.7-6.5-1.9-9.4-3.8-1.3-.8-2.6-1.8-3.7-2.8-3.4-3.1-6-7.1-7.6-11.7-1.3-3.8-1.8-7.8-1.5-11.7l.6-8.3-8.3-.8c-3.2-.3-6.4-1.3-9.9-3.1l-.1-.1c-.4-.2-.7-.4-1.1-.6-2.7-1.8-5-4-6.8-6.5-5.4-7.6-6.5-17.9-2.1-26.8v-.1l1-2c.1-.1.1-.2.2-.3l.1-.2c.3-.5.8-1.1 1.2-1.6.3-.5.6-.9 1-1.4 2.4-2.7 5.2-4.9 8.4-6.3l2.7-1.2 1.3-2.6c.6-1.2 1.2-2.3 1.9-3.5 8.5-13.7 23.6-21.7 39.5-21h4.1zm-85.1-69.6c16.5-2.1 32.6 8 38.2 24.1l2.1 6.1 6.4-.4c14.3-.8 27.2 8.7 31.2 22.4l-.3.3c-2.4 0-4.7.3-7 .6-.7.1-1.5.3-2.2.4-1.6.3-3.2.6-4.7 1-.8.2-1.6.4-2.4.7-1.5.5-3 1-4.4 1.5-.7.3-1.5.5-2.2.9-1.7.8-3.4 1.6-5.1 2.5-.4.2-.8.4-1.1.6-2 1.2-3.9 2.4-5.8 3.8l-1.5 1.2c-1.3 1.1-2.6 2.1-3.9 3.3-.6.6-1.2 1.1-1.7 1.7l-1.7 1.7c0-.2-.1-.3-.1-.5-.2-1.5-.6-3-1-4.6-.3-1.1-.5-2.3-.8-3.4-.5-1.6-1.2-3.1-1.8-4.6-.4-1-.8-2.1-1.3-3-.8-1.6-1.9-3.1-2.9-4.7-.5-.8-.9-1.6-1.5-2.4-1.7-2.2-3.6-4.3-5.6-6.3-1.6-1.5-3.4-2.8-5.2-4.1-.4-.3-.8-.6-1.3-.9-1.8-1.1-3.6-2.2-5.4-3-.4-.2-.9-.4-1.3-.6-1.6-.7-3.1-1.3-4.8-1.8-.6-.2-1.2-.4-1.8-.5-1.9-.5-3.8-.9-5.8-1.2-.3 0-.5-.1-.8-.2-.1-.4-.2-.8-.3-1.1-.3-1.2-.6-2.5-1-3.7-.2-.7-.4-1.4-.7-2-.5-1.3-1-2.6-1.6-3.8-.2-.5-.5-1.1-.7-1.6-.9-1.7-1.9-3.4-3-5-.2-.3-.4-.5-.6-.8-.9-1.3-1.9-2.6-3-3.8-.1-.1-.2-.3-.4-.5 5.4-4.5 11.9-7.4 18.8-8.3zm-41.8 12.1c2.1.9 4.1 2.1 6.1 3.6 1.2.9 2.3 1.9 3.4 3 .3.3.5.6.8.9.9.9 1.7 1.9 2.5 3 .1.2.3.3.4.5.8 1.2 1.5 2.5 2.2 3.8.2.3.3.7.5 1 .5 1.1.9 2.2 1.3 3.4.1.2.1.4.2.6-1.5.4-3 .9-4.5 1.4h-.1c-2 .7-3.8 1.6-5.7 2.5-.5.2-.9.5-1.4.7-1.8 1-3.6 2.1-5.3 3.4-2.2-.9-4.4-1.7-6.7-2.3-.2-.1-.4-.2-.6-.2.1-.6.1-1.1.2-1.7.2-1.3.4-2.6.5-3.9.1-.9.2-1.9.2-2.8v-3.9c0-.9-.1-1.9-.2-2.8-.1-1.3-.4-2.6-.6-4-.2-.9-.3-1.8-.5-2.6-.3-1.4-.8-2.7-1.2-4-.2-.6-.3-1.3-.6-1.9 3.1.3 6.2 1 9.1 2.3zm-16.6 40.8c.7.1 1.4.1 2.1.2 4.2.7 8.2 2.2 11.8 4.3L942 84l4.6-4.6c5.3-5.2 12.3-8.3 19.9-8.7 8.2-.4 15.9 2.4 21.8 7.9 1.3 1.2 2.5 2.6 3.6 4 .3.4.6.9.9 1.4.7 1 1.4 2 1.9 3 .3.6.5 1.3.8 1.9.4 1 .9 1.9 1.2 2.9.2.7.3 1.4.5 2.1.2 1 .5 2 .7 2.9.1.7.1 1.5.2 2.3.1 1 .2 2 .2 2.9 0 .8-.1 1.6-.2 2.3-.1 1-.1 1.9-.3 2.9-.1.8-.4 1.6-.6 2.4-.2.9-.4 1.8-.7 2.7-.3.8-.7 1.5-1 2.3-.4.8-.7 1.7-1.2 2.5-.1.1-.1.1-.1.2-1.2 1.5-2.3 2.9-3.2 4.4l-.3.6-7.7 8.4 3.3 2v.1c-.5 1.8-.9 3.6-1.1 5.4-.1.4-.1.8-.2 1.2-.2 1.8-.3 3.6-.3 5.4v.7c0 1.7.2 3.3.4 4.9 0 .4.1.7.1 1.1.3 1.7.7 3.5 1.2 5.2.1.3.2.7.3 1 .5 1.6 1.1 3.2 1.8 4.7.1.2.1.3.2.5.8 1.6 1.7 3.2 2.6 4.7.2.3.4.7.7 1 1 1.5 2.1 2.9 3.3 4.3l.4.4c1.1 1.2 2.4 2.4 3.7 3.5.2.1.3.3.4.4-.5.8-1.1 1.6-1.7 2.3l-.3.3c-.3-.1-.5-.1-.8-.1-1.5-.3-3-.5-4.4-.7-.5-.1-1.1-.1-1.6-.2-1.4-.1-2.8-.2-4.2-.2h-1.2c-1.8 0-3.6.1-5.3.3-.4 0-.8.1-1.2.2-1.4.2-2.7.4-4.1.7-.6.1-1.2.2-1.7.4-1.3.3-2.5.7-3.8 1.1-.5.2-1 .3-1.4.4-1.6.5-3.1 1.2-4.7 1.9l-1.8.9c-1 .5-2 1-2.9 1.5-.7.4-1.3.8-2 1.2-.9.6-1.8 1.2-2.8 1.9-.4.3-.9.6-1.3.9v-.3c0-1-.1-1.9-.2-2.9-.1-.8-.1-1.5-.2-2.3-.1-1-.4-2-.6-3-.1-.7-.2-1.4-.4-2.1-.3-1.1-.6-2.2-1-3.3-.2-.6-.3-1.2-.5-1.8-.6-1.7-1.3-3.3-2-4.9-1-2-2.1-3.9-3.3-5.7-.3-.4-.5-.8-.8-1.2-1.2-1.7-2.5-3.4-3.8-4.9-.2-.3-.5-.5-.7-.8-1.3-1.4-2.7-2.7-4.1-3.9-.2-.2-.5-.4-.7-.6-1.6-1.3-3.2-2.5-5-3.6-.4-.2-.7-.5-1.1-.7-1.8-1.1-3.6-2.1-5.5-2.9-.1 0-.1 0-.2-.1-1.9-.8-3.8-1.5-5.7-2.1-.4-.1-.8-.2-1.1-.3-2-.5-4-1-6-1.3-.3 0-.7-.1-1-.1-1.9-.2-3.9-.4-5.9-.4h-.8c-1.1 0-2.2.1-3.2.2-.4 0-.9 0-1.3.1-1.3.1-2.6.3-3.9.5-.2 0-.4.1-.7.1l.6-2.8-2.5-3.2c-2.6-3.2-4.6-6.9-6-11-2.8-8-2.7-16.8.1-24.8 1.6-4.4 3.8-8.3 6.8-11.7l.9-1c7.7-8.3 18.6-12.3 29.7-11zm-73.2-35.1l6.4 1.2 2.8-5.8c7.2-14.7 24.4-21.2 39.1-14.8 4.7 2.1 8.9 5.3 12.1 9.5.8 1.1 1.5 2.2 2.2 3.3.2.4.4.7.6 1.1l1.2 2.4c.2.4.3.9.5 1.3.3.8.6 1.6.8 2.5.1.4.2.9.3 1.3.2.9.4 1.8.5 2.7.1.4.1.7.1 1.1.1 1 .2 2 .2 3.1v.8c0 1.2-.1 2.4-.2 3.6v.3c-.2 1.5-.5 2.9-.9 4.4-.1 0-.3.1-.4.1-2.5.2-5 .6-7.4 1.1l-2.1.6c-1.8.5-3.5 1-5.2 1.7-.9.3-1.7.7-2.5 1.1-1.6.7-3.2 1.5-4.7 2.4-.7.4-1.5.8-2.2 1.3-2.2 1.4-4.2 2.9-6.2 4.6h-.1c-.2-.1-.4-.2-.6-.2-1.1-.5-2.1-1-3.2-1.5-.4-.2-.8-.4-1.3-.5-1.5-.6-3-1-4.6-1.4-.5-.1-.9-.2-1.4-.3-1.1-.2-2.2-.5-3.4-.6-.6-.1-1.3-.1-1.9-.2-1-.1-2-.2-3-.2-.3 0-.7-.1-1-.1s-.5.1-.8.1c-1.9 0-3.8.1-5.7.4h-.1c-4-9.4-11.7-19.5-21.9-26 4.6-1.2 9.3-1.3 14-.4zM745 102.4c1.1-1.1 2.2-2.2 3.5-3.1 3-2.4 5.9-4.1 8.9-5.2l5.9-2.3-.5-6.3c-1.4-16.4 10-31.2 25.9-33.6 1.5-.2 3-.3 4.5-.3 2.6 0 5.1.3 7.7 1 11.9 3.2 20.7 13.2 22.5 25.4l1.4 11.3 10-3.7c1.7-.6 3.5-1.1 5.3-1.4 3.1-.5 6.3-.4 9.5.3.7.2 1.5.3 2.2.6 1.8.5 3.6 1.3 5.2 2.2.5.3 1 .7 1.5 1 1.1.7 2.1 1.4 3.1 2.2l1.5 1.5c.8.8 1.6 1.7 2.4 2.6.5.6.9 1.2 1.3 1.9.4.5.7 1.1 1 1.7v.1c-.6 2.1-1 4.1-1.3 6.2-.1.5-.1.9-.2 1.4-.3 2.2-.5 4.3-.5 6.5s.1 4.3.4 6.5c.1.5.1.9.2 1.4.3 2.1.7 4.2 1.2 6.2v.1c-.4.7-.7 1.4-1.2 2.1-.1.1-.1.2-.2.3l-.1.1c-1.9-.6-3.8-1.2-5.8-1.6-.5-.1-1.1-.2-1.6-.3-1.4-.3-2.8-.5-4.3-.7-.7-.1-1.3-.1-2-.2-1.3-.1-2.6-.2-4-.2h-2.1c-1.3 0-2.6.1-3.9.3-.7.1-1.4.2-2.2.3-1.3.2-2.6.4-3.9.7-.7.1-1.4.3-2.1.4-1.4.3-2.7.8-4.1 1.2-.6.2-1.1.3-1.7.5-1.9.7-3.8 1.5-5.6 2.4-2.1 1-4.1 2.2-6 3.5-.4.3-.8.5-1.2.8-1.8 1.3-3.6 2.6-5.3 4.1-.3.3-.6.5-.9.8-1.6 1.4-3 2.9-4.4 4.5l-.5.5c-1.5 1.7-2.8 3.5-4 5.3-.3.4-.5.8-.8 1.1-1.2 1.9-2.3 3.8-3.3 5.7-.1.2-.2.5-.3.7-.9 1.9-1.7 3.8-2.4 5.8-.1.3-.3.7-.4 1-.7 2.1-1.2 4.2-1.7 6.4-.1.4-.2.9-.3 1.4-.4 2.2-.7 4.4-.9 6.6-.6-.3-1.2-.6-1.7-.9-.3-.2-.7-.4-1-.6-1.8-1.1-3.5-2.4-5.1-3.8-.3-.2-.6-.5-.8-.8-1.6-1.5-3.2-3.1-4.6-4.8l-2.2-2.7-1.1-1.5h-.1l-1.8-2.2-2.8 2.2c-2.9 0-5.7-.4-8.6-1.2-13.9-3.8-24.2-15.6-26.3-30-1.3-11.6 2.4-23.1 10.7-31.4zm-113.3 27.4c1.4-17 14.3-31.1 30.9-33.4l6.3-.9.9-6.3c2.3-16.3 16.7-28 32.6-26.7 11.9 1 22.2 9.1 26.3 20.6 1.1 3.2 1.7 6.5 1.8 9.9-.3.4-.6.8-1 1.2-.6.7-1.1 1.4-1.7 2.1-.7.9-1.3 1.8-1.9 2.8-.5.7-1 1.5-1.4 2.3-.6 1-1.1 2-1.6 3-.4.8-.8 1.6-1.1 2.4-.5 1-.9 2.1-1.2 3.2l-.9 2.4c-.3 1.1-.6 2.2-.9 3.4l-.6 2.4c-.2 1.2-.4 2.4-.5 3.6-.1.8-.2 1.5-.3 2.3-.1 1.3-.1 2.7-.1 4.1 0 .7-.1 1.3 0 2 .1 2 .2 4.1.5 6.1.4 2.5.9 5 1.6 7.4.2.8.6 1.6.8 2.4.5 1.6 1.1 3.1 1.8 4.6.4.9.9 1.7 1.4 2.6l2.1 3.9c.6.9 1.2 1.7 1.8 2.6.8 1.2 1.7 2.3 2.6 3.4l2.1 2.4c1 1 1.9 2 3 2.9.8.7 1.6 1.4 2.5 2.1 1.1.9 2.2 1.7 3.3 2.5.9.6 1.8 1.2 2.7 1.7 1.2.7 2.5 1.4 3.7 2 1 .5 1.9.9 2.9 1.4.4.2.7.4 1.1.5v1.7c-1.3-.1-2.5 0-3.8 0H746c-2.2.1-4.3.3-6.4.6h-.2c-1.9.3-3.8.7-5.6 1.3-.5.2-1.1.4-1.6.5-1.3.4-2.6.9-3.9 1.4-.6.3-1.2.6-1.8.8-1.1.5-2.3 1.1-3.3 1.8-.6.3-1.2.7-1.7 1.1-1.1.7-2.1 1.5-3.1 2.3-.5.4-1 .7-1.4 1.1-1.4 1.2-2.7 2.5-3.9 4-2.5-.5-5-.9-7.6-1.1 0-.2-.1-.3-.1-.5-.2-2.2-.6-4.3-1.1-6.4-.1-.4-.2-.7-.3-1.1-.6-2.1-1.3-4.2-2.1-6.2-.1-.3-.2-.5-.4-.8-.9-2.1-1.9-4.1-3.1-6 0 0 0-.1-.1-.1-1.2-1.9-2.5-3.7-4-5.4-.2-.2-.3-.4-.5-.6-1.4-1.6-3-3.2-4.6-4.6-.3-.2-.5-.5-.8-.7-1.6-1.4-3.4-2.6-5.2-3.8-.3-.2-.6-.4-1-.6-1.9-1.1-3.8-2.1-5.8-3-.3-.1-.5-.2-.8-.3-2.2-.9-4.4-1.6-6.7-2.2-2.3-.5-4.6-.8-6.9-1-.5 0-1-.1-1.5-.1-2.2-.1-4.4-.1-6.6.1-.4 0-.9.1-1.3.2-1.9.2-3.8.6-5.6 1.1-.5.1-1 .2-1.4.3-2 .6-4 1.3-6 2.2-.3.1-.6.2-.8.3-.7-1-1.3-2.1-1.9-3.1-.3-.6-.8-1.2-1.1-1.8-.9-1.8-1.7-3.6-2.3-5.5-1.6-5.2-2.1-10-1.8-14.8zm-45.1 148c-22.3-11.9-33.8-20.6-34.2-20.9-.1 0-.1-.1-.2-.1-5-10.9-4.6-24.1 1.9-34.8l3.2-5.4-4.2-4.7c-11-12.2-10.8-31 .5-42.9 5.7-6 13.2-9.4 21.4-9.5h.6c7.9 0 15.4 3.1 20.9 8.5l8.1 8.2 5.7-9c1-1.6 2.1-3.1 3.4-4.4 2-2.2 4.4-3.9 7-5.3 0 .1.1.1.1.2 1.1 2.2 2.4 4.3 3.8 6.3 0 .1.1.2.1.3-1.2 1.2-2.3 2.5-3.3 3.8-.3.3-.5.7-.8 1-.9 1.2-1.7 2.4-2.5 3.6-.3.4-.5.9-.8 1.3-.9 1.6-1.8 3.2-2.5 5-22 2.4-40.8 19-45.9 41.3-.6 2.6-.9 5.2-1.2 7.8 0 .3-.1.6-.1.9-.2 2.5-.1 4.9 0 7.3 0 .4 0 .8.1 1.2.2 2.4.6 4.7 1.1 6.9l.3 1.2c.6 2.3 1.3 4.5 2.1 6.7.1.3.3.6.4.9.9 2.2 2 4.4 3.2 6.5.1.1.2.3.2.4 1.2 2.1 2.6 4 4.1 5.9.1.2.3.3.4.5 1.5 1.8 3.2 3.6 4.9 5.2l.8.8c1.7 1.6 3.6 3 5.6 4.3.2.1.3.3.5.4-1.5.4-3.1.5-4.7.6zm109.5 4.6c1 4 1 8.1.1 12.1-.4 1.8-1 3.6-1.9 5.3-.8 1.7-1.9 3.4-3.1 5-4.5 5.7-10.9 9-17.7 9.5-6.2-2-12.3-4.1-18.1-6.2-.6-.5-1.2-1.1-1.8-1.7l-2-2.2-3-.4c-1.3-.2-2.6-.4-3.8-.7-13.8-3.2-24.9-12.7-30.7-26.1-.7-1.7-1.4-3.4-1.9-5.2l-1.2-3.9-3.8-1.5c-16.4-6.6-25.8-24.8-21.8-42.4 3.7-16.5 18.4-28.4 34.9-28.4h.3l6.4.1 1.8-6.2c1.9-6.6 5.8-12.2 11.3-16.3h.1c.1-.1.2-.2.4-.3l.9-.6c7-4.7 15.4-6.3 23.5-4.4 3.7.9 7.1 2.4 10.1 4.5 9 6.2 14.5 17.2 13.4 28.8-.1 1.4-.3 2.8-.6 4l-2.6 10.9 10.4.3c1.8.1 3.7.3 5.4.7 14.9 3.5 24.2 18.8 20.8 34.1-2.3 10.2-9.9 18.2-19.9 20.9l-8 2.2 2.1 8.1zM798.6 312c-.5 0-1 0-1.5-.1l-10.2-.7 1.2 10.2c.4 3.8-.1 7.3-1.6 10.3-1.9 3.9-5 6.4-7.9 7.9-13.8-2.2-27-4.7-39.5-7.4-2.1-1.9-4.1-4-5.7-6.2l-1.4-1.9-2.2-.9c-1.5-.6-3-1.3-4.5-2.1-6.1-3.1-11.7-7.1-16.6-11.8.2-.3.2-.6.4-.8.6-1.1 1.1-2.2 1.6-3.4.2-.5.5-1 .7-1.6.6-1.7 1.2-3.4 1.5-5.1.9-4.1 1.3-8.2 1-12.3 12.5-5.8 21.7-17.1 24.8-30.9.4-1.9.7-3.9.9-5.8 0-.5.1-1 .1-1.5.1-1.6.1-3.2 0-4.8v-1c-.1-1.9-.4-3.7-.7-5.5-.1-.5-.2-.9-.3-1.3-.3-1.5-.7-2.9-1.2-4.3-.1-.4-.3-.8-.4-1.3-.6-1.7-1.3-3.4-2.1-5-.2-.3-.3-.6-.5-.9-.7-1.3-1.5-2.7-2.3-3.9-.3-.4-.5-.8-.8-1.2-1.1-1.5-2.2-2.9-3.4-4.3l-.2-.2c-1.2-1.3-2.5-2.5-3.8-3.6l-.5-.5.5-.8c5.7-9.7 18.7-14 33.2-11.1 2.1.4 4.2 1 6.1 1.6 2.3.8 4.5 1.7 6.5 2.7 1.6.8 3.2 1.8 4.7 2.8.5.3.9.6 1.4 1 1 .7 2 1.5 3 2.2.5.4 1 .8 1.4 1.2.9.8 1.7 1.6 2.5 2.4l1.3 1.3c.2.2.4.5.6.7-.1.3-.1.6-.2.9-.2.8-.4 1.7-.6 2.5-.3 1.2-.5 2.4-.7 3.6-.1.9-.3 1.8-.4 2.6-.1 1.2-.3 2.4-.3 3.5-.1.9-.1 1.8-.1 2.7v3.5c0 .9.1 1.8.1 2.7.1 1.2.2 2.4.4 3.5.1.9.2 1.7.3 2.6.2 1.2.5 2.4.7 3.6.2.8.3 1.6.5 2.4.3 1.3.8 2.6 1.2 3.9.2.7.4 1.4.6 2 .7 1.9 1.5 3.9 2.4 5.8.4.9.9 1.8 1.3 2.6-.6 7.8.9 15.7 4.2 22.8.1.3.3.5.4.8v4.5c0 1.2.2 2.4.3 3.6.1.8.1 1.5.2 2.3.2 1.3.5 2.6.7 3.8.1.6.2 1.2.4 1.9.5 1.9 1.1 3.7 1.7 5.5l.9 2.1c.1.7 0 1.4-.1 2.2zm.9 30.6c.8-1.2 1.6-2.3 2.2-3.5.4-.8.7-1.7 1-2.6 1.4 2.6 3.2 5 5.2 7.3l-8.4-1.2zm11.8-61.8c-.2-.3-.5-.6-.7-.9-.4-.6-.7-1.3-1.1-1.9-2.4-5-3.2-10.5-2.4-16.1l.4-2.9-1.5-2.6c-.7-1.2-1.4-2.5-2-3.8-2.1-4.4-3.5-9-4.2-13.8-.5-3.2-.6-6.3-.5-9.6.2-4.8 1.2-9.6 2.8-14.3 1.5-4.2 3.4-8.1 5.8-11.6l2.8.6-.7-3.7.5-.8-1.2-3.9c-.4-1.4-.7-2.9-1-4.3-3.3-17.9 5.8-36 22.2-44.1 1.4-.7 2.8-1.3 4.2-1.8.5-.2 1.1-.3 1.6-.5.9-.3 1.8-.6 2.8-.8.6-.1 1.3-.2 1.9-.3.8-.2 1.7-.3 2.5-.4.7-.1 1.3-.1 2-.1.8-.1 1.7-.1 2.5-.1s1.7.1 2.5.1c.6 0 1.2 0 1.8.1.9.1 1.7.3 2.6.4.6.1 1.1.2 1.7.3.9.2 1.9.5 2.8.8.5.1 1 .2 1.4.4 1.4.5 2.8 1 4.1 1.7 4.6 2.2 8.6 5.1 12 8.7l2.1 2.4 4 5.1.7-.3 6.8 7.4.6-10.3c16.1-5.6 33.9 1.5 41.2 16.9 1 2.1 1.8 4.3 2.3 6.6.5 2.2.9 4.5.9 6.8.2 4.6-.6 9.3-2.3 13.7-.2.6-.5 1.1-.8 1.6-.6.2-1.2.5-1.8.7-1.1.4-2.1.8-3.1 1.2-1.2.5-2.5 1.1-3.7 1.7-1 .5-2 1-2.9 1.6-1.2.7-2.3 1.4-3.5 2.2l-2.7 1.8c-1.1.8-2.2 1.7-3.2 2.6l-2.4 2.1-3 3c-.7.7-1.4 1.5-2.1 2.2-1 1.1-1.9 2.3-2.8 3.5-.6.8-1.2 1.5-1.7 2.3-.9 1.4-1.8 2.8-2.6 4.3l-1.2 2.1c-1.1 2.2-2.2 4.5-3.1 6.8-.3.9-.7 1.8-1 2.7-5.9 4.9-10.5 11.2-13.3 18.5-.6 1.4-1 2.9-1.4 4.4-.1.5-.2 1-.3 1.4-.2 1-.5 2-.6 3-.1.6-.2 1.1-.2 1.7-.1.9-.2 1.9-.3 2.8 0 .6-.1 1.2-.1 1.8v3.8c-.6-.2-1.2-.5-1.7-.7l-1.2-.6c-1.3-.7-2.5-1.4-3.7-2.3l-6.8-4.9-5 6.7c-2.8 3.7-6.2 6.6-10.3 8.6-9.9 4.9-21.3 3.4-29.5-2.9-.8-.6-1.5-1.4-2.3-2.1-.5-.5-1.1-.9-1.5-1.4-.6-1-1.4-2.1-2.1-3.3zm67 48.1l-5.9-4.4-5.2 5.2c-3.6 3.6-7.9 6.4-12.7 8.3-8.8 3.5-18.3 3.5-26.1.1-4.1-1.8-9.5-5.4-12.1-12.3-.7-1.9-1.1-4-1.3-6.3-.2-2.8.2-5.5 1-8.1l1-3.2-.7-1.4c.2.1.5.2.8.3.6.3 1.2.5 1.8.7 1.1.4 2.2.8 3.2 1.1.7.2 1.3.4 2 .5 1.1.3 2.2.5 3.3.7.7.1 1.3.2 2 .3 1.3.1 2.6.2 3.9.2.4 0 .8.1 1.2.1h.3c.9 0 1.8-.1 2.7-.2.7-.1 1.5-.1 2.2-.2 1-.1 1.9-.3 2.9-.5.7-.1 1.4-.2 2.1-.4 1.1-.3 2.1-.6 3.2-.9.6-.2 1.1-.3 1.7-.5 1.6-.6 3.2-1.3 4.8-2 4.1-2 7.9-4.6 11.2-7.8 2.1 1.1 4.4 1.9 6.7 2.7.6.2 1.1.4 1.7.5 2.3.7 4.7 1.2 7.1 1.5.1.2.3.4.4.6 1.1 1.9 2.3 3.8 3.7 5.5.1.2.3.4.4.5 1.4 1.8 3 3.4 4.7 5 .3.3.6.6 1 .9 1.7 1.5 3.5 2.8 5.4 4 .3.2.7.4 1 .6 2 1.2 4.1 2.3 6.3 3.2 4.2 1.7 8.5 2.7 12.9 3 .3 1.1.7 2.2 1.1 3.3-1.8 1-3.7 1.9-5.6 2.7-12.1 4.6-25.1 3.4-34.1-3.3zm34.7 20.8c1.9-.5 3.7-1.1 5.6-1.9 2.7-1.1 5.4-2.4 7.9-3.8 1.7 2 3.5 3.8 5.4 5.5-6.2.1-12.5.2-18.9.2zm80.7-41.6l-1.8 10.4c-.2 1.2-.5 2.4-.8 3.5-.2.8-.5 1.6-.8 2.4-2.9 7.6-8.6 13.6-16 16.8-7.3 3.2-15.5 3.4-23 .4-6.6-2.6-11.9-7.3-15.3-13.5-2-3.6-3.3-7.6-3.8-11.7l-1-8.3-8.3.8c-1.1.1-2.2.1-3.3.1-3.2-.1-6.4-.7-9.4-1.9-1.8-.7-3.5-1.6-5.1-2.6s-3-2.2-4.4-3.6c-2.6-2.7-4.8-5.9-6.2-9.5-2.7-6.6-2.7-13.9-.2-20.5 1.9-5.1 5.3-9.4 9.7-12.5l2.4-1.7.8-2.8c.4-1.4.8-2.7 1.4-4.1 2.1-5.4 5-10.3 8.7-14.5 6.1-7 14.2-12.1 23.5-14.6 1.8-.5 3.7-.9 5.6-1.2l4.1-.6 2.1-3.6c.4-.7.8-1.4 1.4-2.2 9.4-14.4 27.4-20.8 43.7-15.6l2.7.9c3.8 1.5 7.5 3.8 10.9 6.6 10.5 8.9 15.8 22.9 13.7 36.5l-.9 6.3 5.7 2.7c1.6.7 3.2 1.7 4.9 2.8 12.9 9 18 25.5 12.4 40.1-.8 2.1-1.8 4.2-3.1 6.1-1.1 1.7-2.2 3.2-3.5 4.6-.5.5-1.1 1-1.6 1.5-.8.8-1.7 1.6-2.6 2.4-8.9 6.8-21.1 8.8-32 4.5l-10.6-4.4zm66.7 9.2c-1.4 7.6-5.5 14.1-11.8 18.4-6 4.2-13.3 5.7-20.4 4.4-5.9-1.1-11.2-4.1-15.1-8.5h1.5c1.9.1 3.8 0 5.7-.1.6-.1 1.3-.1 1.9-.2 1.7-.2 3.4-.5 5.1-.9.6-.1 1.1-.2 1.7-.4 2.1-.6 4.2-1.2 6.2-2.1.1 0 .1 0 .2-.1 2.1-.9 4.2-1.9 6.1-3.1l1.5-.9c1.4-.9 2.8-1.9 4.2-3 .6-.4 1.1-.9 1.7-1.4 1.3-1.1 2.5-2.3 3.7-3.6.4-.4.8-.8 1.2-1.3.1-.2.3-.3.5-.5l1.5.3c1.6.3 3.3.5 4.9.6l-.3 2.4zm74.3-18.2c-1.4 7.6-5.5 14.1-11.8 18.4-6 4.2-13.3 5.7-20.4 4.4-7.9-1.5-14.8-6.5-18.9-13.8-1.1-2-1.9-3.8-2.5-5.6l-2.5-8.1-8.1 2.5c-1.1.3-2.2.6-3.3.8-.3.1-.6.1-.9.1-.8.1-1.6.2-2.4.2h-.5c.1-.2.1-.4.2-.6.7-2.2 1.3-4.4 1.8-6.6 0-.3.1-.5.1-.8.4-2.3.7-4.5.7-6.8v-.3c.1-2.3 0-4.6-.3-6.8 0-.3-.1-.6-.1-1-.3-2.2-.7-4.3-1.2-6.4-.1-.4-.2-.7-.3-1.1-.6-2.1-1.3-4.1-2.1-6.1-.1-.3-.3-.6-.4-1-.9-2-1.9-4-3.1-5.9-.1-.2-.2-.3-.4-.5-1.2-1.9-2.6-3.8-4-5.5-.1-.1-.2-.2-.2-.3-1.5-1.7-3.1-3.4-4.9-4.9-.1-.1-.2-.3-.4-.4.2-.9.4-1.8.7-2.7.1-.4.2-.8.4-1.2.6-1.8 1.3-3.5 2.1-5.1.2-.4.4-.7.6-1.1.7-1.3 1.4-2.6 2.2-3.9.3-.4.6-.9.9-1.3.2-.3.5-.7.8-1h.7c.8 0 1.6.1 2.5.1.5 0 .9-.1 1.4-.1.9 0 1.8-.1 2.7-.2 1-.1 2-.2 3-.4.9-.2 1.9-.3 2.8-.5 1-.2 1.9-.5 2.8-.8.9-.3 1.8-.5 2.7-.9.9-.3 1.8-.7 2.7-1.2.8-.4 1.7-.7 2.5-1.2.9-.5 1.8-1 2.7-1.6.7-.5 1.5-.9 2.2-1.4.9-.6 1.8-1.4 2.7-2.1.6-.5 1.3-1 1.8-1.5 1-.9 1.8-1.8 2.7-2.8.4-.5.9-.9 1.4-1.4 1.3-1.5 2.5-3.1 3.5-4.8 1.7.7 3.5 1.3 5.3 1.7.5.1 1 .2 1.5.4.7.2 1.4.4 2.1.5 0 0 0 .1-.1.1-1 2-1.7 4.1-2.4 6.2-.1.3-.2.7-.3 1-.6 2.1-1 4.1-1.3 6.2 0 .4-.1.7-.1 1.1-.2 2.1-.3 4.3-.2 6.4 0 .2 0 .5.1.7.1 2.2.4 4.3.9 6.4 0 .1 0 .2.1.3.5 2.1 1.1 4.2 1.9 6.2.1.3.2.6.4.9.8 1.9 1.8 3.8 2.9 5.6.2.3.4.7.6 1 1.1 1.8 2.4 3.5 3.9 5.2.2.2.4.5.6.7 1.5 1.7 3.2 3.3 5.1 4.8 3.3 2.6 6.8 4.6 10.6 6 0 1.9.2 3.7.4 5.6.1.5.1 1 .2 1.5.2 1.4.5 2.9.9 4.3.1.4.2.8.3 1.3.5 1.8 1.1 3.5 1.8 5.2.1.3.3.6.4.9.6 1.4 1.3 2.8 2.1 4.1.1.2.2.5.4.7v2.2c-.2 2.2-.4 4.2-.7 6zm12.8 14.9c1.2-2.4 2.1-4.9 2.9-7.6 2.5 1.5 5.2 2.9 7.9 3.9-3.6 1.2-7.1 2.5-10.8 3.7zm111.9-53.9l-.9.6c-.4.3-12.5 9.7-36.6 22.2-3.7-1-7.3-2.8-10.4-5.2l-8.9-7.2-4.6 9.6c-.8 1.7-1.8 3.3-2.9 4.8-4.5 6-11.1 9.8-18.4 10.8s-14.5-1-20.3-5.6c-.9-.7-1.6-1.4-2.4-2.2-6.5-6.5-9.5-15.9-8-25.1l1.4-8.2-8.2-1.5c-3.9-.7-7.5-2.4-10.7-4.8-11.1-8.7-13.2-24.9-4.6-36.2.4-.5.9-1.1 1.4-1.6l1.7-1.7c.2-.2.4-.3.6-.5l5.4-.8-1.1-2.2c1.2-.7 2.4-1.3 3.7-1.8l2.8-1 1.6-2.5c.7-1.1 1.4-2.2 2.2-3.3 1.1-1.5 2.4-2.9 3.7-4.2.4-.4.9-.8 1.3-1.2.9-.9 1.8-1.7 2.8-2.5.6-.4 1.1-.8 1.7-1.3.9-.7 1.8-1.3 2.8-1.9.6-.4 1.3-.7 1.9-1.1l3-1.5c.7-.3 1.3-.6 2-.9 1.1-.4 2.1-.8 3.2-1.1.7-.2 1.3-.4 2-.6 1.2-.3 2.5-.5 3.7-.7.5-.1 1.1-.2 1.6-.3 1.8-.2 3.6-.3 5.5-.3 2 0 4 .1 6 .4l4.1.6 3-2.9c12.9-12.6 32.4-13.7 46.6-2.7 1.7 1.4 3.4 3 5.2 5.1 9.4 11 11.5 26.6 5.5 39.7l-2.6 5.7 4.7 4.2c8.8 7.8 12.1 19.8 9.5 30.9z"
			},
			children: [
			]
		}
	]
};
var promo = {
	id: "promo",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "promo",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "promo",
					name: "",
					type: "text",
					value: "Promo icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "promo",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M978.4 852.4c0-77.6-22-146.8-79.9-245.3-57.9 98.6-79.9 167.7-77.9 245.3L720.6 997 524.8 852.4l95.9-142.6c77.9-29.4 113.9-65 199.8-167.7-147.8-33.6-189.8-25.2-251.8 0l-165.8-67.2 79.9-232.8 161.8 50.3c42 62.9 83.9 92.3 203.8 155.2-8-127.9-34-209.7-69.9-272.6V1h241.8v174.1c-40 65-57.9 153.1-71.9 272.6 121.9-62.9 163.8-92.3 205.8-155.2l161.8-50.3 79.9 232.8-165.8 67c-71.9-33.6-131.9-23.1-251.8 0 71.9 90.2 127.9 140.5 199.8 167.7l95.9 142.6L1078.3 997l-99.9-144.6z"
			},
			children: [
			]
		}
	]
};
var prohibited = {
	id: "prohibited",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.731 511.69"
	},
	children: [
		{
			id: "prohibited",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "prohibited",
					name: "",
					type: "text",
					value: "Prohibited icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "prohibited",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.845 0C114.512 0 0 114.552 0 255.886 0 397.178 114.512 511.69 255.845 511.69c141.33 0 255.886-114.512 255.886-255.804C511.73 114.552 397.175 0 255.846 0zM420.89 386.793l-61.873-61.833H290.78l96.013 95.932c-35.97 28.606-81.452 45.72-130.948 45.72-116.382 0-210.724-94.344-210.724-210.726 0-49.537 17.11-94.98 45.72-130.988L290.78 324.96h68.238L124.82 90.84c36.01-28.607 81.488-45.68 131.025-45.68 116.345 0 210.725 94.34 210.725 210.726 0 49.455-17.11 94.974-45.68 130.907z"
			},
			children: [
			]
		},
		{
			id: "prohibited",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M372.867 209.372c-.318.04-.477.04-.477.04s.158 0 .477-.04zM327.665 224.81c-.277.077-.477.077-.477.077s.2 0 .477-.077z"
			},
			children: [
			]
		}
	]
};
var recap = {
	id: "recap",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 877 713",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "recap",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "recap",
					name: "",
					type: "text",
					value: "Recap icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "recap",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "recap",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M0 712.23h876.285V0H0z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "recap",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "recap",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M766.623 109.533V0H0v602.697S0 712.23 109.492 712.23H794.04s82.245-1.746 82.245-109.533V109.533H766.62h.003zM108.028 657.637c-54.66 0-54.66-54.68-54.66-54.68V55.11h657.127v547.847c0 25.132 7.737 42.663 18.448 54.68H108.028z"
					},
					children: [
					]
				},
				{
					id: "recap",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M108.46 547.756H354.86V273.833H108.46M108.46 163.61H656.1v54.716h-547.64M409.733 547.408h246.403v-54.852H409.733M409.733 438.908h246.403v-54.852H409.733M409.733 328.686h246.403v-54.853H409.733"
					},
					children: [
					]
				}
			]
		}
	]
};
var recycling = {
	id: "recycling",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512.013 501.173"
	},
	children: [
		{
			id: "recycling",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "recycling",
					name: "",
					type: "text",
					value: "Recycling icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "recycling",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M214.35 346.622v106.02s-53.618-1.647-100.738-1.647c-68.09 0-110.415-134.913-110.415-134.913s22.96 30.54 95.532 30.54h115.62z"
			},
			children: [
			]
		},
		{
			id: "recycling",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M98.436 327.038c-55.704 0-115.572-28.36-93.586-69.232 19.44-36.258 30.828-56.865 30.828-56.865L0 175.734l119.693 3.202L168.83 274l-30.01-15.414s-27.05 45.085-40.384 68.452zM365.993 231.873l95.477-47.994s23.05 48.43 44.6 90.313c31.194 60.598-70.563 159.402-70.563 159.402s16.58-34.472-16.53-99.09c-24.603-47.56-52.984-102.632-52.984-102.632z"
			},
			children: [
			]
		},
		{
			id: "recycling",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M402.932 344.343c25.5 49.593 27.73 115.766-18.86 114.992-40.964-.824-64.618-1.455-64.618-1.455l-6.012 43.293-51.9-107.913 61.883-87.217.075 33.792s52.5 3.39 79.432 4.508z"
			},
			children: [
			]
		},
		{
			id: "recycling",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "recycling",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M188.606 173.017L99.31 117.512s29.91-44.504 55.024-84.308c36.408-57.784 172.85-22.592 172.85-22.592s-38.25 3.25-76.886 64.48c-28.58 45.424-61.692 97.925-61.692 97.925z"
					},
					children: [
					]
				},
				{
					id: "recycling",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M267.29 86.337c29.665-47.07 85.682-82.605 108.567-42.077 20.214 35.633 31.632 56.33 31.632 56.33l40.31-16.725-66.61 99.478-106.533-9.064 29.086-17.257s-23.78-46.833-36.454-70.686z"
					},
					children: [
					]
				}
			]
		}
	]
};
var reddit = {
	id: "reddit",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "reddit",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "reddit",
					name: "",
					type: "text",
					value: "Reddit icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "reddit",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M512 256c0 11.048-2.81 21.095-8.43 30.143-5.618 9.048-13.19 15.952-22.713 20.714 2.286 8.762 3.43 17.905 3.43 27.43 0 29.523-10.144 56.856-30.43 82s-47.952 45-83 59.57-73.143 21.857-114.286 21.857-79.19-7.286-114.142-21.857c-34.952-14.57-62.57-34.43-82.857-59.57s-30.428-52.477-30.428-82c0-8.953 1.048-17.906 3.143-26.858-9.714-4.763-17.524-11.763-23.43-21C2.953 277.19 0 267.047 0 256c0-15.62 5.524-29 16.57-40.143 11.05-11.143 24.477-16.714 40.287-16.714 16.19 0 30 6 41.43 18 41.523-28.952 90.57-44.38 147.142-46.286L278.57 22c.572-2.476 2-4.476 4.287-6s4.762-2 7.43-1.43l105.428 23.144c3.43-7.048 8.57-12.714 15.43-17s14.38-6.43 22.57-6.43c11.81 0 21.905 4.144 30.286 12.43s12.572 18.333 12.572 30.143-4.19 21.905-12.572 30.286-18.476 12.57-30.286 12.57-21.857-4.142-30.143-12.428c-8.285-8.286-12.428-18.333-12.428-30.143L295.714 36 266 170.857c57.143 1.714 106.57 16.952 148.286 45.714 11.048-11.618 24.667-17.428 40.857-17.428 15.81 0 29.238 5.57 40.286 16.714C506.475 227 512 240.38 512 256zm-392.57 56.857c0 11.81 4.142 21.905 12.428 30.286 8.286 8.38 18.333 12.57 30.143 12.57s21.906-4.19 30.287-12.57c8.38-8.38 12.57-18.476 12.57-30.286 0-11.81-4.19-21.857-12.57-30.143-8.38-8.286-18.476-12.43-30.286-12.43-11.618 0-21.618 4.19-30 12.572s-12.57 18.382-12.57 30zm231.427 101.43c2.095-2.096 3.143-4.572 3.143-7.43s-1.048-5.333-3.143-7.43c-1.905-1.904-4.286-2.856-7.143-2.856s-5.333.953-7.43 2.858c-7.81 8-19.332 13.905-34.57 17.714s-30.476 5.714-45.714 5.714-30.476-1.905-45.714-5.714c-15.238-3.81-26.762-9.714-34.57-17.714-2.096-1.905-4.572-2.857-7.43-2.857-2.857 0-5.238.953-7.143 2.858-2.095 1.905-3.143 4.333-3.143 7.286s1.048 5.476 3.143 7.57c8.19 8.19 19.476 14.668 33.857 19.43 14.38 4.762 26.048 7.57 35 8.43s17.62 1.285 26 1.285 17.048-.43 26-1.287 20.62-3.667 35-8.43c14.38-4.76 25.667-11.237 33.857-19.427zM350 355.713c11.81 0 21.857-4.19 30.143-12.57 8.286-8.382 12.43-18.477 12.43-30.287 0-11.62-4.19-21.62-12.572-30s-18.38-12.57-30-12.57c-11.81 0-21.904 4.142-30.285 12.428-8.38 8.286-12.57 18.333-12.57 30.143 0 11.81 4.19 21.905 12.57 30.286 8.38 8.38 18.475 12.57 30.285 12.57z"
			},
			children: [
			]
		}
	]
};
var reels = {
	id: "reels",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "reels",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "reels",
					name: "",
					type: "text",
					value: "Reels icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "reels",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.460 5.459 C 2.907 5.581,2.514 5.807,2.112 6.233 C 1.738 6.630,1.550 6.989,1.443 7.512 C 1.375 7.848,1.386 16.226,1.456 16.540 C 1.581 17.103,1.807 17.489,2.258 17.911 C 2.595 18.225,2.928 18.406,3.376 18.520 C 3.688 18.599,3.822 18.600,12.000 18.600 C 20.178 18.600,20.312 18.599,20.624 18.520 C 21.136 18.390,21.413 18.228,21.821 17.821 C 22.228 17.413,22.390 17.136,22.520 16.624 C 22.598 16.317,22.600 16.177,22.600 12.000 C 22.600 7.823,22.598 7.683,22.520 7.376 C 22.390 6.864,22.228 6.587,21.821 6.179 C 21.450 5.808,21.214 5.662,20.720 5.494 C 20.508 5.423,20.177 5.420,12.100 5.413 C 5.244 5.407,3.656 5.416,3.460 5.459 M20.568 6.727 C 20.859 6.863,21.137 7.141,21.273 7.432 L 21.380 7.660 21.380 12.000 L 21.380 16.340 21.273 16.568 C 21.137 16.859,20.859 17.137,20.568 17.273 L 20.340 17.380 12.000 17.380 L 3.660 17.380 3.432 17.273 C 3.141 17.137,2.863 16.859,2.727 16.568 L 2.620 16.340 2.620 12.000 L 2.620 7.660 2.727 7.432 C 2.912 7.037,3.300 6.720,3.694 6.641 C 3.785 6.623,7.568 6.611,12.100 6.614 L 20.340 6.620 20.568 6.727 M6.649 8.599 C 6.312 8.679,6.000 9.063,6.000 9.398 C 6.001 10.050,6.653 10.474,7.227 10.196 C 7.924 9.859,7.844 8.839,7.104 8.619 C 6.888 8.555,6.845 8.553,6.649 8.599 M16.879 8.620 C 16.453 8.755,16.198 9.226,16.319 9.656 C 16.503 10.312,17.362 10.498,17.794 9.975 C 18.335 9.320,17.689 8.363,16.879 8.620 M9.485 9.494 C 9.452 9.534,9.442 10.234,9.450 12.044 L 9.460 14.540 9.570 14.553 C 9.650 14.562,10.329 14.240,12.050 13.378 C 13.353 12.725,14.452 12.162,14.492 12.127 C 14.664 11.976,14.634 11.957,12.120 10.677 C 10.789 9.999,9.662 9.443,9.615 9.442 C 9.568 9.441,9.509 9.465,9.485 9.494 M6.500 11.226 C 5.932 11.525,5.832 12.224,6.298 12.633 C 6.489 12.801,6.609 12.846,6.866 12.846 C 7.319 12.846,7.720 12.449,7.720 12.000 C 7.720 11.702,7.515 11.382,7.232 11.236 C 7.048 11.142,6.671 11.137,6.500 11.226 M16.760 11.238 C 16.482 11.386,16.280 11.707,16.280 12.000 C 16.280 12.449,16.681 12.846,17.134 12.846 C 17.391 12.846,17.511 12.801,17.702 12.633 C 18.165 12.226,18.070 11.523,17.512 11.236 C 17.316 11.136,16.950 11.137,16.760 11.238 M6.491 13.804 C 6.043 14.026,5.882 14.507,6.106 14.957 C 6.371 15.488,7.022 15.590,7.445 15.166 C 7.806 14.805,7.809 14.328,7.455 13.973 C 7.195 13.713,6.811 13.645,6.491 13.804 M16.847 13.766 C 16.649 13.823,16.385 14.107,16.323 14.330 C 16.192 14.796,16.468 15.275,16.942 15.406 C 17.304 15.505,17.718 15.310,17.894 14.957 C 18.244 14.255,17.619 13.543,16.847 13.766"
			},
			children: [
			]
		}
	]
};
var repeat = {
	id: "repeat",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		"class": "feather feather-repeat",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "repeat",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "repeat",
					name: "",
					type: "text",
					value: "Repeat icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "repeat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21 12a1 1 0 0 0-1 1v2c0 1.669-1.331 3-3 3H3a1 1 0 0 0-1 1 1 1 0 0 0 1 1h14c2.75 0 5-2.25 5-5v-2a1 1 0 0 0-1-1zM7 4C4.25 4 2 6.25 2 9v2a1 1 0 0 0 1 1 1 1 0 0 0 1-1V9c0-1.669 1.331-3 3-3h14a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm.03 10a1 1 0 0 0-.737.293l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414 0 1 1 0 0 0 0-1.414L4.414 19l3.293-3.293a1 1 0 0 0 0-1.414A1 1 0 0 0 7.03 14zm10-14a1 1 0 0 0-.737.293 1 1 0 0 0 0 1.414L19.586 5l-3.293 3.293a1 1 0 0 0 0 1.414 1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414l-4-4A1 1 0 0 0 17.03 0z",
				fill: "#000",
				stroke: "none"
			},
			children: [
			]
		}
	]
};
var restrooms = {
	id: "restrooms",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 509.796 510.885"
	},
	children: [
		{
			id: "restrooms",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "restrooms",
					name: "",
					type: "text",
					value: "Restrooms icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "restrooms",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.091 510.878c-66.826-.001-133.653.027-200.479-.025-12.94-.01-25.362-2.427-35.994-10.319C5.689 490.937 1.554 476.945.193 461.75c-.173-1.931-.185-3.882-.185-5.824C0 323.62.002 191.313 0 59.006 0 47.068 1.567 35.471 7.445 24.82 15.683 9.893 29.188 3.212 45.353.979 50.51.267 55.77.042 60.984.04 191.348-.01 321.711-.003 452.075.006c12.098.001 23.901 1.627 34.503 7.918 14.493 8.6 20.476 22.413 22.392 38.363.711 5.914.79 11.929.792 17.898.042 130.513.045 261.026.01 391.54-.003 12.577-2.004 24.77-9.303 35.399-9.484 13.812-23.839 18.131-39.525 19.551-2.524.228-5.077.195-7.617.196-66.079.01-132.158.008-198.236.007zm-50.854-195.072l-38.143-131.598c4.023-1.453 6.148-.826 7.38 3.546 4.779 16.959 9.927 33.814 14.968 50.698 2.221 7.441 4.285 14.941 6.852 22.263 1.928 5.499 6.836 8.276 12.279 7.77 5.151-.478 9.744-4.389 10.355-9.629.353-3.024.075-6.334-.796-9.254-7.892-26.444-15.923-52.847-24.029-79.226-5.125-16.679-19.994-27.55-37.318-27.539-12.258.008-24.517-.025-36.775.025-17.405.071-31.375 10.495-36.449 27.098-4.707 15.403-9.458 30.792-14.139 46.202-3.687 12.139-7.603 24.221-10.843 36.48-2.43 9.196 3.792 16.326 12.95 15.731 5.387-.35 8.951-4.086 11.206-11.76 6.735-22.922 13.521-45.828 20.147-68.781 1.077-3.732 2.775-5.364 7.031-3.659L70.935 315.877h35.876v5.444c-.003 31.393-.011 62.787-.004 94.18.001 6.211 2.879 10.582 8.194 12.577 9.736 3.654 18.673-2.537 18.689-13.099.049-31.244.017-62.488.017-93.731v-5.054h7.838v18.271c-.001 26.759-.015 53.518.005 80.277.006 7.321 3.119 11.803 9.289 13.595 9.854 2.861 17.815-3.525 17.833-14.483.05-30.795.017-61.591.018-92.386v-5.662h35.547zm208.882-127.587v5.486c.002 24.667-.091 49.335.056 74.002.052 8.778 4.559 13.497 12.148 13.575 7.61.079 12.57-4.539 12.605-12.6.128-29.899.434-59.806-.132-89.695-.376-19.833-16.116-35.766-34.74-36.051-20.925-.319-41.863-.338-62.787.009-19.26.32-34.982 16.455-35.049 35.543-.106 29.9-.048 59.8-.008 89.7.011 8.066 4.746 13.076 12.137 13.094 7.774.018 12.567-4.998 12.564-13.136-.009-25.116-.015-50.232-.022-75.348v-4.489h5.819v5.69c.007 72.358-.001 144.715.032 217.073.006 12.582 10.483 20.242 22.144 16.321 7.332-2.466 11.013-8.247 11.018-17.573.022-41.112.01-82.225.011-123.337v-5.982l5.478.244v5.903c.002 41.561-.039 83.122.03 124.682.022 13.374 13.144 21.2 24.964 14.969 6.477-3.415 8.259-9.249 8.253-16.18-.061-72.208-.037-144.416-.036-216.625v-5.275h5.515zM240.208 81.182v5.156c-.004 111.518-.008 223.035-.009 334.553 0 1.345-.192 2.748.136 4.013.202.78 1.214 1.917 1.875 1.925 10.116.122 20.233.085 30.458.085V81.183l-32.46-.001zm-73.89 25.665c.176-16.264-12.174-28.934-28.265-28.997-15.843-.062-28.619 12.38-28.904 28.146-.284 15.708 12.314 28.718 28.021 28.936 16.356.229 28.973-11.928 29.148-28.085zm205.189 28.087c15.756.011 28.646-12.699 28.733-28.333.087-15.59-12.81-28.691-28.36-28.808-16.301-.123-28.99 12.539-28.959 28.897.031 15.811 12.604 28.234 28.586 28.244z"
			},
			children: [
			]
		}
	]
};
var rewards = {
	id: "rewards",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "rewards",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "rewards",
					name: "",
					type: "text",
					value: "Rewards icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "rewards",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.653 0h.711c.492.358 1.016.681 1.467 1.084.716.639 1.485.815 2.42.584 2.285-.564 2.411-.496 3.189 1.705.3.85.81 1.377 1.68 1.656 2.371.76 2.416.83 1.88 3.275-.18.819-.012 1.486.469 2.124.341.453.685.904 1.006 1.371.428.625.372 1.245-.084 1.834-.188.243-.372.495-.59.708-.79.773-.954 1.649-.671 2.722.486 1.845.27 2.176-1.51 2.85-.06.023-.114.064-.203.115.067.136.121.264.19.382 1.279 2.208 2.564 4.412 3.836 6.625.399.694.185 1.079-.604 1.121-.567.03-1.137.062-1.703.041-1.392-.054-2.385.482-3.046 1.754-.383.738-.971 1.37-1.467 2.049h-.142c-.217-.24-.48-.453-.644-.725-.622-1.033-1.209-2.086-1.814-3.129-.756-1.301-1.517-2.598-2.34-4.008-1.115 1.324-2.237 1.028-3.367.053-.667 1.141-1.278 2.203-1.905 3.256-.904 1.521-1.819 3.036-2.73 4.553h-.427c-.562-.844-1.134-1.682-1.681-2.536-.484-.755-1.132-1.168-2.051-1.17-.71-.002-1.419-.073-2.129-.105-1.109-.049-1.276-.331-.724-1.29 1.191-2.07 2.395-4.134 3.591-6.201.124-.214.231-.437.349-.662-.141-.078-.199-.119-.263-.144-1.752-.693-1.891-.953-1.495-2.817.02-.092.05-.182.073-.274.214-.84.073-1.591-.539-2.235-.212-.223-.403-.466-.595-.706-.735-.922-.847-1.573-.058-2.404 1.2-1.262 1.567-2.582 1.018-4.254-.281-.857.078-1.539.931-1.72 1.802-.383 2.849-1.387 3.274-3.166.179-.749.815-1.013 1.563-.89.535.088 1.059.301 1.593.322.434.017.927-.075 1.303-.283.778-.431 1.496-.971 2.239-1.465zm9.696 12.487c-.07-5.298-4.243-9.399-9.503-9.34-5.078.057-9.283 4.357-9.23 9.437.055 5.303 4.255 9.384 9.595 9.323 5.04-.057 9.205-4.351 9.138-9.42z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "rewards",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8.094 12.55c.009-4.411 3.483-7.89 7.877-7.887a7.897 7.897 0 0 1 7.933 7.939c-.009 4.305-3.558 7.833-7.892 7.844-4.335.011-7.926-3.57-7.918-7.896zm4.662 4.178c-.044.59.222.781.778.524a21.28 21.28 0 0 0 1.381-.72c.771-.428 1.531-.414 2.296.01.392.217.778.454 1.191.625.241.1.622.205.77.09.156-.121.161-.506.142-.769-.029-.398-.133-.791-.211-1.185-.183-.928.008-1.732.742-2.378.337-.297.668-.607.961-.945.156-.181.357-.478.301-.644-.058-.173-.386-.304-.619-.361-.388-.094-.793-.124-1.193-.164-.999-.099-1.737-.553-2.138-1.506a8.509 8.509 0 0 0-.569-1.138c-.125-.205-.379-.521-.506-.491-.222.051-.439.302-.574.521-.247.4-.44.834-.641 1.261-.337.717-.887 1.153-1.671 1.277-.56.089-1.125.143-1.683.245-.619.113-.737.471-.304.934.355.38.747.725 1.118 1.091.615.607.884 1.313.679 2.186-.116.504-.168 1.024-.25 1.537z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var replay = {
	id: "replay",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "replay",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "replay",
					name: "",
					type: "text",
					value: "Replay icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "replay",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M487.7 232.3c-12.7 0-23 10.3-23 23 0 115.4-93.9 209.3-209.3 209.3S46.1 370.8 46.1 255.4C46.1 140 140 46.1 255.4 46.1c33.5 0 65.4 7.7 95 22.8 20.8 10.6 39.8 24.9 56.1 41.8h-62.6c-12.7 0-23 10.3-23 23s10.3 23 23 23h110.6c12.7 0 23-10.3 23-23V23c0-12.7-10.3-23-23-23s-23 10.3-23 23v47.7C384.2 25.5 321.5 0 255.4 0 114.6 0 0 114.6 0 255.4s114.6 255.4 255.4 255.4 255.4-114.6 255.4-255.4c-.1-12.7-10.4-23.1-23.1-23.1z"
			},
			children: [
			]
		}
	]
};
var rewind = {
	id: "rewind",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "rewind",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "rewind",
					name: "",
					type: "text",
					value: "Rewind icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "rewind",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M23.598 232.3c12.714 0 23.025 10.3 23.025 23 0 115.4 94.002 209.3 209.528 209.3S465.68 370.8 465.68 255.4c0-115.4-94.002-209.3-209.528-209.3-33.536 0-65.471 7.7-95.103 22.8-20.823 10.6-39.844 24.9-56.161 41.8h62.668c12.714 0 23.025 10.3 23.025 23s-10.311 23-23.025 23H56.835c-12.715 0-23.026-10.3-23.026-23V23c0-12.7 10.311-23 23.025-23S79.86 10.3 79.86 23v47.7C127.211 25.5 189.98 0 256.151 0 397.105 0 511.83 114.6 511.83 255.4S397.105 510.8 256.15 510.8.473 396.2.473 255.4c.1-12.7 10.411-23.1 23.125-23.1z"
			},
			children: [
			]
		}
	]
};
var pause = {
	id: "pause",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 161 236",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "pause",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pause",
					name: "",
					type: "text",
					value: "Pause icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pause",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd"
			},
			children: [
				{
					id: "pause",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M135.72 0c-13.65 0-24.716 11.066-24.716 24.716v186.01c0 13.65 11.067 24.715 24.717 24.715 13.65 0 24.718-11.065 24.718-24.715V24.715C160.438 11.066 149.37 0 135.72 0M24.716 0C11.066 0 0 11.066 0 24.716v186.01c0 13.65 11.066 24.715 24.716 24.715s24.716-11.065 24.716-24.715V24.715C49.432 11.066 38.366 0 24.716 0"
					},
					children: [
					]
				}
			]
		}
	]
};
var search = {
	id: "search",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "search",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "search",
					name: "",
					type: "text",
					value: "Search icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "search",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M667.6 705.2L502.7 564.7c23.2-31.7 37-70.8 37-113.1 0-105.8-86.1-191.9-191.9-191.9S156 345.8 156 451.6s86.1 191.9 191.9 191.9c43.7 0 84.1-14.7 116.4-39.4L632 747l35.6-41.8zM347.9 589.1c-75.9 0-137.6-61.7-137.6-137.6 0-75.8 61.7-137.5 137.6-137.5s137.6 61.7 137.6 137.6c-.1 75.8-61.8 137.5-137.6 137.5z"
			},
			children: [
			]
		}
	]
};
var scissors = {
	id: "scissors",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 18 15"
	},
	children: [
		{
			id: "scissors",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "scissors",
					name: "",
					type: "text",
					value: "Scissors icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "scissors",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				strokeWidth: ".25",
				d: "M17.25 3.465s-1.003-.891-1.846-.397c-.652.386-4.78 2.525-6.62 3.478l-2.606-1.54c.281-.518.33-1.117.176-1.692-.193-.733-.703-1.423-1.454-1.868-1.355-.8-2.979-.495-3.631.68-.289.519-.337 1.12-.184 1.703.193.729.703 1.423 1.455 1.869.332.196.679.322 1.025.389 0 0 .003 0 .007.003.027.003.057.01.089.014 2.146.33 3.244.954 3.777 1.395-.533.442-1.63 1.066-3.777 1.395l-.09.014c-.003.004-.006.004-.006.004-.346.066-.693.196-1.025.39-.752.448-1.262 1.138-1.455 1.868-.153.581-.105 1.184.184 1.703.652 1.174 2.276 1.482 3.631.68.751-.445 1.261-1.136 1.454-1.868.153-.576.105-1.175-.176-1.69l2.605-1.539c1.841.95 5.973 3.091 6.621 3.474.843.494 1.846-.392 1.846-.392l-6.846-4.039 6.846-4.034zm-12.183.9c-.3.533-1.162.621-1.893.19-.427-.253-.75-.652-.859-1.07-.048-.185-.078-.455.061-.704.296-.533 1.162-.62 1.89-.193.434.256.746.645.858 1.069.052.187.079.46-.057.709zm.057 6.976c-.112.424-.424.813-.859 1.069-.727.431-1.593.343-1.889-.192-.14-.25-.109-.52-.06-.706.108-.416.43-.816.858-1.068.731-.431 1.594-.344 1.893.189.136.252.109.522.057.708z"
			},
			children: [
			]
		}
	]
};
var security = {
	id: "security",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 495.676 512.36"
	},
	children: [
		{
			id: "security",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "security",
					name: "",
					type: "text",
					value: "Security icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "security",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M247.837 0C209.227 28.022 96.362 87.295 0 87.295c0 0 .596 353.178 247.837 425.065 247.25-71.887 247.84-425.065 247.84-425.065-96.357 0-209.057-59.273-247.84-87.295zm3.33 457.254l-3.335.968-3.334-.968c-189.39-55.077-192.025-315.02-192.043-326.06l-.018-11.945h11.955c67.748 0 149.53-42.81 176.432-62.337l6.99-5.072 7.008 5.055c28.157 20.342 108.36 62.354 176.468 62.354h11.955l-.018 11.944c-.02 11.04-2.653 270.983-192.06 326.06z"
			},
			children: [
			]
		},
		{
			id: "security",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M76.76 142.71c2.813 49.735 23.28 244.87 171.072 290.635 148.007-45.83 168.33-240.918 171.09-290.645-65.776-4.176-138.148-40.03-171.072-61.663-32.817 21.64-105.064 57.496-171.09 61.672zm204.81 68.384l75.37 11.163-54.653 53.126 12.735 75.224-67.355-35.683-67.522 35.33 13.04-75.156-54.45-53.41 75.403-10.763 33.86-68.33 33.57 68.5z"
			},
			children: [
			]
		}
	]
};
var settings = {
	id: "settings",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "settings",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "settings",
					name: "",
					type: "text",
					value: "Settings icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "settings",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M668 539v-83h-1.3l-67.3-9.9-2.1-6.6c-3.8-12.1-7.7-21.8-12.2-30.4L582 403l41.4-55.1.5-.5c.7-.7 1.1-1.5 1.3-1.9l-58-58c-.5.1-1.1.5-1.9 1.2l-.6.6-55.2 41.2-6.1-3.2c-9.7-5-19.9-9.2-30.3-12.5l-6.6-2.1-9.9-66.5v-.8-.4h-83.1V246.2l-9.9 67.7-6.5 2.1c-12 3.9-21.5 7.7-29.8 12l-6.1 3.2-55.6-41.8-.5-.5c-.7-.7-1.5-1.1-1.9-1.3l-58 58c.1.5.5 1.1 1.2 1.9l.6.5 41.8 55.9-3.1 6.1c-4.8 9.4-8.9 19.3-12.1 29.4l-2.1 6.6-70.9 10h-.8c-1.5 0-3 .5-3.8 1v81c.8.5 2.3 1 3.8 1h.8l70.3 10 2.1 6.5c2.8 8.9 6.8 18.1 12.5 29.1l3.1 6.1-41.8 56.3-.6.6c-.7.7-1 1.4-1.2 1.8l58.2 58.1c.5-.1 1.2-.5 1.9-1.2l.6-.6 56.2-42 6.1 3.2c9.3 4.8 19.1 8.9 29.2 12.2l6.6 2.1 10 71v.8c0 1.6.6 3.1 1.1 3.9h80.9c.5-.9 1.1-2.4 1.1-3.9v-.8l10-69.8 6.6-2.1c9-2.8 18.4-6.8 29.7-12.6l6.1-3.1L565 706l.6.6c.7.7 1.4 1 1.8 1.2l58.1-58.2c-.1-.5-.5-1.2-1.2-1.9l-.6-.6-41.4-55.4 3.2-6.1c5-9.6 9.2-19.7 12.6-30.1l2.1-6.5 66.6-9.9h.8c.1-.1.3-.1.4-.1zm-252.2 59.2c-55.7 0-101.1-45.3-101.1-101.1 0-55.7 45.3-101.1 101.1-101.1 55.7 0 101.1 45.3 101.1 101.1s-45.3 101.1-101.1 101.1z"
			},
			children: [
			]
		}
	]
};
var share = {
	id: "share",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "share",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "share",
					name: "",
					type: "text",
					value: "Share icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "share",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M611.2 245H307.1c-26.2 0-47.5 26.7-47.5 56.3 0 29.7 21.2 56.4 47.5 56.4H437c-72.4 50.9-213 172.2-263.1 374.7l.2.1c-.3 1.4-.9 2.8-.9 4.3 0 11.1 9 20 20 20 6.3 0 11.7-3.1 15.4-7.7l.5.2s161.6-214 346.2-259.4v100.5c0 24.8 26.7 44.8 56.3 44.8s56.3-20.1 56.3-44.8V301.8c.1-31.4-25.3-56.8-56.7-56.8z"
			},
			children: [
			]
		}
	]
};
var shoe = {
	id: "shoe",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "shoe",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "shoe",
					name: "",
					type: "text",
					value: "Shoe icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "shoe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.088 18.902h5.7374c.5454 0 1.0055-.4061 1.0731-.9473.0531-.4249-.1495-.8411-.5167-1.0614l-2.6495-1.5897a4.19838 4.19838 0 0 1-1.028-.8682l-.5871-.6849a4.1978 4.1978 0 0 1-.8161-1.4685l-1.0988-3.47933-.3997-.91365c-.3437-.78553-1.2546-1.1493-2.0448-.81658l-.1573.06621c-1.3128.55277-2.82642.3022-3.89108-.64416l-.28082-.24962a2.7944 2.7944 0 0 1-.93359-1.93353c-.01818-.32722-.40438-.49078-.65204-.27615L3.9336 5.68998c-.68312.59204-.75572 1.62624-.16201 2.30791L12.7306 18.2842c.3419.3925.8369.6178 1.3574.6178Zm1.2394-10.5217-.4254-.97227c-.6067-1.38675-2.2148-2.02894-3.6099-1.44155l-.1572.06621c-.8868.37336-1.90913.20411-2.62824-.43509l-.28082-.24962a1.59436 1.59436 0 0 1-.53267-1.10321c-.0735-1.3229-1.63487-1.98415-2.63611-1.1164L3.14768 4.78315C1.96287 5.81 1.83695 7.60373 2.86669 8.78603L11.8257 19.0724a3.0003 3.0003 0 0 0 2.2623 1.0296h5.7374c1.1506 0 2.1211-.8567 2.2638-1.9984.1121-.8964-.3153-1.7745-1.09-2.2393l-2.6496-1.5897a3.001 3.001 0 0 1-.7342-.6201l-.5871-.6849a2.99932 2.99932 0 0 1-.5829-1.049l-1.118-3.5403Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "shoe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1518 10.0143c-.1482-.29636-.028-.65676.2684-.80495l2.3997-1.1999c.2964-.14819.6568-.02805.805.26833.1482.29639.0281.65679-.2683.80499l-2.3998 1.19993c-.2964.1482-.6568.028-.805-.2684ZM12.0201 11.7509c-.1482-.2964-.0281-.6568.2683-.805l2.3998-1.1999c.2964-.1482.6568-.02806.805.2683.1482.2964.028.6568-.2684.805l-2.3997 1.1999c-.2964.1482-.6568.0281-.805-.2683ZM12.8884 13.4874c-.1482-.2964-.0281-.6568.2683-.805l2.3998-1.1999c.2964-.1482.6568-.028.805.2684.1482.2964.028.6568-.2684.805l-2.3997 1.1998c-.2964.1482-.6568.0281-.805-.2683ZM1.86914 16.463c0-.3313.26863-.6.6-.6h4.87792c.33137 0 .6.2687.6.6 0 .3314-.26863.6-.6.6H2.46914c-.33137 0-.6-.2686-.6-.6ZM1.86914 13.4241c0-.3314.26863-.6.6-.6h2.2731c.33137 0 .6.2686.6.6 0 .3313-.26863.6-.6.6h-2.2731c-.33137 0-.6-.2687-.6-.6ZM1.86914 19.502c0-.3314.26863-.6.6-.6h7.48275c.33141 0 .60001.2686.60001.6s-.2686.6-.60001.6H2.46914c-.33137 0-.6-.2686-.6-.6Z",
				fill: "#000"
			},
			children: [
			]
		}
	]
};
var sheraton = {
	id: "sheraton",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 624 623",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "sheraton",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "sheraton",
					name: "",
					type: "text",
					value: "Sheraton icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "sheraton",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M249.82 555.253c-16.83 0-30.494 6.728-39.568 9.043-4.957 1.34-19.418 5.15-31.292 0-2.285-.93-9.375-1.47-.927 8.242 2.306 2.748 6.79 5.473 12.198 8.22 29.01 14.322 55.087 8.437 86.38-5.862 7.737-3.656 20.603-3.31 20.387-7.355-.194-4.153-6.81-6.813-11.314-13.238-17.37-24.532-38.77-44.78-64.526-54.688-13.75-5.3-19.913-1.493-15.862 2.206 10.173 9.432 14.87 27.517 28.147 42.444 4.052 4.586 10.043 9.13 16.38 10.99M294 541.708c0-9.55 14.775-24.105 17.51-32.708 3.22 8.603 17.49 23.157 17.49 32.708 0 9.552-7.705 17.292-17.49 17.292-9.652 0-17.51-7.74-17.51-17.292M294.43 589.664c0 9.533 14.626 24.635 17.334 33.345 3.185-8.71 17.312-23.813 17.312-33.346 0-9.62-7.627-17.377-17.312-17.377-9.555 0-17.333 7.757-17.333 17.377"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M163.995 518.974c-15.48-5.455-30.054-3.687-39.618-5.024-5.03-.668-19.15-1.272-28.22-9.983-1.834-1.812-7.965-5.09-3.647 7.266.95 2.717 4.037 6.426 8.182 10.89 21.785 23.2 47.78 25.378 80.532 23.2 8.7-.625 22.756 2.674 23.706-1.38.842-3.644-6.11-7.202-8.226-14.123-8.4-28.01-20.165-53.863-40.46-71.285-10.558-9.056-18.028-7.396-15.48-2.846 6.326 11.73 4.447 29.647 11.83 47.802 2.246 5.456 6.392 11.385 11.4 15.482"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M92.942 454.567c-12.31-9.56-26.544-12.046-34.635-15.42-5.04-2.162-17.177-6.963-23.278-17.322-1.342-2.357-7.14-6.79-5.842 5.385.195 2.768 2.1 7.418 4.976 13.257 13.196 26.73 36.755 35.662 67.453 43.426 7.853 1.838 19.773 8.37 21.936 5.298 2.034-2.854-3.548-8.066-3.245-15.397 1.19-27.855-4.65-54.542-17.804-76.6C95.58 385.6 88.68 384.78 89.74 390.315c2.466 12.198-4.067 28.244-2.683 46.973.455 5.947 2.683 12.305 5.885 17.28"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M50.2 376.936c-8.67-12.233-20.39-19.21-26.92-24.574-4-3.273-12.802-11.63-15.894-22.635-.692-2.347-5.687-8.033-7.244 3.575-.368 2.692 0 7.237.865 13.18 4.39 28.644 22.834 43.634 48.33 59.442 6.94 4.35 16.022 13.87 18.703 11.78 2.81-2.132-.93-8.528 1.32-14.924 9.103-25.457 12.584-51.624 6.832-75.357-3.07-12.62-9.04-14.968-9.536-9.993-1.168 11.996-11.958 24.595-16.455 42.233-1.254 5.04-1.362 11.824 0 17.273"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M35.728 289.01c-3.155-13.182-12.096-23.122-15.6-30.49-1.87-4.084-7.004-14.413-5.894-25.563.217-1.793-1.22-8.427-7.354.93-1.436 2.268-2.937 6.828-4.11 11.84-6.31 26.233 4.98 46.524 22.428 68.845 4.59 5.856 9.116 17.438 11.966 16.357 3.023-1.254 2.806-7.672 6.83-12.274 16.622-19.188 28.087-41.596 30.72-64.263 1.39-11.906-2.633-16.595-4.526-12.295-4.72 10.653-18.536 18.518-28.5 31.894-2.893 3.89-5.96 10.004-5.96 15.017"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M46.6 207.325c0-13.155-5.215-24.477-6.86-31.767-.972-4.55-2.42-14.966.91-24.563.8-2.2.022-9.187-7.27-1.424-1.534 1.662-3.806 5.436-6.402 10.073-12.265 22.256-6.662 43.973 3.743 68.623 2.683 6.318 3.98 17.446 6.772 17.727 3.158.26 4.434-6.492 9.107-10.028 19.273-14.58 36.06-30.624 44.26-50.918 4.282-10.545 1.253-16.045-1.407-12.68-6.793 8.518-20.378 13.025-33.682 22.71-3.85 2.802-7.787 7.74-9.17 12.248"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M80.19 133.43c4.006-12.708 2.477-24.92 2.736-32.675.15-4.588.193-16.133 7.214-23.607 1.335-1.422 3.294-6.656-5.944-2.693-2.196.905-5.32 3.662-9 7.647-17.293 19.04-19.102 40.45-15.894 66.75.905 7.28-.926 18.46 1.81 19.085 3.186.732 5.835-5.105 11.822-7.26 22.094-8.098 42.83-19.298 55.817-36.336 7.042-9.175 6.16-15.12 2.262-12.75-9.11 5.772-23.473 6.224-38.59 12.255-4.457 1.767-9.496 5.493-12.23 9.586"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M130.102 75.363c7.347-9.59 9.47-20.215 12.354-26.37 1.517-3.348 5.96-11.88 13.698-16.414 1.907-1.146 5.05-5.033-4.118-4.536-1.864.108-5.982 1.274-10.057 3.174-20.288 9.59-28.676 27.234-34.268 50.084-1.408 5.81-6.415 14.988-4.118 16.392 2.276 1.382 6.416-2.375 11.422-2.29 21.48.217 42.156-2.893 58.043-12.784 8.517-5.292 9.623-10.28 5.96-9.568-9.56 1.88-21.523-2.678-35.654-2.268-4.595.173-9.602 1.836-13.264 4.58"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M188.284 36.273c7.74-6.343 11.644-15.043 15.417-19.93 1.748-2.292 6.88-9.814 14.62-11.678 1.812-.472 4.874-3.15-2.78-4.543-1.877-.322-4.982 0-9.1.9-19.084 4.414-29.348 18.15-38.663 37.05-2.22 4.523-8.474 11.53-6.34 13.18 1.532 1.136 5.887-1.307 10.545 0 17.552 4.886 36.096 5.272 51.73-.492 8.064-2.958 10.005-6.815 6.857-6.794-8.69.108-17.877-6.193-30.448-8.614-3.73-.75-8.647-.472-11.838.92"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M277 6.492c-5.937 12.717-20.984 16.775-25.517 18.2-3.67 1.296-19.04 5.506-30.483-2.245 5.915-12.76 20.876-17.035 25-18.18 4.036-1.165 19.126-5.504 31 2.225M405.964 136.232c10.04 3.61 18.567-.994 22.376-9.14 1.753-3.697 2.727-5.922 2.727-9.575h13.2v107.038h-9.52c-16.426-44.67-57.175-89.425-105.498-98.372-47.112-8.774-102.317-6.224-129.973 35.096-7.596 11.41-3.463 34.382 10.97 42.853 49.298 28.72 102.21 15.927 167.043 24.982 32.807 4.538 68.838 23.253 83.424 59.69 14.11 35.05 11.296 70.99-2.748 94.74C424.38 440.338 362.64 446 322.93 446c-41.485 0-82.97-19.17-115.863-31.01-10.084-3.654-18.46.97-22.31 9.075-1.71 3.74-2.706 6.42-2.706 9.595h-13.265V320.744c3.658 0 7.748 0 13.266.346 12.725 52.017 53.8 90.074 94.85 102.11 47.48 13.918 94.634 11.584 131.77-14.154 14.54-10.114 20.06-31.833 14.628-51.023-8.202-28.678-52.478-36.263-84.42-36.933-68.405-1.426-153.58-.15-176.044-76.005-10.604-35.744-4.025-76.048 22.333-102.564 42.264-42.42 114.24-40.692 169.747-26.407 19.39 4.992 32.785 14.608 51.05 20.12M373.98 555.317c16.883 0 30.546 6.67 40.058 9.052 5.058 1.342 19.045 5.153 31.022 0 2.29-.932 9.34-1.474.908 8.25-2.378 2.707-6.788 5.48-12.215 8.23-29.14 14.336-55.148 8.1-86.213-5.87-8.107-3.746-20.753-3.27-20.537-7.363.28-4.158 6.485-6.82 11.003-13.253 17.403-24.56 38.848-44.83 64.617-54.748 13.814-5.305 20.04-1.494 16.02 2.21-10.27 9.485-14.658 27.46-28.3 42.49-4.106 4.59-9.965 9.138-16.364 11"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M460.074 518.95c15.382-5.45 30.01-3.684 39.523-5.02 5.07-.668 19.567-1.38 28.218-9.975 1.79-1.81 8.047-5.084 3.646 7.26-1.013 2.715-4.076 6.42-8.218 10.88-21.81 23.14-47.743 25.358-80.534 23.182-8.565-.625-22.46 2.78-23.602-1.38-1.057-3.597 6.084-7.195 8.176-14.11 8.5-27.986 20.215-53.818 40.472-71.225 10.528-9.092 17.993-7.433 15.512-2.844-6.386 11.72-4.466 29.666-11.844 47.763-2.244 5.452-6.343 11.377-11.348 15.47"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M530.91 454.562c12.346-9.554 26.62-12.04 34.72-15.412 5.113-2.16 17.59-6.96 23.308-17.314 1.3-2.356 7.126-6.787 5.89 5.383-.215 2.765-2.12 7.413-5.002 13.25-13.126 26.8-36.8 35.6-67.58 43.402-7.798 1.837-19.95 8.43-21.877 5.295-1.777-2.766 3.443-8.062 3.205-15.39-1.148-27.84 4.245-54.794 17.76-76.56 7.28-11.694 13.864-12.407 12.78-6.874-2.468 12.19 4.116 28.23 2.752 46.948-.455 5.945-2.75 12.3-5.957 17.272"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M573.708 377.332c8.6-12.306 20.532-19.066 27.176-24.72 3.72-3.143 13.78-11.376 15.91-22.773.408-2.32 4.128-7.952 6.708 3.596.666 2.708.28 7.323-.387 13.26-3.333 28.968-23.22 43.918-48.483 59.8-6.923 4.377-15.91 13.758-18.103 11.852-2.774-2.21.343-8.58-1.85-15.016-8.75-25.566-12.878-52-6.772-75.81 3.246-12.74 9.03-15.06 9.503-10.055 1.097 12.07 11.374 24.96 16.298 42.49 1.44 5.156 1.763 11.894 0 17.375"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M588.25 289.99c3.606-13.188 12.08-23.132 15.558-30.504 1.956-4.085 7.084-14.42 5.933-25.574-.173-1.794 1.63-8.323 7.737.93 1.52 2.27 2.542 6.83 3.672 11.847 6.345 26.243-4.282 47.06-21.905 68.874-4.846 6.01-9.52 17.445-12.365 16.364-3.065-1.253-2.326-7.674-6.41-12.28-16.908-19.282-28.317-41.57-31.142-64.29-1.52-11.847 2.63-16.603 4.564-12.3 4.672 10.656 18.037 18.958 28.402 31.907 3.217 4.02 5.955 10.01 5.955 15.024"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M576.582 207.23c-.454-13.19 4.776-24.54 6.418-31.85 1.08-4.562 3.717-15.372-.475-24.627-.972-2.27-1.016-8.605 6.807-1.427 1.923 1.795 3.847 5.45 6.44 10.098 12.512 22.4 7.023 44.28-3.177 68.8-2.723 6.378-4.56 17.99-7.326 17.773-3.2-.324-4.128-6.4-9.142-10.054-19.146-14.054-36.283-30.573-44.15-51.05-4.018-10.507-1.144-16.258 1.816-12.712 6.807 8.11 20.768 12.67 33.734 22.768 3.328 2.638 7.67 7.762 9.054 12.28"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M543.748 134.133c-4.077-12.82-1.94-25.18-2.265-32.96-.26-4.67-1.553-15.576-7.765-23.81-.993-1.325-3.064-7.17 6.406-2.716 1.812.847 4.897 3.694 8.672 7.713 17.365 19.14 19.134 40.844 15.855 67.328-.905 7.344.93 18.62-1.79 19.25-3.278.738-5.824-5.258-11.367-7.322-22.457-8.517-43.316-19.51-56.367-36.652-7.12-9.277-5.76-15.164-2.308-12.86 8.91 6.082 23.556 6.277 38.635 12.36 4.53 1.782 9.6 5.54 12.295 9.67"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M494.6 74.292c-6.883-9.555-9.07-20.146-11.904-26.358-1.493-3.343-6.385-11.95-13.7-16.35-1.948-1.165-5.042-4.076 4.156-4.573 1.753-.15 5.583 1.21 9.977 3.194 20.58 9.102 28.524 27.2 33.804 50.02 1.45 6.32 6.688 14.84 4.567 16.372-2.423 1.682-6.362-2.438-11.794-2.308-21.08.474-41.878-2.59-57.59-12.274-8.983-5.63-9.545-10.655-6.32-9.986 9.912 1.94 21.772-1.834 35.99-2.308 4.135-.15 9.632 1.855 12.813 4.572"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M435.72 36.39c-7.832-6.365-11.565-15.16-15.49-20.428-1.77-2.323-6.776-9.742-14.522-11.763-1.79-.496-4.898-2.69 2.718-4.087 1.856-.322 5.46.065 9.084.903 19.052 4.688 29.71 18.02 38.643 36.772 2.31 4.882 8.587 11.74 6.387 13.14-1.424 1.784-5.848-.818-10.508.494-17.585 4.903-36.14 4.795-51.33-.495-8.5-2.99-10.4-6.537-7.314-7.225 8.436-2.086 17.822-6.322 30.487-8.71 3.71-.688 8.652 0 11.845 1.398"
					},
					children: [
					]
				},
				{
					id: "sheraton",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M346 6.492c5.96 12.717 20.992 16.775 25.506 18.2 3.736 1.296 19.113 5.506 30.494-2.245-5.896-12.76-20.884-17.035-25.01-18.18-4.08-1.165-19.155-5.504-30.99 2.225"
					},
					children: [
					]
				}
			]
		}
	]
};
var snapchat = {
	id: "snapchat",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 360 338.362"
	},
	children: [
		{
			id: "snapchat",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "snapchat",
					name: "",
					type: "text",
					value: "Snapchat icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "snapchat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M353.75 254.164c-48.947-8.067-70.965-58.29-71.88-60.42a4.407 4.407 0 00-.167-.363c-2.613-5.298-3.19-9.733-1.73-13.18 2.823-6.656 13.232-9.96 20.12-12.144 1.927-.612 3.738-1.188 5.227-1.776 12.203-4.82 18.324-10.737 18.195-17.59-.105-5.383-4.298-10.186-10.96-12.566l-.02-.007c-2.242-.93-4.903-1.438-7.51-1.438-1.78 0-4.422.24-6.89 1.396-5.805 2.72-11.02 4.198-15.518 4.4-2.982-.138-4.934-.89-6.046-1.504.142-2.48.3-5.033.47-7.7l.062-1.038c1.543-24.46 3.46-54.906-4.534-72.83C248.813 4.145 198.375 0 183.482 0h-.015c-.31 0-.602 0-.88.006 0 0-5.77.057-6.23.057-14.85 0-65.18 4.137-88.926 57.375-7.985 17.91-6.07 48.33-4.535 72.773.18 2.883.373 5.875.538 8.767-1.23.68-3.472 1.526-7.003 1.526-4.714 0-10.285-1.487-16.556-4.427-1.665-.78-3.585-1.17-5.706-1.17-7.345 0-16.13 4.832-17.498 12.035-.987 5.188 1.334 12.754 18.008 19.34 1.504.595 3.313 1.168 5.224 1.772 6.888 2.188 17.3 5.492 20.126 12.147 1.463 3.447.88 7.885-1.73 13.185-.058.12-.116.238-.167.362-.915 2.132-22.952 52.367-71.876 60.42a7.474 7.474 0 00-6.242 7.784c.065 1.134.333 2.26.796 3.355 3.67 8.585 19.163 14.875 47.365 19.252.942 1.275 1.922 5.778 2.522 8.522.59 2.706 1.197 5.498 2.064 8.443.85 2.895 3.057 6.356 8.733 6.356 2.293 0 4.998-.53 8.13-1.145 4.7-.918 11.133-2.175 19.187-2.175 4.466 0 9.096.388 13.758 1.16 9.1 1.518 16.833 6.983 25.785 13.312 12.823 9.067 27.345 19.331 49.418 19.331.607 0 1.217-.018 1.82-.063.716.03 1.645.063 2.636.063 22.08 0 36.598-10.266 49.413-19.327 8.972-6.338 16.7-11.802 25.8-13.315 4.653-.77 9.284-1.16 13.752-1.16 7.685 0 13.764.978 19.187 2.036 3.397.665 6.132 1.003 8.13 1.003l.208.003h.203c4.194 0 7.152-2.215 8.325-6.236.85-2.884 1.46-5.604 2.062-8.357.597-2.737 1.574-7.22 2.513-8.487 28.21-4.38 43.698-10.66 47.362-19.207a9.99 9.99 0 00.806-3.372 7.46 7.46 0 00-6.238-7.78h-.001z",
				fill: "#FFF"
			},
			children: [
			]
		}
	]
};
var spotify = {
	id: "spotify",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 167.487 167.487"
	},
	children: [
		{
			id: "spotify",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M83.743 0C37.493 0 0 37.493 0 83.742c0 46.254 37.494 83.745 83.743 83.745 46.25 0 83.743-37.49 83.743-83.745C167.486 37.492 129.994 0 83.743 0zm38.406 120.787c-1.506 2.467-4.72 3.24-7.178 1.737-19.665-12.02-44.417-14.734-73.567-8.075-2.81.643-5.61-1.118-6.25-3.926-.642-2.81 1.11-5.61 3.927-6.25 31.9-7.292 59.263-4.153 81.336 9.335 2.46 1.502 3.235 4.717 1.73 7.177zm10.246-22.803c-1.894 3.073-5.912 4.037-8.98 2.15-22.506-13.834-56.823-17.84-83.448-9.76-3.453 1.044-7.1-.902-8.148-4.35-1.04-3.452.907-7.092 4.354-8.142 30.415-9.23 68.226-4.76 94.074 11.125 3.07 1.89 4.035 5.91 2.148 8.977zm.884-23.744c-26.994-16.03-71.52-17.505-97.29-9.684-4.137 1.255-8.513-1.08-9.767-5.22-1.254-4.14 1.08-8.512 5.22-9.77 29.582-8.98 78.757-7.245 109.833 11.202 3.722 2.21 4.943 7.016 2.737 10.733-2.21 3.723-7.02 4.95-10.733 2.74z",
				fill: "#191414"
			},
			children: [
			]
		}
	]
};
var standings = {
	id: "standings",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "standings",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "standings",
					name: "",
					type: "text",
					value: "Standings Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "standings",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.78 8.538a.833.833 0 0 0-.945-.247c-4.968 1.944-8.769.528-12.795-.969-3.682-1.371-7.479-2.775-12.182-1.542.157-.357.238-.743.238-1.133 0-1.573-1.28-2.853-2.853-2.853S.39 3.074.39 4.647 1.671 7.5 3.243 7.5c.116 0 .227-.02.339-.034l1.489 4.05 3.059 8.403a.93.93 0 0 0 .095.179l3.515 9.564a.83.83 0 0 0 1.064.495l.003-.001a.83.83 0 0 0 .493-1.065v-.001l-3.442-9.365c2.909-4.264 6.45-4.406 10.196-4.543 3.919-.143 8.361-.305 11.784-5.668a.831.831 0 0 0-.058-.976zM2.053 4.647a1.191 1.191 0 1 1 2.38-.097 1.191 1.191 0 0 1-2.38.097z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "standings",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "3.243",
				cy: "4.647",
				r: "1.191",
				fill: "#fff"
			},
			children: [
			]
		}
	]
};
var sort = {
	id: "sort",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 22 7",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "sort",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "sort",
					name: "",
					type: "text",
					value: "Sort Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "sort",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "sort",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						fillRule: "nonzero"
					},
					children: [
						{
							id: "sort",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M15.7449273,-0.769159008 C15.35147,-1.09534357 14.7649596,-1.0734129 14.3986655,-0.718819879 C14.0323714,-0.364226855 14.009717,0.203547661 14.3466652,0.584436171 L17.3064863,3.75242489 L14.3466652,6.91081364 C14.0636648,7.14542709 13.9403938,7.51380515 14.0275341,7.86449246 C14.1146744,8.21517976 14.3975188,8.48898881 14.7597783,8.57334545 C15.1220378,8.65770209 15.5025719,8.53836896 15.7449273,8.26440882 L19.7116281,4.4244225 C20.096124,4.04998787 20.096124,3.44526194 19.7116281,3.07082732 L15.7449273,-0.769159008 Z",
								transform: "translate(17.000000, 3.800000) rotate(90.000000) translate(-17.000000, -3.800000)"
							},
							children: [
							]
						},
						{
							id: "sort",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M3.74492728,-0.769159008 C3.35146995,-1.09534357 2.76495963,-1.0734129 2.3986655,-0.718819879 C2.03237137,-0.364226855 2.00971702,0.203547661 2.34666525,0.584436171 L5.30648633,3.75242489 L2.34666525,6.91081364 C2.06366478,7.14542709 1.94039382,7.51380515 2.02753411,7.86449246 C2.11467441,8.21517976 2.3975188,8.48898881 2.75977832,8.57334545 C3.12203784,8.65770209 3.5025719,8.53836896 3.74492728,8.26440882 L7.71162809,4.4244225 C8.09612397,4.04998787 8.09612397,3.44526194 7.71162809,3.07082732 L3.74492728,-0.769159008 Z",
								transform: "translate(5.000000, 3.800000) scale(1, -1) rotate(90.000000) translate(-5.000000, -3.800000)"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
};
var stadium = {
	id: "stadium",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512.218 469.359"
	},
	children: [
		{
			id: "stadium",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "stadium",
					name: "",
					type: "text",
					value: "Stadium icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "stadium",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M262.38 469.36h-12.543c-.767-.1-1.534-.277-2.302-.285-27.694-.274-55.29-2.03-82.77-5.498-25.213-3.182-50.165-7.733-74.646-14.643-20.293-5.728-40.152-12.643-58.3-23.588-14.59-8.798-27.878-18.942-31.82-37V160.982c1.442-6.446 3.824-12.51 8.24-17.492 3.28-3.7 6.692-7.373 10.505-10.495 13.152-10.77 28.398-17.78 44.142-23.795 5.962-2.278 5.993-2.197 5.993-8.614 0-20.82-.016-41.637.014-62.456.008-5.48 4.166-8.702 8.983-6.777 13.807 5.52 27.555 11.186 41.308 16.838 2.662 1.095 4.116 3.204 4.122 6.104.007 2.904-1.5 4.92-4.102 6.13-.71.33-1.446.6-2.17.896-6.516 2.673-13.008 5.406-19.564 7.975-1.58.62-2.043 1.444-2.028 3.068.075 8.013.03 16.027.042 24.04 0 .675.11 1.35.18 2.133.928-.176 1.702-.276 2.452-.472 18.034-4.712 36.31-8.202 54.762-10.784 2.11-.295 2.664-1.1 2.657-3.15-.07-21.166-.06-42.333-.03-63.5.01-6.478 4.297-9.323 10.272-6.883 13.042 5.325 26.06 10.705 39.12 15.988 3.042 1.23 5.072 3.172 5.08 6.535.005 3.368-2.032 5.345-5.067 6.555-6.865 2.737-13.67 5.625-20.55 8.32-1.715.672-2.367 1.51-2.342 3.407.112 8.36.048 16.724.048 25.086v3.665l60.57-3.4v-2.888c0-22.648.064-45.296-.056-67.943-.024-4.447 1.318-7.598 5.692-9.07h2.09c13.812 5.684 27.607 11.405 41.444 17.023 3.1 1.26 5.313 3.085 5.328 6.62.015 3.532-2.154 5.435-5.265 6.67-6.788 2.695-13.504 5.57-20.3 8.242-1.68.66-2.394 1.42-2.377 3.356.105 11.93.05 23.862.06 35.793 0 .757.087 1.513.128 2.16 20.026 1.11 39.875 2.213 59.938 3.328V80.24c0-19.855-.007-39.712.004-59.568.003-6.477 4.263-9.423 10.185-7.01 13.043 5.314 26.057 10.7 39.11 15.984 3.006 1.217 5.09 2.994 5.146 6.453.06 3.59-2.07 5.49-5.157 6.727-6.94 2.78-13.836 5.67-20.79 8.412-1.454.572-1.917 1.33-1.907 2.866.066 10.363.032 20.727.042 31.09 0 .5.11 1 .11.997L416.022 98v-2.576-32.136c0-8.448-.038-16.896.015-25.343.034-5.285 4.352-8.25 9.276-6.44 1.63.6 3.22 1.313 4.83 1.97l34.772 14.18c.403.164.8.344 1.197.518 2.717 1.19 4.328 3.165 4.326 6.226-.002 3.053-1.565 5.082-4.318 6.22-7.15 2.956-14.29 5.94-21.488 8.775-1.567.617-2.04 1.396-2.03 3.032.074 10.537.095 21.076-.01 31.613-.022 2.047.508 3 2.54 3.723 14.79 5.265 29.108 11.572 42.082 20.538 11.83 8.176 21.92 17.775 25.007 32.685v227.362c-1.733 8.103-5.553 15.08-11.25 21.08-8.63 9.094-19.04 15.68-30.14 21.23-25.785 12.895-53.316 20.457-81.413 26.12-40.29 8.124-81.06 11.7-122.12 12.25-1.642.02-3.278.217-4.916.332zM42.387 164.996c4.68 2.937 8.82 5.833 13.223 8.246 16.668 9.132 34.63 14.89 52.936 19.586 39.547 10.146 79.884 14.59 120.583 16.16 30.664 1.184 61.283.347 91.852-2.44 26.465-2.414 52.693-6.273 78.508-12.656 19.71-4.873 39.037-10.892 56.997-20.59 4.466-2.41 8.625-5.39 12.926-8.108.02-.367.04-.735.058-1.102-5.088-3.103-10.015-6.52-15.296-9.25-18.823-9.735-38.98-15.732-59.524-20.495-35.3-8.186-71.142-12.237-107.3-13.73-52.2-2.155-104.08.57-155.437 10.62-23.002 4.5-45.563 10.568-67.014 20.243-7.78 3.506-15.276 7.504-22.514 13.514zm200.348 122.006l-55.964-3.077v26.635l55.964 2.995v-26.552zm-56.02 108.064l55.98 3.01V371.54l-55.98-3.117v26.644zm82.77-81.514l55.46-2.942V284c-18.564 1.01-36.947 2.01-55.46 3.02v26.535zm55.487 54.935l-55.422 3.06v26.537l55.423-2.984V368.49zm-219.056-97.636c-.04.24-.145.573-.145.908-.012 8.014.01 16.028-.037 24.04-.008 1.403.487 1.94 1.882 2.213 8.193 1.604 16.334 3.487 24.55 4.95 9.14 1.63 18.34 2.91 27.682 4.368v-26.427l-53.933-10.05zm-.16 84.48c0 8.094.057 16.264-.043 24.43-.022 1.848.54 2.573 2.364 2.904 12.902 2.34 25.776 4.83 38.68 7.164 4.3.778 8.657 1.236 13.03 1.846v-26.254l-54.03-10.09zm246.215-74.336v26.325c2.632-.364 5.055-.615 7.445-1.045 14.808-2.664 29.608-5.376 44.415-8.047 1.452-.262 2.24-.732 2.216-2.486-.104-7.838-.042-15.68-.057-23.52-.002-.475-.147-.95-.185-1.178l-53.836 9.952zm53.972 74.575l-53.997 9.988v26.288c2.29-.313 4.368-.52 6.42-.888 15.138-2.716 30.266-5.49 45.41-8.168 1.763-.312 2.25-1.087 2.2-2.776-.11-3.652-.033-7.31-.033-10.966V355.57zM33.946 327.017c0 9.97-.04 19.453.078 28.935.01.728.98 1.773 1.75 2.11 8.91 3.893 17.81 7.822 26.835 11.44 5.28 2.12 10.777 3.7 16.458 5.615.09-1.204.194-1.955.195-2.706.012-7.4-.11-14.8.075-22.195.06-2.436-.706-3.444-2.995-4.2-13.562-4.49-26.65-10.082-38.968-17.382-.948-.564-2-.95-3.43-1.617zm45.326-36.492c0-8.883-.068-17.146.048-25.406.03-2.03-.684-2.793-2.568-3.423-13.547-4.53-26.698-9.978-38.98-17.366-1.086-.654-2.295-1.102-3.704-1.766-.054 1.142-.12 1.9-.12 2.657-.007 8.358.068 16.716-.06 25.07-.03 1.9.664 2.83 2.275 3.49 10.686 4.376 21.334 8.85 32.053 13.144 3.432 1.375 7.04 2.308 11.056 3.6zm353.19 84.408c.884-.123 1.24-.124 1.565-.224 13.81-4.234 27.355-9.158 40.294-15.62.81-.403 1.574-1.8 1.588-2.745.122-8.527.076-17.057.06-25.587 0-.64-.15-1.28-.248-2.074-.81.31-1.408.45-1.92.745-12.628 7.274-25.997 12.855-39.76 17.566-.728.25-1.508 1.566-1.54 2.413-.148 4.085-.043 8.178-.038 12.27.005 4.327 0 8.656 0 13.256zm-.095-84.262c14.422-4.37 28.107-9.38 41.315-15.686 1.73-.825 2.173-1.823 2.156-3.59-.077-8.188-.03-16.376-.04-24.564-.002-.82-.093-1.638-.17-2.928-2.888 1.568-5.302 3.13-7.906 4.25-11.092 4.767-22.248 9.385-33.35 14.127-.792.337-1.91 1.228-1.92 1.876-.127 8.703-.085 17.41-.085 26.514z"
			},
			children: [
			]
		}
	]
};
var stats = {
	id: "stats",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "stats",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "stats",
					name: "",
					type: "text",
					value: "Stats Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "stats",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.3 16.7c0-.4-.4-.7-.8-.7H3.3c-.4 0-.7.3-.7.7v14c0 .4.3.7.7.7h6.3c.4 0 .7-.3.7-.7v-14zM19.8 9c0-.4-.3-.7-.7-.7h-6.3c-.4 0-.7.3-.7.7v21.6c0 .4.3.7.7.7h6.3c.4 0 .7-.3.7-.7V9zm9.6-7.7c0-.4-.3-.7-.7-.7h-6.3c-.4 0-.7.3-.7.7v29.3c0 .4.3.7.7.7h6.3c.4 0 .7-.3.7-.7V1.3z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var stories = {
	id: "stories",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 16 16"
	},
	children: [
		{
			id: "stories",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "stories",
					name: "",
					type: "text",
					value: "Stories icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "stories",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#57606C",
				d: "m5.632 5.816 3.176 1.588a.667.667 0 0 1 0 1.192l-3.176 1.588a.667.667 0 0 1-.965-.596V6.412c0-.496.522-.818.965-.596Z"
			},
			children: [
			]
		},
		{
			id: "stories",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#57606C",
				fillRule: "evenodd",
				d: "M1.917 3.333c0-1.15.933-2.083 2.083-2.083h5.334c1.15 0 2.083.933 2.083 2.083v9.334c0 1.15-.933 2.083-2.083 2.083H4a2.083 2.083 0 0 1-2.083-2.083V3.333ZM4 2.75a.583.583 0 0 0-.583.583v9.334c0 .322.261.583.583.583h5.334a.583.583 0 0 0 .583-.583V3.333a.583.583 0 0 0-.583-.583H4Z",
				clipRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "stories",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#57606C",
				d: "M14.75 3.333a.75.75 0 0 0-1.5 0v9.334a.75.75 0 0 0 1.5 0V3.333Z"
			},
			children: [
			]
		}
	]
};
var student = {
	id: "student",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 389.181 511.71"
	},
	children: [
		{
			id: "student",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "student",
					name: "",
					type: "text",
					value: "Student icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "student",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "184.393",
				cy: "53.447",
				r: "53.447"
			},
			children: [
			]
		},
		{
			id: "student",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M375.818 246.543H250.34l40.412-12.996c12.73-4.096 19.733-17.737 15.637-30.466-4.097-12.728-17.738-19.732-30.467-15.636l-5.447 1.752-25.538-42.245c-2.862-4.735-9.024-6.254-13.76-3.39-4.738 2.863-6.256 9.023-3.392 13.76l23.08 38.18-39.756 12.79.657-41.67c.356-22.525-17.737-41.027-40.254-41.188l-37.3-.267c-22.548-.16-40.9 18.123-40.84 40.66l.376 137.53c.05 18.757 12.992 35.16 31.485 39.402H74.273L39.716 166.953c-2.136-10.862-12.67-17.936-23.535-15.8-10.86 2.133-17.935 12.67-15.8 23.533l37.734 191.982c1.805 9.182 9.714 15.844 19.008 16.15l-38.532 99.91c-2.656 6.883.774 14.62 7.66 17.275 6.888 2.657 14.62-.777 17.275-7.66l42.23-109.498h84.363l24.147 62.606-10.486 26.503c-5.907 14.924 1.403 31.807 16.325 37.71 14.924 5.907 31.807-1.404 37.71-16.325l65.963-166.69c7.538-19.044-6.516-39.748-27.018-39.748h-.086l-97.353.284c-16.833.048-31.11-12.425-33.267-29.12l-.01-.073-7.368-59.356 23.557 53.45c5.004 11.357 17.775 17.082 29.57 13.286l32.13-10.332c-.592 1.51-.928 3.15-.928 4.87 0 7.383 5.997 13.362 13.366 13.362h139.45c7.38 0 13.363-5.983 13.363-13.363s-5.982-13.362-13.362-13.362l-.002-.002zm-168.1 98.677l26.244-.078-25.188 63.653-10.02-25.982c10.76-.35 19.384-9.163 19.384-20.01 0-7.584-4.21-14.18-10.42-17.584zm-9.97-132.632l-19.41-44.044 29.346 40.85-9.935 3.193h-.003z"
			},
			children: [
			]
		}
	]
};
var star = {
	id: "star",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	},
	children: [
		{
			id: "star",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "star",
					name: "",
					type: "text",
					value: "star icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "star",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.767 9.872l-2.69 1.415a.5.5 0 01-.726-.527l.514-2.997a.5.5 0 00-.144-.442L.544 5.199a.5.5 0 01.277-.853l3.009-.438a.5.5 0 00.376-.273L5.552.908a.5.5 0 01.896 0l1.346 2.727a.5.5 0 00.376.273l3.01.438a.5.5 0 01.276.853L9.28 7.32a.5.5 0 00-.144.442l.514 2.997a.5.5 0 01-.725.527L6.233 9.872a.5.5 0 00-.466 0z",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
};
var subway = {
	id: "subway",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 494.046 511"
	},
	children: [
		{
			id: "subway",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "subway",
					name: "",
					type: "text",
					value: "Subway icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "subway",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M405.463 459.488l-10.66-14.775c60.172-45.093 99.243-116.88 99.243-197.69C494.046 110.814 383.236 0 247.026 0S0 110.814 0 247.024c0 80.81 39.082 152.584 99.256 197.677l-10.67 14.788-20.595 28.54L51.39 511h23.45l16.6-22.973h311.168l16.6 22.973h23.45l-16.6-22.973-20.595-28.54zM23.783 247.024c0-123.095 100.146-223.24 223.242-223.24 123.092 0 223.238 100.145 223.238 223.24 0 72.886-35.17 137.65-89.37 178.417l-7.49-10.377-9.868-13.668h.162c14.372 0 26.022-11.65 26.022-26.022v-225.93c0-31.365-25.427-56.79-56.79-56.79H161.12c-31.364 0-56.79 25.426-56.79 56.79v225.93c0 14.37 11.652 26.02 26.023 26.02h.162l-9.87 13.67-7.493 10.383c-54.2-40.766-89.37-105.536-89.37-178.422zm158.083-102.096c-8.964 0-16.23-7.266-16.23-16.23 0-8.965 7.268-16.233 16.233-16.233h130.315c8.964 0 16.23 7.266 16.23 16.23 0 8.963-7.264 16.233-16.227 16.233H181.866zm97.24 29.297v181.193c0 6.884-5.582 12.464-12.465 12.464h-39.23c-6.885 0-12.465-5.58-12.465-12.464V174.225c0-6.883 5.58-12.464 12.464-12.464h39.23c6.885 0 12.465 5.582 12.465 12.465zm-91.453-12.464c6.884 0 12.464 5.582 12.464 12.465v70.192c0 6.884-5.58 12.464-12.464 12.464h-52.13c-6.885 0-12.465-5.58-12.465-12.463v-70.192c0-6.883 5.58-12.464 12.464-12.464h52.13zM153.31 322.845c10.05 0 18.198 8.147 18.198 18.197 0 10.05-8.148 18.198-18.197 18.198-10.05 0-18.196-8.147-18.196-18.197 0-10.05 8.147-18.196 18.197-18.196zm.7 78.55h186.03l9.867 13.668H144.142l9.867-13.668zm178.502-42.156c-10.05 0-18.197-8.147-18.197-18.197 0-10.05 8.147-18.196 18.197-18.196 10.05 0 18.197 8.147 18.197 18.197 0 10.05-8.148 18.198-18.198 18.198zM306.396 256.88c-6.883 0-12.464-5.58-12.464-12.464v-70.192c0-6.883 5.58-12.464 12.464-12.464h52.132c6.883 0 12.464 5.58 12.464 12.464v70.192c0 6.884-5.58 12.464-12.464 12.464h-52.132zm-194.36 202.608L123.5 443.6h247.05l11.463 15.888H112.036z"
			},
			children: [
			]
		}
	]
};
var support = {
	id: "support",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "support",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "support",
					name: "",
					type: "text",
					value: "Support icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "support",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M181.9 715.2c5-6.1 9.1-12.4 11.7-19.6 3.6-10.1 5.1-20.6 7.2-31 1.8-9.1-1.6-14.6-7.8-20.6-17.8-17.2-28.8-38.3-31.6-63-2.4-21.4 1.7-41.7 12.5-60.5 17-29.6 43.1-48.2 74.3-60.4 16.2-6.3 33-10.1 50.2-11.4 14.4-1 29-1.1 43.5.9 21.9 3.1 42.8 9.4 62.3 20 24.9 13.7 44.8 32.2 57.1 58.2 5.8 12.2 8.7 25.1 9.1 38.6.9 30.6-10.7 55.8-31.7 77.3-24.5 25.1-54.8 38.7-88.9 44.9-12.3 2.2-24.7 3.4-37.2 3-16.4-.4-32.6-2.4-48.4-7.1-3.4-1-6.1-.6-8.9 1.6-12.9 10-26.9 18.1-42.1 24-9 3.5-18.3 6.1-28.1 5.9-.9.2-1.7.3-3.2-.8z"
			},
			children: [
			]
		},
		{
			id: "support",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M515.9 635.4c-21.6 6.6-43.4 10.3-66.1 11.3 6.2-9 12.9-17.6 17.9-27.2 7.4-1.3 14.6-2.4 21.6-4 6.9-1.5 13.8-3.2 20.6-5.1 8.5-2.4 16-.1 22.8 4.8 14.6 10.6 29.5 20.8 45.9 28.6l4.2 1.8c.2.1.6-.2 1.2-.4 0-3.8-1.3-7.5-2.1-11.2-3.1-13.5-5.2-27.2-5.5-41-.2-10.4 3.4-19 11.7-26.1 21.9-18.9 37.8-42.1 46.1-70.1 1.4-4.7 2.1-9.6 2.6-14.4 2.3-22.1.1-43.5-9.2-64.2-10.2-22.6-25.7-40.6-44.3-56.3-24.1-20.3-52.1-32.9-82-41.7-17.4-5.1-35.3-7.3-53.4-8.3-7.4-.4-14.8-1-22.2-.7-33.5 1-66 6.3-96.9 20.2-17.3 7.8-33.9 16.7-48.7 28.7-25.4 20.5-44.4 45.6-53.3 77.5-1.8 6.4-2.1 13-2.9 19.5-.2 1.3 0 2.7-.8 4.5-8 5-16.4 10.1-24 16.2-2-1.2-1.7-2.7-1.7-3.9-1.5-36.5 9.5-69.1 31.1-98.3 17.2-23.2 38.9-40.9 63.7-55.3 29.7-17.1 61.7-27.1 95.3-32.4 22.3-3.5 44.8-3.3 67.2-1.9 33.4 2.1 65.5 10.6 96 24.8 27.5 12.8 51.8 29.8 71.9 52.4 21.3 23.9 35.8 51.4 39.9 83.7 5.3 42.1-6 79.5-31.5 112.9-7.8 10.2-16.5 19.6-26.4 27.8-.5.4-.9 1-1.9 1.7 2.2 33.9 5.9 67.4 30.2 94.8-4 1.5-7.5 1-10.9.6-26.7-3.1-50.7-13.6-73.6-27.1-11.1-6.8-21.6-14.4-32.5-22.2z"
			},
			children: [
			]
		}
	]
};
var taxi = {
	id: "taxi",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "taxi",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "taxi",
					name: "",
					type: "text",
					value: "Taxi icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "taxi",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M853.2 99.3H622.7l-.5-79.6v-.5C622.2 8.6 613.6 0 603 0H395.5c-10.6 0-19.2 8.6-19.2 19.2v80.1H160.4c-8.5 0-16.2 5.3-19.2 13.3L8 465.1c-1.7 4.6-2.6 9.5-2.6 14.4V979.2c0 11.1 9.1 20.1 20.1 20.1h114.6c11.1 0 20.1-9.1 20.1-20.1v-99.8h676v99.8c0 11.1 9.1 20.1 20.1 20.1h114.6c11.1 0 20.1-9.1 20.1-20.1V478.3c0-4.1-.7-8.2-2-12.2L872.6 113.4c-2.7-8.4-10.6-14.1-19.4-14.1zM187.3 718.7c-36.2 0-65.6-29.3-65.6-65.6 0-36.2 29.3-65.6 65.6-65.6s65.6 29.3 65.6 65.6c0 36.2-29.4 65.6-65.6 65.6zm624.5-1.1c-36.2 0-65.6-29.3-65.6-65.6 0-36.2 29.3-65.6 65.6-65.6 36.2 0 65.6 29.3 65.6 65.6s-29.4 65.6-65.6 65.6zM124.5 435.5l78.9-228.9c2.9-8.3 10.7-13.9 19.5-13.9h565c8.9 0 16.8 5.8 19.4 14.2l72.2 228.4c3 9.4-4.1 19.1-14 19.1H138c-9.8.1-16.7-9.6-13.5-18.9z"
			},
			children: [
			]
		}
	]
};
var swap = {
	id: "swap",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 19 21"
	},
	children: [
		{
			id: "swap",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "swap",
					name: "",
					type: "text",
					value: "Swap icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "swap",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "nonzero",
				d: "M5.206 9.375l-3.42 3.484 3.42 3.484V13.73h6.008v-1.742H5.206V9.375zm12.008-1.742l-3.42-3.484v2.613H7.786v1.742h6.008v2.613l3.42-3.484z"
			},
			children: [
			]
		}
	]
};
var teams = {
	id: "teams",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "teams",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "teams",
					name: "",
					type: "text",
					value: "Teams Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.296 5.132c.315-.216.538-.532.706-.883a5.09 5.09 0 0 1-2.018.408 5.114 5.114 0 0 1-1.976-.392c.167.345.389.654.699.867.45.309.89.651 1.294 1.052a9.273 9.273 0 0 1 1.295-1.052zm-5.304-2.405c-.82.23-2.099.609-3.566 1.123.173 1.445.237 4.995-1.364 9.455v12.543c.8.104 1.924.449 2.88 1.503.84.927 1.921 1.651 4.322 2.036V11.333c0-1.69.279-2.919.831-3.871-.371-.4-.877-.722-1.298-1.012-1.355-.929-1.722-2.606-1.805-3.723zM1.965 6.691c.012.882.117 3.001.794 5.332l2.997.289C7.01 8.744 7.007 5.838 6.89 4.423c-1.609.62-3.338 1.379-4.925 2.268zm21.475-2.84c-1.467-.515-2.618-.894-3.438-1.123-.083 1.117-.446 2.794-1.8 3.724-1.263.868-2.497 1.961-2.515 4.887l-.002 18.339c2.755-.13 5.159-1.037 6.327-2.325.956-1.054 1.853-1.4 2.653-1.503V13.306c-1.599-4.461-1.397-8.01-1.225-9.455zm-6.575 18.743a.5.5 0 1 1 0-1.001.5.5 0 0 1 0 1.001zm0-6.383a.5.5 0 1 1 0-1.002h.001a.501.501 0 1 1-.001 1.002zm0-6.383a.5.5 0 1 1 0-1.002h.001a.501.501 0 1 1-.001 1.002zm9.382 2.485l2.998-.289c.493-1.736.76-3.528.793-5.332-1.587-.889-3.316-1.649-4.925-2.269-.116 1.415-.12 4.322 1.134 7.89z",
				fill: "none"
			},
			children: [
			]
		},
		{
			id: "teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.636 6.193a.8.8 0 0 0-.396-.659C26.159 2.572 19.67.975 19.397.909a.818.818 0 0 0-.203-.02c-.004 0-.173.024-.226.04a.79.79 0 0 0-.588.757c0 .648-.984 1.37-2.396 1.37-1.399 0-2.375-.709-2.393-1.352a.794.794 0 0 0-.271-.622 1.303 1.303 0 0 0-.237-.137 1.668 1.668 0 0 0-.296-.059c-.006 0-.126.01-.181.023C12.335.975 5.844 2.573.764 5.534a.8.8 0 0 0-.396.659c-.005.133-.12 3.287 1.021 6.821.098.304.348.52.666.551l3.407.331V26.62c0 .229.122.446.293.598.17.152.413.224.641.195.046-.005 1.244-.134 2.285 1.014 1.161 1.28 3.23 2.221 5.636 2.632.227.049 3.034.093 3.355.002 2.28-.65 4.483-1.352 5.646-2.634 1.039-1.147 2.23-1.019 2.271-1.015.231.038.345-.034.52-.187.176-.152.158-.373.158-.605V13.896l3.546-.331c.318-.03.646-.247.745-.551 1.138-3.534 1.083-6.688 1.078-6.821zm-25.88 6.12l-2.997-.289a20.883 20.883 0 0 1-.794-5.333c1.587-.889 3.316-1.648 4.925-2.268.117 1.415.12 4.321-1.134 7.89zm8.508-.98v18.054c-2.401-.384-3.481-1.109-4.322-2.036a4.634 4.634 0 0 0-2.88-1.503V13.306c1.6-4.46 1.536-8.01 1.364-9.455a58.474 58.474 0 0 1 3.566-1.123c.083 1.117.45 2.794 1.804 3.724.421.29.927.612 1.298 1.012-.551.95-.83 2.18-.83 3.869zm.444-6.201c-.31-.213-.532-.522-.699-.867.626.26 1.298.394 1.976.392.745 0 1.427-.155 2.018-.408-.169.351-.393.667-.707.883-.45.309-.89.651-1.294 1.052a9.265 9.265 0 0 0-1.294-1.052zm9.958 20.716c-.8.104-1.697.449-2.653 1.503-1.167 1.288-3.572 2.195-6.327 2.325l.002-18.339c.017-2.926 1.252-4.019 2.515-4.887 1.354-.93 1.718-2.607 1.8-3.724.82.23 1.97.609 3.438 1.123-.173 1.445-.374 4.995 1.226 9.455l-.001 12.544zm4.58-13.825l-2.998.289c-1.254-3.568-1.25-6.474-1.133-7.89 1.608.62 3.337 1.38 4.925 2.269a20.963 20.963 0 0 1-.794 5.332z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "teams",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "16.864",
				cy: "15.711",
				r: ".5",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "teams",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "16.864",
				cy: "9.328",
				r: ".5",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "teams",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "16.864",
				cy: "22.094",
				r: ".5",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var telephone = {
	id: "telephone",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "telephone",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "telephone",
					name: "",
					type: "text",
					value: "Telephone icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "telephone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M605.8 738H220.2c-.6-.3-1.1-.7-1.7-.9-18.4-4.8-26.6-15.4-26.6-34.5 0-15.5.5-31-.1-46.5-.7-18.5 3.1-36 10-52.9 20-48.7 47.6-93.1 76.5-136.9 4.5-6.9 11.4-10.7 19.6-12.2 5.3-1 10.5-.7 15.8-.6 3.6.1 4.9-.9 4.8-4.7-.2-10.9 0-21.7-.1-32.6-.1-9.1 3.9-15.9 11.5-20.5 9.5-5.7 19.7-6.9 30.4-4 14.5 4 20.7 12.2 20.7 27.1 0 10.1.1 20.1-.1 30.2-.1 3.5 1.1 4.5 4.5 4.4 18.3-.1 36.6-.2 54.9 0 3.8 0 4.8-1.2 4.7-4.8-.2-10.9 0-21.7-.1-32.6-.1-9.1 3.9-15.9 11.6-20.4 9.4-5.6 19.4-6.8 30-4.1 14.6 3.8 21.1 12.3 21.1 27.3V448c0 5.3 0 5.3 5.5 5.3h9.4c11.1.2 20.1 4.5 26.6 13.6 3.8 5.4 7.6 10.8 11.3 16.2 23.1 34.3 44.7 69.5 60.4 108 7 17.1 12.7 34.7 13.2 53.4.5 20.4.3 40.9.1 61.3-.2 15.7-10.2 27.3-25.6 30.8-1 .5-1.8 1-2.7 1.4zm-97.6-126.7c.6-52-43.3-95.2-95.1-95.3-51.5-.1-95.7 42.6-95.5 95.5.3 52.6 42.6 94.9 95.2 95.2 52.9.3 96.2-43.8 95.4-95.4z"
			},
			children: [
			]
		},
		{
			id: "telephone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M665.3 424.4c-.4.9.1 2.2-.5 3.4-3.1 15-14.3 24.8-29.4 25.1-21.1.3-42.2.3-63.3 0-17.3-.3-31.2-13.5-31.3-30.6-.2-35.4-18.5-59.4-47.1-77-17.4-10.7-37-15.1-57.2-16.9-16.1-1.4-32.2-1.5-48.3.1-36.2 3.6-67.7 16.2-89 47.7-8.7 12.9-13.3 27-13.2 42.7.1 20.9-13.4 34.1-34.5 34.1h-56.3c-18.9 0-29.6-8.2-34.5-26.6-.2-.6-.3-2.1-.5-2.7 0-13.8-.4-26.8-.4-40.6.3-1 .3-1.8.4-2.7 1.2-13.6 8.1-24.8 17.6-34.2 21.4-21.2 44.9-39.7 72.3-52.8 40.5-19.4 84-26 128.2-28.5 20.7-1.2 41.5-1.3 62.2-.3 27.3 1.3 54.4 4.2 81.2 10.1 49.8 11 91.5 36.1 127 72.2 7.9 8 13.3 17.5 15.7 28.6 1 2.9.5 5.8 1.1 8.5 0 13.3-.2 26.8-.2 40.4zM412.8 548.5c34.4-.1 63.4 28.5 63 62.9-.3 34.8-27.1 62.8-62.9 62.8-35.2 0-62.5-27.3-62.7-62.4-.2-35.6 27.5-62.5 62.6-63.3z"
			},
			children: [
			]
		}
	]
};
var tickets = {
	id: "tickets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "tickets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tickets",
					name: "",
					type: "text",
					value: "Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tickets",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M660.1 396.3l-28.2-28.2c-24 24-63 24-87 0s-24-63 0-87l-28.3-28.2c-9.8-9.8-25.7-9.8-35.5 0L164.3 569.7c-9.8 9.8-9.8 25.7 0 35.5l28.2 28.2c24-24 63-24 87 0s24 63 0 87l28.2 28.2c9.8 9.8 25.7 9.8 35.5 0L660 431.8c9.8-9.7 9.8-25.7.1-35.5zm-198.2-45.5l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4zm42 42l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4zm42 42l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4zm42 42l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4z"
			},
			children: [
			]
		}
	]
};
var tiktok = {
	id: "tiktok",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 291.7 291.1",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "tiktok",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tiktok",
					name: "",
					type: "text",
					value: "Tiktok icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tiktok",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "tiktok-blue",
				fill: "#25f4ee"
			},
			children: [
				{
					id: "tiktok",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M120.96 123.89v-8.8a64.83 64.83 0 0 0-9.23-.79c-29.93-.06-56.42 19.33-65.41 47.87s1.62 59.62 26.18 76.71c-25.77-27.58-24.3-70.83 3.28-96.6a68.425 68.425 0 0 1 45.18-18.39z"
					},
					children: [
					]
				},
				{
					id: "tiktok",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M122.62 223.53c16.73-.02 30.48-13.2 31.22-29.92V44.44h27.25a50.7 50.7 0 0 1-.79-9.44h-37.27v149.02c-.62 16.8-14.41 30.11-31.22 30.14-5.02-.04-9.97-1.28-14.42-3.6a31.276 31.276 0 0 0 25.23 12.97zM231.98 95.05v-8.29c-10.03 0-19.84-2.96-28.19-8.51a51.63 51.63 0 0 0 28.19 16.8z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "tiktok",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "tiktok-red",
				fill: "#fe2c55"
			},
			children: [
				{
					id: "tiktok",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M203.8 78.26a51.301 51.301 0 0 1-12.76-33.89h-9.95a51.564 51.564 0 0 0 22.71 33.89zm-92.07 73.32c-17.28.09-31.22 14.17-31.13 31.45a31.293 31.293 0 0 0 16.71 27.53c-10.11-13.96-6.99-33.48 6.97-43.6a31.191 31.191 0 0 1 18.34-5.93c3.13.04 6.24.53 9.23 1.45v-37.93c-3.05-.46-6.14-.7-9.23-.72h-1.66v28.84c-3.01-.82-6.12-1.18-9.23-1.09z"
					},
					children: [
					]
				},
				{
					id: "tiktok",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M231.98 95.05v28.84a88.442 88.442 0 0 1-51.69-16.8v75.77c-.08 37.81-30.75 68.42-68.56 68.42a67.816 67.816 0 0 1-39.22-12.4c25.73 27.67 69.02 29.25 96.7 3.52a68.397 68.397 0 0 0 21.83-50.09v-75.56a88.646 88.646 0 0 0 51.76 16.58V96.21c-3.64-.02-7.26-.4-10.82-1.16z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "tiktok",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M180.29 182.87V107.1a88.505 88.505 0 0 0 51.76 16.58V94.84a51.73 51.73 0 0 1-28.26-16.58 51.634 51.634 0 0 1-22.71-33.89h-27.25v149.24c-.71 17.27-15.27 30.69-32.54 29.99a31.278 31.278 0 0 1-24.06-12.9c-15.29-8.05-21.16-26.97-13.11-42.26a31.274 31.274 0 0 1 27.53-16.71c3.13.03 6.24.51 9.23 1.44V123.9c-37.74.64-67.82 32.19-67.18 69.93a68.353 68.353 0 0 0 18.73 45.86 67.834 67.834 0 0 0 39.29 11.61c37.82-.01 68.49-30.62 68.57-68.43z",
				fill: "#fff"
			},
			children: [
			]
		}
	]
};
var transactions = {
	id: "transactions",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "transactions",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "transactions",
					name: "",
					type: "text",
					value: "Transactions icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "transactions",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.6004 8.00039c0 .33137-.2686.6-.6.6H4.00039c-.33137 0-.6-.26863-.6-.6s.26863-.6.6-.6H21.0004c.3314 0 .6.26863.6.6Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "transactions",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.42468 4.57613c.23431.23431.23431.61421 0 .84852L3.84892 8.00041l2.57576 2.57579c.23431.2343.23431.6142 0 .8485-.23432.2343-.61422.2343-.84853 0L2.57613 8.42468c-.23432-.23432-.23432-.61422 0-.84853l3.00002-3.00002c.23431-.23432.61421-.23432.84853 0ZM2.40039 16.0005c0-.3314.26863-.6.6-.6l17.00001-.0001c.3314 0 .6.2687.6.6001 0 .3313-.2686.5999-.6.5999l-17.00001.0001c-.33137 0-.6-.2687-.6-.6Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "transactions",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.5761 19.4247c-.2343-.2343-.2343-.6142 0-.8485l2.5758-2.5758-2.5758-2.5757c-.2343-.2343-.2343-.6142 0-.8486.2343-.2343.6142-.2343.8486 0l3 3.0001c.2343.2343.2343.6142 0 .8485l-3 3c-.2344.2343-.6143.2343-.8486 0Z",
				fill: "#000"
			},
			children: [
			]
		}
	]
};
var train = {
	id: "train",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 390.398 510.333"
	},
	children: [
		{
			id: "train",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "train",
					name: "",
					type: "text",
					value: "Train icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "train",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M347.464 140.07V46.85c0-25.874-20.975-46.85-46.85-46.85H89.79C63.916 0 42.94 20.975 42.94 46.85v93.22c47.395-17.848 98.702-27.642 152.262-27.642s104.867 9.795 152.262 27.642zM203.986 49.778c0-9.703 7.866-17.57 17.57-17.57h89.673c9.702 0 17.568 7.867 17.568 17.57v23.058c0 9.703-7.866 17.57-17.57 17.57h-89.673c-9.703 0-17.57-7.867-17.57-17.57V49.778zm-17.568 23.058c0 9.703-7.866 17.57-17.57 17.57H79.176c-9.703 0-17.568-7.867-17.568-17.57V49.778c0-9.703 7.865-17.57 17.568-17.57h89.674c9.702 0 17.568 7.867 17.568 17.57v23.058z"
			},
			children: [
			]
		},
		{
			id: "train",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M372.53 485.608l-22.166-30.716-12.337-17.1-22.167-30.714-10.622-14.71h17.89c13.44 0 24.336-10.896 24.336-24.335V156.447c-47.205-18.526-98.565-28.712-152.26-28.712-53.698 0-105.058 10.187-152.263 28.713v211.585c0 13.44 10.896 24.334 24.335 24.334H85.16l-10.623 14.71-22.167 30.716-12.338 17.1-22.167 30.715L0 510.333h25.238l17.866-24.726h304.19l17.865 24.726h25.237l-17.866-24.725zM266.393 196.963c0-6.37 5.165-11.535 11.535-11.535h39.335c6.37 0 11.535 5.165 11.535 11.535v2.55c0 6.37-5.165 11.535-11.535 11.535h-39.335c-6.37 0-11.535-5.164-11.535-11.535v-2.55zm24.18 210.115H99.825l10.62-14.71H279.95l10.62 14.71zM195.2 149.192c18.193 0 32.942 14.75 32.942 32.94s-14.75 32.942-32.94 32.942c-18.194 0-32.942-14.75-32.942-32.94s14.747-32.942 32.94-32.942zm-122.06 61.856c-6.37 0-11.534-5.164-11.534-11.535v-2.55c0-6.37 5.164-11.535 11.535-11.535h39.334c6.37 0 11.535 5.165 11.535 11.535v2.55c0 6.37-5.164 11.535-11.535 11.535H73.143zm-7.87 243.844l12.337-17.1h235.18l12.336 17.1H65.27z"
			},
			children: [
			]
		}
	]
};
var trash = {
	id: "trash",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "trash",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "trash",
					name: "",
					type: "text",
					value: "Trash icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "trash",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.44.182c-.143.031-.43.14-.637.242-.741.366-1.235 1.028-1.421 1.906l-.024.11-3.389.001c-3.244.001-3.396.004-3.557.077-.329.149-.52.577-.415.928a.992.992 0 0 0 .188.314c.278.308-.641.283 10.122.271l9.646-.011.173-.122c.266-.186.36-.38.344-.707-.014-.297-.069-.401-.326-.609l-.151-.122-3.676-.011-3.676-.01-.023-.11c-.186-.876-.68-1.539-1.421-1.905-.591-.292-1.159-.37-1.757-.242m.8 1.581c.236.054.452.199.6.404.205.282.233.273-.84.273-1.071 0-1.044.008-.844-.269.143-.197.318-.325.538-.394.205-.064.315-.067.546-.014M2.881 12.469c0 4.552.015 7.294.04 7.471.098.69.347 1.367.701 1.907.105.161.382.483.615.715.62.62 1.189.946 2.08 1.192l.383.106h10.6l.383-.106c.891-.246 1.46-.572 2.08-1.192a5.76 5.76 0 0 0 .617-.718 4.777 4.777 0 0 0 .699-1.924c.023-.184.039-3.078.04-7.471l.001-7.171-.81.011-.81.011-.02 7.34-.02 7.34-.113.32a2.71 2.71 0 0 1-.53.94 2.929 2.929 0 0 1-1.445.93l-.312.09H6.94l-.312-.09c-.941-.273-1.613-.903-1.974-1.85l-.114-.3-.02-7.36L4.5 5.3l-.81-.011-.81-.011.001 7.191m5.181-6.331a.774.774 0 0 0-.462.386l-.1.176V13c0 5.07.01 6.329.052 6.447.07.196.361.461.547.495.382.072.755-.092.917-.402l.084-.16.01-6.274c.007-4.293-.003-6.324-.031-6.431a.946.946 0 0 0-.395-.493.876.876 0 0 0-.622-.044m3.732-.021a.886.886 0 0 0-.465.339l-.109.157-.012 6.324c-.008 4.41.001 6.368.031 6.471.211.729 1.311.729 1.522 0 .03-.103.039-2.061.031-6.471l-.012-6.324-.111-.159c-.188-.273-.592-.428-.875-.337m3.706-.002a.834.834 0 0 0-.579.56c-.028.107-.038 2.138-.031 6.431l.01 6.274.084.16c.162.31.535.474.917.402.186-.034.477-.299.547-.495.042-.118.052-1.377.052-6.447V6.7l-.086-.16a.996.996 0 0 0-.16-.225c-.196-.172-.523-.259-.754-.2"
			},
			children: [
			]
		}
	]
};
var trolley = {
	id: "trolley",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 244.708 511.694"
	},
	children: [
		{
			id: "trolley",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "trolley",
					name: "",
					type: "text",
					value: "Trolley icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "trolley",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M227.922 511.694H206.09l-29.967-117.53h21.833M46.64 395.33L17.106 511.694h21.832L68.474 395.33"
			},
			children: [
			]
		},
		{
			id: "trolley",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M58.963 426.768h127.12l4.38 16.735H54.58M48.654 463.018h147.05l4.38 16.736H44.275M236.104 123.983c-10.23-56.143-218.81-56.278-228.27 0-17.627 104.89 0 252.422 0 252.422 0 10.792 8.75 19.54 19.542 19.54h189.187c10.792 0 19.54-8.748 19.54-19.54 0 0 19.36-146.18 0-252.422zm-145.876-.542c0-9.498 7.7-17.2 17.2-17.2h34.134c9.5 0 17.2 7.702 17.2 17.2H90.228zM50.026 341.2c-8.418 0-15.242-6.824-15.242-15.243 0-8.418 6.824-15.242 15.242-15.242 8.418 0 15.242 6.824 15.242 15.242 0 8.418-6.824 15.243-15.242 15.243zm108.617 2.336H86.057c-1.08 0-1.954-.875-1.954-1.954 0-1.08.875-1.954 1.954-1.954h72.586c1.08 0 1.954.875 1.954 1.954 0 1.08-.875 1.954-1.954 1.954zm0-15.1H86.057c-1.08 0-1.954-.876-1.954-1.955 0-1.078.875-1.953 1.954-1.953h72.586c1.08 0 1.954.875 1.954 1.954 0 1.08-.875 1.955-1.954 1.955zm0-16.15H86.057c-1.08 0-1.954-.874-1.954-1.953 0-1.08.875-1.954 1.954-1.954h72.586c1.08 0 1.954.874 1.954 1.953 0 1.08-.875 1.954-1.954 1.954zm35.16 28.818c-8.365 0-15.146-6.782-15.146-15.147s6.782-15.147 15.147-15.147c8.366 0 15.147 6.782 15.147 15.147 0 8.366-6.78 15.147-15.146 15.147zm18.152-99.138c0 8.992-7.29 16.28-16.28 16.28H48.262c-8.992 0-16.28-7.288-16.28-16.28v-85.274c0-8.992 7.288-16.28 16.28-16.28h147.41c8.993 0 16.282 7.288 16.282 16.28v85.274z"
			},
			children: [
			]
		},
		{
			id: "trolley",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M148.302 90.29c-.335 0-.676-.036-1.017-.114-2.44-.56-3.965-2.992-3.406-5.432l18.103-78.958c.56-2.44 2.99-3.967 5.432-3.405 2.44.56 3.965 2.992 3.406 5.433L152.718 86.77c-.482 2.1-2.35 3.52-4.415 3.52zM97.19 90.29c-2.066 0-3.932-1.42-4.414-3.52L74.67 7.813c-.56-2.44.966-4.873 3.407-5.432 2.44-.558 4.872.966 5.432 3.406l18.103 78.958c.56 2.44-.965 4.873-3.406 5.432-.34.078-.68.115-1.016.115z"
			},
			children: [
			]
		},
		{
			id: "trolley",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M197.84 31.58c-2.218 0-4.392-1.084-5.697-3.077l-7.61-11.622c-1.337-2.044-3.595-3.264-6.038-3.264L65.443 13.6c-2.445 0-4.702 1.222-6.04 3.266l-7.608 11.62c-2.057 3.143-6.272 4.023-9.414 1.965-3.14-2.056-4.02-6.27-1.964-9.413l7.607-11.62C51.883 3.52 58.393 0 65.44 0h.005l113.053.015c7.046 0 13.557 3.52 17.416 9.416l7.608 11.623c2.057 3.142 1.178 7.357-1.965 9.414-1.148.752-2.44 1.112-3.718 1.112z"
			},
			children: [
			]
		}
	]
};
var tumblr = {
	id: "tumblr",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "tumblr",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tumblr",
					name: "",
					type: "text",
					value: "Tumblr icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tumblr",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M534.5 654c-9.5 4.5-27.7 8.5-41.3 8.8-41 1.1-48.9-28.8-49.3-50.5V452.9h102.8v-77.5H444.3V245h-75s-3.4 1.1-3.7 3.8c-4.4 39.9-23.1 110-100.7 138v66.1h51.8v167.3c0 57.3 42.3 138.6 153.8 136.7 37.6-.7 79.4-16.4 88.7-30L534.5 654z"
			},
			children: [
			]
		}
	]
};
var trophy = {
	id: "trophy",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 507 507"
	},
	children: [
		{
			id: "trophy",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "trophy",
					name: "",
					type: "text",
					value: "Trophy icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "trophy",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 65.91V45.63c6.805-7.76 15.11-10.577 25.607-10.178 19.566.745 39.18.214 58.988.214 0-3.614.04-5.29-.006-6.962C83.912 4.066 87.856.002 112.496 0H389.48c31.353 0 33.036 1.674 32.91 32.55-.003.7.675 1.404 1.554 3.115 18.83 0 38.172.562 57.46-.224 10.528-.428 18.763 2.512 25.596 10.19v20.28c-.856 3.176-2.002 6.306-2.524 9.538-6.03 37.297-16.894 73.02-34.904 106.35-31.94 59.113-77.98 98.746-147.218 106.523-3.914.44-8.815 3.33-10.93 6.587-8.472 13.056-16.62 26.4-23.797 40.206-14.522 27.93-10.406 54.84 7.182 79.846 19.3 27.44 46.552 44.507 76.866 57.704 6.494 2.827 13.416 8.684 16.256 14.916 3.872 8.494-3.486 14.586-10.217 19.42h-248.43c-16.398-13.79-14.492-26.367 5.058-34.702 29.487-12.57 56.352-28.99 75.905-55.104 19.288-25.76 24.08-53.492 8.675-82.954-5.852-11.193-12.99-21.724-18.642-33.008-4.906-9.797-12.29-13.313-22.874-14.46-35.514-3.845-66.216-18.818-92.58-42.745-32.41-29.413-53.47-66.198-66.806-107.266C10.51 113.634 5.91 89.56 0 65.91zm469.326 3.595c-13.904 0-27.74.528-41.508-.196-8.394-.442-10.23 3.453-12.2 10.572-6.614 23.89-12.137 48.417-21.97 71.006-14.56 33.443-32.452 65.436-48.445 97.098 66.47-9.713 116.66-100.02 124.123-178.48zM163.56 248.33c-.146-.786-.072-1.71-.47-2.338-33.3-52.68-61.252-107.636-72.8-169.674-.448-2.41-3.06-6.256-4.755-6.307-16.155-.48-32.33-.287-48.628-.287 9.096 89.08 69.604 173.497 126.653 178.607z"
			},
			children: [
			]
		}
	]
};
var twitch = {
	id: "twitch",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 450 450"
	},
	children: [
		{
			id: "twitch",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "twitch",
					name: "",
					type: "text",
					value: "Twitch icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "twitch",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M438 0v255.5L273.75 419.75h-73L109.5 511v-91.25H0V91.25L91.25 0H438zm-36.5 36.5h-292v273.75h82.125v63.875L255.5 310.25h73l73-73V36.5zm-54.75 63.875v109.5h-36.5v-109.5h36.5zm-100.375 0v109.5h-36.5v-109.5h36.5z",
				fill: "#FFF"
			},
			children: [
			]
		}
	]
};
var twitter = {
	id: "twitter",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "twitter",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "twitter",
					name: "",
					type: "text",
					value: "Twitter icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "twitter",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M614.9 395.8c.2 4.5.3 9 .3 13.6 0 138.4-105.4 298-298 298-59.2 0-114.2-17.4-160.6-47.1 8.2 1 16.5 1.5 25 1.5 49.1 0 94.2-16.7 130.1-44.8-45.8-.8-84.5-31.1-97.9-72.8 6.4 1.2 13 1.9 19.7 1.9 9.6 0 18.8-1.3 27.6-3.7-47.9-9.6-84-52-84-102.7v-1.3c14.1 7.8 30.3 12.6 47.4 13.1-28-18.8-46.5-50.9-46.5-87.2 0-19.2 5.2-37.2 14.2-52.7C243.8 375 321 416.7 408.1 421.1c-1.8-7.7-2.7-15.7-2.7-23.9 0-57.8 46.9-104.8 104.8-104.8 30.1 0 57.4 12.7 76.5 33.1 23.9-4.7 46.3-13.4 66.5-25.4-7.8 24.5-24.4 45-46.1 58 21.2-2.5 41.4-8.2 60.2-16.5-14.1 21-31.9 39.4-52.4 54.2z"
			},
			children: [
			]
		}
	]
};
var video = {
	id: "video",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 47 26",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "video",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "video",
					name: "",
					type: "text",
					value: "Video Highlights icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "video",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "video",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M2.824 0H31.06c1.56 0 2.822 1.264 2.822 2.824v19.764c0 1.56-1.263 2.824-2.823 2.824H2.823C1.264 25.412 0 24.148 0 22.588V2.824C0 1.264 1.264 0 2.824 0"
					},
					children: [
					]
				},
				{
					id: "video",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.394 11.96l22.58-8.472v16.95"
					},
					children: [
					]
				}
			]
		}
	]
};
var upgrade = {
	id: "upgrade",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 85.378 103.229"
	},
	children: [
		{
			id: "upgrade",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "upgrade",
					name: "",
					type: "text",
					value: "Upgrade icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "upgrade",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21.014 39.674l13.795-12.739v41.488c0 4.14 3.592 7.508 8.006 7.508s8.005-3.368 8.005-7.508V26.92l13.795 12.739c3.097 2.859 8.133 2.858 11.228 0 1.54-1.422 2.388-3.321 2.388-5.346s-.848-3.924-2.388-5.346l-27.64-25.51-1.005-.739a3.3 3.3 0 0 0-.35-.189l-.731-.354a1.937 1.937 0 0 1-.158-.062l-.212-.079c-.088-.027-.137-.045-.17-.057l-1.297-.34a2.8 2.8 0 0 0-.426-.056l-.125-.012a3.094 3.094 0 0 0-.194-.017l-.633-.032a4.094 4.094 0 0 0-.395-.015l-.233.012c-.092.006-.185.012-.286.028-.068.005-.122.01-.165.015l-.063-.01-.164.038a7.907 7.907 0 0 0-.545.09c-.2.038-.279.056-.421.09-.15.038-.295.074-.448.14l-.031.01a2.96 2.96 0 0 0-.242.087 2.722 2.722 0 0 0-.366.137 2.594 2.594 0 0 0-.383.172l-.266.126c-.137.068-.254.126-.371.207a3.021 3.021 0 0 0-.324.211l-.113.077a2.463 2.463 0 0 0-.162.115 3.18 3.18 0 0 0-.336.257 3.734 3.734 0 0 0-.434.386L9.787 28.982c-1.54 1.422-2.388 3.321-2.388 5.347 0 2.025.849 3.924 2.388 5.346 3.097 2.859 8.133 2.858 11.227-.001zm57.228 54.255l-.013-.203a4.29 4.29 0 0 0-.026-.273 4.321 4.321 0 0 0-.012-.146l.01-.064-.061-.338a4.237 4.237 0 0 0-.057-.321c-.034-.192-.052-.269-.084-.407a2.617 2.617 0 0 0-.126-.415l-.004-.015a3.264 3.264 0 0 0-.082-.237 2.426 2.426 0 0 0-.131-.358l.001-.001a2.347 2.347 0 0 0-.149-.343l-.094-.205a3.078 3.078 0 0 0-.205-.388 2.716 2.716 0 0 0-.198-.313l-.196-.293a2.915 2.915 0 0 0-.201-.269 3.392 3.392 0 0 0-.412-.468c-1.289-1.396-2.995-2.164-4.816-2.164H13.99c-1.907 0-3.679.839-4.975 2.347l-.788 1.077c-.146.266-.163.308-.202.394a5.602 5.602 0 0 0-.14.288l-.167.382c-.104.257-.195.52-.273.792l-.136.569c-.023.117-.046.234-.062.342a1.942 1.942 0 0 0-.025.181v-.001a9.225 9.225 0 0 0-.074.858 3.061 3.061 0 0 0-.003.376l-.008.132.012.281c.005.079.011.163.024.256l.013.143-.01.062.06.341c.035.219.055.318.058.322.028.161.045.236.078.386.036.146.069.285.131.433l.007.031c.021.064.044.141.078.226.037.123.072.229.123.339.042.113.087.235.157.363l.111.244c.06.123.113.235.188.349.067.121.128.219.194.309l.188.281c.118.173.172.239.218.291.135.179.256.322.406.46 1.289 1.396 2.994 2.164 4.815 2.164h57.396c1.881 0 3.699-.861 4.973-2.344l.791-1.08c.161-.294.178-.341.197-.385a7.49 7.49 0 0 0 .172-.356l.14-.323c.101-.251.191-.508.268-.772l.138-.575a7.59 7.59 0 0 0 .09-.53c.024-.173.043-.348.057-.543l.02-.324c.005-.092.01-.184.01-.277l-.005-.138.007-.15z"
			},
			children: [
			]
		}
	]
};
var uber = {
	id: "uber",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "uber",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "uber",
					name: "",
					type: "text",
					value: "Uber icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "uber",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M512 32.05C512 14.35 497.65 0 479.95 0H32.05C14.35 0 0 14.35 0 32.05V479.95C0 497.652 14.35 512 32.05 512H479.95c17.7 0 32.05-14.35 32.05-32.05V32.05zM266.89 416.473C180.666 422.24 105.4 358 96.76 273H208v23.26c0 4.426 3.715 8.74 8.14 8.74h80.12c4.426 0 8.74-4.314 8.74-8.74v-80.12c0-4.425-4.314-8.14-8.74-8.14h-80.12c-4.425 0-8.14 3.715-8.14 8.14V241H96.76c8.228-82 77.146-144.632 159.44-144.63 86.418 0 157.27 68.513 160.153 154.882 2.883 86.37-63.238 159.456-149.463 165.222z"
			},
			children: [
			]
		}
	]
};
var vip = {
	id: "vip",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 510.413 510.4"
	},
	children: [
		{
			id: "vip",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "vip",
					name: "",
					type: "text",
					value: "VIP icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "vip",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M297.006 183.707c-3.064-3.08-6.028-5.094-8.88-6.042-2.854-.946-5.595-1.15-8.218-.615-2.622.54-5.16 1.664-7.608 3.377-2.447 1.718-4.8 3.695-7.055 5.938l-15.284 15.208 28.946 29.09 15.283-15.21c2.254-2.243 4.245-4.584 5.972-7.025 1.73-2.438 2.866-4.97 3.416-7.59.55-2.62.357-5.362-.574-8.22-.935-2.858-2.93-5.83-5.998-8.91z"
			},
			children: [
			]
		},
		{
			id: "vip",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M503.15 150.75l-28.2-28.2c-24 24-63 24-87 0s-24-63 0-87l-28.3-28.2c-9.8-9.8-25.7-9.8-35.5 0L7.35 324.15c-9.8 9.8-9.8 25.7 0 35.5l28.2 28.2c24-24 63-24 87 0s24 63 0 87l28.2 28.2c9.8 9.8 25.7 9.8 35.5 0l316.8-316.8c9.8-9.7 9.8-25.7.1-35.5zm-224.6-70.5l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4zm-64.647 317.346L88.393 329.34l20.17-20.07 87.816 48.415.25-.25-47.73-88.303 20.296-20.194 66.88 126.594-22.173 22.064zm59.504-59.21l-96.57-97.05 19.668-19.572 96.57 97.05-19.668 19.572zm56.625-56.344l-19.668 19.57-96.57-97.05 40.337-40.14c5.595-5.566 11.235-9.42 16.92-11.56 5.683-2.14 11.2-2.983 16.55-2.536 5.348.45 10.436 1.97 15.26 4.562 4.826 2.594 9.22 5.884 13.188 9.87 3.878 3.898 7.125 8.29 9.738 13.17 2.614 4.882 4.13 10 4.553 15.35.423 5.354-.452 10.864-2.618 16.536-2.168 5.675-6.05 11.295-11.645 16.86l-20.67 20.57 34.625 34.798zM346.95 147.25l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4zm42 42l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4zm42 42l-.7.7c-4.5 4.5-11.9 4.5-16.4 0l-9.3-9.3c-4.5-4.5-4.5-11.9 0-16.4l.7-.7c4.5-4.5 11.9-4.5 16.4 0l9.3 9.3c4.5 4.5 4.5 11.9 0 16.4z"
			},
			children: [
			]
		}
	]
};
var visa = {
	id: "visa",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 576 512"
	},
	children: [
		{
			id: "visa",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "visa",
					name: "",
					type: "text",
					value: "Visa",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "visa",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
			},
			children: [
			]
		}
	]
};
var threads = {
	id: "threads",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 192 192"
	},
	children: [
		{
			id: "threads",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "threads",
					name: "",
					type: "text",
					value: "Threads icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "threads",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.229c8.249.053 14.474 2.452 18.503 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036 9.607 125.202.195 97.07 0h-.113C68.882.194 47.292 9.642 32.788 28.08 19.882 44.485 13.224 67.315 13.001 95.932L13 96v.067c.224 28.617 6.882 51.447 19.788 67.854C47.292 182.358 68.882 191.806 96.957 192h.113c24.96-.173 42.554-6.708 57.048-21.189 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.723-24.553ZM98.44 129.507c-10.44.588-21.286-4.098-21.82-14.135-.397-7.442 5.296-15.746 22.461-16.735 1.966-.114 3.895-.169 5.79-.169 6.235 0 12.068.606 17.371 1.765-1.978 24.702-13.58 28.713-23.802 29.274Z"
			},
			children: [
			]
		}
	]
};
var watch = {
	id: "watch",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "watch",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "watch",
					name: "",
					type: "text",
					value: "Watch icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "watch",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M262.4 690.7v-45.4c0-1.1.9-2 2-2h295.2c1.1 0 2 .9 2 2v45.4c0 1.1-.9 2-2 2H264.4c-1.1 0-2-.9-2-2zM655.5 309.3h-487c-4.8 0-8.6 3.9-8.6 8.6v294.7c0 4.8 3.9 8.6 8.6 8.6h487c4.8 0 8.6-3.9 8.6-8.6V317.9c.1-4.7-3.8-8.6-8.6-8.6zm-40.7 253.9c0 4.8-3.9 8.6-8.6 8.6H217.9c-4.8 0-8.6-3.9-8.6-8.6V367.3c0-4.8 3.9-8.6 8.6-8.6h388.2c4.8 0 8.6 3.9 8.6 8.6l.1 195.9z"
			},
			children: [
			]
		}
	]
};
var vote = {
	id: "vote",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "vote",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "vote",
					name: "",
					type: "text",
					value: "Vote icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "vote",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M22.103 25.871c0-2.182.034-4.201-.017-6.218-.02-.789.186-1.368.783-1.895.747-.66 1.413-1.412 2.282-2.294.025.566.051.873.051 1.18.003 2.967.012 5.933-.002 8.9-.011 2.272-1.155 3.431-3.389 3.434-6.042.007-12.084.01-18.126-.001-2.319-.004-3.45-1.157-3.452-3.48-.004-5.97-.005-11.939 0-17.909.002-2.476 1.102-3.577 3.569-3.578 6.33-.004 12.66-.001 19.322-.001-1.676 1.366-2.423 3.289-4.972 3.161-4.474-.227-8.968-.064-13.454-.064H3.407c-.027.426-.067.773-.067 1.12-.004 5.499.016 10.998-.021 16.497-.006.883.216 1.175 1.139 1.168 5.499-.042 10.998-.021 16.497-.021l1.148.001z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "vote",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.77 7.174c-6.862 4.401-11.86 10.309-16.382 16.684l-.449.097c-.229-.357-.444-.725-.69-1.07-2.062-2.898-4.318-5.621-7.163-7.796-.531-.406-.704-.848-.509-1.494.272-.898.475-1.816.729-2.719.273-.97.686-1.137 1.421-.429a162.737 162.737 0 0 1 5.42 5.445c1.145 1.211 1.328 1.269 2.131-.208 2.139-3.933 5.165-7.125 8.393-10.15.229-.214.666-.434.919-.358 1.964.59 3.906 1.251 6.18 1.998z",
				fill: "#444"
			},
			children: [
			]
		}
	]
};
var wifi = {
	id: "wifi",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.744 373.862"
	},
	children: [
		{
			id: "wifi",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "wifi",
					name: "",
					type: "text",
					value: "Wi-fi connect icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "wifi",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.872 280.398c-25.797 0-46.733 20.935-46.733 46.732s20.936 46.733 46.732 46.733 46.733-20.936 46.733-46.733-20.936-46.733-46.733-46.732zm250.392-163.393C443.767 42.635 352.5 0 255.872 0S67.992 42.637 5.478 117.005c-8.303 9.875-7.024 24.612 2.868 32.914 4.376 3.675 9.688 5.483 15 5.483 6.667 0 13.287-2.835 17.914-8.334C94.847 83.31 173.078 46.732 255.872 46.732s161.025 36.577 214.61 100.32c4.628 5.5 11.247 8.334 17.915 8.334 5.312 0 10.64-1.792 15.016-5.484 9.876-8.287 11.156-23.04 2.85-32.898zm-250.392-23.54c-69.024 0-134.2 30.455-178.846 83.56-8.302 9.874-7.024 24.612 2.868 32.914 4.376 3.674 9.703 5.482 15.016 5.482 6.668 0 13.29-2.835 17.9-8.334 35.72-42.51 87.873-66.89 143.065-66.89 55.19 0 107.343 24.38 143.078 66.89 4.627 5.515 11.247 8.334 17.898 8.334 5.313 0 10.64-1.792 15.02-5.484 9.89-8.303 11.166-23.054 2.865-32.916-44.66-53.104-109.838-83.558-178.863-83.558v.002zm0 93.466c-41.436 0-80.55 18.274-107.313 50.13-8.304 9.874-7.028 24.612 2.865 32.914 4.377 3.676 9.704 5.483 15.016 5.483 6.668 0 13.288-2.835 17.9-8.334 17.868-21.264 43.944-33.46 71.532-33.46s53.665 12.197 71.532 33.46c4.627 5.515 11.247 8.334 17.9 8.334 5.31 0 10.64-1.79 15.015-5.483 9.89-8.303 11.17-23.04 2.867-32.915-26.764-31.856-65.88-50.13-107.315-50.13z"
			},
			children: [
			]
		}
	]
};
var wrap = {
	id: "wrap",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 40 40",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "wrap",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "wrap",
					name: "",
					type: "text",
					value: "Wrap icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "wrap",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "wrap",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						transform: "translate(6.000000, 6.466667)"
					},
					children: [
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								strokeWidth: "2",
								fillOpacity: "0.2",
								x: "0",
								y: "0",
								width: "24.2666667",
								height: "26.1333333",
								rx: "1"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "3.73333333",
								y: "4.15257308",
								width: "16.8",
								height: "3.73333333"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "3.73333333",
								y: "9.75257308",
								width: "6.53333333",
								height: "11.2"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "13.0666667",
								y: "9.75257308",
								width: "7.46666667",
								height: "1.86666667"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "13.0666667",
								y: "14.4192397",
								width: "7.46666667",
								height: "1.86666667"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "rect",
							type: "element",
							value: "",
							attributes: {
								x: "13.0666667",
								y: "19.0859064",
								width: "7.46666667",
								height: "1.86666667"
							},
							children: [
							]
						},
						{
							id: "wrap",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M23.8,2.285906 L26.9635517,2.32169791 C27.5158011,2.32794597 27.9584227,2.78069763 27.9521746,3.33294703 C27.9520394,3.34489862 27.9516899,3.35684681 27.9511263,3.36878587 L26.8995241,25.6463913 C26.8743472,26.17975 26.434589,26.5992393 25.9006364,26.5992393 L23.8,26.5992393 L23.8,26.5992393 L23.8,2.285906 Z",
								stroke: "#666666"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
};
var facebook = {
	id: "facebook",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "facebook",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "facebook",
					name: "",
					type: "text",
					value: "Facebook icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "facebook",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M388.4 85.3h-48c-37.6 0-45.1 17.9-45.1 44.2v58.1h89.9l-11.8 90.7H295v233.2h-93.9V278.7h-78.3V188h78.3v-67c0-77.7 47.4-119.9 116.8-119.9 33.2 0 61.8 2.6 70.2 3.5v80.9h.3z"
			},
			children: [
			]
		}
	]
};
var x = {
	id: "x",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "x",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "x",
					name: "",
					type: "text",
					value: "X icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "x",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M300.764 216.797 475.983 0h-41.521L282.319 188.241 160.805 0H20.65l183.756 284.654L20.65 512h41.523L222.84 313.21 351.17 512h140.154l-190.57-295.203h.01Zm-56.871 70.365-18.62-28.345L77.135 33.272h63.778l119.55 182.022 18.619 28.346 155.399 236.601h-63.777L243.893 287.174v-.012Z"
			},
			children: [
			]
		}
	]
};
var youtube = {
	id: "youtube",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "youtube",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "youtube",
					name: "",
					type: "text",
					value: "YouTube icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "youtube",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M662.9 398.8s-5-35.3-20.4-50.8c-19.5-20.4-41.3-20.7-51.3-21.9-71.6-5.2-179.1-5.4-179.1-5.4h-.2s-107.5.2-179.1 5.4c-10 1.2-31.8 1.4-51.3 21.8-15.4 15.5-20.3 50.9-20.3 50.9s-5.2 41.5-5.2 82.9v38.8c0 41.4 5.1 82.9 5.1 82.9s5 35.3 20.3 50.8c19.5 20.4 45.1 19.7 56.5 21.9 41 3.9 174.1 5.1 174.1 5.1s107.6-.2 179.2-5.3c10-1.2 31.8-1.3 51.3-21.7 15.4-15.5 20.4-50.8 20.4-50.8s5.1-41.4 5.1-82.9v-38.8c0-41.4-5.1-82.9-5.1-82.9zm-303.8 169v-144L497.4 496l-138.3 71.8z"
			},
			children: [
			]
		}
	]
};
const icons = {
	"accessibility-seating": {
	id: "accessibility-seating",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 135.2 170.372"
	},
	children: [
		{
			id: "accessibility-seating",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accessibility-seating",
					name: "",
					type: "text",
					value: "Accessibility Seating icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accessibility-seating",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M100.114 122.84c-4.056 20.652-22.238 36.286-44.014 36.286-24.748 0-44.88-20.18-44.88-44.983 0-12.972 5.513-24.67 14.305-32.888v-14.22C10.175 77.08 0 94.437 0 114.145c0 31.003 25.165 56.227 56.1 56.227 23.15 0 43.057-14.136 51.612-34.244l-7.598-13.287zM60.026 14.057c0 7.758-6.284 14.057-14.025 14.057s-14.024-6.3-14.024-14.057S38.26 0 46 0c7.742 0 14.026 6.3 14.026 14.057",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "accessibility-seating",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M133.673 131.798c-27.002-48.258-24.56-47.642-32.32-47.642h-38.38l-.566-11.62H90.88c3.718 0 6.733-3.022 6.733-6.748 0-3.726-3.015-6.747-6.732-6.747H61.75l-.6-12.37c0-7.758-6.284-14.056-14.026-14.056-7.74 0-14.025 6.298-14.025 14.057l2.243 46.108c0 7.758 6.284 14.057 14.025 14.057h50.49l19.3 33.343c1.337 2.887 4.247 4.892 7.628 4.892 4.646 0 8.415-3.776 8.415-8.434 0-1.18-1.195-4.364-1.527-4.838",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"accessibility-parking": {
	id: "accessibility-parking",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 150.904 170.372"
	},
	children: [
		{
			id: "accessibility-parking",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accessibility-parking",
					name: "",
					type: "text",
					value: "Accessibility Parking icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accessibility-parking",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M70.01 131.965c3.276 16.687 17.968 29.32 35.564 29.32 19.997 0 36.264-16.305 36.264-36.347 0-10.482-4.455-19.935-11.56-26.574v-11.49c12.405 8.115 20.626 22.14 20.626 38.065 0 25.05-20.334 45.433-45.33 45.433-18.708 0-34.792-11.422-41.705-27.67l6.14-10.738zM102.4 44.064c0 6.27 5.078 11.36 11.333 11.36s11.333-5.09 11.333-11.36-5.078-11.36-11.333-11.36-11.333 5.09-11.333 11.36",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "accessibility-parking",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M42.892 139.203c21.82-38.994 19.845-38.496 26.115-38.496h31.013l.457-9.39H77.47c-3.005 0-5.44-2.44-5.44-5.452 0-3.01 2.435-5.452 5.44-5.452h23.537l.487-9.996c0-6.27 5.077-11.36 11.333-11.36 6.255 0 11.333 5.09 11.333 11.36l-1.813 37.256c0 6.27-5.078 11.36-11.333 11.36H70.216l-15.595 26.94c-1.08 2.334-3.43 3.954-6.163 3.954-3.754 0-6.8-3.05-6.8-6.815 0-.953.966-3.526 1.235-3.91M63.223 53.066c-5.586 4.57-13.563 6.855-23.93 6.855h-19.87v33.644H0V0h40.752c9.395 0 16.885 2.412 22.47 7.236 5.587 4.824 8.38 12.293 8.38 22.407 0 11.046-2.793 18.853-8.38 23.423zM48.4 19.36c-2.56-2.074-6.146-3.11-10.758-3.11H19.424V43.8h18.218c4.613 0 8.2-1.122 10.76-3.365 2.56-2.243 3.84-5.798 3.84-10.664s-1.28-8.336-3.84-10.41z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"50-50": {
	id: "50-50",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511 511.139"
	},
	children: [
		{
			id: "50-50",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "50-50",
					name: "",
					type: "text",
					value: "50 50 icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "50-50",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M51.724 67.32l-6.997 39.73.5.5c4.83-4.83 9.995-8.284 15.492-10.37 5.496-2.08 11.743-3.122 18.74-3.122 8.66 0 16.324 1.585 22.99 4.748 6.66 3.167 12.282 7.414 16.866 12.744 4.58 5.333 8.078 11.62 10.495 18.866 2.414 7.247 3.624 14.954 3.624 23.114 0 8.996-1.75 17.366-5.248 25.113-3.498 7.746-8.207 14.454-14.118 20.115-5.915 5.666-12.787 10.038-20.615 13.12-7.832 3.08-16.16 4.536-24.988 4.372-8.496 0-16.617-1.125-24.363-3.374-7.747-2.25-14.618-5.704-20.615-10.37C17.49 197.844 12.7 192.054 9.12 185.14c-3.585-6.912-5.46-14.95-5.624-24.114H38.98c.832 7.996 3.83 14.368 8.996 19.116 5.162 4.748 11.744 7.122 19.74 7.122 4.662 0 8.87-.957 12.62-2.874 3.747-1.913 6.91-4.412 9.495-7.497 2.582-3.08 4.58-6.66 5.998-10.745 1.413-4.08 2.124-8.285 2.124-12.62 0-4.497-.668-8.745-2-12.743-1.334-3.998-3.333-7.497-5.996-10.495-2.667-3-5.833-5.33-9.496-6.997-3.666-1.663-7.914-2.5-12.744-2.5-6.333 0-11.495 1.126-15.492 3.374-3.998 2.25-7.747 5.79-11.245 10.62H8.994l17.242-96.703h97.702V67.32H51.723zM148.302 81.94c3.412-11.578 8.035-20.866 13.868-27.862 5.83-6.997 12.62-11.994 20.365-14.993s15.95-4.498 24.613-4.498c8.828 0 17.117 1.5 24.863 4.498 7.748 3 14.576 7.996 20.49 14.993 5.913 6.997 10.58 16.285 13.995 27.86 3.412 11.58 5.123 25.863 5.123 42.855 0 17.49-1.71 32.11-5.123 43.854-3.416 11.744-8.082 21.114-13.994 28.11-5.914 6.998-12.743 11.995-20.49 14.994-7.745 3-16.034 4.5-24.862 4.5-8.664 0-16.867-1.5-24.613-4.5S168 203.756 162.17 196.76c-5.833-6.997-10.456-16.367-13.868-28.11-3.417-11.746-5.123-26.363-5.123-43.855 0-16.99 1.705-31.273 5.122-42.854zm30.86 60.97c.332 7.082 1.374 13.91 3.123 20.49 1.75 6.582 4.537 12.204 8.37 16.866 3.83 4.666 9.33 6.997 16.493 6.997 7.33 0 12.95-2.33 16.867-6.997 3.912-4.662 6.747-10.284 8.496-16.867 1.75-6.58 2.79-13.41 3.125-20.49.332-7.08.5-13.12.5-18.117 0-3-.043-6.622-.125-10.87-.085-4.248-.417-8.62-1-13.12-.585-4.497-1.417-8.952-2.5-13.368-1.084-4.412-2.708-8.37-4.872-11.87-2.167-3.497-4.916-6.328-8.246-8.495-3.334-2.163-7.414-3.25-12.244-3.25-4.833 0-8.87 1.086-12.12 3.25-3.248 2.167-5.914 4.998-7.995 8.496-2.085 3.5-3.71 7.458-4.873 11.87-1.167 4.415-2 8.87-2.5 13.368-.5 4.498-.79 8.87-.874 13.12-.086 4.247-.125 7.87-.125 10.87.002 4.997.166 11.037.502 18.115zM31.86 511.14H0L479.14 0H511"
			},
			children: [
			]
		},
		{
			id: "50-50",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "50-50",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M285.725 319.32l-6.997 39.73.5.5c4.83-4.828 9.995-8.284 15.492-10.37 5.497-2.08 11.744-3.122 18.74-3.122 8.66 0 16.325 1.585 22.99 4.748 6.66 3.166 12.282 7.414 16.866 12.743 4.58 5.332 8.078 11.618 10.494 18.865 2.413 7.246 3.623 14.953 3.623 23.113 0 8.996-1.748 17.366-5.247 25.113-3.498 7.747-8.207 14.454-14.118 20.115-5.915 5.665-12.787 10.038-20.615 13.118-7.832 3.08-16.16 4.537-24.987 4.373-8.495 0-16.616-1.124-24.362-3.373-7.747-2.25-14.62-5.704-20.615-10.37-6-4.66-10.79-10.452-14.37-17.366-3.583-6.91-5.457-14.95-5.622-24.113h35.483c.833 7.996 3.83 14.368 8.997 19.115 5.16 4.747 11.744 7.12 19.74 7.12 4.66 0 8.87-.955 12.618-2.873 3.748-1.912 6.91-4.412 9.495-7.496 2.58-3.08 4.58-6.66 5.998-10.743 1.412-4.08 2.123-8.285 2.123-12.62 0-4.497-.667-8.745-1.997-12.743-1.336-3.998-3.335-7.496-5.998-10.494-2.666-3-5.833-5.33-9.495-6.997-3.666-1.663-7.914-2.5-12.743-2.5-6.334 0-11.495 1.126-15.492 3.374-3.998 2.25-7.747 5.79-11.245 10.62h-31.984l17.24-96.702h97.703v29.235h-72.215zM382.302 333.94c3.412-11.577 8.035-20.866 13.868-27.862 5.83-6.996 12.62-11.994 20.365-14.992 7.746-3 15.95-4.498 24.612-4.498 8.828 0 17.116 1.5 24.862 4.498 7.746 2.998 14.575 7.996 20.49 14.992 5.91 6.996 10.577 16.285 13.993 27.86 3.412 11.58 5.123 25.863 5.123 42.855 0 17.492-1.71 32.11-5.123 43.854-3.416 11.744-8.082 21.115-13.994 28.11-5.915 6.997-12.744 11.995-20.49 14.993-7.747 3-16.035 4.498-24.863 4.498-8.663 0-16.866-1.5-24.612-4.498-7.746-2.998-14.536-7.996-20.365-14.992-5.833-6.996-10.456-16.367-13.868-28.11-3.417-11.745-5.122-26.362-5.122-43.855 0-16.99 1.705-31.273 5.122-42.854zm30.86 60.97c.33 7.082 1.373 13.91 3.123 20.49 1.75 6.582 4.537 12.204 8.37 16.865 3.83 4.666 9.328 6.997 16.492 6.997 7.33 0 12.95-2.33 16.867-6.997 3.912-4.66 6.747-10.283 8.495-16.866 1.75-6.58 2.787-13.408 3.123-20.49.33-7.08.5-13.12.5-18.117 0-2.998-.044-6.62-.126-10.87-.085-4.247-.417-8.62-1-13.118-.584-4.498-1.416-8.952-2.498-13.368-1.086-4.41-2.71-8.37-4.873-11.87-2.167-3.497-4.915-6.328-8.246-8.494-3.333-2.164-7.413-3.25-12.243-3.25-4.833 0-8.87 1.086-12.118 3.25-3.25 2.166-5.917 4.997-7.997 8.495-2.086 3.5-3.71 7.458-4.873 11.87-1.168 4.415-2 8.87-2.5 13.367-.498 4.498-.79 8.87-.873 13.12-.086 4.247-.125 7.87-.125 10.868 0 4.998.164 11.038.5 18.116z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"accordion-contract": {
	id: "accordion-contract",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 369 90",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "accordion-contract",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accordion-contract",
					name: "",
					type: "text",
					value: "Accordion Contract icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accordion-contract",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accordion-contract",
					name: "",
					type: "text",
					value: "accordion_contract",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accordion-contract",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 89.04h368.194V0H0",
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"accordion-expand": {
	id: "accordion-expand",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 369 369",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "accordion-expand",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "accordion-expand",
					name: "",
					type: "text",
					value: "Accordion Expand icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "accordion-expand",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M139.5 0v139.5H0v89.02h139.5v139.5h89.02v-139.5h139.5V139.5h-139.5V0",
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"ada-assistance": {
	id: "ada-assistance",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 135.016 116.208"
	},
	children: [
		{
			id: "ada-assistance",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "ada-assistance",
					name: "",
					type: "text",
					value: "ADA Assistance icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "ada-assistance",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M29.597 8.505c0 4.694-3.81 8.505-8.505 8.505s-8.505-3.81-8.505-8.505S16.397 0 21.092 0s8.505 3.81 8.505 8.505M55.854 56.925l-30.562-36.11s-5.037-2.08-10.402 0L0 47.2 1.99 67.06c.187 2.364 2.165 4.23 4.58 4.23 2.536 0 4.598-2.062 4.598-4.598 0-.167-1.642-17.08-1.642-17.08l4.926-10.183v28.084L1.675 105.946c-.23.67-.362 1.385-.362 2.133 0 3.624 2.945 6.57 6.57 6.57 3.05 0 5.61-2.088 6.348-4.91L29.344 68.23v-23.43l-7.445-8.98s.11-2.41 2.518-1.863l24.616 29.117c.844 1.008 2.11 1.65 3.523 1.65 2.537 0 4.6-2.063 4.6-4.6 0-1.243-.497-2.37-1.3-3.197",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "ada-assistance",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M30.548 70.633l-6.24 17.414 9.174 22.833c1.054 2.225 3.312 3.767 5.934 3.767 3.625 0 6.57-2.945 6.57-6.57 0-1.97-15.438-37.444-15.438-37.444M113.738 87.45c-2.46 12.495-13.486 21.954-26.69 21.954-15.01 0-27.217-12.21-27.217-27.216 0-7.85 3.345-14.927 8.676-19.9v-8.603c-9.31 6.077-15.48 16.58-15.48 28.502 0 18.76 15.262 34.02 34.02 34.02 14.04 0 26.112-8.553 31.3-20.72l-4.608-8.037zM89.428 21.63c0 4.695-3.81 8.506-8.505 8.506-4.694 0-8.505-3.81-8.505-8.505s3.81-8.504 8.505-8.504c4.694 0 8.505 3.81 8.505 8.505",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "ada-assistance",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M134.09 92.87c-16.375-29.198-14.893-28.826-19.6-28.826H91.216l-.343-7.03h17.267c2.253 0 4.08-1.83 4.08-4.083s-1.827-4.08-4.08-4.08H90.473l-.365-7.486c0-4.695-3.81-8.505-8.506-8.505-4.694 0-8.505 3.81-8.505 8.504l1.36 27.897c0 4.695 3.81 8.506 8.505 8.506h30.618l11.704 20.174c.81 1.747 2.575 2.96 4.626 2.96 2.818 0 5.103-2.285 5.103-5.103 0-.714-.725-2.64-.926-2.927",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	accessibility: accessibility,
	"add-to-calendar": {
	id: "add-to-calendar",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "add-to-calendar",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "add-to-calendar",
					name: "",
					type: "text",
					value: "Add to Calendar icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "add-to-calendar",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M825.2 457.6V192.8c0-34.6-29.5-63.7-64.3-63.7h-57.5V54c0-24.9-20.4-45-45.2-45h-93.7c-24.7 0-46.2 20.4-46.2 45v75h-182V54c0-24.9-19.3-45-44.1-45h-93.9c-24.7 0-45.8 20.4-45.8 45v75H93.7c-34.6 0-63.1 29.1-63.1 63.7v607.8c0 34.4 28.3 62.9 63.1 62.9H453c50.8 77.8 138.6 129 238.1 129 157.1 0 284.3-127.5 284.3-284.3.2-108.2-60.6-202.6-150.2-250.5zM596 68.9h29.5c9 0 16.1 7.3 16.1 16.1v136.3c0 9-7.3 16.1-16.1 16.1h-29.3c-9 0-16.1-7.3-16.1-16.1V85h-.2c-.1-9 7.2-16.1 16.1-16.1zM214.2 85c0-9 7.3-16.1 16.1-16.1h29.5c9 0 16.1 7.3 16.1 16.1v136.3c0 9-7.3 16.1-16.1 16.1h-29.5c-9 0-16.1-7.3-16.1-16.1V85zm192.5 623.3c0 32.8 5.6 64.3 15.8 93.5H92.3V312.6h671.2v120.5c-23.1-6-47.4-9.4-72.2-9.4-157.1.4-284.6 127.4-284.6 284.6zM864.6 752H733.5v131.1h-83.4V752H519v-83.6h131.1V537.3h83.4v131.1h131.1V752z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"add-reel": {
	id: "add-reel",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "add-reel",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "add-reel",
					name: "",
					type: "text",
					value: "Add Reel icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "add-reel",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.440 5.102 C 2.720 5.257,1.997 5.825,1.681 6.484 C 1.389 7.093,1.401 6.846,1.401 12.000 C 1.401 17.156,1.389 16.907,1.682 17.519 C 1.816 17.798,1.906 17.918,2.192 18.199 C 2.548 18.548,2.802 18.704,3.280 18.865 C 3.489 18.936,3.766 18.941,8.797 18.960 L 14.095 18.980 14.161 19.240 C 14.506 20.606,15.453 21.790,16.713 22.433 C 17.506 22.838,18.101 22.980,19.000 22.980 C 19.898 22.980,20.494 22.838,21.286 22.433 C 22.630 21.748,23.580 20.489,23.907 18.960 C 24.008 18.489,24.008 17.511,23.907 17.040 C 23.722 16.176,23.337 15.385,22.795 14.753 L 22.600 14.526 22.599 10.953 C 22.599 6.960,22.606 7.083,22.319 6.484 C 21.999 5.816,21.276 5.254,20.540 5.100 C 20.130 5.014,3.839 5.016,3.440 5.102 M20.565 6.365 C 20.881 6.514,21.098 6.725,21.250 7.033 L 21.380 7.298 21.391 10.449 C 21.397 12.182,21.392 13.600,21.380 13.600 C 21.367 13.600,21.270 13.556,21.163 13.501 C 20.663 13.248,20.137 13.103,19.470 13.036 C 18.592 12.947,17.586 13.120,16.878 13.481 C 16.739 13.552,16.714 13.554,16.584 13.499 C 16.082 13.289,15.495 13.702,15.570 14.213 C 15.587 14.325,15.558 14.373,15.316 14.633 C 14.601 15.398,14.154 16.397,14.018 17.530 L 13.991 17.761 8.824 17.750 L 3.658 17.740 3.393 17.610 C 3.085 17.458,2.874 17.241,2.725 16.925 L 2.620 16.700 2.620 12.000 L 2.620 7.300 2.724 7.078 C 2.908 6.686,3.204 6.426,3.611 6.298 C 3.749 6.255,5.292 6.246,12.060 6.252 L 20.340 6.260 20.565 6.365 M7.380 9.235 C 6.924 9.518,6.866 10.049,7.253 10.389 C 7.579 10.675,8.143 10.580,8.337 10.207 C 8.530 9.833,8.378 9.367,8.013 9.215 C 7.825 9.136,7.523 9.146,7.380 9.235 M15.978 9.216 C 15.911 9.245,15.809 9.325,15.751 9.394 C 15.278 9.956,15.832 10.754,16.535 10.522 C 16.840 10.421,17.054 10.017,16.980 9.681 C 16.947 9.532,16.755 9.300,16.596 9.218 C 16.457 9.146,16.141 9.145,15.978 9.216 M9.888 9.928 C 9.852 9.964,9.840 10.480,9.840 12.005 C 9.840 13.815,9.847 14.041,9.904 14.099 C 9.945 14.139,9.999 14.153,10.054 14.136 C 10.187 14.096,14.011 12.155,14.087 12.090 C 14.124 12.058,14.145 12.007,14.133 11.977 C 14.107 11.908,10.121 9.880,10.013 9.880 C 9.971 9.880,9.914 9.902,9.888 9.928 M7.512 11.317 C 7.220 11.411,7.002 11.703,7.002 12.000 C 7.002 12.163,7.115 12.430,7.226 12.528 C 7.327 12.618,7.573 12.720,7.689 12.720 C 8.154 12.719,8.523 12.258,8.402 11.830 C 8.348 11.637,8.274 11.537,8.093 11.409 C 7.951 11.308,7.675 11.265,7.512 11.317 M16.100 11.307 C 15.877 11.369,15.666 11.589,15.598 11.830 C 15.477 12.258,15.846 12.719,16.311 12.720 C 16.427 12.720,16.673 12.618,16.774 12.528 C 16.885 12.430,16.998 12.163,16.998 12.000 C 16.998 11.786,16.867 11.539,16.692 11.423 C 16.538 11.321,16.252 11.265,16.100 11.307 M7.420 13.497 C 7.271 13.563,7.099 13.744,7.043 13.893 C 6.918 14.223,7.076 14.610,7.408 14.784 C 7.545 14.855,7.844 14.856,8.013 14.785 C 8.282 14.673,8.472 14.312,8.417 14.018 C 8.335 13.582,7.826 13.315,7.420 13.497 M19.605 14.058 C 20.855 14.247,21.964 15.042,22.536 16.160 C 22.767 16.611,22.871 16.930,22.942 17.395 C 23.014 17.879,23.014 18.121,22.942 18.605 C 22.604 20.845,20.437 22.368,18.227 21.917 C 16.566 21.579,15.309 20.265,15.058 18.605 C 14.986 18.121,14.986 17.879,15.058 17.395 C 15.314 15.698,16.675 14.324,18.358 14.061 C 18.816 13.990,19.144 13.989,19.605 14.058 M18.636 15.610 C 18.561 15.660,18.460 15.781,18.410 15.879 C 18.328 16.041,18.320 16.113,18.320 16.685 L 18.320 17.313 17.650 17.327 C 17.067 17.338,16.962 17.350,16.844 17.420 C 16.584 17.573,16.457 17.860,16.522 18.147 C 16.568 18.352,16.676 18.485,16.881 18.590 C 17.041 18.672,17.112 18.680,17.688 18.680 L 18.320 18.680 18.320 19.312 C 18.320 19.888,18.328 19.959,18.410 20.119 C 18.559 20.411,18.839 20.548,19.147 20.478 C 19.352 20.432,19.485 20.324,19.590 20.119 C 19.672 19.959,19.680 19.888,19.680 19.312 L 19.680 18.680 20.312 18.680 C 20.888 18.680,20.959 18.672,21.119 18.590 C 21.324 18.485,21.432 18.352,21.478 18.147 C 21.543 17.860,21.416 17.573,21.156 17.420 C 21.038 17.350,20.933 17.338,20.350 17.327 L 19.680 17.313 19.680 16.685 C 19.680 16.113,19.672 16.041,19.590 15.879 C 19.463 15.628,19.286 15.520,19.000 15.520 C 18.830 15.520,18.737 15.543,18.636 15.610"
			},
			children: [
			]
		}
	]
},
	"all-teams": {
	id: "all-teams",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "all-teams",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "all-teams",
					name: "",
					type: "text",
					value: "All Teams",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "all-teams",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "16",
				cy: "16",
				r: "16",
				fill: "#333"
			},
			children: [
			]
		},
		{
			id: "all-teams",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "16",
				cy: "16",
				r: "15.5",
				stroke: "#fff"
			},
			children: [
			]
		},
		{
			id: "all-teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#fff",
				d: "M9.754 17.435a.635.635 0 0 0-.648.622c.001.343.291.622.649.622a.636.636 0 0 0 .647-.623.635.635 0 0 0-.648-.621"
			},
			children: [
			]
		},
		{
			id: "all-teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#fff",
				d: "M24.195 19.054c0 .5-.424.906-.944.906h-1.8v-.59h1.44c.364-.036.754-.65.86-1.017.045-.136-.168-.238-.328-.477-.116-.171-.142-.487-.347-.563-.293-.111-.622-.401-.622-.401v-.35c0-.009-.151-.162-.151-.162l-.152-.025v-.154l-.133-.18-.151-.025v-.162l-.124-.17-.213-.025-2.334-3.739h4.055c.253 0 .49.094.668.266.177.17.276.399.276.64v6.228Zm-3.59-3.045s-.524-.35-1.066-.333h-1.332c-.302.001-.187-.647-.187-.647s.169.025.177-.009c.053-.597 0-1.45-.676-1.885-1.146-.733-3.039-.596-3.09 1.179 0 0-1.022.674-1.005.675l1.218-.001.044.187-.328.683s-.062.085.027.111c.07.017.408.008.408.008.125.137.17.598.072.615-.702.179-1.297 1.11-1.296 2.782h.702c.05.082.216.35.365.586h-5.89a.96.96 0 0 1-.667-.265.885.885 0 0 1-.277-.64v-6.229c0-.242.1-.47.277-.64a.958.958 0 0 1 .667-.266h9.066l2.925 3.645-.133.444Zm2.646-4.542H8.748c-.781 0-1.415.609-1.415 1.36v6.227c0 .75.634 1.36 1.415 1.36h14.503c.782 0 1.415-.61 1.415-1.36v-6.228c0-.75-.633-1.359-1.415-1.359Z"
			},
			children: [
			]
		},
		{
			id: "all-teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#BC0022",
				d: "M23.252 11.92h-4.056l2.334 3.739.213.025.124.17v.162l.151.026.134.179v.154l.15.025s.152.153.152.163v.35s.33.289.623.4c.204.076.23.392.346.563.16.238.374.34.329.477-.106.367-.497.981-.86 1.016h-1.44v.591h1.8c.52 0 .943-.405.943-.906v-6.228a.883.883 0 0 0-.276-.64.957.957 0 0 0-.667-.266"
			},
			children: [
			]
		},
		{
			id: "all-teams",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#041E42",
				d: "M9.755 18.679a.636.636 0 0 1-.648-.622c0-.344.29-.622.648-.622.357 0 .648.278.648.621 0 .344-.29.623-.648.623ZM8.75 11.92a.958.958 0 0 0-.668.266.883.883 0 0 0-.276.64v6.228c0 .242.098.47.276.641a.96.96 0 0 0 .668.265h5.89c-.149-.236-.315-.505-.366-.586h-.702c0-1.672.595-2.603 1.296-2.782.098-.017.053-.478-.072-.615 0 0-.337.01-.408-.008-.089-.026-.027-.11-.027-.11l.329-.684-.045-.187h-1.217a46.53 46.53 0 0 1 1.004-.674c.052-1.775 1.944-1.912 3.09-1.18.676.435.73 1.29.676 1.886-.008.034-.177.008-.177.008s-.115.65.187.649h1.332c.543-.018 1.067.332 1.067.332l.133-.444-2.925-3.645H8.75Z"
			},
			children: [
			]
		}
	]
},
	"alternate-format-materials": {
	id: "alternate-format-materials",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 131.359 75.92"
	},
	children: [
		{
			id: "alternate-format-materials",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "alternate-format-materials",
					name: "",
					type: "text",
					value: "Alternate Format Materials icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "alternate-format-materials",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M122.79 47.73v4.99h-8.363v23.2h-5.878v-23.2h-8.4v-4.99h22.64zm-48.446 0h6.124l11.13 19.68V47.73h5.442v28.19H91.2L79.786 55.896V75.92h-5.442V47.73zm-5.346 28.19h-5.802V47.73h5.802v28.19zM53.97 48.456c1.056.446 1.95 1.103 2.684 1.97.607.714 1.087 1.505 1.44 2.372.355.867.532 1.855.532 2.964 0 1.34-.335 2.655-1.005 3.95-.67 1.293-1.775 2.208-3.317 2.743 1.29.523 2.203 1.265 2.74 2.228.537.963.806 2.432.806 4.408v1.894c0 1.288.05 2.16.15 2.62.153.727.507 1.262 1.063 1.607v.71h-6.428c-.177-.626-.303-1.13-.38-1.512-.15-.79-.233-1.6-.245-2.43l-.038-2.62c-.025-1.797-.35-2.995-.976-3.595-.626-.6-1.798-.9-3.517-.9h-6.03V75.92h-5.707V47.73H49.45c1.958.038 3.466.28 4.52.726zm-12.522 4.17V60.2h6.617c1.315 0 2.3-.153 2.958-.46 1.163-.535 1.744-1.593 1.744-3.174 0-1.71-.562-2.856-1.687-3.443-.632-.332-1.58-.497-2.844-.497h-6.788zM28.725 63.718c-1.67 1.377-4.05 2.066-7.148 2.066h-5.935V75.92h-5.8V47.73h12.172c2.806 0 5.044.726 6.712 2.18 1.67 1.453 2.503 3.703 2.503 6.75-.002 3.33-.836 5.68-2.505 7.058zm-4.427-10.155c-.765-.625-1.836-.937-3.214-.937h-5.442v8.3h5.442c1.378 0 2.45-.338 3.214-1.014.765-.676 1.147-1.747 1.147-3.213 0-1.467-.382-2.512-1.147-3.137zM130.676 5.72h-14.79v5.985h13.577V16.6h-13.576v7.25h15.472v5.068h-21.18V.728h20.496v4.99zm-32.08 3.804c-.443-1.925-1.524-3.27-3.243-4.035-.96-.422-2.03-.632-3.204-.632-2.25 0-4.1.857-5.547 2.572s-2.17 4.294-2.17 7.736c0 3.468.783 5.923 2.35 7.363 1.567 1.44 3.35 2.16 5.347 2.16 1.96 0 3.565-.57 4.816-1.712 1.25-1.14 2.022-2.636 2.313-4.485h-6.467v-4.705h11.642v15.128h-3.868l-.588-3.52c-1.126 1.34-2.137 2.283-3.035 2.832-1.542.956-3.438 1.434-5.688 1.434-3.704 0-6.737-1.294-9.1-3.882-2.466-2.6-3.698-6.158-3.698-10.672 0-4.565 1.244-8.224 3.734-10.978C84.684 1.377 87.977 0 92.074 0c3.55 0 6.405.908 8.56 2.725 2.155 1.817 3.39 4.083 3.707 6.8h-5.745zm-28.47-8.07c1.055.446 1.95 1.103 2.683 1.97.606.714 1.086 1.505 1.44 2.372.354.867.53 1.855.53 2.964 0 1.34-.334 2.655-1.004 3.95-.67 1.293-1.776 2.208-3.318 2.744 1.29.523 2.203 1.265 2.74 2.228.537.963.806 2.432.806 4.408v1.893c0 1.288.05 2.16.152 2.62.152.727.506 1.262 1.062 1.607v.708H68.79c-.177-.625-.303-1.128-.38-1.51-.15-.792-.233-1.6-.245-2.43l-.038-2.62c-.025-1.798-.35-2.996-.976-3.596-.625-.6-1.797-.9-3.516-.9h-6.03V28.92H51.9V.728h13.708c1.957.037 3.464.28 4.52.726zm-12.524 4.17v7.573h6.617c1.314 0 2.3-.153 2.957-.46 1.163-.535 1.744-1.593 1.744-3.174 0-1.71-.56-2.856-1.686-3.443-.632-.332-1.58-.497-2.844-.497h-6.788zM31.722.726h6.597l9.896 28.19h-6.333l-1.8-5.794H29.786l-1.934 5.795h-6.105L31.72.728zm-.36 17.538h7.09l-3.49-11.093-3.6 11.093zM0 .727h5.84V23.85h13.84v5.068H0V.728z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	android: android,
	"all-times": {
	id: "all-times",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 16 24"
	},
	children: [
		{
			id: "all-times",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "all-times",
					name: "",
					type: "text",
					value: "All Times",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "all-times",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8 18.8A6.8 6.8 0 1 0 8 5.2a6.8 6.8 0 0 0 0 13.6ZM8 20A8 8 0 1 0 8 4a8 8 0 0 0 0 16Z",
				clipRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "all-times",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8.536 12.6H12a.6.6 0 1 0 0-1.2H8.345a.8.8 0 0 0-.62.295l-3.19 3.926a.6.6 0 0 0 .93.757l3.07-3.778ZM5 .4a.6.6 0 0 1 .6.6v4a.6.6 0 0 1-1.2 0V1A.6.6 0 0 1 5 .4ZM5 18.4a.6.6 0 0 1 .6.6v4a.6.6 0 1 1-1.2 0v-4a.6.6 0 0 1 .6-.6ZM11 .4a.6.6 0 0 1 .6.6v4a.6.6 0 1 1-1.2 0V1a.6.6 0 0 1 .6-.6ZM11 18.4a.6.6 0 0 1 .6.6v4a.6.6 0 1 1-1.2 0v-4a.6.6 0 0 1 .6-.6Z",
				clipRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"american-express": {
	id: "american-express",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 576 512"
	},
	children: [
		{
			id: "american-express",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "american-express",
					name: "",
					type: "text",
					value: "American Express",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "american-express",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2-19 20.2zm65.8 8.2l-25.3-28.1L241 276v55.5zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5h38.9zM576 255.4h-.2.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2h16.8zM31.2 188.8l11.2-27.6 11.5 27.6H31.2zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5h38.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2h-16.1zm42.1 12.1l11.2 27.6h-22.8l11.6-27.6zm-101.1-12v69.3h16.9v-69.3h-16.9z"
			},
			children: [
			]
		}
	]
},
	apps: apps,
	"arrow-expand": {
	id: "arrow-expand",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 420.255 244.264"
	},
	children: [
		{
			id: "arrow-expand",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-expand",
					name: "",
					type: "text",
					value: "Arrow Expand icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-expand",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M410.568 11.816c-12.915-12.915-33.855-12.916-46.77 0L211.19 164.42 56.457 9.687C43.542-3.23 22.602-3.23 9.687 9.686s-12.917 33.855 0 46.77l175.99 175.992c.357.357.723.7 1.092 1.038.336.37.68.735 1.037 1.092 12.915 12.915 33.856 12.915 46.77 0l175.99-175.99c12.917-12.916 12.916-33.856 0-46.772z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"arrow-left": {
	id: "arrow-left",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 278.696 469.219"
	},
	children: [
		{
			id: "arrow-left",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-left",
					name: "",
					type: "text",
					value: "Arrow Left icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-left",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M13.497 265.405c-17.996-17.18-17.996-45.007 0-62.218L213.443 12.72c18.027-17.21 65.252-24.81 65.252 29.57v384.07c0 56.215-47.194 46.782-65.252 29.57L13.497 265.406z"
			},
			children: [
			]
		}
	]
},
	"arrow-contract": {
	id: "arrow-contract",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 420.255 244.264"
	},
	children: [
		{
			id: "arrow-contract",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-contract",
					name: "",
					type: "text",
					value: "Arrow Contract icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-contract",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.687 232.448c12.915 12.915 33.855 12.916 46.77 0L209.063 79.843l154.735 154.735c12.915 12.915 33.855 12.915 46.77 0 12.916-12.915 12.917-33.855.002-46.77L234.577 11.815c-.357-.357-.723-.7-1.092-1.038-.337-.37-.68-.735-1.038-1.092-12.915-12.915-33.856-12.915-46.77 0L9.685 185.676c-12.915 12.916-12.915 33.856 0 46.772z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"arrow-next": {
	id: "arrow-next",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 245 421",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "arrow-next",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-next",
					name: "",
					type: "text",
					value: "Carousel Arrow Right icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-next",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.817 9.687c-12.915 12.915-12.916 33.855 0 46.77l152.605 152.606L9.687 363.798c-12.915 12.915-12.915 33.855 0 46.77 12.915 12.916 33.856 12.916 46.77 0L232.45 234.58c.356-.357.7-.723 1.036-1.092.37-.337.735-.68 1.092-1.038 12.915-12.915 12.915-33.856 0-46.77L58.588 9.687c-12.916-12.917-33.856-12.916-46.77 0",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"arrow-previous": {
	id: "arrow-previous",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 245 421",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "arrow-previous",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-previous",
					name: "",
					type: "text",
					value: "Carousel Arrow Left icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-previous",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M232.447 410.568c12.915-12.915 12.916-33.855 0-46.77L79.842 211.19 234.577 56.457c12.915-12.915 12.915-33.855 0-46.77-12.915-12.916-33.856-12.916-46.77 0L11.814 185.676c-.357.357-.7.723-1.037 1.092-.37.336-.735.68-1.092 1.037-12.915 12.915-12.915 33.856 0 46.77l175.99 175.99c12.916 12.917 33.856 12.916 46.77 0",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"arrow-up": {
	id: "arrow-up",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 470 279",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "arrow-up",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-up",
					name: "",
					type: "text",
					value: "Arrow Up icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M203.814 13.497c17.18-17.996 45.007-17.996 62.218 0L456.5 213.443c17.21 18.027 24.81 65.252-29.572 65.252H42.858c-56.215 0-46.78-47.194-29.57-65.252L203.813 13.497z",
				fill: "#010201",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	atm: atm,
	"arrow-right-circle": {
	id: "arrow-right-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 40 40",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "arrow-right-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-right-circle",
					name: "",
					type: "text",
					value: "Arrow Right Circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-right-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20 39c10.493 0 19-8.507 19-19S30.493 1 20 1 1 9.507 1 20s8.507 19 19 19Zm0 1c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
			},
			children: [
			]
		},
		{
			id: "arrow-right-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m19.506 28-1.412-1.33 6.073-5.715H12v-1.88h12.167l-6.073-5.716 1.412-1.329 7.072 6.656.01-.01L28 20.006l-.01.009.01.01-1.412 1.329-.01-.01L19.506 28Z"
			},
			children: [
			]
		}
	]
},
	"arrow-right": {
	id: "arrow-right",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "122.6 15.333 278.8 469.276"
	},
	children: [
		{
			id: "arrow-right",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-right",
					name: "",
					type: "text",
					value: "Arrow Right icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-right",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M387.9 219.2c18 17.2 18 45 0 62.2l-200 190.5c-18 17.2-65.3 24.8-65.3-29.6V58.2c0-56.2 47.2-46.8 65.3-29.6l200 190.6z"
			},
			children: [
			]
		}
	]
},
	audio: audio,
	ballpark: ballpark,
	"back-to-start": {
	id: "back-to-start",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 255 238",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "back-to-start",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "back-to-start",
					name: "",
					type: "text",
					value: "Back to Start icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "back-to-start",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M228.293 3.58L56.59 103.247c-3.226 1.826-5.716 3.927-7.485 6.18V26.56c0-13.64-10.992-24.696-24.552-24.696C10.993 1.862 0 12.918 0 26.557v185.905c0 13.64 10.993 24.696 24.553 24.696s24.552-11.057 24.552-24.696V126.84c1.77 2.292 4.26 4.446 7.486 6.34l171.703 99.668c14.284 8.38 25.89 1.497 25.89-14.965V18.543c0-16.46-11.606-23.345-25.89-14.964",
				fill: "#000",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"baseball-3": {
	id: "baseball-3",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 22 22",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "baseball-3",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11 1.28997C5.63731 1.28997 1.29 5.63728 1.29 11C1.29 16.3626 5.63731 20.71 11 20.71C16.3627 20.71 20.71 16.3626 20.71 11C20.71 5.63728 16.3627 1.28997 11 1.28997ZM0.0899963 11C0.0899963 4.97454 4.97457 0.0899658 11 0.0899658C17.0254 0.0899658 21.91 4.97454 21.91 11C21.91 17.0254 17.0254 21.91 11 21.91C4.97457 21.91 0.0899963 17.0254 0.0899963 11Z"
			},
			children: [
			]
		},
		{
			id: "baseball-3",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.63668 15.3735C3.48318 11.5377 1.19092 10.7575 0.571112 10.5757L0.90888 9.42422C1.78906 9.68241 4.35672 10.6422 6.68319 14.7862C8.00703 17.1468 9.40599 18.6426 10.4597 19.5425C10.987 19.9928 11.429 20.295 11.7334 20.482C11.8857 20.5755 12.0036 20.6403 12.0806 20.6804C12.119 20.7005 12.1473 20.7144 12.1645 20.7227L12.1819 20.7309C12.1817 20.7308 12.1822 20.731 11.94 21.28C11.6978 21.8289 11.6975 21.8288 11.6972 21.8287L11.6951 21.8277L11.6913 21.826L11.6803 21.821C11.6716 21.817 11.6599 21.8115 11.6454 21.8046C11.6165 21.7907 11.5763 21.7709 11.5258 21.7445C11.4249 21.6919 11.2824 21.6133 11.1053 21.5045C10.751 21.2868 10.258 20.9483 9.68033 20.455C8.52404 19.4674 7.0328 17.8628 5.63668 15.3735Z"
			},
			children: [
			]
		},
		{
			id: "baseball-3",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.55201 5.29572C7.51242 4.33025 6.70776 3.1395 6.19978 1.8148L7.32022 1.38514C7.76259 2.53872 8.4633 3.57567 9.36861 4.41643C10.2739 5.25719 11.3598 5.87942 12.5429 6.23541L12.5543 6.23884L12.5655 6.24271C13.8695 6.69215 14.9818 6.96439 16.0266 7.22011C16.4979 7.33547 16.9555 7.44747 17.4107 7.57086C18.8604 7.96377 20.2061 8.45686 21.6206 9.5204L20.8994 10.4795C19.6539 9.54307 18.4696 9.10116 17.0968 8.72907C16.6898 8.61877 16.2588 8.51316 15.8025 8.40136C14.7389 8.14075 13.5381 7.84654 12.1856 7.38105C10.8315 6.97169 9.58867 6.25847 8.55201 5.29572Z"
			},
			children: [
			]
		}
	]
},
	"baseball-bat": {
	id: "baseball-bat",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 373.475 510.927"
	},
	children: [
		{
			id: "baseball-bat",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "baseball-bat",
					name: "",
					type: "text",
					value: "Baseball bat icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "baseball-bat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M165.522 239.722c-18.394 32.927-37.42 66.975-45.924 80.18-6.243 9.703-28.807 43.054-100.826 146.77-5.898-1.366-12.25 1.033-16.114 6.656-2.29 3.333-3.136 7.346-2.4 11.318.738 3.963 2.99 7.403 6.314 9.694l20.253 13.92c2.537 1.74 5.496 2.667 8.565 2.667h.01c4.973 0 9.624-2.45 12.78-7.04 3.568-5.193 3.44-11.918.118-16.933 13.46-19.8 85.647-125.947 100.895-146.73 9.272-12.665 34.225-42.593 58.343-71.528 19.842-23.802 38.57-46.288 47.547-57.9 19.644-25.426 51.628-68.794 52.05-69.354l60.025-87.336c12.172-17.707 4.09-31.06-2.094-35.798L342.598 2.87c-.485-.294-4.89-2.87-11.173-2.87-6.035 0-14.895 2.41-22.78 13.893l-60.12 87.465c-.285.452-29.31 45.857-46.014 73.307-7.638 12.526-21.894 38.04-36.987 65.058z"
			},
			children: [
			]
		}
	]
},
	"audio-2": {
	id: "audio-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "audio-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "audio-2",
					name: "",
					type: "text",
					value: "Audio icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "audio-2",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 6.5)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "audio-2",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M28.125 13.0344828C28.125 5.8357368 22.2487373 0 15 0S1.875 5.8357367 1.875 13.0344828",
						strokeWidth: "2",
						fill: "none"
					},
					children: [
					]
				},
				{
					id: "audio-2",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						strokeWidth: "2",
						fillOpacity: ".2",
						x: "1.875",
						y: "12.1034483",
						width: "5.625",
						height: "14.8965517",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "audio-2",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						strokeWidth: "2",
						fillOpacity: ".2",
						x: "22.5",
						y: "12.1034483",
						width: "5.625",
						height: "14.8965517",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "audio-2",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						y: "15.5",
						width: "2",
						height: "7.5",
						rx: "1"
					},
					children: [
					]
				},
				{
					id: "audio-2",
					name: "rect",
					type: "element",
					value: "",
					attributes: {
						x: "28",
						y: "15.5",
						width: "2",
						height: "7.5",
						rx: "1"
					},
					children: [
					]
				}
			]
		}
	]
},
	"baseball-glove": {
	id: "baseball-glove",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 484.062 511.667"
	},
	children: [
		{
			id: "baseball-glove",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "baseball-glove",
					name: "",
					type: "text",
					value: "Baseball glove icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "baseball-glove",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M286.467 0h12.29c1.596.75 3.176 1.557 4.787 2.245 9.643 4.12 16.552 12.265 21.107 24.06 1.135 2.938.803 4.865-.625 7.66-4.527 8.857-9.34 17.66-12.736 27.275-20.073 56.83-42.146 112.24-67.273 165.544-.66 1.398-1.458 2.76-1.84 4.29-1.137 4.572-.536 8.753 2.753 11.357 3.36 2.66 6.676 2.08 9.357-1.846 1.036-1.518 1.796-3.37 2.618-5.123 25.527-54.423 48.297-110.746 68.563-168.834 2.56-7.337 6.212-14.453 10.487-20.25 10.167-13.785 24.21-16.42 37.838-8.376 13.14 7.754 21.798 25.208 21.032 43.168-.095 2.232-1.714 4.828-3.166 6.405-6.126 6.648-13.403 11.916-18.472 19.68-6.477 9.924-11.37 21.655-16.706 32.804-17.026 35.573-33.903 71.267-50.94 106.83-2.5 5.22-5.662 9.887-8.32 14.987-2.308 4.433-1.674 9.63 1.247 12.754 3.13 3.35 7.11 2.878 10.122-1.286.862-1.192 1.596-2.547 2.362-3.853 25.348-43.238 47.172-89.368 66.553-137.557 6.66-16.56 16.19-29.403 31.526-30.423 22.874-1.52 41.552 31.026 35.47 61.34-16.127 2.167-27.703 14.168-37.274 30.344-.868 1.465-1.695 2.97-2.536 4.462-19.34 34.296-38.68 68.592-58.016 102.89-.653 1.158-1.433 2.248-1.89 3.53-1.664 4.663-1.21 9.005 2.044 12.083 3.01 2.845 6.257 2.613 9.076-.704 1.272-1.498 2.306-3.376 3.33-5.193 18.695-33.127 37.305-66.337 56.112-99.355 3.55-6.23 7.488-12.262 11.897-17.44 21.942-25.77 50.818-4.184 55.518 24.324.395 2.393.865 4.765 1.3 7.146v7.415c-2.44 7.904-3.867 16.73-7.5 23.546-13.22 24.8-26.94 49.164-40.906 73.26-26.215 45.228-54.555 87.89-89.324 122.48-25.947 25.81-54.2 45.536-86.333 54.57-8.42 2.366-17.016 3.668-25.53 5.46H208c-1.524-.386-3.036-.965-4.574-1.13-26.88-2.898-52.188-12.494-75.5-30.44-33.31-25.64-56.82-63.11-74.92-106.937C31.12 320.18 18.736 262.947 9.52 204.387c-3.51-22.31-6.366-44.795-9.52-67.2v-7.416c.252-.965.674-1.914.732-2.9 1.73-29.374 21.75-43.394 40.517-35.24 1.276.555 3.375-.183 4.514-1.314 18.27-18.154 38.148-32.622 59.102-44.703 50.978-29.39 103.992-40.845 159.438-31.148 1.007.176 2.49.175 3.068-.606C272.682 6.685 279.5 3.193 286.467 0zm-88.143 305.022c-13.66-.144-27 2.222-39.89 8.206-4.933 2.29-6.92 6.91-5.565 12.224 1.438 5.65 5.258 7.838 10.338 5.58 19.438-8.634 39.253-8.873 59.19-4.22 20.236 4.724 39.084 13.89 55.245 31.158 3.762 4.02 7.738 3.552 10.492-.657 2.827-4.32 2.32-9.76-1.518-14.056-2.385-2.67-4.896-5.186-7.51-7.46-24.465-21.295-51.744-30.016-80.783-30.775zM258.6 58.418c-1.596-2.217-3.16-5.768-5.496-7.29-2.998-1.95-6.23-.525-8.22 3.447-.85 1.69-1.354 3.686-1.962 5.572-11.028 34.238-22.026 68.49-33.088 102.71-1.955 6.048-4.31 11.877-6.22 17.947-1.65 5.24-.064 10.394 3.486 12.553 3.594 2.185 7.346.364 9.543-4.653.31-.71.584-1.456.83-2.21 13.164-40.408 26.327-80.817 39.466-121.24.546-1.68.857-3.49 1.66-6.836zm-59.985 13.344c.056-5.973-3.672-10.364-8.453-9.438-28.745 5.566-56.552 15.674-83.456 29.987-4.733 2.52-6.353 7.608-4.597 12.84 1.705 5.08 5.685 6.813 10.355 4.513 5.733-2.824 11.412-5.86 17.212-8.426 19.985-8.843 40.295-16.017 61.237-19.856 5.11-.936 7.65-4.23 7.7-9.618zM145.17 258.748c20.547-1.644 37.275-12.602 51.37-31.134 3.615-4.75 3.63-10.14.425-14.158-2.975-3.732-7.034-3.485-10.538.672-.815.967-1.54 2.063-2.363 3.017-16.184 18.785-34.344 26.768-55.716 17.554-4.668-2.013-8.617.475-9.89 5.808-1.212 5.067.672 10.218 5.25 11.88 7.06 2.563 14.298 4.283 21.462 6.36zm-80.088-135.28c-7.638.042-10.64 7.616-7.36 15.228 11.333 26.302 22.797 52.507 34.288 78.692 2.447 5.575 6.71 7.196 10.358 4.39 3.555-2.732 4.627-8.03 2.292-13.425-11.526-26.632-23.088-53.238-34.85-79.69-1.177-2.647-3.79-4.2-4.728-5.196zm109.9 9.424c.006-6.892-3.936-11.765-8.56-10.175-13.216 4.543-26.348 9.537-39.404 14.816-3.968 1.604-5.425 7.403-3.95 12.25 1.345 4.426 5.145 6.72 8.987 5.29 12.542-4.67 25.077-9.372 37.608-14.093 3.443-1.298 5.162-4.41 5.318-8.088z"
			},
			children: [
			]
		}
	]
},
	"been-here": {
	id: "been-here",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 418.455 511.444"
	},
	children: [
		{
			id: "been-here",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "been-here",
					name: "",
					type: "text",
					value: "Been here icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "been-here",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M371.96 0H46.495C20.923 0 0 20.923 0 46.495v299.892c0 16.273 6.974 30.222 20.923 39.52l188.305 125.537 188.305-125.536c11.624-9.3 20.923-23.247 20.923-39.52V46.494C418.456 20.923 397.532 0 371.96 0zm.787 148.174c-1.84 2.53-3.38 5.36-5.564 7.543-63.42 63.403-126.903 126.74-190.376 190.09-6.61 6.596-11.646 6.658-18.114-.015-35.736-36.87-71.45-73.763-107.11-110.707-1.713-1.776-2.842-4.117-4.244-6.195v-5.084c2.167-2.525 4.115-5.288 6.542-7.533 8.162-7.545 16.494-14.906 24.76-22.337 6.25-5.617 11.08-5.434 17.035.63 21.067 21.455 42.137 42.907 63.205 64.36 6.22 6.333 11.328 6.355 17.64.074l148.353-147.66c6.36-6.33 11.36-6.32 17.687.04 8.212 8.258 16.484 16.458 24.578 24.83 2.155 2.23 3.754 4.996 5.608 7.516v4.448z"
			},
			children: [
			]
		}
	]
},
	"baseball-2": {
	id: "baseball-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "baseball-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "baseball-2",
					name: "",
					type: "text",
					value: "Baseball icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "baseball-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.26.864c-1.312.129-2.281.341-3.211.7C3.561 3.299.7 7.583.852 12.34A11.127 11.127 0 0 0 7.06 22c1.101.541 2.08.848 3.34 1.046.493.078.734.091 1.6.091 1.1 0 1.703-.065 2.574-.279 2.471-.608 4.577-1.941 6.126-3.878 1.265-1.581 2.021-3.315 2.346-5.38.078-.493.091-.734.091-1.6 0-.866-.013-1.107-.091-1.6-.326-2.067-1.08-3.797-2.346-5.38-1.8-2.251-4.358-3.687-7.273-4.084-.43-.058-1.835-.105-2.167-.072m1.772 1.738a9.6 9.6 0 0 1 3.808 1.277c1.875 1.128 3.327 2.885 4.047 4.896.085.24.149.442.142.45-.008.007-.197-.067-.421-.165-.828-.365-1.578-.595-3.456-1.063-3.128-.778-4.557-1.278-5.552-1.94a7.91 7.91 0 0 1-2.68-2.97c0-.088 1.299-.404 1.98-.48.456-.052 1.674-.054 2.132-.005M7.982 4.84A9.666 9.666 0 0 0 11.38 7.9c1.026.549 2.527 1.036 5.484 1.777 2.354.591 3.163.891 4.281 1.587l.295.184v.598c0 1.057-.146 1.96-.479 2.952a9.452 9.452 0 0 1-7.465 6.342l-.404.067-.216-.132c-1.718-1.049-3.505-3.053-4.916-5.515-1.443-2.518-2.994-4.16-4.821-5.102-.241-.125-.444-.241-.451-.259-.027-.071.212-1.01.381-1.497a9.55 9.55 0 0 1 3.97-4.953l.298-.184.194.347c.107.192.31.519.451.728m-4.685 7.912c.712.526 1.374 1.198 2.001 2.028.407.539.643.904 1.201 1.86.991 1.698 1.874 2.883 3.017 4.05.296.302.515.55.488.55-.103 0-.684-.163-1.146-.322-.996-.341-2.069-.953-2.938-1.674-.998-.829-1.924-2.034-2.488-3.238-.489-1.043-.872-2.602-.872-3.548v-.185l.207.12c.115.066.353.227.53.359"
			},
			children: [
			]
		}
	]
},
	billing: billing,
	blackout: blackout,
	binoculars: binoculars,
	bike: bike,
	baseball: baseball,
	blog: blog,
	"beer-stein": {
	id: "beer-stein",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 428.561 509"
	},
	children: [
		{
			id: "beer-stein",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "beer-stein",
					name: "",
					type: "text",
					value: "Beer Stein icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "beer-stein",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M420.037 169.65h-.002c-5.494-6.958-14.033-11.707-23.656-11.707-.037 0-.094-.004-.184.003l-67.247-.003.002-23.4c2.22-1.865 4.286-4.002 6.077-6.51l.563-.79-.012-.006c4.773-7.027 7.457-16.303 7.514-26.61-.003-3.18-.28-6.446-.88-9.74-.51-4.422-1.573-8.512-3.05-12.228-5.518-14.315-16.003-25.074-29.737-31.297-6.44-2.97-13.12-3.993-19.417-3.993h-.02c-.01 0-.025 0-.06.004-7.44.016-14.47 1.38-20.797 2.877-8.032 1.905-15.735 2.877-23.205 2.877-13.29-.017-25.863-3.017-38.715-9.83-9.914-6.405-18.718-13.514-27.184-20.01-8.565-6.533-16.76-12.564-26.078-16.262C148.726.99 143.612.003 138.72 0h-.086c-9.495 0-17.547 3.675-24.09 8.102-6.594 4.46-12.105 9.74-17.297 14.23-7.48 6.356-13.213 7.884-21.215 8.832-7.858.882-17.762.36-29.68 2.643-14.193 2.795-25.677 11.86-33.63 22.958C4.773 67.922.04 81.375.003 94.703c-.004 0 0 .03 0 .045-.004 9.14 2.354 18.398 8.03 26.15 3.3 4.535 7.73 8.37 13.063 11.286.436 5.54.617 11.366.617 17.313 0 .067 0 .15.004.258 0 .03-.004.097-.004.17.004 21.29-2.243 43.967-2.257 62.365 0 1.06.007 2.1.028 3.13v.276l.028.354c.046.482.063.973.063 1.476v.184c.01 4.532-2.038 10.154-4.806 16.815-2.695 6.726-6.143 14.623-6.195 24.246 0 1.53.094 3.09.3 4.672.106 5.208 1.86 10.09 4.427 14.286 3.993 6.498 9.916 11.675 16.702 15.45 6.052 3.335 12.876 5.553 19.995 6.027v127.37c-2.746.13-5.473.893-7.95 2.29-5.607 3.167-9.077 9.11-9.077 15.552v11.24c0 6.257 3.275 12.057 8.633 15.286 40.702 24.555 93.202 38.054 147.87 38.057 54.672-.003 107.172-13.502 147.87-38.057 5.358-3.23 8.632-9.03 8.632-15.286v-11.24c0-6.443-3.47-12.385-9.078-15.552-2.478-1.398-5.204-2.162-7.948-2.29v-20.433h47.238c16.062-.155 29.66-12.23 31.677-28.328l20.367-176.68c.22-1.9.33-3.78.326-5.633-.007-9.758-2.946-18.857-8.52-25.85zM369.8 214.46l-15.573 135.16H328.95V214.46h40.85zM328.95 368.304h33.607c4.738-.003 8.733-3.57 9.28-8.275L389.56 206.19c.045-.365.06-.723.06-1.073.002-2.287-.835-4.495-2.365-6.214-1.774-1.993-4.307-3.125-6.97-3.125h-51.337v-19.155h67.3c3.71.06 6.535 1.5 9.21 4.713 2.55 3.16 4.42 8.168 4.416 14.123.003 0-.005.03.003.106-.003 1.115-.068 2.263-.204 3.434l-20.367 176.663c-.534 6.192-6.894 11.838-12.874 11.793-.073.003-.158 0-.26.003h-47.224v-19.156zm-277.29 77.573c36.518 21.668 84.826 34.85 137.818 34.85 52.988 0 101.296-13.183 137.82-34.85v9.308c-36.317 21.798-84.696 35.13-137.82 35.13-53.127 0-101.497-13.33-137.82-35.128v-9.31zm-24.114-182.98l.017-.692.005-.076-.118-.774c-.13-.864-.188-1.71-.188-2.577-.004-.08-.004-.136-.004-.184-.01-4.703 2.045-10.363 4.81-17.006 2.683-6.713 6.132-14.52 6.195-24.054 0-.9-.034-1.807-.104-2.723-.01-.792-.016-1.646-.016-2.517v-.195c-.005-16.963 2.246-39.91 2.26-62.368-.003-3.752-.075-7.49-.228-11.197l-.384-19.356-.587-.157c-.293-.076-.572-.14-.825-.21l-.205-.054-.187-.045c-.014 0-.073-.02-.195-.05-3.74-.888-6.692-2.12-9.06-3.618-2.368-1.497-4.174-3.25-5.632-5.205-2.434-3.32-3.883-7.515-4.286-12.377-.073-.91-.124-1.823-.124-2.757-.004-.062-.004-.108-.004-.146-.004-8.69 3.43-18.888 9.234-26.92 5.824-8.16 13.75-13.932 21.996-15.49 9.313-1.845 18.14-1.407 28.09-2.406 9.9-.952 21.087-4.12 31.504-13.308 5.566-4.862 10.65-9.612 15.467-12.827 4.88-3.257 9.06-4.907 13.703-4.92 2.448.002 5.163.457 8.473 1.74 6.07 2.344 13.265 7.33 21.505 13.686 8.272 6.337 17.655 13.946 28.8 21.12l.28.18.36.198c15.434 8.293 31.45 12.203 47.725 12.2h.06c9.144.003 18.315-1.187 27.562-3.378 5.698-1.365 11.374-2.376 16.46-2.376h.01c4.41.007 8.24.69 11.704 2.282 4.447 2.09 8.104 4.56 11.192 7.52 3.81 3.654 6.732 8.06 8.974 13.66l.067.172c.52 1.333.94 2.742 1.273 4.265.23 1.058.43 2.15.565 3.346l.03.31.07.39c.417 2.216.614 4.426.614 6.565v.025l.003.078v.21c.016 6.945-2.336 13.367-4.51 16.19l-.05.07-.07.096c-.227.332-.502.673-.797 1.016l-.06.083c-1.73 2.018-4.485 3.976-8.18 5.743-.99.475-2.02.94-3.132 1.383-5.758 2.316-13.043 4.17-20.717 6.14-.246.062-.48.12-.725.183-3.06.8-6.08 1.69-9.073 2.614-11.044 3.41-21.652 7.32-31.553 9.47-2.623.57-5.197 1.025-7.71 1.306-.512.06-1.018.102-1.528.132-.668.042-1.328.067-1.977.067h-.09c-4.768.002-9.754-1.133-15.487-2.61-2.66-.673-5.484-1.413-8.487-2.062-3.506-.754-7.267-1.38-11.34-1.587-.74-.042-1.51-.058-2.244-.058-13.23.142-24.382 5.472-33.685 8.918-1.24.46-2.447.892-3.614 1.27-5.8 1.946-11.043 2.88-16.01 3.115-.853.042-1.698.066-2.527.07-.012 0-.036-.004-.08-.004-1.942 0-3.866-.12-5.775-.33-2.858-.307-5.688-.836-8.505-1.55-6.91-1.762-13.782-4.633-21.033-8.057-.757-.355-1.518-.716-2.28-1.084-1.894-.907-3.822-1.85-5.766-2.8-1.232-.6-2.475-1.208-3.73-1.82-1.343-.65-2.71-1.3-4.08-1.948-1.504-.712-3.03-1.41-4.573-2.105-2.778-1.253-5.616-2.48-8.56-3.63-2.705-1.055-5.5-2.02-8.352-2.92-2.75-.87-5.563-1.663-8.482-2.34h-.003l-.023-.005-.067-.016h-.003c-.26-.06-.55-.15-.896-.226-2.42-.53-4.99-1.11-7.608-1.74-.19-.048-.378-.09-.562-.135l-1.038-.253.576 158.997c-5.104-.608-10.8-2.99-15.022-6.306-2.507-1.932-4.504-4.143-5.726-6.16l-.708.43.705-.433c-1.232-2.024-1.697-3.764-1.703-5.104zM84.904 153.3c2.286 1.1 4.582 2.222 6.89 3.347.538.264 1.077.524 1.62.785.55.27 1.103.542 1.666.812 1.73.83 3.48 1.654 5.247 2.463 8.064 3.695 16.58 7.067 25.893 8.922 2.795.554 5.66.978 8.61 1.225 1.965.163 3.965.26 6.007.26h.035c.854 0 1.712-.02 2.566-.053 5.267-.19 10.727-.982 16.37-2.464 1.82-.476 3.653-1.01 5.514-1.64 1.042-.36 2.063-.73 3.073-1.104 2.938-1.08 5.806-2.188 8.584-3.233 7.143-2.686 13.71-4.888 19.31-4.88.128 0 .246 0 .354.002.48 0 .9.01 1.292.035.945.045 1.896.14 2.857.253 3.03.36 6.147 1.035 9.464 1.858 1.26.313 2.545.643 3.865.983 1.6.407 3.25.82 4.958 1.217 4.61 1.062 9.657 1.97 15.245 1.975.433 0 .854-.024 1.243-.034 1.442-.034 2.91-.114 4.422-.288 1.417-.173 2.816-.386 4.202-.614 2.9-.483 5.757-1.08 8.573-1.76 9.005-2.182 17.6-5.185 25.764-7.835 2.815-.912 5.583-1.778 8.295-2.555 1.35-.39 2.69-.76 4.008-1.094 1.403-.366 2.82-.728 4.237-1.093 5.05-1.306 10.187-2.67 15.196-4.396v43.112c-4.913 2.625-10.03 5.055-15.288 7.332-2.785 1.205-5.61 2.36-8.48 3.465-2.796 1.075-5.618 2.11-8.483 3.087-3.745 1.274-7.554 2.464-11.417 3.573-2.76.792-5.55 1.54-8.363 2.247-1.942.486-3.888.958-5.848 1.403-.834.188-1.685.368-2.538.552-1.974.427-3.957.837-5.95 1.22-2.805.54-5.636 1.037-8.487 1.492-5.317.854-10.7 1.56-16.136 2.112-2.815.288-5.644.534-8.488.74-2.817.2-5.647.364-8.49.488-4.26.184-8.53.306-12.823.306-4.292 0-8.56-.122-12.817-.306-2.84-.124-5.67-.285-8.49-.49-2.844-.204-5.67-.45-8.488-.735-5.442-.556-10.825-1.262-16.14-2.112-2.852-.458-5.682-.955-8.488-1.497-2.856-.548-5.686-1.135-8.487-1.77-8.807-1.994-17.37-4.407-25.63-7.223-2.263-.772-4.506-1.57-6.722-2.404-.58-.215-1.16-.45-1.757-.684-2.258-.87-4.49-1.768-6.693-2.7-.596-.25-1.194-.505-1.792-.763-2.253-.98-4.475-1.986-6.67-3.027-2.928-1.39-5.815-2.81-8.62-4.308V146.16c2.573.98 5.128 2.04 7.67 3.173 2.33 1.035 4.66 2.115 6.99 3.23.527.247 1.048.487 1.562.737zm40.648 74.202v177.256c-.01 6.644-5.382 12.018-12.023 12.032-6.644-.014-12.02-5.39-12.03-12.032V221.195c7.767 2.422 15.79 4.532 24.052 6.307zm51.902 6.44c3.977.154 7.98.26 12.022.26 4.046 0 8.05-.106 12.03-.26v180.996c-.014 6.644-5.386 12.015-12.025 12.03-6.644-.015-12.015-5.386-12.026-12.03V233.94zm82.218-7.863c2.833-.677 5.643-1.39 8.42-2.147 3.162-.864 6.28-1.78 9.36-2.738v183.563c-.014 6.644-5.387 12.018-12.02 12.032-6.645-.014-12.016-5.39-12.032-12.032V227.502c2.105-.453 4.196-.926 6.272-1.423zm-190.99-17.693c2.5 1.192 5.042 2.348 7.62 3.47 2.144.933 4.315 1.836 6.515 2.715v190.186c0 16.94 13.777 30.71 30.712 30.716 16.933-.005 30.704-13.777 30.704-30.716V230.89c4.786.708 9.627 1.323 14.534 1.808v182.24c0 16.94 13.776 30.714 30.713 30.714 16.936 0 30.708-13.775 30.708-30.713V232.697c4.907-.485 9.743-1.1 14.527-1.808v173.868c.003 16.94 13.778 30.71 30.716 30.716 16.74-.005 30.37-13.47 30.678-30.144.003-.124.026-.312.026-.572l.003-190.184c.28-.11.562-.217.847-.332 4.548-1.837 8.975-3.794 13.283-5.853v225.448c-33.89 18.104-76.364 28.018-120.79 28.018s-86.904-9.913-120.793-28.02v-225.45zm341.82-9.293z"
			},
			children: [
			]
		}
	]
},
	bus: bus,
	"calendar-3": {
	id: "calendar-3",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 25 25"
	},
	children: [
		{
			id: "calendar-3",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "calendar-3",
					name: "",
					type: "text",
					value: "Calendar",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "calendar-3",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M19.792 4.167H5.208c-1.15 0-2.083.932-2.083 2.083v14.583c0 1.15.933 2.084 2.083 2.084h14.584c1.15 0 2.083-.933 2.083-2.084V6.25c0-1.15-.933-2.083-2.083-2.083ZM16.666 2.083V6.25M8.334 2.083V6.25M3.125 10.416h18.75"
			},
			children: [
			]
		}
	]
},
	boat: boat,
	calendar: calendar,
	"camera-fv-fill": {
	id: "camera-fv-fill",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		width: "21.67",
		height: "14.98",
		viewBox: "0 0 21.67 14.98"
	},
	children: [
		{
			id: "camera-fv-fill",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0,1.48A1.48,1.48,0,0,1,1.48,0H15.24a1.48,1.48,0,0,1,1.48,1.48V11.77a1.48,1.48,0,0,1-1.48,1.48H1.48A1.48,1.48,0,0,1,0,11.77Z",
				fillRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "camera-fv-fill",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.4,14.43a.56.56,0,0,1-.56.55H5.76a.56.56,0,1,1,0-1.11h6.08A.56.56,0,0,1,12.4,14.43Z",
				fillRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "camera-fv-fill",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21.42,2.4a.56.56,0,0,1,.25.46v7.39a.55.55,0,0,1-.26.46.53.53,0,0,1-.52,0L18.12,9.52c-.28-.13-.29-.43-.28-.73s0,0,0,0V4.31s0-.61.28-.73l2.77-1.22A.56.56,0,0,1,21.42,2.4Z",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"booking-bed": {
	id: "booking-bed",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 462 462",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "booking-bed",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "booking-bed",
					name: "",
					type: "text",
					value: "Booking icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "booking-bed",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M52.9375 231H409.062C422.345 231 433.125 241.78 433.125 255.062V346.5L447.562 332.062H14.4375L28.875 346.5V255.062C28.875 241.78 39.655 231 52.9375 231ZM52.9375 202.125C38.8976 202.125 25.4327 207.702 15.505 217.63C5.57733 227.558 0 241.023 0 255.062L0 346.5C0 354.47 6.468 360.938 14.4375 360.938H447.562C451.392 360.938 455.064 359.416 457.771 356.709C460.479 354.001 462 350.329 462 346.5V255.062C462 241.023 456.423 227.558 446.495 217.63C436.567 207.702 423.102 202.125 409.062 202.125H52.9375ZM0 346.5V404.25C0 408.079 1.52109 411.751 4.22865 414.459C6.9362 417.166 10.6084 418.688 14.4375 418.688C18.2666 418.688 21.9388 417.166 24.6464 414.459C27.3539 411.751 28.875 408.079 28.875 404.25V346.5C28.875 342.671 27.3539 338.999 24.6464 336.291C21.9388 333.584 18.2666 332.062 14.4375 332.062C10.6084 332.062 6.9362 333.584 4.22865 336.291C1.52109 338.999 0 342.671 0 346.5ZM433.125 346.5V404.25C433.125 408.079 434.646 411.751 437.354 414.459C440.061 417.166 443.733 418.688 447.562 418.688C451.392 418.688 455.064 417.166 457.771 414.459C460.479 411.751 462 408.079 462 404.25V346.5C462 342.671 460.479 338.999 457.771 336.291C455.064 333.584 451.392 332.062 447.562 332.062C443.733 332.062 440.061 333.584 437.354 336.291C434.646 338.999 433.125 342.671 433.125 346.5ZM418.688 216.562V86.625C418.688 75.1378 414.124 64.1211 406.002 55.9984C397.879 47.8758 386.862 43.3125 375.375 43.3125H86.625C75.1378 43.3125 64.1211 47.8758 55.9984 55.9984C47.8758 64.1211 43.3125 75.1378 43.3125 86.625V216.562C43.3125 220.392 44.8336 224.064 47.5411 226.771C50.2487 229.479 53.9209 231 57.75 231C61.5791 231 65.2513 229.479 67.9589 226.771C70.6664 224.064 72.1875 220.392 72.1875 216.562V86.625C72.1875 82.7959 73.7086 79.1237 76.4161 76.4161C79.1237 73.7086 82.7959 72.1875 86.625 72.1875H375.375C379.204 72.1875 382.876 73.7086 385.584 76.4161C388.291 79.1237 389.812 82.7959 389.812 86.625V216.562C389.812 220.392 391.334 224.064 394.041 226.771C396.749 229.479 400.421 231 404.25 231C408.079 231 411.751 229.479 414.459 226.771C417.166 224.064 418.688 220.392 418.688 216.562ZM163.625 158.812H298.375C299.651 158.812 300.875 159.32 301.778 160.222C302.68 161.125 303.188 162.349 303.188 163.625V216.562L317.625 202.125H144.375L158.812 216.562V163.625C158.812 162.349 159.32 161.125 160.222 160.222C161.125 159.32 162.349 158.812 163.625 158.812ZM163.625 129.938C154.691 129.938 146.122 133.487 139.804 139.804C133.487 146.122 129.938 154.691 129.938 163.625V216.562C129.938 224.532 136.405 231 144.375 231H317.625C321.454 231 325.126 229.479 327.834 226.771C330.541 224.064 332.062 220.392 332.062 216.562V163.625C332.062 154.691 328.513 146.122 322.196 139.804C315.878 133.487 307.309 129.938 298.375 129.938H163.625Z",
				fill: "#262626"
			},
			children: [
			]
		}
	]
},
	"camera-fv": {
	id: "camera-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 12",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "camera-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.96875 1.21875C0.96875 0.666465 1.41647 0.21875 1.96875 0.21875H14.7188C15.271 0.21875 15.7188 0.666465 15.7188 1.21875V10.7812C15.7188 11.3335 15.271 11.7812 14.7188 11.7812H1.96875C1.41646 11.7812 0.96875 11.3335 0.96875 10.7812V1.21875ZM2.56875 10.1812V1.81875H14.1187V10.1812H2.56875Z"
			},
			children: [
			]
		},
		{
			id: "camera-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.7292 10.4937L16.7188 8.90625V3.21875L21.7292 1.63128C22.3739 1.42701 23.0312 1.90828 23.0312 2.58457V9.54043C23.0312 10.2167 22.3739 10.698 21.7292 10.4937ZM18.3188 7.7348V4.39021L21.4312 3.40407V8.72093L18.3188 7.7348Z"
			},
			children: [
			]
		}
	]
},
	camera: camera,
	"calendar-2": {
	id: "calendar-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22 25"
	},
	children: [
		{
			id: "calendar-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "calendar-2",
					name: "",
					type: "text",
					value: "Calendar icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "calendar-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.9230769 3.9285714c.4679231 0 .8461539-.3831428.8461539-.8571428V1.3571429C17.7692308.884 17.391.5 16.9230769.5c-.4679231 0-.8461538.384-.8461538.8571429v1.7142857c0 .474.3782307.8571428.8461538.8571428zm-11.8461538 0c.467923 0 .8461538-.3831428.8461538-.8571428V1.3571429C5.923077.884 5.5448461.5 5.0769231.5c-.4679231 0-.8461539.384-.8461539.8571429v1.7142857c0 .474.3782308.8571428.8461539.8571428zm15.2307692-.8571428h-.8461538c0 1.4202857-1.1363847 2.5714285-2.5384616 2.5714285-1.4020769 0-2.5384615-1.1511428-2.5384615-2.5714285H7.6153846c0 1.4202857-1.1363846 2.5714285-2.5384615 2.5714285-1.402077 0-2.5384616-1.1511428-2.5384616-2.5714285h-.8461538C.7581538 3.0714286 0 3.8394286 0 4.7857143v18C0 23.732.7581538 24.5 1.6923077 24.5h18.6153846C21.2418462 24.5 22 23.732 22 22.7857143v-18c0-.9462857-.7581538-1.7142857-1.6923077-1.7142857zm0 19.7142857H1.6923077V9.0714286h18.6153846v13.7142857z",
				fillRule: "nonzero"
			},
			children: [
			]
		}
	]
},
	"caret-up": {
	id: "caret-up",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 11 6",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "caret-up",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "caret-up",
					name: "",
					type: "text",
					value: "Caret Up icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "caret-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.974.672l4.292 3.66a.65.65 0 0 1-.065 1.046.74.74 0 0 1-.88-.05L5.499 2.07 1.678 5.33a.739.739 0 0 1-.884.046.65.65 0 0 1-.062-1.043L5.027.671A.73.73 0 0 1 5.5.5c.17 0 .34.058.474.172zm-.808 1.114h.666L5.5 2.07l-.333-.284z",
				fillRule: "nonzero"
			},
			children: [
			]
		}
	]
},
	"carousel-arrow-left": {
	id: "carousel-arrow-left",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 245 421",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "carousel-arrow-left",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "carousel-arrow-left",
					name: "",
					type: "text",
					value: "Carousel Arrow Left icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "carousel-arrow-left",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M232.447 410.568c12.915-12.915 12.916-33.855 0-46.77L79.842 211.19 234.577 56.457c12.915-12.915 12.915-33.855 0-46.77-12.915-12.916-33.856-12.916-46.77 0L11.814 185.676c-.357.357-.7.723-1.037 1.092-.37.336-.735.68-1.092 1.037-12.915 12.915-12.915 33.856 0 46.77l175.99 175.99c12.916 12.917 33.856 12.916 46.77 0",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	box: box,
	car: car,
	"caret-down": {
	id: "caret-down",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 11 6",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "caret-down",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "caret-down",
					name: "",
					type: "text",
					value: "Caret Down icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "caret-down",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.974 5.328l4.292-3.66a.65.65 0 0 0-.065-1.046.74.74 0 0 0-.88.05L5.499 3.928 1.678.671A.739.739 0 0 0 .794.625a.65.65 0 0 0-.062 1.042L5.027 5.33a.73.73 0 0 0 .473.17.727.727 0 0 0 .474-.171zm-.808-1.115h.666L5.5 3.93l-.333.284z",
				fillRule: "nonzero"
			},
			children: [
			]
		}
	]
},
	"carousel-arrow-right": {
	id: "carousel-arrow-right",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 245 421",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "carousel-arrow-right",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "carousel-arrow-right",
					name: "",
					type: "text",
					value: "Carousel Arrow Right icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "carousel-arrow-right",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.817 9.687c-12.915 12.915-12.916 33.855 0 46.77l152.605 152.606L9.687 363.798c-12.915 12.915-12.915 33.855 0 46.77 12.915 12.916 33.856 12.916 46.77 0L232.45 234.58c.356-.357.7-.723 1.036-1.092.37-.337.735-.68 1.092-1.038 12.915-12.915 12.915-33.856 0-46.77L58.588 9.687c-12.916-12.917-33.856-12.916-46.77 0",
				fillRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	cheer: cheer,
	checkmark: checkmark,
	channels: channels,
	"clock-fill": {
	id: "clock-fill",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "clock-fill",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "clock-fill",
					name: "",
					type: "text",
					value: "Clock Fill icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "clock-fill",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.8 0C114.5 0 0 114.5 0 255.8s114.5 255.8 255.8 255.8c141.2 0 255.8-114.5 255.8-255.8S397 0 255.8 0zm47.9 365.9l-100.6-98.2V130.9H260v112.9l83.4 81.5-39.7 40.6z"
			},
			children: [
			]
		}
	]
},
	close: close,
	"close-thin": {
	id: "close-thin",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "close-thin",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "close-thin",
					name: "",
					type: "text",
					value: "Close Thin icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "close-thin",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.42 3.4a.6.6 0 0 1 .85 0l16.15 16.16a.6.6 0 1 1-.84.85L3.42 4.26a.6.6 0 0 1 0-.85z"
			},
			children: [
			]
		},
		{
			id: "close-thin",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M20.42 3.42a.6.6 0 0 1 0 .85L4.27 20.42a.6.6 0 0 1-.85-.84L19.58 3.42a.6.6 0 0 1 .84 0z"
			},
			children: [
			]
		}
	]
},
	"closed-captions": {
	id: "closed-captions",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "closed-captions",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "closed-captions",
					name: "",
					type: "text",
					value: "Closed captions icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "closed-captions",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M933.6,164H68c-33.5,0-61,25.1-61,58.6v561.1c0,33.5,27.5,59.9,61,59.9h865.6\r\n\tc33.5,0,59.4-26.4,59.4-59.9V222.6C993,189.1,967.1,164,933.6,164z M454.8,669.6c-17.7,21.9-48.3,32.8-91.6,32.8\r\n\tc-56.6,0-95.7-16.6-117.2-49.7c-10.9-16.6-18.6-35.8-23.1-57.9c-4.5-22-6.7-48.9-6.7-80.7c0-31.8,2.2-58.7,6.7-80.7\r\n\tc4.5-22,12.2-41.3,23.1-57.9c21.5-33.1,60.6-49.7,117.2-49.7c40.7,0,70,9.1,87.9,27.3c17.9,18.2,28.8,45,32.8,80.5l-54.6,8.4\r\n\tc-2-19.9-8.1-35.1-18.4-45.7c-10.3-10.6-26.2-15.9-47.7-15.9c-31.1,0-52.1,10.2-63.1,30.5c-10.9,20.4-16.4,54.6-16.4,102.8\r\n\tc0,48.2,5.5,82.5,16.4,103.1c10.9,20.5,32,30.8,63.1,30.8c24.2,0,41.3-6.6,51.4-19.9c10.1-13.2,15.5-32.4,16.1-57.6l54.6,2.5\r\n\tC482.7,615.5,472.5,647.7,454.8,669.6z M765.7,669.6c-17.7,21.9-48.3,32.8-91.6,32.8c-56.6,0-95.7-16.6-117.2-49.7\r\n\tc-10.9-16.6-18.6-35.8-23.1-57.9c-4.5-22-6.7-48.9-6.7-80.7c0-31.8,2.2-58.7,6.7-80.7c4.5-22,12.2-41.3,23.1-57.9\r\n\tc21.5-33.1,60.6-49.7,117.2-49.7c40.7,0,70,9.1,87.9,27.3c17.9,18.2,28.8,45,32.8,80.5l-54.6,8.4c-2-19.9-8.1-35.1-18.4-45.7\r\n\tc-10.3-10.6-26.2-15.9-47.7-15.9c-31.1,0-52.1,10.2-63.1,30.5c-10.9,20.4-16.4,54.6-16.4,102.8c0,48.2,5.5,82.5,16.4,103.1\r\n\tc10.9,20.5,32,30.8,63.1,30.8c24.2,0,41.3-6.6,51.4-19.9c10.1-13.2,15.5-32.4,16.1-57.6l54.6,2.5\r\n\tC793.6,615.5,783.5,647.7,765.7,669.6z"
			},
			children: [
			]
		}
	]
},
	cocktail: cocktail,
	"closed-caption": {
	id: "closed-caption",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "closed-caption",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "closed-caption",
					name: "",
					type: "text",
					value: "Closed Caption icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "closed-caption",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M933.6 164H68c-33.5 0-61 25.1-61 58.6v561.1c0 33.5 27.5 59.9 61 59.9h865.6c33.5 0 59.4-26.4 59.4-59.9V222.6c0-33.5-25.9-58.6-59.4-58.6zM454.8 669.6c-17.7 21.9-48.3 32.8-91.6 32.8-56.6 0-95.7-16.6-117.2-49.7-10.9-16.6-18.6-35.8-23.1-57.9-4.5-22-6.7-48.9-6.7-80.7 0-31.8 2.2-58.7 6.7-80.7s12.2-41.3 23.1-57.9c21.5-33.1 60.6-49.7 117.2-49.7 40.7 0 70 9.1 87.9 27.3 17.9 18.2 28.8 45 32.8 80.5l-54.6 8.4c-2-19.9-8.1-35.1-18.4-45.7-10.3-10.6-26.2-15.9-47.7-15.9-31.1 0-52.1 10.2-63.1 30.5-10.9 20.4-16.4 54.6-16.4 102.8 0 48.2 5.5 82.5 16.4 103.1 10.9 20.5 32 30.8 63.1 30.8 24.2 0 41.3-6.6 51.4-19.9 10.1-13.2 15.5-32.4 16.1-57.6l54.6 2.5c-2.6 42.9-12.8 75.1-30.5 97zm310.9 0c-17.7 21.9-48.3 32.8-91.6 32.8-56.6 0-95.7-16.6-117.2-49.7-10.9-16.6-18.6-35.8-23.1-57.9-4.5-22-6.7-48.9-6.7-80.7 0-31.8 2.2-58.7 6.7-80.7s12.2-41.3 23.1-57.9c21.5-33.1 60.6-49.7 117.2-49.7 40.7 0 70 9.1 87.9 27.3 17.9 18.2 28.8 45 32.8 80.5l-54.6 8.4c-2-19.9-8.1-35.1-18.4-45.7-10.3-10.6-26.2-15.9-47.7-15.9-31.1 0-52.1 10.2-63.1 30.5-10.9 20.4-16.4 54.6-16.4 102.8 0 48.2 5.5 82.5 16.4 103.1 10.9 20.5 32 30.8 63.1 30.8 24.2 0 41.3-6.6 51.4-19.9 10.1-13.2 15.5-32.4 16.1-57.6l54.6 2.5c-2.6 42.9-12.7 75.1-30.5 97z"
			},
			children: [
			]
		}
	]
},
	community: community,
	"clock-outline": {
	id: "clock-outline",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "clock-outline",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "clock-outline",
					name: "",
					type: "text",
					value: "Clock Outline icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "clock-outline",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.7 0C114.5 0 0 114.5 0 255.7s114.5 255.7 255.7 255.7S511.5 397 511.5 255.7 397 0 255.7 0zm0 483.1c-125.4 0-227.3-102-227.3-227.3s102-227.3 227.3-227.3c125.4 0 227.3 102 227.3 227.3S381.1 483.1 255.7 483.1z"
			},
			children: [
			]
		},
		{
			id: "clock-outline",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M260 127.9h-28.5v133.9l96.4 92.5 19.7-20.4-87.6-84.2z"
			},
			children: [
			]
		}
	]
},
	"coffee-cup": {
	id: "coffee-cup",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 499.053 511.412"
	},
	children: [
		{
			id: "coffee-cup",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "coffee-cup",
					name: "",
					type: "text",
					value: "Coffee cup icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "coffee-cup",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M499.053 296.193c-.12.475-.315.944-.352 1.425-1.4 18.35-7.39 35.2-16.856 50.852-8.24 13.626-18.883 25.02-32.328 33.673-10.172 6.547-21.212 10.834-33.247 12.372-8.906 1.138-17.714.573-26.39-1.806-.95-.26-1.903-.506-2.995-.795-.482.665-.92 1.294-1.384 1.905-2.96 3.902-5.965 7.774-8.873 11.716-.816 1.106-1.734 1.594-3.064 1.396-.278-.04-.567-.006-.85-.006-91.626 0-183.25-.007-274.876.044-1.972 0-3.196-.553-4.417-2.134-18.05-23.36-31.08-49.278-39.713-77.46-4.894-15.98-8.352-32.27-10.747-48.803-2.19-15.12-3.666-30.31-4.23-45.574-.44-11.85-.486-23.716-.916-35.566-.21-5.808 4.01-11.088 10.862-11.063.568.003 1.136 0 1.705 0 123.517 0 247.034-.002 370.55.008 1.345 0 2.707.026 4.03.236 4.875.773 8.396 4.807 8.5 9.737.064 2.983 0 5.967-.006 8.95v2.22c2.188.27 4.224.465 6.24.778 21.94 3.41 37.997 15.223 48.825 34.38 5.484 9.706 8.52 20.235 10.007 31.24.197 1.455.352 2.915.526 4.373v17.903zm-96.647 70.303c.337.21.444.318.568.345.276.06.56.08.843.116 6.23.755 12.15-.46 17.878-2.836 8.145-3.377 15.01-8.584 20.99-14.98 10.715-11.456 17.62-24.984 21.444-40.12 3.446-13.65 3.916-27.364.36-41.075-2.11-8.147-5.63-15.61-11.356-21.896-4.306-4.73-9.453-8.137-15.708-9.705-1.48-.37-2.974-.907-4.635-.553-.06.54-.135 1.022-.17 1.507-.565 8.07-1.037 16.15-1.71 24.213-1.152 13.802-3.17 27.486-6.016 41.043-4.378 20.858-10.978 40.957-20.526 60.048-.632 1.263-1.272 2.523-1.962 3.892zM0 427.916c0-.023.005-.045.016-.065.317-.605.674-1.195.94-1.822 1.754-4.133 4.89-6.314 9.336-6.643.777-.058 1.562-.02 2.343-.02 149.22-.002 298.44-.003 447.66.016 4.04.002 8.475.24 10.19 6.03 1.43 4.83.032 10.06-3.323 13.82-8.522 9.55-14.854 19.486-27.355 28.162-.254.176-.495.38-.71.6-15.026 15.4-33.65 23.11-50.935 30.598l-.013.005c-11.91 3.824-24.046 6.722-36.34 8.958-6.98 1.27-14 2.317-20.998 3.48-.32.052-.618.238-.925.368-.018.01-.037.012-.056.012H142.798c-.018 0-.036-.003-.053-.01-.312-.12-.617-.298-.94-.345-8.144-1.178-16.313-2.197-24.43-3.54-12.398-2.052-24.634-4.842-36.557-8.884-12.465-4.35-21.65-9.53-31.882-17.294-8.244-6.258-17.207-13.725-24.11-21.382C18.12 452.525 11.32 445.18 4.5 437.856c-1.612-1.732-3.206-3.406-3.858-5.763-.08-.29-.39-.514-.61-.764-.02-.025-.032-.058-.032-.092v-3.322zM158.172 0c3.49.988 5.967 3.353 8.34 5.944 5.624 6.146 10.834 12.59 14.836 19.936 3.183 5.84 5.455 11.985 6.31 18.63 1.033 8.046-.353 15.69-3.61 23.04-2.84 6.418-6.85 12.092-11.326 17.445-4.098 4.9-8.303 9.712-12.432 14.588-2.985 3.525-5.728 7.222-8.05 11.235-4.748 8.21-5.166 16.626-1.47 25.32 2.782 6.54 6.852 12.24 11.354 17.667.725.874 1.495 1.712 2.207 2.596 3.44 4.27 3.166 9.992-.638 13.7-3.887 3.79-10.036 3.98-14.118.362-1.108-.983-2.063-2.15-3.023-3.286-6.306-7.466-11.83-15.428-15.435-24.59-5.514-14.015-4.62-27.614 2.596-40.823 3.253-5.953 7.372-11.28 11.74-16.43 4.133-4.87 8.318-9.7 12.402-14.61 2.912-3.503 5.416-7.284 7.296-11.46 2.536-5.638 2.768-11.368.845-17.217-1.5-4.566-3.764-8.76-6.693-12.523-3.177-4.082-6.606-7.973-10.016-11.868-1.686-1.926-2.965-3.962-3.138-6.58-.305-4.587 2.173-8.534 6.452-10.233.72-.286 1.443-.56 2.164-.84C155.9 0 157.036 0 158.172 0zM274.49 50.96c.03 9.646-2.692 17.536-7.085 24.93-3.204 5.394-7.116 10.26-11.187 15.007-3.374 3.934-6.778 7.843-10.117 11.806-2.93 3.48-5.578 7.162-7.778 11.163-4.376 7.955-4.6 16.07-1.113 24.38 2.355 5.613 5.676 10.63 9.43 15.378 1.364 1.726 2.832 3.37 4.21 5.085 3.583 4.453 3.094 10.498-1.12 14.137-4.095 3.538-10.676 3.352-14.29-.665-6.672-7.418-12.553-15.406-16.663-24.576-2.666-5.948-4.367-12.15-4.674-18.68-.37-7.825 1.4-15.21 4.778-22.243 3.476-7.236 8.342-13.506 13.502-19.577 4.092-4.814 8.217-9.6 12.26-14.456 2.64-3.173 4.892-6.62 6.687-10.35 2.954-6.14 3.218-12.415.898-18.806-1.86-5.126-4.675-9.727-8.075-13.942-2.76-3.422-5.725-6.68-8.664-9.954-2.517-2.803-3.5-6-2.53-9.642C234.888 2.74 244.107-.35 249.51 4.833c10.494 10.07 19.338 21.377 23.408 35.723 1.05 3.702 1.605 7.487 1.574 10.405zM365.707 51.974c-.058 8.707-2.792 16.59-7.192 23.982-3.21 5.39-7.137 10.243-11.194 15-3.96 4.645-7.954 9.264-11.838 13.974-2.805 3.403-5.193 7.093-7.063 11.112-2.857 6.137-3.238 12.408-1.243 18.863 1.87 6.056 5.09 11.384 8.853 16.403 1.958 2.61 4.132 5.056 6.143 7.627 3.582 4.58 2.74 10.933-1.855 14.354-3.906 2.908-9.82 2.913-13.136-.637-9.598-10.276-17.52-21.63-20.8-35.615-2.7-11.52-.707-22.398 4.838-32.724 3.413-6.357 7.855-11.976 12.51-17.443 4.052-4.755 8.136-9.483 12.12-14.294 2.77-3.343 5.116-6.977 6.923-10.947 2.594-5.7 2.835-11.5.85-17.414-1.81-5.386-4.726-10.17-8.245-14.565-2.702-3.375-5.623-6.58-8.516-9.8-1.613-1.793-2.803-3.747-3.04-6.182-.415-4.28 1.634-8.103 5.368-10.072 3.788-1.996 8.53-1.474 11.743 1.364 1.06.938 2.02 1.995 2.99 3.03 5.75 6.132 10.964 12.666 15.024 20.06 3.31 6.027 5.664 12.38 6.42 19.256.173 1.55.23 3.112.34 4.668z"
			},
			children: [
			]
		}
	]
},
	"connected-devices": {
	id: "connected-devices",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "connected-devices",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "connected-devices",
					name: "",
					type: "text",
					value: "Connected Devices icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "connected-devices",
			name: "style",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "connected-devices",
					name: "",
					type: "text",
					value: ".st0{clip-path:url(#SVGID_2_);} .st1{clip-path:url(#SVGID_4_);}",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "connected-devices",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "desktop"
			},
			children: [
				{
					id: "connected-devices",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "Layer_5"
					},
					children: [
						{
							id: "connected-devices",
							name: "defs",
							type: "element",
							value: "",
							attributes: {
							},
							children: [
								{
									id: "connected-devices",
									name: "path",
									type: "element",
									value: "",
									attributes: {
										id: "SVGID_1_",
										d: "M173 153v85l21.3.3.4 87.4 61.6.8.7 33.5h80v-34h49v-85l37.7-.3-.4-89.4z"
									},
									children: [
									]
								}
							]
						},
						{
							id: "connected-devices",
							name: "clipPath",
							type: "element",
							value: "",
							attributes: {
								id: "SVGID_2_"
							},
							children: [
								{
									id: "connected-devices",
									name: "use",
									type: "element",
									value: "",
									attributes: {
										xlinkHref: "#SVGID_1_",
										overflow: "visible"
									},
									children: [
									]
								}
							]
						},
						{
							id: "connected-devices",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								"class": "st0",
								d: "M414.5 155.6H182c-3.6 0-6.3 2.7-6.3 6.3v155.6c0 3.6 2.7 6.3 6.3 6.3h99.9l-4.5 20c-1.5 6.9-7.8 11.3-14.6 10.7h-.3c-.9 0-1.8.9-1.8 1.8s.6 1.5 1.2 1.5H334c.6-.3 1.2-.9 1.2-1.5 0-.9-.9-1.8-1.8-1.8h-.3c-6.9.3-13.1-4.2-14.6-10.7l-4.5-20h99.9c3.6 0 6.3-2.7 6.3-6.3V161.8c.5-3.5-2.2-6.2-5.7-6.2zm-3.9 157H186.1V165.4h224.7v147.2h-.2z"
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			id: "connected-devices",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M103.2 353.5c0-.8.7-1.5 1.5-1.5h21.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-21.9c-.8 0-1.5-.7-1.5-1.5m88.2-9.8H39.3V241.8h152.1v101.9zm30.3 10.5c0-2.3-1.8-4.1-4.1-4.1v-.3h-21.7c1.1-.5 1.9-1.6 1.9-2.9V238.6c0-1.8-1.4-3.2-3.2-3.2H36.2c-1.7 0-3.2 1.4-3.2 3.2v108.3c0 1.3.8 2.4 1.9 2.9H13.8v.3c-2.3 0-4.1 1.8-4.1 4.1s1.8 4.1 4.1 4.1h203.8c2.3 0 4.1-1.8 4.1-4.1",
				id: "laptop"
			},
			children: [
			]
		},
		{
			id: "connected-devices",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "tablet"
			},
			children: [
				{
					id: "connected-devices",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "Layer_6"
					},
					children: [
						{
							id: "connected-devices",
							name: "defs",
							type: "element",
							value: "",
							attributes: {
							},
							children: [
								{
									id: "connected-devices",
									name: "path",
									type: "element",
									value: "",
									attributes: {
										id: "SVGID_3_",
										d: "M379 232.9v125.8l95-.4v-6.5l-14-.2V273h13l-.1-40.5z"
									},
									children: [
									]
								}
							]
						},
						{
							id: "connected-devices",
							name: "clipPath",
							type: "element",
							value: "",
							attributes: {
								id: "SVGID_4_"
							},
							children: [
								{
									id: "connected-devices",
									name: "use",
									type: "element",
									value: "",
									attributes: {
										xlinkHref: "#SVGID_3_",
										overflow: "visible"
									},
									children: [
									]
								}
							]
						},
						{
							id: "connected-devices",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								"class": "st1",
								d: "M466.9 235.4h-80.4c-2.8 0-5 2.2-5 5v112.1c0 2.8 2.2 5 5 5h80.4c2.8 0 5-2.2 5-5V240.4c0-2.8-2.2-5-5-5zm-39 119.8c-2.6 0-4.6-2.1-4.6-4.6 0-2.6 2.1-4.6 4.6-4.6 2.6 0 4.6 2.1 4.6 4.6 0 2.5-2.1 4.6-4.6 4.6zm34.8-13.1h-71.9v-97.4h71.9v97.4z"
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			id: "connected-devices",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M503 312.3v38.8c0 2.5-1.1 4.4-3.2 5.6-1 .6-2 .8-3.2.8h-31.9c-3.2 0-5.7-2.1-6.3-5.2-.1-.4-.1-.8-.1-1.2v-77.7c0-3.4 2.7-6.5 6.5-6.5h31.8c3.7 0 6.4 2.7 6.4 6.4v39zm-42.3-.5v34.6c0 .8-.1.8.8.8h38.7c.4 0 .5-.1.5-.5v-.5-68.6c0-1.1.1-1-1-1h-37.9c-1.2 0-1-.2-1 1.1-.1 11.3-.1 22.7-.1 34.1zm20.1 37.2c-1.6 0-3 1.3-3.1 3 0 1.6 1.3 3 3 3.1 1.6 0 3-1.3 3.1-3 0-1.7-1.4-3.1-3-3.1zm-.1-77.1h-2.9c-.2 0-.4 0-.4.2s.2.3.4.3h5.7c.2 0 .4 0 .4-.2s-.2-.3-.4-.3h-2.8zm-6.1.8c.3 0 .5-.2.6-.6 0-.3-.3-.7-.6-.6-.3 0-.5.2-.6.6-.1.3.2.6.6.6z",
				id: "phone"
			},
			children: [
			]
		}
	]
},
	comments: comments,
	copyright: copyright,
	"day-games": {
	id: "day-games",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 37 23"
	},
	children: [
		{
			id: "day-games",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "day-games",
					name: "",
					type: "text",
					value: "Day Games",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "day-games",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				d: "M18.351 7.13c-.302 0-.592-.121-.806-.337a1.156 1.156 0 0 1-.333-.813V1.15c0-.305.12-.598.333-.813a1.134 1.134 0 0 1 1.612 0c.213.215.333.508.333.813v4.83c0 .305-.12.598-.333.813a1.134 1.134 0 0 1-.806.337ZM25.192 9.518a1.13 1.13 0 0 1-.817-.345 1.175 1.175 0 0 1 0-1.629l3.4-3.373a1.136 1.136 0 0 1 1.614 0 1.158 1.158 0 0 1 0 1.629l-3.343 3.373a1.12 1.12 0 0 1-.854.345ZM11.374 9.42a1.093 1.093 0 0 1-.798-.346L7.177 5.663A1.158 1.158 0 0 1 7.3 4.16a1.134 1.134 0 0 1 1.491-.089l3.438 3.373a1.13 1.13 0 0 1 .343.815 1.14 1.14 0 0 1-.343.814 1.101 1.101 0 0 1-.855.345ZM30.7 15.423a1.133 1.133 0 0 1-.742-.272 1.152 1.152 0 0 1-.237-1.475c.14-.234.36-.41.618-.495l4.538-1.572a1.13 1.13 0 0 1 1.321.26 1.152 1.152 0 0 1 .297.892 1.16 1.16 0 0 1-.461.817c-.13.096-.278.163-.435.197l-4.52 1.571a.905.905 0 0 1-.38.077ZM6.075 15.272a.808.808 0 0 1-.361 0L1.175 13.7a1.145 1.145 0 0 1-.58-.592 1.16 1.16 0 0 1-.032-.833c.093-.272.283-.499.534-.636a1.13 1.13 0 0 1 .819-.105l4.539 1.572a1.16 1.16 0 0 1 .266 1.859c-.178.17-.404.277-.646.307Z"
			},
			children: [
			]
		},
		{
			id: "day-games",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.351 12.65c-4.615 0-8.356 3.776-8.356 8.433H7.717c0-5.927 4.76-10.733 10.634-10.733 5.873 0 10.634 4.806 10.634 10.733h-2.279c0-4.657-3.74-8.433-8.355-8.433Z",
				clipRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "day-games",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M1.26 21.85c0-.635.51-1.15 1.14-1.15h31.902c.63 0 1.14.515 1.14 1.15 0 .635-.51 1.15-1.14 1.15H2.4c-.63 0-1.14-.515-1.14-1.15Z",
				clipRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"delete-reel": {
	id: "delete-reel",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "delete-reel",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "delete-reel",
					name: "",
					type: "text",
					value: "Delete Reel icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "delete-reel",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M3.440 5.102 C 2.720 5.257,1.997 5.825,1.681 6.484 C 1.389 7.093,1.401 6.846,1.401 12.000 C 1.401 17.156,1.389 16.907,1.682 17.519 C 1.816 17.798,1.906 17.918,2.192 18.199 C 2.548 18.548,2.802 18.704,3.280 18.865 C 3.489 18.936,3.766 18.941,8.797 18.960 L 14.095 18.980 14.161 19.240 C 14.506 20.606,15.453 21.790,16.713 22.433 C 17.506 22.838,18.101 22.980,19.000 22.980 C 19.898 22.980,20.494 22.838,21.286 22.433 C 22.630 21.748,23.580 20.489,23.907 18.960 C 24.008 18.489,24.008 17.511,23.907 17.040 C 23.722 16.176,23.337 15.385,22.795 14.753 L 22.600 14.526 22.599 10.953 C 22.599 6.960,22.606 7.083,22.319 6.484 C 21.999 5.816,21.276 5.254,20.540 5.100 C 20.130 5.014,3.839 5.016,3.440 5.102 M20.565 6.365 C 20.881 6.514,21.098 6.725,21.250 7.033 L 21.380 7.298 21.391 10.449 C 21.397 12.182,21.392 13.600,21.380 13.600 C 21.367 13.600,21.270 13.556,21.163 13.501 C 20.663 13.248,20.137 13.103,19.470 13.036 C 18.592 12.947,17.586 13.120,16.878 13.481 C 16.739 13.552,16.714 13.554,16.584 13.499 C 16.082 13.289,15.495 13.702,15.570 14.213 C 15.587 14.325,15.558 14.373,15.316 14.633 C 14.601 15.398,14.154 16.397,14.018 17.530 L 13.991 17.761 8.824 17.750 L 3.658 17.740 3.393 17.610 C 3.085 17.458,2.874 17.241,2.725 16.925 L 2.620 16.700 2.620 12.000 L 2.620 7.300 2.724 7.078 C 2.908 6.686,3.204 6.426,3.611 6.298 C 3.749 6.255,5.292 6.246,12.060 6.252 L 20.340 6.260 20.565 6.365 M7.380 9.235 C 6.924 9.518,6.866 10.049,7.253 10.389 C 7.579 10.675,8.143 10.580,8.337 10.207 C 8.530 9.833,8.378 9.367,8.013 9.215 C 7.825 9.136,7.523 9.146,7.380 9.235 M15.978 9.216 C 15.911 9.245,15.809 9.325,15.751 9.394 C 15.278 9.956,15.832 10.754,16.535 10.522 C 16.840 10.421,17.054 10.017,16.980 9.681 C 16.947 9.532,16.755 9.300,16.596 9.218 C 16.457 9.146,16.141 9.145,15.978 9.216 M9.888 9.928 C 9.852 9.964,9.840 10.480,9.840 12.005 C 9.840 13.815,9.847 14.041,9.904 14.099 C 9.945 14.139,9.999 14.153,10.054 14.136 C 10.187 14.096,14.011 12.155,14.087 12.090 C 14.124 12.058,14.145 12.007,14.133 11.977 C 14.107 11.908,10.121 9.880,10.013 9.880 C 9.971 9.880,9.914 9.902,9.888 9.928 M7.512 11.317 C 7.220 11.411,7.002 11.703,7.002 12.000 C 7.002 12.163,7.115 12.430,7.226 12.528 C 7.327 12.618,7.573 12.720,7.689 12.720 C 8.154 12.719,8.523 12.258,8.402 11.830 C 8.348 11.637,8.274 11.537,8.093 11.409 C 7.951 11.308,7.675 11.265,7.512 11.317 M16.100 11.307 C 15.877 11.369,15.666 11.589,15.598 11.830 C 15.477 12.258,15.846 12.719,16.311 12.720 C 16.427 12.720,16.673 12.618,16.774 12.528 C 16.885 12.430,16.998 12.163,16.998 12.000 C 16.998 11.786,16.867 11.539,16.692 11.423 C 16.538 11.321,16.252 11.265,16.100 11.307 M7.420 13.497 C 7.271 13.563,7.099 13.744,7.043 13.893 C 6.918 14.223,7.076 14.610,7.408 14.784 C 7.545 14.855,7.844 14.856,8.013 14.785 C 8.282 14.673,8.472 14.312,8.417 14.018 C 8.335 13.582,7.826 13.315,7.420 13.497 M19.605 14.058 C 20.855 14.247,21.964 15.042,22.536 16.160 C 22.767 16.611,22.871 16.930,22.942 17.395 C 23.014 17.879,23.014 18.121,22.942 18.605 C 22.604 20.845,20.437 22.368,18.227 21.917 C 16.566 21.579,15.309 20.265,15.058 18.605 C 14.986 18.121,14.986 17.879,15.058 17.395 C 15.314 15.698,16.675 14.324,18.358 14.061 C 18.816 13.990,19.144 13.989,19.605 14.058 M17.148 17.444 C 16.742 17.658,16.701 18.229,17.070 18.511 L 17.214 18.620 19.000 18.620 L 20.786 18.620 20.930 18.511 C 21.303 18.226,21.257 17.653,20.843 17.442 C 20.689 17.363,20.617 17.360,18.992 17.362 C 17.379 17.363,17.293 17.367,17.148 17.444"
			},
			children: [
			]
		}
	]
},
	"description-on-fv": {
	id: "description-on-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "description-on-fv",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "description-on-fv",
					name: "",
					type: "text",
					value: "Field Vision Description On icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "description-on-fv",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "description-on-fv",
					name: "mask",
					type: "element",
					value: "",
					attributes: {
						id: "a"
					},
					children: [
						{
							id: "description-on-fv",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M21 37c8.837 0 16-7.163 16-16S29.837 5 21 5 5 12.163 5 21s7.163 16 16 16zm-7-22a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zm-1 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1zm1 4a1 1 0 1 0 0 2h8.667a1 1 0 1 0 0-2z",
								clipRule: "evenodd",
								fillRule: "evenodd"
							},
							children: [
							]
						}
					]
				}
			]
		},
		{
			id: "description-on-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zM9 10a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zm-1 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1zm1 4a1 1 0 1 0 0 2h8.667a1 1 0 1 0 0-2z",
				clipRule: "evenodd",
				fillRule: "evenodd"
			},
			children: [
			]
		},
		{
			id: "description-on-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(-5 -5)",
				d: "M35.5 21c0 8.008-6.492 14.5-14.5 14.5v3c9.665 0 17.5-7.835 17.5-17.5zM21 6.5c8.008 0 14.5 6.492 14.5 14.5h3c0-9.665-7.835-17.5-17.5-17.5zM6.5 21c0-8.008 6.492-14.5 14.5-14.5v-3C11.335 3.5 3.5 11.335 3.5 21zM21 35.5c-8.008 0-14.5-6.492-14.5-14.5h-3c0 9.665 7.835 17.5 17.5 17.5zM14.5 16a.5.5 0 0 1-.5.5v-3a2.5 2.5 0 0 0-2.5 2.5zm-.5-.5a.5.5 0 0 1 .5.5h-3a2.5 2.5 0 0 0 2.5 2.5zm14 0H14v3h14zm-.5.5a.5.5 0 0 1 .5-.5v3a2.5 2.5 0 0 0 2.5-2.5zm.5.5a.5.5 0 0 1-.5-.5h3a2.5 2.5 0 0 0-2.5-2.5zm-14 0h14v-3H14zm0 2a2.5 2.5 0 0 0-2.5 2.5h3a.5.5 0 0 1-.5.5zm14 0H14v3h14zm2.5 2.5a2.5 2.5 0 0 0-2.5-2.5v3a.5.5 0 0 1-.5-.5zM28 23.5a2.5 2.5 0 0 0 2.5-2.5h-3a.5.5 0 0 1 .5-.5zm-14 0h14v-3H14zM11.5 21a2.5 2.5 0 0 0 2.5 2.5v-3a.5.5 0 0 1 .5.5zm3 5a.5.5 0 0 1-.5.5v-3a2.5 2.5 0 0 0-2.5 2.5zm-.5-.5a.5.5 0 0 1 .5.5h-3a2.5 2.5 0 0 0 2.5 2.5zm8.667 0H14v3h8.667zm-.5.5a.5.5 0 0 1 .5-.5v3a2.5 2.5 0 0 0 2.5-2.5zm.5.5a.5.5 0 0 1-.5-.5h3a2.5 2.5 0 0 0-2.5-2.5zM14 26.5h8.667v-3H14z",
				mask: "url(#a)"
			},
			children: [
			]
		}
	]
},
	discover: discover,
	"assistive-listening-device": {
	id: "assistive-listening-device",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 96.166 96.167"
	},
	children: [
		{
			id: "assistive-listening-device",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "assistive-listening-device",
					name: "",
					type: "text",
					value: "Assistive Listening Device icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "assistive-listening-device",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M60.92 40.664c-1.38 0-2.5-1.12-2.5-2.5 0-4.82-1.68-6.86-6.202-7.527-3.306-.486-5.736.33-7.43 2.503-1.274 1.63-1.655 3.46-1.66 3.477-.25 1.358-1.555 2.255-2.91 2.006-1.358-.25-2.256-1.554-2.006-2.91.757-4.107 4.808-11.49 14.737-10.022 7.046 1.04 10.47 5.12 10.47 12.474 0 1.38-1.12 2.5-2.5 2.5",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "assistive-listening-device",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M45.497 81.84c-1.82 0-3.366-.617-4.482-1.262-4.52-2.61-3.737-8.298-3.27-11.697l.043-.305c.187-1.368 1.45-2.323 2.815-2.14 1.368.188 2.325 1.45 2.14 2.816l-.044.313c-.42 3.033-.67 5.826.815 6.684 1.088.628 3.637 2.1 7.793-3.994 1.403-2.057 1.888-3.806 2.45-5.832.825-2.976 1.76-6.35 5.602-10.876 4.855-5.72 6.292-8.267 7.245-10.965 1.76-4.983.998-11.06-1.94-15.484-2.89-4.346-7.66-6.832-13.795-7.188-15.944-.933-17.19 14.757-17.236 15.424-.094 1.378-1.287 2.415-2.665 2.324-1.378-.094-2.418-1.287-2.324-2.664.014-.216.396-5.345 3.298-10.362 2.765-4.78 8.345-10.345 19.216-9.714 9.812.57 15.024 5.434 17.668 9.412 3.78 5.687 4.757 13.504 2.492 19.917-1.328 3.76-3.384 6.922-8.148 12.535-3.13 3.687-3.84 6.256-4.595 8.976-.623 2.25-1.267 4.574-3.138 7.315-3.592 5.265-7.102 6.77-9.943 6.77M74.754 26.36L96.166 4.95 91.216 0 70.74 20.476c.944 1.038 3.535 4.917 4.014 5.885",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "assistive-listening-device",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M53.414 37.802L0 91.216l4.95 4.95 51.783-51.783c-1.74-1.94-3.316-6.465-3.32-6.58",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	desktop: desktop,
	"dot-menu": {
	id: "dot-menu",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "dot-menu",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "dot-menu",
					name: "",
					type: "text",
					value: "Dot Menu icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "dot-menu",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM12 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
			},
			children: [
			]
		}
	]
},
	drag: drag,
	"drop-off-pick-up": {
	id: "drop-off-pick-up",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 145.304 74.749"
	},
	children: [
		{
			id: "drop-off-pick-up",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "drop-off-pick-up",
					name: "",
					type: "text",
					value: "Drop-Off Pick-Up icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "drop-off-pick-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.134 6.15c.625 2.94-1.247 5.833-4.177 6.456-2.93.623-5.816-1.258-6.44-4.198-.626-2.94 1.246-5.832 4.176-6.455 2.93-.622 5.816 1.26 6.44 4.198M54.495 44.84C40.387 28.725 41.36 28.762 38.425 29.386l-14.53 3.088-1.15-4.358 10.778-2.29c1.407-.3 2.305-1.687 2.005-3.1-.3-1.41-1.685-2.313-3.092-2.014L21.41 23.057l-1.224-4.64c-.625-2.94-3.51-4.82-6.44-4.197-2.93.623-4.803 3.515-4.178 6.455l4.563 17.29c.626 2.94 3.512 4.82 6.442 4.198L39.684 38.1l9.99 11.082c.74.986 2.003 1.512 3.283 1.24 1.76-.374 2.88-2.108 2.506-3.873-.096-.448-.805-1.558-.968-1.71M133.824 0h-57.61c-.71 0-1.347.44-1.598 1.103L63.54 30.383c-.145.382-.22.787-.22 1.196V73.075c0 .92.755 1.673 1.677 1.673h9.532c.92 0 1.675-.754 1.675-1.674v-8.292h56.217v8.292c0 .92.754 1.673 1.675 1.673h9.532c.92 0 1.675-.754 1.675-1.674V31.48c0-.343-.055-.685-.163-1.01l-9.698-29.302C135.212.47 134.56 0 133.824 0m-55.37 51.438C75.44 51.438 73 49 73 45.994s2.44-5.444 5.45-5.444c3.012 0 5.452 2.437 5.452 5.444 0 3.006-2.44 5.444-5.45 5.444m51.934-.087c-3.01 0-5.45-2.436-5.45-5.443 0-3.007 2.44-5.444 5.45-5.444 3.01 0 5.45 2.437 5.45 5.444 0 3.006-2.44 5.444-5.45 5.444m-57.16-23.428l6.565-19.007c.238-.69.888-1.152 1.618-1.152h46.987c.74 0 1.393.48 1.616 1.183l6.002 18.97c.248.785-.338 1.584-1.16 1.584h-60.5c-.818 0-1.393-.806-1.126-1.578M56.084 63.456v11.262L0 74.68",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "drop-off-pick-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M41.07 44.145c.128 8.15-5.495 15.538-13.738 17.29C17.964 63.427 8.718 57.4 6.72 48.002c-1.045-4.915.1-9.792 2.766-13.613L8.34 29c-5 5.042-7.454 12.437-5.867 19.904 2.497 11.75 14.055 19.282 25.764 16.793 8.763-1.863 15.16-8.82 16.78-17.128l-3.947-4.425z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"dual-view": {
	id: "dual-view",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "dual-view",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "dual-view",
					name: "",
					type: "text",
					value: "Dual View Mode icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "dual-view",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M44.5 166.9H0V345h244.8V167H44.5zm155.8 133.5H44.5v-89h155.8v89zM467.4 166.9H267.1V345h244.8V167h-44.5zm0 133.5H311.6v-89h155.8v89z"
			},
			children: [
			]
		}
	]
},
	download: download,
	elevators: elevators,
	"electrical-outlets": {
	id: "electrical-outlets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 339.768 509.928"
	},
	children: [
		{
			id: "electrical-outlets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "electrical-outlets",
					name: "",
					type: "text",
					value: "Electrical Outlet icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "electrical-outlets",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M.001 255.13c0-77.074-.007-154.149.022-231.223.001-3.397-.163-6.905.587-10.169C2.581 5.165 9.752.096 19.707.068c27.965-.079 55.93-.042 83.896-.041C175.221.029 246.84.059 318.458 0c6.013-.005 11.507.856 15.945 5.36 4.259 4.321 5.363 9.548 5.355 15.433-.076 57.635-.025 115.271-.027 172.906-.002 98.56-.049 197.12.036 295.679.007 8.256-2.555 14.903-10.152 18.476-3.231 1.52-7.223 1.963-10.872 1.97-64.629.118-129.258.095-193.887.098-34.615.001-69.231.029-103.846-.029C6.743 509.869.032 503.082.031 488.912.027 410.984.03 333.057.03 255.13H.001zm175.864 177.606l.017-.509c7.16 0 14.323.142 21.478-.04 7.306-.185 14.734.055 21.882-1.191 21.013-3.663 42.971-20.612 41.842-50.064.838-16.705.874-32.741-.117-48.579-.011-10.236-3.064-19.462-9.518-27.44-10.901-13.474-25.455-19.712-42.413-20.189-15.841-.445-31.705-.234-47.557-.094-9.016.08-18.146-.221-27.017 1.076-21.756 3.18-44.284 20.219-43.346 49.807-.545 15.327-.594 30.698.016 46.02-1.021 28.671 20.724 46.42 41.916 49.341 14.089 1.944 28.532 1.331 42.817 1.862zm.668-365.173v-.196c-9.886 0-19.775-.144-29.657.059-5.087.105-10.254.36-15.226 1.35-22.386 4.454-39.062 21.701-40.087 43.052-.931 19.384-.562 38.856-.105 58.273.315 13.358 6.747 24.048 17.07 32.41 10.788 8.737 23.361 12.408 37.007 12.513 20.623.159 41.25.169 61.872-.053 5.061-.054 10.221-.795 15.144-2.001 19.129-4.686 39.363-20.749 38.515-48.691-.496-16.348-.096-32.724-.094-49.087.001-10.614-3.176-20.161-10.002-28.301-9.927-11.839-22.85-18.343-38.145-19.194-12.061-.671-24.191-.134-36.292-.134z"
			},
			children: [
			]
		},
		{
			id: "electrical-outlets",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M226.1 343.121c0 7.146.052 14.292-.017 21.437-.052 5.34-2.82 7.923-8.329 7.991-5.658.069-8.785-2.722-8.806-8.136-.057-14.121-.057-28.243.002-42.365.022-5.319 3.319-8.388 8.701-8.387 5.358.002 8.399 3.026 8.437 8.532.049 6.977.012 13.953.012 20.928zM143.168 343.566c0 6.979.054 13.959-.017 20.937-.055 5.419-3.15 8.162-8.854 8.047-5.432-.11-8.277-2.792-8.294-8.072a6580.56 6580.56 0 0 1 0-42.385c.017-5.397 3.188-8.433 8.585-8.436 5.38-.003 8.529 3.052 8.568 8.461.051 7.149.012 14.299.012 21.448zM190.086 413.036c-8.904 0-17.206.089-25.499-.135-.847-.023-2.307-1.898-2.351-2.96-.231-5.609-.382-11.252-.019-16.848.414-6.383 6.264-10.43 14.125-10.304 7.984.128 13.316 4.228 13.661 10.812.24 4.586.071 9.193.083 13.791.004 1.518 0 3.037 0 5.644zM226.124 125.042c.001 7.143.056 14.287-.017 21.43-.056 5.49-3.067 8.24-8.71 8.172-5.342-.065-8.411-2.833-8.441-8.008a4282.032 4282.032 0 0 1-.018-42.86c.021-4.967 3.363-7.979 8.535-8.007 5.218-.028 8.567 2.921 8.628 7.844.088 7.142.022 14.286.023 21.429zM143.19 125.41c.001 7.148.071 14.296-.022 21.443-.066 5.037-3.239 7.808-8.62 7.795-5.411-.012-8.515-2.73-8.543-7.852-.079-14.465-.08-28.931-.011-43.397.022-4.652 3.333-7.541 8.337-7.636 5.19-.098 8.758 2.893 8.829 7.693.108 7.317.029 14.636.03 21.954zM189.915 195.139c-8.714 0-17.014.09-25.305-.136-.856-.023-2.335-1.905-2.377-2.97-.221-5.611-.335-11.253.016-16.853.374-5.974 5.515-9.921 12.586-10.245 8.004-.367 14.415 3.224 14.946 9.287.587 6.708.134 13.508.134 20.917z"
			},
			children: [
			]
		}
	]
},
	"email-circle": {
	id: "email-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		x: "0px",
		y: "0px",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "email-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "email-circle",
					name: "",
					type: "text",
					value: "Email circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "email-circle",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#fff"
			},
			children: [
				{
					id: "email-circle",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M291.833 122.15L107.655 122.15 199.744 204.302z"
					},
					children: [
					]
				},
				{
					id: "email-circle",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M192.778,225.66l-97.62-86.352v138.594h209.12V139.307l-97.62,86.865 C201.895,229.86,195.39,228.272,192.778,225.66z"
					},
					children: [
					]
				},
				{
					id: "email-circle",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M200,0C89.543,0,0,89.543,0,200s89.543,200,200,200s200-89.543,200-200S310.457,0,200,0z M325.636,288.555c-0.563,5.839-5.327,10.653-11.217,10.653H85.017c-5.839,0-10.653-4.763-10.653-10.653v-177.11 c0-5.839,4.763-10.653,10.653-10.653h229.966c5.839,0,10.653,4.814,10.653,10.704V288.555z"
					},
					children: [
					]
				}
			]
		}
	]
},
	email: email,
	"email-subscribe": {
	id: "email-subscribe",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 95.04 95.04"
	},
	children: [
		{
			id: "email-subscribe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M91.139 15.78H3.971c-1.755 0-3.199 1.426-3.18 3.18v57.119a3.182 3.182 0 0 0 3.18 3.18h87.168a3.185 3.185 0 0 0 3.18-3.192V18.959a3.18 3.18 0 0 0-3.18-3.179zm-79.236 4.9c.055-.128.366-.274.914-.274h69.548c.64 0 .877.164.914.274.037.092 0 .384-.457.841L49.3 55.116a2.25 2.25 0 0 1-3.18 0L12.36 21.521c-.384-.384-.512-.713-.457-.841zM5.689 73.302c-.128-.055-.274-.366-.274-.914V22.635c0-.548.146-.859.274-.914.018-.018.055-.018.073-.018.165 0 .439.128.768.457l23.506 23.597c.859.878.877 2.322 0 3.199L6.512 72.845c-.384.384-.695.512-.823.457zm77.572 1.115c-.055.128-.366.274-.914.274h-69.53c-.64 0-.878-.164-.914-.274-.037-.092 0-.384.457-.841l21.239-21.294a2.197 2.197 0 0 1 1.572-.658c.603 0 1.152.237 1.572.676l8.737 8.847c.603.603 1.407.932 2.248.932s1.627-.329 2.23-.932l8.792-8.865c.421-.42.987-.658 1.572-.658a2.197 2.197 0 0 1 1.572.658l20.91 21.276c.402.402.512.713.457.859zm6.471-1.975c0 .548-.146.859-.274.914s-.439-.055-.823-.457L65.111 49.01c-.877-.896-.877-2.322 0-3.199l23.506-23.597c.366-.384.622-.475.768-.475.036 0 .055 0 .073.018.109.037.274.274.274.914v49.771z",
				fill: "none",
				stroke: "#333",
				strokeWidth: "2",
				strokeMiterlimit: "10"
			},
			children: [
			]
		},
		{
			id: "email-subscribe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M30.036 45.756L6.53 22.159c-.329-.329-.603-.457-.768-.457-.018 0-.055 0-.073.018-.128.055-.274.366-.274.914v49.753c0 .548.146.859.274.914s.439-.073.823-.457l23.524-23.889c.877-.877.859-2.321 0-3.199zm16.084 9.36a2.25 2.25 0 0 0 3.18 0l33.522-33.595c.457-.457.494-.749.457-.841-.037-.11-.274-.274-.914-.274H12.817c-.548 0-.859.146-.914.274s.073.457.457.841l33.76 33.595z",
				fill: "#333"
			},
			children: [
			]
		},
		{
			id: "email-subscribe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M61.894 52.281a2.197 2.197 0 0 0-1.572-.658c-.585 0-1.151.238-1.572.658l-8.792 8.865c-.603.603-1.389.932-2.23.932s-1.645-.329-2.248-.932l-8.737-8.847a2.14 2.14 0 0 0-1.572-.676 2.197 2.197 0 0 0-1.572.658L12.36 73.575c-.457.457-.494.749-.457.841.036.11.274.274.914.274h69.53c.548 0 .859-.146.914-.274.055-.146-.055-.457-.457-.859l-20.91-21.276zm27.564-30.524c-.018-.018-.037-.018-.073-.018-.146 0-.402.091-.768.475L65.111 45.811c-.877.877-.877 2.303 0 3.199l23.524 23.889c.384.402.695.512.823.457.128-.055.274-.366.274-.914V22.671c0-.64-.165-.877-.274-.914z",
				fill: "#333"
			},
			children: [
			]
		}
	]
},
	"email-unsubscribe": {
	id: "email-unsubscribe",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 95.04 95.04"
	},
	children: [
		{
			id: "email-unsubscribe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M47.552 2.235c-1.35 0-42.748 33.91-42.731 35.512V89.9a2.906 2.906 0 0 0 2.904 2.904h79.589a2.91 2.91 0 0 0 2.904-2.916V37.747c.001-1.601-41.316-35.512-42.666-35.512z",
				fill: "none",
				stroke: "#333",
				strokeWidth: "2",
				strokeMiterlimit: "10"
			},
			children: [
			]
		},
		{
			id: "email-unsubscribe",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M31.523 62.214L10.061 40.669c-.3-.3-.551-.417-.701-.417-.017 0-.05 0-.067.017-.117.05-.25.334-.25.834V86.53c0 .501.133.784.25.834s.401-.067.751-.417l21.479-21.812c.801-.801.785-2.12 0-2.921zm17.3-54.769a1.945 1.945 0 0 0-2.748 0L11.931 36.469c-.395.395-.426.647-.395.726.032.095.237.237.79.237h70.452c.474 0 .742-.126.79-.237.047-.111-.063-.395-.395-.726L48.823 7.445zm11.789 60.728a2.006 2.006 0 0 0-1.435-.601c-.534 0-1.051.217-1.435.601l-8.027 8.094c-.551.551-1.268.851-2.036.851s-1.502-.3-2.053-.851l-7.977-8.077a1.96 1.96 0 0 0-1.435-.618c-.551 0-1.051.217-1.435.601L15.386 87.616c-.417.417-.451.684-.417.768.033.1.25.25.834.25h63.485c.501 0 .784-.133.834-.25.05-.133-.05-.417-.417-.784L60.612 68.173zm25.167-27.872c-.017-.017-.033-.017-.067-.017-.134 0-.367.083-.701.434L63.549 62.263a2.074 2.074 0 0 0 0 2.92l21.479 21.812c.35.367.634.467.751.417s.25-.334.25-.834V41.134c0-.582-.15-.798-.25-.833z",
				fill: "#333"
			},
			children: [
			]
		}
	]
},
	"emergency-evacuation": {
	id: "emergency-evacuation",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.864 399"
	},
	children: [
		{
			id: "emergency-evacuation",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "emergency-evacuation",
					name: "",
					type: "text",
					value: "Emergency Evacuation icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "emergency-evacuation",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M188.106 173.777c7.02-10.162 13.611-19.781 20.286-29.342 5.841-8.366 12.926-10.447 19.793-5.941 6.977 4.578 8.455 12.119 2.985 20.571-9.186 14.193-18.724 28.172-28.516 41.954-5.333 7.507-11.658 8.572-19.797 3.989-9.947-5.601-19.722-11.508-30.292-17.706-10.673 18.331-21.189 36.173-31.314 54.234-.746 1.33.734 4.816 2.189 6.326 9.753 10.122 19.806 19.955 29.711 29.932 10.625 10.701 12.095 20.853 4.776 33.816-8.822 15.626-17.74 31.197-26.681 46.755-3.561 6.197-8.87 9.42-16.168 8.601-6.33-.711-11.213-4.276-12.3-10.293-.799-4.42-.129-9.961 1.967-13.893 7.57-14.201 16.02-27.932 24.456-42.385-11.405-9.905-22.584-19.591-33.734-29.311-3.335-2.907-6.681-5.812-9.863-8.882-14.571-14.06-16.279-23.293-8.098-41.66 7.166-16.087 14.176-32.243 21.538-49.011-11.291-.352-20.609.527-25.477 12.149-2.482 5.926-6.459 11.276-10.111 16.649-4.907 7.219-12.673 9.423-18.874 5.751-6.612-3.915-7.913-10.666-3.302-19.031 6.026-10.931 12.311-21.719 18.438-32.595 3.589-6.37 9.041-9.811 16.216-10.826 14.163-2.005 28.289-4.298 42.478-6.087 13.126-1.655 25.406 1.496 36.496 8.514 6.127 3.877 11.876 8.425 17.449 13.086 5.342 4.466 10.234 9.47 15.749 14.636z"
			},
			children: [
			]
		},
		{
			id: "emergency-evacuation",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M69.945 259.367l26.405 24.926c-19.32 31.522-44.567 57.728-69.425 84.218-6.355 6.772-16.383 6.398-22.33.261-5.946-6.136-6.381-15.365.231-21.618 25.75-24.354 45.553-53.039 62.481-83.914.724-1.321 1.698-2.505 2.638-3.873zM153.479 85.15c13.621.141 24.637 10.499 24.51 23.045-.144 14.305-13.554 27.862-27.363 27.664-12.772-.182-23.351-11.751-23.209-25.381.148-14.289 11.661-25.477 26.062-25.328zM511.504 19.76c0-6.631-3.532-12.324-8.36-15.856-.865-.432-1.297-1.303-2.234-1.736C498.242.871 495.143 0 492.549 0h-235.17C246.785 0 238 9.237 238 20.264V69h98.37l-10.162-10.062c-2.667-2.667-2.234-6.58 0-9.247l6.631-6.606c1.297-1.297 2.667-1.717 4.396-1.717 1.73 0 3.532.439 4.829 1.736l32.648 33.156c1.297 1.297 1.729 2.668 1.729 4.398 0 1.73-.864 3.532-1.729 4.83l-32.648 33.081c-2.667 2.667-6.631 2.667-9.297 0l-6.631-6.63c-2.667-2.667-2.667-6.87 0-9.537L336.73 92H238v287.613c0 10.595 8.785 19.387 19.379 19.387h235.097c10.594 0 19.387-8.361 19.387-19.387l-.359-359.853zm-69.391 98.962c14.01 0 25.366 11.358 25.366 25.368 0 14.01-11.356 25.368-25.366 25.368-14.012 0-25.368-11.357-25.368-25.368 0-14.009 11.357-25.368 25.368-25.368zM352.75 373.8c-42.805 0-77.504-34.699-77.504-77.503 0-18.019 6.167-34.589 16.482-47.753l19.797 19.796a49.542 49.542 0 0 0-8.604 27.957c0 27.476 22.354 49.83 49.83 49.83a49.549 49.549 0 0 0 27.956-8.604l19.796 19.795c-13.165 10.316-29.734 16.482-47.753 16.482zm121.682-127.614l-6.386 78.358c-.645 7.922-7.277 13.924-15.088 13.924-.413 0-.83-.016-1.247-.05-8.342-.681-14.555-7.994-13.874-16.336l4.976-61.031-20.453 1.139c5.052 10.293 7.894 21.867 7.894 34.107 0 20.544-8.007 39.206-21.053 53.075l-19.584-19.585c8.049-8.854 12.963-20.608 12.963-33.49 0-27.476-22.353-49.83-49.829-49.83-12.881 0-24.637 4.914-33.49 12.964l-19.585-19.585c10.984-10.332 24.977-17.499 40.529-20.035l37.504-42.714-21.247-12.338-25.701 22.926c-6.245 5.573-15.825 5.024-21.397-1.221-5.571-6.246-5.024-15.826 1.221-21.397l33.901-30.24a15.153 15.153 0 0 1 17.698-1.795s69.399 40.316 69.509 40.394a15.087 15.087 0 0 1 6.76 9.593c1.602 5.62.418 11.908-3.725 16.626l-29.079 33.118 52.84-2.941a15.18 15.18 0 0 1 11.696 4.555 15.166 15.166 0 0 1 4.247 11.809z"
			},
			children: [
			]
		}
	]
},
	"enter-full-screen": {
	id: "enter-full-screen",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "enter-full-screen",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "enter-full-screen",
					name: "",
					type: "text",
					value: "Enter full screen icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "enter-full-screen",
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "351.5,500.4 107,744.1 107,630 4,630 4,848.4 4,996 151.6,996 370,996 370,893 256,893 499.4,648.7"
			},
			children: [
			]
		},
		{
			id: "enter-full-screen",
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "847.9,4 631,4 631,109 743.5,109 499.7,352.8 647.3,500.4 891,256.8 891,370 997,370 997,152.5 997,4"
			},
			children: [
			]
		}
	]
},
	"enter-fullscreen": {
	id: "enter-fullscreen",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "enter-fullscreen",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "enter-fullscreen",
					name: "",
					type: "text",
					value: "Enter Fullscreen icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "enter-fullscreen",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#020202"
			},
			children: [
				{
					id: "enter-fullscreen",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M351.5 500.4L107 744.1V630H4v366h366V893H256l243.4-244.3M847.9 4H631v105h112.5L499.7 352.8l147.6 147.6L891 256.8V370h106V4"
					},
					children: [
					]
				}
			]
		}
	]
},
	"ev-station": {
	id: "ev-station",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 499.213 510.768"
	},
	children: [
		{
			id: "ev-station",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "ev-station",
					name: "",
					type: "text",
					value: "EV station icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "ev-station",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M498.333 345.294c-1.437-7.038-2.753-14.104-4.334-21.11-5.63-24.94-16.972-47.51-28.915-69.866-13.65-25.55-25.718-51.793-32.098-80.248-1.718-7.662-2.663-15.497-4.076-23.93 9.436 0 18 .006 26.562-.003 9.496-.01 11.973-2.483 11.942-11.785-.03-9.244-.047-18.49.002-27.732.054-10.168-1.77-11.896-11.808-12.175-.932-.025-1.608-.16-3.608-.296V80.49c0-8.29.292-16.578.18-24.864-.08-5.694-3.952-10.258-9.517-11.424-4.245-.89-9.882 2.073-11.526 6.487-.802 2.15-.912 4.64-.932 6.98-.1 11.634-.16 23.27 0 34.903.06 4.336-1.12 6.193-5.902 5.982-8.874-.39-17.303-.112-27.303-.112V85.258c0-9.563-.016-19.126-.03-28.69-.01-7.115-4.686-12.463-10.9-12.53-6.634-.072-11.13 4.98-11.148 12.635-.028 12.272-.132 24.547.06 36.816.06 3.67-.906 5.073-4.803 5.04-8.65-.074-10.532 2.048-10.535 10.708-.004 10.04-.006 20.082 0 30.123.005 7.923 2.885 10.758 10.994 10.776 8.89.02 17.78.004 25.794.004 2.646 13.738 4.548 27.033 7.833 39.976 7.198 28.36 19.564 54.697 33.27 80.41 9.378 17.59 18.656 35.21 23.82 54.616 4.726 17.768 7.475 35.644 2.533 53.897-9.037 33.38-46.02 37.836-65.36 23.27-10.817-8.15-15.092-20.036-16.86-32.94-2.736-19.974 3.367-38.874 7.096-58.1 2.857-14.726 6.678-29.63 6.723-44.464.12-40-20.385-72.754-60.483-87.822-6.292-2.364-13.057-3.607-19.703-4.833-3.66-.675-4.458-2.295-4.45-5.725.1-44.786.06-89.573.062-134.36 0-14.52-6.984-24.608-19.67-31.112C289.46 2.037 287.74.988 285.99 0H49.738c-7.934 3.65-17.274 7.067-21.404 15.333C25.72 20.563 25.96 20.24 24.667 26c-.75 3.345-.78 13.266-.78 16.772C23.88 174.43 24 306.086 24 437.742V447h287V205.993c23 1.305 45.068 20.838 50.604 43.353 4.067 16.54 1.346 32.684-2.41 48.84-5.087 21.884-11.472 43.71-9.925 66.452 2.082 30.626 13.11 56.576 42.565 70.737 27.685 13.31 63.362 6.79 84.358-15 12.286-12.75 18.518-28.488 21.21-45.785.134-.865.612-1.676.93-2.513 1.334-8.41 1-17.077 0-26.783zm-393.1 78.178c-.444-.227-.888-.517-1.332-.745C118.56 385.014 133.217 347 148.078 309h-47.705c.81-2 1.336-3.603 2.104-5.094 17.883-34.743 35.83-69.457 53.634-104.24 1.694-3.31 3.815-4.463 7.46-4.432 18.163.157 36.33.06 54.493.11 1.842.004 3.684.543 6.412.86-15.497 22.77-30.53 44.796-46.047 67.796h54.474c-43.027 54-85.348 106.56-127.67 159.472zm162.54-278.717c-.01 8.745-4.488 13.14-13.23 13.147-29.164.02-58.543.008-87.543.008v-.053c-29 0-58.593.013-87.916-.01-7.443-.005-12.085-4.59-12.102-12.17-.066-29.322-.057-58.645.006-87.97.017-8.124 5.13-12.71 13.873-12.714 48.767-.02 97.536-.017 146.302-.02 8.924 0 17.85-.025 26.775.02 9.122.044 13.837 4.708 13.843 13.705.015 28.686.022 57.37-.008 86.057zM313.752 472.7c-96.014.05-192.027-.05-288.04.045-5.787.006-14.71-.656-19.462 4.005-3.25 3.188-4.75 6-6.25 10.105v9.565C2.684 503.3 7.506 508 14.347 511h307.035c1.4-1 3.408-1.295 4.868-2.134 6.235-3.58 8.192-10.112 8.486-16.967.357-8.316-6.603-19.207-20.984-19.2z"
			},
			children: [
			]
		}
	]
},
	exclaimation: exclaimation,
	"exit-full-screen-filmroom": {
	id: "exit-full-screen-filmroom",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		version: "1.0",
		viewBox: "0 0 32 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "exit-full-screen-filmroom",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exit-full-screen-filmroom",
					name: "",
					type: "text",
					value: "Exit full screen filmroom icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "exit-full-screen-filmroom",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exit-full-screen-filmroom",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						id: "a",
						d: "M-51.3 22.7h-4.9c-1 0-1.8-.7-1.8-1.5V15c0-.9.8-1.5 1.8-1.5h4.8L-46 9c.3-.2.5-.1.5.2V27c0 .3-.2.5-.5.2l-5.3-4.5z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "exit-full-screen-filmroom",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exit-full-screen-filmroom",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						id: "b",
						d: "M-53.5 6c.6-.6 1.5-.6 2.1 0l21.9 21.9c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0L-53.5 8.1c-.6-.6-.6-1.5 0-2.1z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "exit-full-screen-filmroom",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.1 0v6.1H0v2.8h12.9V0zm9 0v8.9H32V6.1H21.9V0zM0 15.1v2.8h10.1V24h2.8v-8.9zm19.1 0V24h2.8v-6.1H32v-2.8z"
			},
			children: [
			]
		}
	]
},
	"enter-full-screen-filmroom": {
	id: "enter-full-screen-filmroom",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 24"
	},
	children: [
		{
			id: "enter-full-screen-filmroom",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "enter-full-screen-filmroom",
					name: "",
					type: "text",
					value: "Enter full screen filmroom icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "enter-full-screen-filmroom",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M32 15v9H19v-3h10v-6h3zm0-6h-3V3H19V0h13v9zM0 15h3v6h10v3H0v-9zm0-6V0h13v3H3v6H0z",
				fill: "#000"
			},
			children: [
			]
		}
	]
},
	"exit-full-screen": {
	id: "exit-full-screen",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "exit-full-screen",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exit-full-screen",
					name: "",
					type: "text",
					value: "Exit full screen icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "exit-full-screen",
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "3.2,854.9 246.4,624 107,624 107,520 350.6,520 471,520 471,642.4 471,886 367,886 367,746.5 137.1,996 "
			},
			children: [
			]
		},
		{
			id: "exit-full-screen",
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "856.6,3.8 628,247 628,106 524,106 524,351.2 524,469 641.9 469 888,469 888,365 746,365 996.6,136.4"
			},
			children: [
			]
		}
	]
},
	es: es,
	"exit-fullscreen": {
	id: "exit-fullscreen",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "exit-fullscreen",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "exit-fullscreen",
					name: "",
					type: "text",
					value: "Exit Fullscreen icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "exit-fullscreen",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#020202",
				d: "M3.2 854.9L246.4 624H107V520h364v366H367V746.5L137.1 996M856.6 3.8L628 247V106H524v363h364V365H746l250.6-228.6"
			},
			children: [
			]
		}
	]
},
	explosion: explosion,
	"facebook-circle": {
	id: "facebook-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "facebook-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "facebook-circle",
					name: "",
					type: "text",
					value: "Facebook circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "facebook-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M399.246 199.623C399.246 89.374 309.872 0 199.623 0S0 89.374 0 199.623c0 99.638 72.999 182.222 168.432 197.197V257.327h-50.686v-57.704h50.686v-43.979c0-50.031 29.803-77.666 75.4-77.666 21.841 0 44.685 3.899 44.685 3.899v49.126h-25.172c-24.798 0-32.531 15.388-32.531 31.174v37.446h55.364l-8.85 57.704h-46.514V396.82c95.433-14.974 168.432-97.559 168.432-197.197z",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	"description-fv": {
	id: "description-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "description-fv",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "description-fv",
					name: "",
					type: "text",
					value: "Field Vision Description icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "description-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9 10a1 1 0 0 0-1 1 1 1 0 0 0 1 1h14a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm0 5a1 1 0 0 0-1 1 1 1 0 0 0 1 1h14a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm0 5a1 1 0 0 0-1 1 1 1 0 0 0 1 1h8.668a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm7-20C7.172 0 0 7.172 0 16s7.172 16 16 16 16-7.172 16-16S24.828 0 16 0zm0 1.5c8.017 0 14.5 6.483 14.5 14.5S24.017 30.5 16 30.5 1.5 24.017 1.5 16 7.983 1.5 16 1.5z"
			},
			children: [
			]
		}
	]
},
	embed: embed,
	"event-ticket": {
	id: "event-ticket",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 54 40"
	},
	children: [
		{
			id: "event-ticket",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "event-ticket",
					name: "",
					type: "text",
					value: "Event Ticket",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "event-ticket",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#000",
				d: "M16.498 31.133 1.642 18.945l2.673-3.476c.255.156.535.273.84.351.306.078.624.117.955.117H6.531h-.039a3.456 3.456 0 0 0 2.292-1.21 3.636 3.636 0 0 0 .916-2.461v-.196a.443.443 0 0 0-.038-.195 2.698 2.698 0 0 0-.306-1.094 4.07 4.07 0 0 0-.572-.976l.725-.938-.42-1.328-1.91 2.344.459.39c.255.209.458.456.61.743.154.286.243.599.268.937a.443.443 0 0 1 .038.195v.235c0 .26-.05.52-.152.781-.077.26-.191.482-.344.664-.204.26-.446.469-.726.625-.254.156-.547.26-.878.313H6.11c-.28 0-.547-.04-.802-.118a2.367 2.367 0 0 1-.687-.43l-.458-.35L0 19.101l17.147 14.062-.65-2.031Zm9.394 6.367-.649.82-2.176-1.797-1.337.43 3.704 3.008 1.184-1.523-.726-.938Zm-8.02-7.969L10.54 6.484l4.125-1.367c.178.339.394.638.649.899.28.26.586.481.917.664a3.374 3.374 0 0 0 1.642.43c.687 0 1.31-.183 1.871-.548a3.61 3.61 0 0 0 1.337-1.445v-.039c.127-.234.216-.495.267-.781.076-.287.114-.586.114-.899v-.273a1.31 1.31 0 0 0-.038-.313v.04l4.125-1.368.573 1.836.61-1.914L26.275 0l-6.263 2.07.191.586c.026.104.051.222.077.352.025.13.038.273.038.43a2.42 2.42 0 0 1-.497 1.484 2.32 2.32 0 0 1-1.183.86 2.141 2.141 0 0 1-.382.116c-.128.026-.255.04-.382.04-.204 0-.408-.027-.611-.079a1.745 1.745 0 0 1-.497-.234v.04a3.34 3.34 0 0 1-.764-.587 2.341 2.341 0 0 1-.458-.82l-.114-.664-6.34 2.11 8.21 25.741.574-1.914Zm5.805 5.117-3.78 1.29-1.07-3.36-1.336-.43 1.68 5.235 5.27-1.758-.764-.977ZM22.38 20.586l6.072-19.063 4.125 1.368-.077.312v.274c0 1.015.357 1.888 1.07 2.617.712.703 1.565 1.054 2.558 1.054.688 0 1.311-.182 1.872-.546.56-.365.992-.847 1.298-1.446l1.375.43 1.07-.86-3.132-1.054-.153.547a2.61 2.61 0 0 1-.879 1.484c-.432.365-.954.547-1.565.547a2.386 2.386 0 0 1-1.719-.703 2.476 2.476 0 0 1-.725-1.797c0-.208.025-.404.076-.586a4.65 4.65 0 0 1 .19-.547v.04l.115-.548L27.65 0l-6.913 21.953 1.642-1.367ZM44.644 6.523l.229-.742-1.108-.39.879 1.132Zm-23.22 25.235-2.33-.781.497-1.563-.878-1.094-1.07 3.438 5.08 1.68-1.299-1.68Zm11.724 5.117 1.68.586.803-2.617-2.483 2.031ZM28.566 40l-4.086-5.234.458-.352c.229-.208.42-.456.573-.742.178-.287.28-.6.305-.938v-.273c0-.625-.204-1.172-.61-1.64-.408-.495-.918-.769-1.529-.821h-.038c-.025-.026-.063-.04-.114-.04h-.153c-.28 0-.56.053-.84.157a2.974 2.974 0 0 0-.688.39l-.458.391-.534-.742-3.552-4.57 25.32-20.86L46.82 10l-.496.39c-.28.235-.497.521-.65.86-.152.338-.228.703-.228 1.094a2.5 2.5 0 0 0 .687 1.758c.484.494 1.07.742 1.757.742.28 0 .547-.052.802-.156.28-.105.522-.235.725-.391l.42-.39L54 19.18 28.566 40Zm-2.52-5.078 2.672 3.437 23.64-19.375-2.712-3.476a4.171 4.171 0 0 1-.84.39 3.683 3.683 0 0 1-.916.118c-.993 0-1.846-.365-2.559-1.094-.687-.73-1.031-1.602-1.031-2.617 0-.47.076-.912.229-1.328.178-.417.407-.795.687-1.133l-2.711-3.438-23.601 19.375 2.711 3.516c.255-.156.535-.274.84-.352.306-.078.612-.117.917-.117h.19c.077 0 .154.013.23.04.484.051.93.195 1.337.429.407.234.763.534 1.069.898.23.313.42.664.573 1.055.153.39.229.807.229 1.25a.443.443 0 0 1-.038.195v.196c-.051.39-.153.755-.306 1.093a2.961 2.961 0 0 1-.61.938ZM10.081 24.297c0 .13-.038.234-.115.312a.408.408 0 0 1-.305.118.55.55 0 0 1-.344-.118.428.428 0 0 1-.114-.312c0-.13.038-.235.114-.313a.47.47 0 0 1 .344-.156.36.36 0 0 1 .305.156.428.428 0 0 1 .115.313Zm1.26-1.602a.49.49 0 0 1-.152.352.408.408 0 0 1-.306.117.501.501 0 0 1-.306-.117.58.58 0 0 1-.114-.352c0-.104.038-.195.114-.273.102-.104.204-.156.306-.156a.36.36 0 0 1 .306.156c.101.078.152.17.152.273Zm1.222-1.562a.527.527 0 0 1-.114.312.408.408 0 0 1-.306.117.408.408 0 0 1-.305-.117.527.527 0 0 1-.115-.312c0-.13.038-.235.115-.313a.36.36 0 0 1 .305-.156.36.36 0 0 1 .306.156.428.428 0 0 1 .114.313Zm2.254-5.664c0 .13-.039.234-.115.312a.408.408 0 0 1-.305.117.55.55 0 0 1-.344-.117.428.428 0 0 1-.115-.312c0-.13.038-.235.115-.313a.47.47 0 0 1 .344-.156.36.36 0 0 1 .305.156.427.427 0 0 1 .115.313Zm1.909-.625c0 .13-.05.234-.153.312a.408.408 0 0 1-.305.117.501.501 0 0 1-.306-.117.428.428 0 0 1-.114-.312c0-.13.038-.235.114-.313.102-.104.204-.156.306-.156a.36.36 0 0 1 .305.156.374.374 0 0 1 .153.313Zm1.871-.625a.527.527 0 0 1-.114.312.408.408 0 0 1-.306.117.55.55 0 0 1-.344-.117.527.527 0 0 1-.114-.312c0-.13.038-.235.114-.313a.47.47 0 0 1 .344-.156.36.36 0 0 1 .306.156.428.428 0 0 1 .114.313Zm1.91-.625c0 .104-.051.208-.153.312a.408.408 0 0 1-.306.117.501.501 0 0 1-.305-.117.527.527 0 0 1-.115-.312c0-.13.039-.235.115-.313.102-.104.204-.156.305-.156a.36.36 0 0 1 .306.156.374.374 0 0 1 .153.313Zm1.871-.625a.527.527 0 0 1-.114.312.408.408 0 0 1-.306.117.55.55 0 0 1-.344-.117.527.527 0 0 1-.114-.312c0-.13.038-.235.114-.313a.47.47 0 0 1 .344-.156.36.36 0 0 1 .306.156.428.428 0 0 1 .114.313Zm8.21-.586c0 .13-.05.234-.152.312a.408.408 0 0 1-.306.117.501.501 0 0 1-.305-.117.428.428 0 0 1-.114-.312c0-.13.038-.235.114-.313.102-.104.204-.156.305-.156a.36.36 0 0 1 .306.156.374.374 0 0 1 .153.313Zm-1.909-.625a.526.526 0 0 1-.114.312.408.408 0 0 1-.306.117.55.55 0 0 1-.344-.117.527.527 0 0 1-.114-.312c0-.13.038-.235.114-.313a.47.47 0 0 1 .344-.156.36.36 0 0 1 .306.156.428.428 0 0 1 .114.313Zm-1.87-.625c0 .104-.052.208-.154.312a.408.408 0 0 1-.305.117.501.501 0 0 1-.306-.117.527.527 0 0 1-.114-.312c0-.13.038-.235.114-.313.102-.104.204-.156.306-.156a.36.36 0 0 1 .305.156.374.374 0 0 1 .153.313Zm17.948 13.203c0 .13-.05.247-.153.352a.363.363 0 0 1-.267.117.55.55 0 0 1-.344-.117.58.58 0 0 1-.114-.352.38.38 0 0 1 .114-.273.47.47 0 0 1 .344-.157c.102 0 .191.052.267.157.102.078.153.169.153.273Zm-1.222-1.563c0 .105-.05.209-.153.313a.408.408 0 0 1-.305.117.408.408 0 0 1-.306-.117.526.526 0 0 1-.114-.313c0-.13.038-.234.114-.312a.36.36 0 0 1 .306-.156.36.36 0 0 1 .305.156.374.374 0 0 1 .153.312Zm-1.26-1.601c0 .13-.051.234-.153.312a.363.363 0 0 1-.267.118.55.55 0 0 1-.344-.118.428.428 0 0 1-.114-.312c0-.13.038-.235.114-.313a.47.47 0 0 1 .344-.156c.102 0 .19.052.267.156a.374.374 0 0 1 .153.313Zm-1.26-1.602a.58.58 0 0 1-.115.352.408.408 0 0 1-.306.117.55.55 0 0 1-.343-.117.58.58 0 0 1-.115-.352c0-.104.038-.195.115-.273a.47.47 0 0 1 .343-.156.36.36 0 0 1 .306.156c.076.078.115.17.115.273Zm-1.222-1.562c0 .104-.051.208-.153.312a.408.408 0 0 1-.306.117.501.501 0 0 1-.305-.117.527.527 0 0 1-.115-.312c0-.13.038-.235.115-.313.102-.104.203-.156.305-.156a.36.36 0 0 1 .306.156.374.374 0 0 1 .153.313Zm-1.223-1.602c0 .13-.05.248-.152.352a.408.408 0 0 1-.306.117.408.408 0 0 1-.305-.117.58.58 0 0 1-.115-.352.38.38 0 0 1 .115-.273.36.36 0 0 1 .305-.156.36.36 0 0 1 .306.156c.102.078.152.17.152.273Zm-1.26-1.562c0 .104-.05.208-.153.312a.408.408 0 0 1-.305.117.501.501 0 0 1-.306-.117.527.527 0 0 1-.114-.312c0-.13.038-.235.114-.313.102-.104.204-.156.306-.156a.36.36 0 0 1 .305.156.374.374 0 0 1 .153.313Zm-1.26-1.602a.58.58 0 0 1-.115.352.408.408 0 0 1-.305.117.55.55 0 0 1-.344-.117.58.58 0 0 1-.114-.352c0-.13.038-.234.114-.312a.55.55 0 0 1 .344-.117c.127 0 .229.039.305.117a.428.428 0 0 1 .115.312Z"
			},
			children: [
			]
		}
	]
},
	family: family,
	"facebook-circle-logo": {
	id: "facebook-circle-logo",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "facebook-circle-logo",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "facebook-circle-logo",
					name: "",
					type: "text",
					value: "Facebook Social Icon Circle Color",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "facebook-circle-logo",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M398.785 200C398.785 90.214 309.786 1.215 200 1.215S1.215 90.214 1.215 200c0 99.219 72.693 181.457 167.725 196.369V257.461h-50.473V200h50.473v-43.795c0-49.82 29.677-77.34 75.084-77.34 21.749 0 44.498 3.883 44.498 3.883v48.92h-25.067c-24.694 0-32.395 15.323-32.395 31.044V200h55.132l-8.813 57.461H231.06v138.908c95.032-14.912 167.725-97.15 167.725-196.369z",
				fill: "#1877f2"
			},
			children: [
			]
		},
		{
			id: "facebook-circle-logo",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M277.379 257.461L286.192 200H231.06v-37.289c0-15.721 7.701-31.044 32.395-31.044h25.067v-48.92s-22.749-3.883-44.498-3.883c-45.406 0-75.084 27.519-75.084 77.34V200h-50.473v57.461h50.473v138.908c10.121 1.588 20.494 2.416 31.06 2.416s20.939-.828 31.06-2.416V257.461h46.319z",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	fans: fans,
	fantasy: fantasy,
	"fast-forward-10": {
	id: "fast-forward-10",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "fast-forward-10",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "fast-forward-10",
					name: "",
					type: "text",
					value: "Fast Forward 10 Seconds icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "fast-forward-10",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M487.7 232.3c-12.7 0-23 10.3-23 23 0 115.4-93.9 209.3-209.3 209.3S46.1 370.8 46.1 255.4C46.1 140 140 46.1 255.4 46.1c33.5 0 65.4 7.7 95 22.8 20.8 10.6 39.8 24.9 56.1 41.8h-62.6c-12.7 0-23 10.3-23 23s10.3 23 23 23h110.6c12.7 0 23-10.3 23-23V23c0-12.7-10.3-23-23-23s-23 10.3-23 23v47.7C384.2 25.5 321.5 0 255.4 0 114.6 0 0 114.6 0 255.4s114.6 255.4 255.4 255.4 255.4-114.6 255.4-255.4c-.1-12.7-10.4-23.1-23.1-23.1z"
			},
			children: [
			]
		},
		{
			id: "fast-forward-10",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M144.5 327.4v22.7h91.2v-22.7h-31V193.9h-22.9c-8.4 6-21 9.9-37.7 11.8v16.9h31.5v104.9h-31.1zM352.9 196.9c-7.9-4.1-17.6-6.2-29-6.2-11.4 0-21 2.1-28.9 6.2-7.8 4.1-13.8 10.1-18 17.9-4.1 7.8-7.1 16.2-8.8 25.4-1.7 9.1-2.6 19.8-2.6 31.9 0 12.1.9 22.8 2.6 31.9 1.7 9.1 4.6 17.6 8.8 25.4 4.1 7.8 10.1 13.7 18 17.8 7.8 4.1 17.5 6.1 28.9 6.1 11.4 0 21.1-2 29-6.1 7.9-4.1 13.9-10 18.1-17.8 4.1-7.8 7.1-16.2 8.8-25.4 1.7-9.1 2.6-19.8 2.6-31.9 0-12.1-.9-22.8-2.6-31.9-1.7-9.1-4.6-17.6-8.8-25.4-4.2-7.8-10.2-13.8-18.1-17.9zm-5.8 119.4c-4.2 9.6-12 14.3-23.2 14.3-11.3 0-19-4.8-23.1-14.3-4.1-9.6-6.2-22.6-6.2-39.2 0-16.5.7-28.9 2.2-37 1.5-8.1 4.5-14.6 8.9-19.5 4.4-4.8 10.5-7.3 18.2-7.3 11.3 0 19 4.8 23.2 14.3 4.2 9.6 6.3 24.3 6.3 44.3 0 20.1-2.1 34.8-6.3 44.4z"
			},
			children: [
			]
		}
	]
},
	fantasy2: fantasy2,
	"filter-2": {
	id: "filter-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "filter-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "filter-2",
					name: "",
					type: "text",
					value: "Filter icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "filter-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.358 2.061c-1.507.235-2.761 1.354-3.215 2.869-.019.066-.3.07-5.157.07-5.595 0-5.306-.011-5.612.222a1.19 1.19 0 0 0-.243.289c-.095.161-.111.233-.111.489s.016.328.111.489c.061.103.17.234.243.289.306.233.017.222 5.612.222 4.857 0 5.138.004 5.157.07.367 1.222 1.219 2.17 2.369 2.634a3.969 3.969 0 0 0 2.976 0 3.936 3.936 0 0 0 2.223-2.244c.067-.176.132-.351.144-.39.021-.064.112-.07 1.157-.07 1.302 0 1.409-.019 1.689-.299a.984.984 0 0 0 0-1.402c-.28-.28-.387-.299-1.689-.299-1.045 0-1.136-.006-1.157-.07a12.924 12.924 0 0 0-.144-.39c-.498-1.308-1.703-2.27-3.106-2.482a3.728 3.728 0 0 0-1.247.003m1.503 1.068c.943.276 1.723 1.054 2.014 2.01.083.273.098.403.098.861 0 .458-.015.588-.098.861a3.073 3.073 0 0 1-2.035 2.025c-.434.135-1.246.135-1.68 0a3.073 3.073 0 0 1-2.035-2.025c-.083-.273-.098-.403-.098-.861 0-.458.015-.588.098-.861a3.042 3.042 0 0 1 2.374-2.099c.333-.06 1.001-.017 1.362.089M7.358 14.061c-1.507.235-2.761 1.354-3.215 2.869-.019.065-.109.07-1.157.07-1.227 0-1.342.016-1.612.222a1.19 1.19 0 0 0-.243.289c-.095.161-.111.233-.111.489s.016.328.111.489c.061.103.17.234.243.289.27.206.385.222 1.612.222 1.048 0 1.138.005 1.157.07.367 1.222 1.219 2.17 2.369 2.634a3.969 3.969 0 0 0 2.976 0 3.936 3.936 0 0 0 2.223-2.244c.067-.176.132-.351.144-.39.021-.066.302-.07 5.157-.07 5.769 0 5.369.021 5.689-.299a.984.984 0 0 0 0-1.402c-.32-.32.08-.299-5.689-.299-4.855 0-5.136-.004-5.157-.07a14.09 14.09 0 0 0-.144-.39c-.498-1.308-1.703-2.27-3.106-2.482a3.728 3.728 0 0 0-1.247.003m1.503 1.068c.943.276 1.723 1.054 2.014 2.01.083.273.098.403.098.861 0 .458-.015.588-.098.861a3.073 3.073 0 0 1-2.035 2.025c-.252.078-.387.093-.84.093-.453 0-.588-.015-.84-.093a3.073 3.073 0 0 1-2.035-2.025c-.083-.273-.098-.403-.098-.861 0-.458.015-.588.098-.861a3.042 3.042 0 0 1 2.374-2.099c.333-.06 1.001-.017 1.362.089"
			},
			children: [
			]
		}
	]
},
	"filter-list": {
	id: "filter-list",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 369 369"
	},
	children: [
		{
			id: "filter-list",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "filter-list",
					name: "",
					type: "text",
					value: "Filter List",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "filter-list",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M184.5 22c43.405 0 84.213 16.903 114.905 47.595S347 141.095 347 184.5s-16.903 84.213-47.595 114.905S227.905 347 184.5 347s-84.213-16.903-114.905-47.595S22 227.905 22 184.5s16.903-84.213 47.595-114.905S141.095 22 184.5 22m0-22C82.604 0 0 82.603 0 184.5S82.604 369 184.5 369 369 286.396 369 184.5 286.397 0 184.5 0z"
			},
			children: [
			]
		},
		{
			id: "filter-list",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M247.252 248.332h-26.258a13.95 13.95 0 0 0-1.632-.105h-97.615c-7.67 0-13.945 6.276-13.945 13.945 0 7.669 6.275 13.945 13.945 13.945h95.983a13.95 13.95 0 0 0 1.632.105h27.89c7.67 0 13.945-6.276 13.945-13.945 0-7.669-6.276-13.945-13.945-13.945zm27.89-69.829H93.858c-7.67 0-13.945 6.275-13.945 13.945s6.275 13.945 13.945 13.945h181.284c7.67 0 13.945-6.275 13.945-13.945 0-7.671-6.276-13.945-13.945-13.945zm20.917-69.725H72.941c-7.67 0-13.945 6.275-13.945 13.945s6.275 13.945 13.945 13.945h223.118c7.67 0 13.945-6.275 13.945-13.945s-6.275-13.945-13.945-13.945z"
			},
			children: [
			]
		}
	]
},
	"first-aid": {
	id: "first-aid",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.674 399.986"
	},
	children: [
		{
			id: "first-aid",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "first-aid",
					name: "",
					type: "text",
					value: "First Aid icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "first-aid",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M477.946 68.986h-120.66V17.348c0-9.596-7.572-17.362-17.127-17.362H177.293c-9.58 0-17.006 7.767-17.006 17.362v51.638H32.745C12.524 68.986.287 79.979.287 95.392v30.594h511V97.812c-.001-14.935-11.167-28.826-33.341-28.826zm-154.66 0h-129v-34h129v34zM.286 376.819c0 13.606 6.419 23.166 22.962 23.166h465.487c16.52 0 22.551-13.215 22.551-23.166V144.986h-511v231.833zm196-123.833h40v-40h39v40h41v39h-41v41h-39v-41h-40v-39z"
			},
			children: [
			]
		}
	]
},
	"food-beverage": {
	id: "food-beverage",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.143 473.239"
	},
	children: [
		{
			id: "food-beverage",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "food-beverage",
					name: "",
					type: "text",
					value: "Food Beverage icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "food-beverage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M334.207 10.228c-.923-1.6-2.058-3.066-3.377-4.363l-.43-.418-.025-.018c-3.686-3.412-8.46-5.335-13.49-5.427L316.84 0H22.112C16.77 0 11.715 2.05 7.882 5.773c-3.834 3.722-6.032 8.713-6.19 14.054-.155 5.307-3.775 130.468.072 173.892.984 11.105 3.27 25.84 12.28 41.335 9.34 16.06 24.123 30.013 45.194 42.656 20.48 12.29 34.676 17.64 44.07 21.18 9.647 3.636 10.203 4.116 11.53 6.047.213.32 5.23 8.29 5.81 45.473.324 20.93-1.015 39.92-1.028 40.108-.052.726-.066 1.463-.04 2.2-.007.493-.108 4.344-1.562 8.764-2.078 6.316-5.794 10.738-11.358 13.52-23.54 11.77-23.54 11.77-42.167 16.73-9.877 2.628-16.326 12.253-15 22.388 1.326 10.135 10.033 17.778 20.254 17.778H268.87c10.22 0 18.93-7.643 20.254-17.778 1.325-10.135-5.123-19.76-15-22.39-18.627-4.957-18.627-4.957-42.167-16.727-12.54-6.27-12.913-20.816-12.918-22.29.043-.877.01-1.47-.044-2.193-.014-.19-1.353-19.16-1.027-40.11.578-37.182 5.595-45.152 5.804-45.468 1.33-1.936 1.887-2.416 11.535-6.052 9.39-3.54 23.585-8.89 44.068-21.18 21.07-12.64 35.853-26.594 45.193-42.655 9.012-15.494 11.297-30.23 12.28-41.336 3.838-43.328.228-168.54.073-173.833-.086-3.39-1.026-6.73-2.716-9.66zM42.024 40.854h254.57c.283 12.21.622 28.675.862 46.44-26.698 3.307-67.432 7.527-84.438 5.908-10.558-1.005-24.48-4-39.222-7.168-22.75-4.89-46.275-9.95-63.66-8.942-19.65 1.137-48.667 6.755-68.986 11.127.24-18.118.584-34.943.874-47.366zm254.134 149.26c-1.473 16.633-5.472 33.17-37.798 52.565-17.317 10.39-28.956 14.776-37.458 17.98-11.287 4.255-21.948 8.273-30.792 21.136-5.696 8.284-12.32 23.522-12.993 68.197-.31 20.48.812 38.714 1.073 42.625.02 5.81 1.09 22.78 11.792 38.424h-41.35c10.703-15.643 11.773-32.61 11.794-38.423.26-3.91 1.382-22.157 1.073-42.627-.674-44.675-7.298-59.913-12.994-68.197-8.844-12.863-19.505-16.88-30.792-21.135-8.5-3.202-20.138-7.59-37.458-17.98-32.325-19.396-36.325-35.933-37.798-52.566-1.32-14.9-1.677-41.088-1.594-68.523 19.11-4.247 51.34-10.876 71.15-12.022 12.986-.754 35.276 4.04 54.944 8.27 15.697 3.375 30.523 6.563 42.975 7.748 3.534.337 7.693.486 12.3.485 22.018 0 54.116-3.407 75.514-6.023.102 27.992-.244 54.886-1.59 70.067zM387.777.285c-8.983 0-16.265 7.282-16.265 16.265v168.673c0 8.983 7.282 16.265 16.265 16.265s16.265-7.282 16.265-16.265V16.55c0-8.984-7.283-16.265-16.265-16.265zM441.324 201.488c8.983 0 16.265-7.282 16.265-16.265V16.55c0-8.984-7.283-16.266-16.266-16.266-8.983 0-16.265 7.282-16.265 16.265V185.22c0 8.984 7.28 16.266 16.264 16.266z"
			},
			children: [
			]
		},
		{
			id: "food-beverage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M511.137 193.4V16.55c0-8.984-7.283-16.266-16.266-16.266-8.982 0-16.264 7.282-16.264 16.265V185.22l.003 8.522c.078 3.627-.37 22.09-16.997 29.32-10.944 4.757-18.875 8.357-23.57 10.698-2.19 1.09-3.696 1.913-4.887 2.665-7.105 4.49-8.816 11.332-8.098 16.62l-.17 203.913c-.007 8.983 7.268 16.27 16.252 16.278h.014c8.976 0 16.257-7.273 16.265-16.252l.163-196.514c3.618-1.676 9.007-4.1 17.002-7.577 15.593-6.78 26.86-19.035 32.584-35.442 3.697-10.604 4.024-20.11 3.967-24.053zm-5.525 12.07c3.104-2.734 5.123-6.612 5.47-10.874-.335 4.302-2.373 8.16-5.47 10.874z"
			},
			children: [
			]
		}
	]
},
	"food-truck": {
	id: "food-truck",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.99 362.672"
	},
	children: [
		{
			id: "food-truck",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "food-truck",
					name: "",
					type: "text",
					value: "Food Truck icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "food-truck",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M510.21 218.08l-42.047-63.075-42.266-105.63c-1.61-4.048-5.53-6.704-9.906-6.704H298.667V10.673C298.666 4.782 293.9 0 287.994 0h-64c-25.75 0-47.295 18.35-52.248 42.67H10.672C4.782 42.67 0 47.445 0 53.336V309.33c0 5.89 4.78 10.654 10.672 10.654H43.75c4.952 24.327 26.5 42.688 52.248 42.688 25.765 0 47.312-18.36 52.265-42.688h215.48c4.953 24.327 26.5 42.688 52.248 42.688 25.767 0 47.312-18.36 52.267-42.688h33.077c5.89 0 10.656-4.766 10.656-10.654v-85.344c0-2.09-.61-4.155-1.78-5.905zm-147.545-4.75c0-2.732-1.047-5.467-3.125-7.53-4.156-4.187-10.922-4.187-15.078 0-4.172 4.157-4.172 10.906 0 15.063 4.156 4.188 10.922 4.188 15.078 0 2.078-2.063 3.125-4.8 3.125-7.532v85.344h-64V170.668h64v42.663zm-64-63.997V106.67h64v42.663h-64zm85.328-42.663h41.858l17.062 42.663h-58.92V106.67zm-106.654-64h-10.673V21.336h10.672V42.67zm-53.345-21.335h21.343V42.67h-51.5c4.408-12.413 16.267-21.335 30.157-21.335zM95.998 341.328c-17.64 0-32-14.343-32-31.998 0-17.656 14.36-32 32-32 17.656 0 32 14.344 32 32 0 17.655-14.344 31.998-32 31.998zm0-85.342c-25.75 0-47.296 18.358-52.25 42.688H21.344V63.998h387.43l8.53 21.336h-129.31c-5.892 0-10.656 4.773-10.656 10.664v202.676H148.263c-4.954-24.328-26.5-42.688-52.265-42.688zm319.993 85.342c-17.64 0-31.997-14.343-31.997-31.998 0-17.656 14.358-32 31.998-32 17.657 0 32 14.344 32 32 0 17.655-14.343 31.998-32 31.998zm52.267-42.654c-4.953-24.328-26.5-42.688-52.266-42.688-11.982 0-23.076 4-31.997 10.703v-96.022h68.967l37.702 56.568v7.438h-10.67c-5.892 0-10.657 4.765-10.657 10.655s4.767 10.655 10.656 10.655h10.672v42.688h-22.405z"
			},
			children: [
			]
		},
		{
			id: "food-truck",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M88.467 301.8c-4.17 4.155-4.17 10.904 0 15.06 4.156 4.19 10.922 4.19 15.078 0 4.172-4.155 4.172-10.904 0-15.06-4.156-4.19-10.922-4.19-15.078 0zM408.46 301.8c-4.17 4.155-4.17 10.904 0 15.06 4.156 4.19 10.922 4.19 15.078 0 4.172-4.155 4.172-10.904 0-15.06-4.156-4.19-10.922-4.19-15.077 0zM255.995 234.675v-93.123c6.5-4.844 10.47-11.578 10.47-19.14 0-1.603-.313-3.493-.485-4.478l-.22-1.156-10.577-24.882c-.016-.03-.03-.062-.047-.102l-2.75-6.46H46.28l-2.75 6.46c0 .04-.015.07-.03.102l-10.468 24.6-.203.837c-.407 1.672-.61 3.383-.61 5.078 0 7.563 3.97 14.298 10.453 19.142v93.123c0 5.874 4.78 10.655 10.672 10.655H245.34c5.89 0 10.655-4.78 10.655-10.655zM53.608 122.622l6.78-15.952h177.888l6.797 15.952c-.656 1.602-5.953 5.375-14.625 5.375-6.438 0-11.11-2.04-13.36-3.945l-6.92-5.914-6.922 5.914c-2.234 1.906-6.922 3.945-13.36 3.945-6.42 0-11.108-2.04-13.342-3.945l-6.922-5.914-6.938 5.914c-2.234 1.906-6.906 3.945-13.343 3.945-6.436 0-11.124-2.04-13.358-3.945l-6.922-5.914-6.922 5.914c-2.234 1.906-6.922 3.945-13.36 3.945-6.437 0-11.108-2.04-13.343-3.945l-6.938-5.914-6.92 5.914c-2.235 1.906-6.923 3.945-13.345 3.945-8.686 0-13.983-3.78-14.624-5.375zm14.625 26.71c7.344 0 14.39-1.6 20.265-4.522 5.89 2.922 12.938 4.523 20.28 4.523 7.36 0 14.407-1.602 20.282-4.523 5.875 2.922 12.92 4.523 20.28 4.523 7.345 0 14.39-1.602 20.282-4.523 5.875 2.922 12.922 4.523 20.265 4.523 7.36 0 14.406-1.602 20.28-4.523 5.876 2.922 12.922 4.523 20.282 4.523 1.437 0 2.843-.062 4.218-.18v42.843H63.998v-42.843c1.39.118 2.797.18 4.235.18zm-4.235 74.654V213.33h170.67v10.656H63.997z"
			},
			children: [
			]
		}
	]
},
	"full-season-tickets": {
	id: "full-season-tickets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 935 981",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "full-season-tickets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "full-season-tickets",
					name: "",
					type: "text",
					value: "Full Season Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "full-season-tickets",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "full-season-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M389.5 49.1c4.3-8.8 10.8-15.8 18.5-20.8.2-.5.4-1.1.5-1.6L361.1 3.2c-14-6.9-31.1-1.2-38 12.8L2.9 663.3c-3.3 6.7-3.8 14.4-1.4 21.6 2.4 7.2 7.5 13 14.2 16.3l47.5 23.5c.3-.4.5-.8.8-1.2-.7-9.3 1-18.7 5.3-27.3L389.5 49.1zM738.6 274.1c20.8 10.3 44.4 11.9 66.5 4.4 16-5.4 29.8-15.1 40-28-2.7-6.1-7.3-11.1-13.3-14.1l-47.4-23.5c-13.6 21.3-33.8 37.3-58.1 45.5-2.4.8-4.9 1.5-7.4 2.2 5.7 5.3 12.3 9.8 19.7 13.5-.1-.1 0-.1 0 0zM459.7 837.8c-7.4-3.7-14.9-6.1-22.6-7.6.9 2.3 1.8 4.6 2.6 6.9 8.2 24.3 7.8 50.1-.9 73.8l47.4 23.5c6.2 3.1 13 3.6 19.2 2.1 4-16 3.3-32.7-2.1-48.7-7.2-21.9-22.8-39.7-43.6-50zM565.6 136.5c4.7-9.4 11.8-16.8 20.2-21.8l-47.1-23.3c-14-6.9-31.1-1.2-38 12.8L180.4 751.4c-3.3 6.7-3.8 14.4-1.4 21.6 2.4 7.2 7.5 13 14.2 16.3l47 23.3c-1.1-9.9.6-19.9 5.1-29l320.3-647.1z"
					},
					children: [
					]
				},
				{
					id: "full-season-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M931.2 317.4c3.3-6.7 3.8-14.4 1.4-21.6-2.4-7.2-7.5-13-14.2-16.3l-47-23.3-.4-.2c-3.7 5.9-8 11.3-12.7 16.3-6.3 6.8-13.5 12.7-21.3 17.7-7.5 4.7-15.5 8.6-24.1 11.5-28.1 9.5-58.3 7.5-84.9-5.7 0 0-.1 0-.1-.1-15.2-7.6-28.3-18.3-38.4-31.4-3.1-4-5.9-8.2-8.5-12.6-2.4-4.2-4.5-8.6-6.4-13.1-.9-2.3-1.8-4.6-2.6-7-8.2-24.3-7.8-50.1.9-73.8l-47.4-23.5c-6.2-3.1-13-3.6-19.2-2.1-5.2 1.3-10 3.9-13.8 7.9-2 2-3.7 4.4-5 7.1l-7.5 15.3-305.4 616.6-7.6 15.3c-1.3 2.6-2.1 5.4-2.6 8.2-.7 4.5-.3 9.1 1.2 13.5.3.8.6 1.5.9 2.3 2.7 6.1 7.3 11.1 13.3 14l47.5 23.5c15.4-24.2 39.2-40.7 65.5-47.6 4.7-1.2 9.5-2.2 14.3-2.8 5-.6 10.1-.9 15.1-.9 16.2.2 32.6 3.8 48 11.5 0 0 .1 0 .1.1 26.6 13.2 46.4 35.9 55.9 64 2.9 8.6 4.7 17.4 5.5 26.2.8 9.2.4 18.5-1.1 27.6-1.1 6.8-2.9 13.5-5.3 20l.3.2 47.1 23.3c14 6.9 31.1 1.2 38-12.8l320.5-647.3zm-339.3-3.8c-4.6 9.2-15.8 13-25 8.5l-19.1-9.4c-9.2-4.6-13-15.8-8.5-25l.7-1.4c4.6-9.2 15.8-13 25-8.5l19.1 9.4c9.2 4.6 13 15.8 8.5 25l-.7 1.4zm60.7 50.9l-19.1-9.4c-9.2-4.6-13-15.8-8.5-25l.7-1.4c4.6-9.2 15.8-13 25-8.5l19.1 9.4c9.2 4.6 13 15.8 8.5 25l-.7 1.4c-4.5 9.2-15.8 13-25 8.5zm85.8 42.4l-19.1-9.4c-9.2-4.6-13-15.8-8.5-25l.7-1.4c4.6-9.2 15.8-13 25-8.5l19.1 9.4c9.2 4.6 13 15.8 8.5 25l-.7 1.4c-4.5 9.3-15.8 13.1-25 8.5zm85.8 42.5l-19.1-9.4c-9.2-4.6-13-15.8-8.5-25l.7-1.4c4.6-9.2 15.8-13 25-8.5l19.1 9.4c9.2 4.6 13 15.8 8.5 25l-.7 1.4c-4.6 9.2-15.8 13-25 8.5zM478.4 93.2c4.3-8.8 10.8-15.8 18.5-20.8.2-.5.4-1.1.5-1.6L450 47.4c-14-6.9-31.1-1.2-38 12.8L91.7 707.4c-3.3 6.7-3.8 14.4-1.4 21.6 2.4 7.2 7.5 13 14.2 16.3l47.5 23.5c.3-.4.5-.8.8-1.2-.7-9.3 1-18.7 5.3-27.3L478.4 93.2z"
					},
					children: [
					]
				}
			]
		}
	]
},
	favorite: favorite,
	fx: fx,
	"full-schedule": {
	id: "full-schedule",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "-319 141 512 512"
	},
	children: [
		{
			id: "full-schedule",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "full-schedule",
					name: "",
					type: "text",
					value: "Full Schedule icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "full-schedule",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M-279.1 474.3V252.8c0-16.8 14.8-31.2 31.5-31.2h28v-36.2c0-12 10.3-21.5 22.3-21.5h41.1V161c0-4.8-1.3-9.1-3.6-12.6-3.5-5.4-9.4-8.9-16.6-8.9h-45.1c-11.9-.1-22.3 9.4-22.3 21.5v36.2h-28c-16.7 0-31.5 14.3-31.5 31.2v294.8c0 1.8.2 3.6.5 5.4 2.3 12.1 12.2 21.7 24.2 24.4-.3-1.7-.5-3.5-.5-5.4V511v-36.7z"
			},
			children: [
			]
		},
		{
			id: "full-schedule",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M-230.6 523.2V301.6c0-16.8 14.8-31.2 31.5-31.2h28v-36.2c0-12 10.3-21.5 22.3-21.5h45.1c7.2 0 13.1 3.5 16.6 8.9h42.7v-36.2c0-12 11.3-21.5 23.3-21.5H21.2V161c0-1.7-.2-3.3-.6-4.9-2.2-9.6-10.6-16.7-20.8-16.7H-45.3c-11.9 0-23.3 9.5-23.3 21.5v36.2h-42.7c-3.5-5.4-9.4-8.9-16.6-8.9H-173c-11.9 0-22.3 9.5-22.3 21.5V246h-28c-16.7 0-31.5 14.3-31.5 31.2V572c0 1.8.2 3.6.5 5.4 2.3 12.1 12.2 21.7 24.2 24.4-.3-1.7-.5-3.5-.5-5.4v-73.2z"
			},
			children: [
			]
		},
		{
			id: "full-schedule",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M151.6 295.4c-1.8-.3-3.6-.5-5.5-.5h-28v-36.2c0-1.7-.2-3.3-.6-4.9-2-8.6-9-15.2-17.8-16.4-1-.1-2-.2-3.1-.2H51.5c-11.9 0-23.3 9.5-23.3 21.5v36.2h-87.6v-24.4H4v-36.3c0-12 11.3-21.5 23.3-21.5H69.6v-2.9c0-1.7-.2-3.3-.6-4.9-2.2-9.6-10.6-16.6-20.9-16.6H3c-11.9 0-23.3 9.5-23.3 21.5V246H-63c-3.5-5.4-9.4-8.9-16.6-8.9h-45.1c-11.9 0-22.3 9.5-22.3 21.5v36.2h-28c-16.7 0-31.5 14.3-31.5 31.2v294.8c0 1.8.2 3.6.5 5.4 2.7 14.3 16.1 25.2 30.9 25.2h321c16.7 0 30.3-13.7 30.3-30.6V326c.2-14.9-10.5-27.9-24.6-30.6zm-93.1 26.5v-48.6c0-3.3 2.1-6.2 5-7.3.9-.3 1.8-.5 2.8-.5h13.6c4.3 0 7.8 3.5 7.8 7.9v65.7c0 4.3-3.5 7.9-7.8 7.9H66.3c-4.3 0-7.8-3.5-7.8-7.9v-17.2zm-176.2 0v-48.6c0-3.3 2.1-6.2 5-7.3.9-.3 1.8-.5 2.8-.5h13.6c4.3 0 7.8 3.5 7.8 7.9v65.7c0 4.3-3.5 7.9-7.8 7.9h-13.6c-4.3 0-7.8-3.5-7.8-7.9v-17.2zm264.9 226.8v73.2h-323.3V384.3H147.2v164.4z"
			},
			children: [
			]
		}
	]
},
	"gameday-2": {
	id: "gameday-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "gameday-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gameday-2",
					name: "",
					type: "text",
					value: "Gameday icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gameday-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M8 7h24c.5522847 0 1 .4477153 1 1v14.0231967c0 .3021616-.1366257.5881211-.3716983.7779698L20 33h0L7.3716983 22.8011665C7.1366257 22.6113178 7 22.3253583 7 22.0231967V8c0-.5522847.4477153-1 1-1z",
				fill: "#666",
				stroke: "#666",
				strokeWidth: "2",
				fillRule: "evenodd",
				fillOpacity: ".2"
			},
			children: [
			]
		}
	]
},
	"gameday-2d": {
	id: "gameday-2d",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "gameday-2d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.0125 1.612C13.2764 1.50165 15.6219 2.14829 17.6336 3.61489C22.1932 6.93905 23.2553 13.1613 20.0922 17.4999C19.8319 17.8569 19.9104 18.3574 20.2674 18.6177C20.6244 18.8779 21.1248 18.7995 21.3851 18.4425C25.101 13.3455 23.8047 6.13384 18.5761 2.32201C15.5591 0.122442 11.8733 -0.482908 8.57934 0.372237C7.83423 0.565676 7.71867 1.55429 8.36752 1.92983L11.9707 4.01529C12.3531 4.23662 12.8426 4.10604 13.0639 3.72364C13.2852 3.34124 13.1546 2.85183 12.7722 2.63051L11.0125 1.612Z"
			},
			children: [
			]
		},
		{
			id: "gameday-2d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M5.5094 13.8134V15.3034H10.7094V13.7234H7.8394L9.3594 12.3034C10.1894 11.5334 10.6094 10.7934 10.6094 9.8834C10.6094 8.4134 9.3594 7.4534 8.0394 7.4534C6.7194 7.4534 5.7894 8.3034 5.4394 9.0934L6.8294 9.9334C7.0494 9.4534 7.4694 9.0634 8.0294 9.0634C8.5494 9.0634 8.9294 9.4434 8.9294 9.9634C8.9294 10.4234 8.6094 10.8134 8.1094 11.2934L5.5094 13.8134Z"
			},
			children: [
			]
		},
		{
			id: "gameday-2d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.7583 7.6034V15.3034H14.8583C16.9883 15.3034 18.5483 13.6334 18.5483 11.4534C18.5483 9.2734 16.9783 7.6034 14.8583 7.6034H11.7583ZM14.8183 13.7234H13.4083V9.1834H14.8183C16.0783 9.1834 16.9383 10.0834 16.9383 11.4534C16.9383 12.8234 16.0883 13.7234 14.8183 13.7234Z",
				fill: "white"
			},
			children: [
			]
		},
		{
			id: "gameday-2d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.7451 20.7523L12.5057 21.7694C10.2418 21.8816 7.89582 21.2368 5.88294 19.7719C1.32065 16.4514 0.253564 10.23 3.41312 5.8888C3.67311 5.53157 3.59429 5.03121 3.23706 4.77121C2.87983 4.51122 2.37947 4.59004 2.11947 4.94727C-1.59233 10.0472 -0.290205 17.2579 4.94141 21.0655C7.96025 23.2626 11.6465 23.865 14.9398 23.0072C15.6847 22.8132 15.7995 21.8245 15.1503 21.4495L11.5454 19.3669C11.1629 19.1459 10.6736 19.2769 10.4525 19.6594C10.2315 20.042 10.3625 20.5313 10.7451 20.7523Z"
			},
			children: [
			]
		}
	]
},
	"gameday-3d": {
	id: "gameday-3d",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "gameday-3d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.7451 2.62949L12.5057 1.6124C10.2418 1.50023 7.89582 2.14498 5.88294 3.60997C1.32064 6.93045 0.253564 13.1518 3.41312 17.493C3.67311 17.8502 3.59429 18.3506 3.23706 18.6106C2.87983 18.8706 2.37947 18.7918 2.11947 18.4345C-1.59233 13.3346 -0.290205 6.12394 4.94141 2.31632C7.96025 0.119185 11.6465 -0.483199 14.9398 0.374597C15.6847 0.568639 15.7995 1.55734 15.1503 1.93236L11.5454 4.01492C11.1629 4.23594 10.6736 4.10497 10.4525 3.72239C10.2315 3.33982 10.3625 2.85051 10.7451 2.62949Z"
			},
			children: [
			]
		},
		{
			id: "gameday-3d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.0125 21.7698C13.2764 21.8802 15.6219 21.2335 17.6336 19.7669C22.1932 16.4428 23.2553 10.2205 20.0922 5.88189C19.8319 5.52487 19.9104 5.02445 20.2674 4.76416C20.6244 4.50388 21.1248 4.5823 21.3851 4.93932C25.101 10.0363 23.8047 17.248 18.5761 21.0598C15.5591 23.2594 11.8733 23.8647 8.57934 23.0096C7.83423 22.8161 7.71867 21.8275 8.36752 21.452L11.9707 19.3665C12.3531 19.1452 12.8426 19.2758 13.0639 19.6582C13.2852 20.0406 13.1546 20.53 12.7722 20.7513L11.0125 21.7698Z"
			},
			children: [
			]
		},
		{
			id: "gameday-3d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M6.86065 13.26L5.47065 14.1H5.48065C5.96065 15.05 6.95065 15.72 8.16065 15.72C9.67065 15.72 11.0007 14.6 11.0007 12.91C11.0007 11.6 10.1307 10.74 9.28065 10.51L10.6307 9.31V7.86H5.82065V9.41H8.57065L6.72065 11.04L7.34065 12.06C7.53065 11.88 7.83065 11.74 8.19065 11.74C8.86065 11.74 9.37065 12.23 9.37065 12.91C9.37065 13.59 8.84065 14.11 8.17065 14.11C7.55065 14.11 7.08065 13.76 6.86065 13.26Z"
			},
			children: [
			]
		},
		{
			id: "gameday-3d",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.7895 7.86V15.56H14.8895C17.0195 15.56 18.5795 13.89 18.5795 11.71C18.5795 9.52999 17.0095 7.86 14.8895 7.86H11.7895ZM14.8495 13.98H13.4395V9.44H14.8495C16.1095 9.44 16.9695 10.34 16.9695 11.71C16.9695 13.08 16.1195 13.98 14.8495 13.98Z",
				fill: "white"
			},
			children: [
			]
		}
	]
},
	"gameday-x": {
	id: "gameday-x",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "gameday-x",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gameday-x",
					name: "",
					type: "text",
					value: "Gameday X icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gameday-x",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.34371 6.34273c.23431-.23432.61421-.23432.84852 0L17.6574 16.8079c.2343.2343.2343.6142 0 .8485-.2343.2344-.6142.2344-.8485 0L6.34371 7.19126c-.23432-.23432-.23432-.61422 0-.84853Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "gameday-x",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.6574 6.34276c.2343.23432.2343.61422 0 .84853L7.19223 17.6565c-.23431.2343-.61421.2343-.84853 0-.23431-.2343-.23431-.6142 0-.8486L16.8089 6.34276c.2343-.23431.6142-.23431.8485 0Z",
				fill: "#000"
			},
			children: [
			]
		}
	]
},
	"gameday-microphone": {
	id: "gameday-microphone",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "gameday-microphone",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gameday-microphone",
					name: "",
					type: "text",
					value: "Gameday Microphone icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gameday-microphone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.40039 22.0542c0-.3313.26863-.6.6-.6h8.32001c.3314 0 .6.2687.6.6 0 .3314-.2686.6-.6.6H8.00039c-.33137 0-.6-.2686-.6-.6ZM7.40039 13.671V9.33474h1.2V13.671c0 1.7038 1.48961 3.1546 3.39981 3.1546 1.911 0 3.4002-1.4508 3.4002-3.1546V9.33474h1.2V13.671c0 2.437-2.0992 4.3546-4.6002 4.3546-2.50027 0-4.59981-1.9176-4.59981-4.3546ZM7.40039 4.99819c0-2.43702 2.09917-4.35464 4.60021-4.35464 2.5002 0 4.5998 1.91762 4.5998 4.35464v4.33655h-1.2V4.99819c0-1.70383-1.4896-3.15464-3.3998-3.15464-1.911 0-3.40021 1.45081-3.40021 3.15464v4.33655h-1.2V4.99819Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "gameday-microphone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.0004 9.93474H8.00039v-1.2h8.00001v1.2Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "gameday-microphone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.00039 8.3999c.33137 0 .6.26863.6.6v5.8952c0 1.1682.65078 2.2804 1.80634 3.1231 1.15476.8421 2.77797 1.3817 4.59367 1.3817 1.816 0 3.4391-.5396 4.5938-1.3817 1.1555-.8426 1.8062-1.9549 1.8062-3.1231V8.9999c0-.33137.2686-.6.6-.6s.6.26863.6.6v5.8952c0 1.6465-.9195 3.0866-2.2991 4.0927-1.3804 1.0067-3.2573 1.6121-5.3009 1.6121-2.04344 0-3.92025-.6054-5.30071-1.6121-1.37965-1.0061-2.2993-2.4462-2.2993-4.0927V8.9999c0-.33137.26863-.6.6-.6Z",
				fill: "#000"
			},
			children: [
			]
		},
		{
			id: "gameday-microphone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.4004 21.8298v-1.919h1.2v1.919h-1.2Z",
				fill: "#000"
			},
			children: [
			]
		}
	]
},
	gameday: gameday,
	"gift-2": {
	id: "gift-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 60 60"
	},
	children: [
		{
			id: "gift-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "gift-2",
					name: "",
					type: "text",
					value: "Gift",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "gift-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#757575",
				fillRule: "evenodd",
				d: "M45.825 12.902a6.023 6.023 0 0 0 1.75-4.325A5.825 5.825 0 0 0 41.6 2.502a10.625 10.625 0 0 0-6.15 2.5 19.475 19.475 0 0 0-4.625 5.725 19.475 19.475 0 0 0-4.625-5.6 10.625 10.625 0 0 0-6.15-2.5 5.8 5.8 0 0 0-5.975 6.025 6.025 6.025 0 0 0 1.75 4.25H5v13h3.325v33h45V25.977h3.3V12.902h-10.8Zm-8.9-5 .325-.325a7.5 7.5 0 0 1 4.55-2.175 2.875 2.875 0 0 1 2.775 3.25 2.5 2.5 0 0 1-2.25 2.825h-8.4a20 20 0 0 1 3-3.575Zm-6.1 5.425v.15-.15Zm-11.2-7.925h.225a7.5 7.5 0 0 1 4.525 2.05l.35.45a20.002 20.002 0 0 1 3 3.6h-8.4a2.5 2.5 0 0 1-2.25-2.85 2.925 2.925 0 0 1 2.55-3.25Zm4.7 50.575h-13.05v-30h13.05v30Zm0-33.075H8v-6.925h16.325v6.925Zm10 33h-7v-30h7v30Zm0-33h-7v-6.925h7v6.925Zm16.025 33H37.325v-30H50.35v30Zm3.3-33H37.325v-6.925H53.65v6.925Z",
				clipRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	gift: gift,
	globe: globe,
	gavel: gavel,
	grid: grid,
	filter: filter,
	glove: glove,
	"hearing-loop-location": {
	id: "hearing-loop-location",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 96.166 96.167"
	},
	children: [
		{
			id: "hearing-loop-location",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "hearing-loop-location",
					name: "",
					type: "text",
					value: "Hearing Loop Location icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "hearing-loop-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M60.92 40.664c-1.38 0-2.5-1.12-2.5-2.5 0-4.82-1.68-6.86-6.202-7.527-3.306-.486-5.736.33-7.43 2.503-1.274 1.63-1.655 3.46-1.66 3.477-.25 1.358-1.555 2.255-2.91 2.006-1.358-.25-2.256-1.554-2.006-2.91.757-4.107 4.808-11.49 14.737-10.022 7.046 1.04 10.47 5.12 10.47 12.474 0 1.38-1.12 2.5-2.5 2.5M74.754 26.36L96.166 4.95 91.216 0 70.74 20.476c.944 1.038 3.535 4.917 4.014 5.885",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "hearing-loop-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M53.414 37.802L0 91.216l4.95 4.95 51.783-51.783c-1.74-1.94-3.316-6.465-3.32-6.58",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "hearing-loop-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M70.6 66.052v6.078h6.92v18.953h6.844V72.13h6.89v-6.078"
			},
			children: [
			]
		},
		{
			id: "hearing-loop-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M45.497 81.84c-1.82 0-3.366-.617-4.482-1.262-4.52-2.61-3.737-8.298-3.27-11.697l.043-.305c.187-1.368 1.45-2.323 2.815-2.14 1.368.188 2.325 1.45 2.14 2.816l-.044.313c-.42 3.033-.67 5.826.815 6.684 1.088.628 3.637 2.1 7.793-3.994 1.403-2.057 1.888-3.806 2.45-5.832.825-2.976 1.76-6.35 5.602-10.876 4.855-5.72 6.292-8.267 7.245-10.965 1.76-4.983.998-11.06-1.94-15.484-2.89-4.346-7.66-6.832-13.795-7.188-15.944-.933-17.19 14.757-17.236 15.424-.094 1.378-1.287 2.415-2.665 2.324-1.378-.094-2.418-1.287-2.324-2.664.014-.216.396-5.345 3.298-10.362 2.765-4.78 8.345-10.345 19.216-9.714 9.812.57 15.024 5.434 17.668 9.412 3.78 5.687 4.757 13.504 2.492 19.917-1.328 3.76-3.384 6.922-8.148 12.535-3.13 3.687-3.84 6.256-4.595 8.976-.623 2.25-1.267 4.574-3.138 7.315-3.592 5.265-7.102 6.77-9.943 6.77",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	group: group,
	"half-season-tickets": {
	id: "half-season-tickets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 836 986",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "half-season-tickets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "half-season-tickets",
					name: "",
					type: "text",
					value: "Half-Season Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "half-season-tickets",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "half-season-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M619.9 205.1c23 11.4 49.1 13.1 73.4 4.9 17.7-6 32.9-16.7 44.2-30.9-2.9-6.8-8.1-12.2-14.7-15.5l-52.4-25.9c-15 23.6-37.4 41.2-64.2 50.2-2.7.9-5.4 1.7-8.2 2.4 6.5 5.8 13.8 10.8 21.8 14.8 0-.1.1 0 .1 0zM311.9 827.8s-.1 0-.1-.1c-8.1-4-16.4-6.7-24.8-8.3 1 2.5 2 5 2.9 7.6 9.1 26.8 8.6 55.3-1 81.5l52.4 25.9c6.8 3.4 14.3 4 21.2 2.4 4.4-17.6 3.7-36.2-2.3-53.8-8.2-24.1-25.4-43.8-48.3-55.2zM428.9 53.1c5.1-10.4 13-18.5 22.3-24.1L399.1 3.3c-15.5-7.7-34.3-1.3-42 14.2L3.3 732.4c-3.7 7.5-4.2 15.9-1.5 23.9 2.7 7.9 8.3 14.4 15.7 18L69.4 800c-1.2-10.9.7-22 5.6-32L428.9 53.1z"
					},
					children: [
					]
				},
				{
					id: "half-season-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M832.7 253c3.7-7.5 4.2-15.9 1.6-23.9-2.7-7.9-8.3-14.4-15.7-18l-51.9-25.7-.5-.2c-4.1 6.5-8.8 12.5-14 18-7 7.5-14.9 14-23.6 19.5-8.3 5.2-17.2 9.5-26.7 12.7-31.1 10.5-64.4 8.3-93.8-6.3 0 0-.1 0-.1-.1-16.8-8.4-31.2-20.2-42.4-34.6-3.4-4.4-6.6-9-9.4-13.9-2.7-4.6-5-9.5-7.1-14.5-1-2.5-2-5.1-2.9-7.7-9.1-26.8-8.6-55.3 1-81.5l-52.4-25.9c-6.8-3.4-14.3-4-21.2-2.4-5.7 1.4-11 4.4-15.2 8.7-2.2 2.3-4.1 4.9-5.5 7.9l-8.3 16.8L107.4 763 99 779.9c-1.4 2.9-2.4 5.9-2.9 9-.8 4.9-.3 10 1.3 14.9.3.9.6 1.7 1 2.5 2.9 6.8 8.1 12.2 14.7 15.5l52.4 25.9c17-26.7 43.3-45 72.4-52.6 5.2-1.4 10.5-2.4 15.8-3.1 5.5-.7 11.1-1 16.7-1 17.9.2 36 4.2 53.1 12.7 0 0 .1 0 .1.1 29.3 14.6 51.3 39.7 61.8 70.7 3.2 9.5 5.2 19.2 6 28.9.9 10.2.5 20.4-1.2 30.4-1.3 7.5-3.2 14.9-5.8 22.1l.4.2 52.1 25.8c15.5 7.7 34.3 1.3 42-14.2L832.7 253zm-374.8-4.3c-5 10.2-17.5 14.4-27.7 9.3l-21.1-10.4c-10.2-5-14.4-17.5-9.3-27.7l.8-1.5c5-10.2 17.5-14.4 27.7-9.3l21.1 10.4c10.2 5 14.4 17.5 9.3 27.7l-.8 1.5zm67 56.2l-21.1-10.4c-10.2-5-14.4-17.5-9.3-27.7l.8-1.5c5-10.2 17.5-14.4 27.7-9.3l21.1 10.4c10.2 5 14.4 17.5 9.3 27.7l-.8 1.5c-5 10.2-17.5 14.4-27.7 9.3zm94.8 46.9l-21.1-10.4c-10.2-5-14.4-17.5-9.3-27.7l.8-1.5c5-10.2 17.5-14.4 27.7-9.3l21.1 10.4c10.2 5 14.4 17.5 9.3 27.7l-.8 1.5c-5.1 10.2-17.5 14.4-27.7 9.3zm94.7 46.9l-21.1-10.4c-10.2-5-14.4-17.5-9.3-27.7l.8-1.5c5-10.2 17.5-14.4 27.7-9.3l21.1 10.4c10.2 5 14.4 17.5 9.3 27.7l-.8 1.5c-5 10.1-17.5 14.4-27.7 9.3z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"help-fv": {
	id: "help-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "help-fv",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "help-fv",
					name: "",
					type: "text",
					value: "Field Vision Help icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "help-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M17.5 23.5c0 2-3 2-3 0s3-2 3 0zM15.523 7.031C13.097 7.285 11 9.326 11 12a1 1 0 0 0 2 0c-.03-2.177 2.213-3.647 4.197-2.75 2.009.84 2.462 3.484.848 4.945C16.859 15.3 15 16.734 15 19a1 1 0 0 0 2 0c0-1.048 1.168-2.187 2.408-3.342 2.608-2.43 1.855-6.82-1.414-8.242a4.885 4.885 0 0 0-2.47-.385zM16 0C7.172 0 0 7.172 0 16s7.172 16 16 16 16-7.172 16-16S24.828 0 16 0zm0 1.5c8.017 0 14.5 6.483 14.5 14.5S24.017 30.5 16 30.5 1.5 24.017 1.5 16 7.983 1.5 16 1.5z",
				fill: "#000"
			},
			children: [
			]
		}
	]
},
	highlight: highlight,
	"home-plate-2": {
	id: "home-plate-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "home-plate-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "home-plate-2",
					name: "",
					type: "text",
					value: "Home plate icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "home-plate-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m2.45 8.488.01 5.488 4.799 3.509c3.625 2.651 4.813 3.5 4.86 3.473.033-.019 2.167-1.598 4.741-3.508l4.68-3.473.01-5.489L21.56 3H2.44l.01 5.488m17.309.442-.001 4.13-3.827 2.837c-2.105 1.56-3.847 2.836-3.871 2.836-.025 0-1.793-1.276-3.93-2.836L4.244 13.06l-.002-4.13L4.24 4.8h15.52l-.001 4.13"
			},
			children: [
			]
		}
	]
},
	"high-bandwidth": {
	id: "high-bandwidth",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "high-bandwidth",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "high-bandwidth",
					name: "",
					type: "text",
					value: "High Bandwidth icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "high-bandwidth",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21 422.5H0V507h85.1v-84.5H64M127.7 317h-21v190h85.1V317h-21.1M277.4 211.5h-64.1V507h85.1V211.5M341 105.8h-21V507h85.1V105.8h-21M491 0h-64.1v507H512V0"
			},
			children: [
			]
		}
	]
},
	"guest-services": {
	id: "guest-services",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 85.378 103.229"
	},
	children: [
		{
			id: "guest-services",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "guest-services",
					name: "",
					type: "text",
					value: "Guest Services icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "guest-services",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M42.69 90.615c-21.506 0-39-17.495-39-39s17.494-39 39-39 39 17.495 39 39-17.496 39-39 39zm0-70c-17.094 0-31 13.907-31 31s13.906 31 31 31 31-13.907 31-31-13.908-31-31-31z",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "guest-services",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M34.06 33.764c2.125-1.368 4.736-2.052 7.833-2.052 4.07 0 7.45.972 10.14 2.917 2.693 1.943 4.038 4.824 4.038 8.64 0 2.342-.584 4.313-1.754 5.915-.684.972-1.998 2.215-3.943 3.727l-1.917 1.485c-1.044.81-1.737 1.755-2.08 2.836-.215.684-.332 1.746-.35 3.187h-7.292c.108-3.043.396-5.145.864-6.306.468-1.16 1.674-2.498 3.62-4.01l1.97-1.54c.648-.485 1.17-1.016 1.566-1.592.72-.99 1.08-2.08 1.08-3.268 0-1.368-.4-2.615-1.202-3.74-.8-1.125-2.264-1.688-4.39-1.688-2.087 0-3.568.693-4.442 2.08-.873 1.385-1.31 2.826-1.31 4.32h-7.805c.218-5.133 2.01-8.77 5.376-10.912zm4.484 30.355h8.048v7.804h-8.048V64.12z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"home-plate": {
	id: "home-plate",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.651 505"
	},
	children: [
		{
			id: "home-plate",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "home-plate",
					name: "",
					type: "text",
					value: "Home plate icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "home-plate",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M460.86 201.806c-.022-5.933-.047-11.867-.056-17.8-.04-33.525-.067-67.05-.093-100.574l-.03-42.17H50.843v.016c-.063.75-.108 1.277-.108 1.802l.01 13.504c.04 60.153.084 122.357.242 183.53.002 1.19.7 3.18 1.98 4.522 14.58 15.24 27.97 29.07 40.937 42.275l5.014 5.107c39.225 39.94 79.785 81.24 119.802 121.717 7.44 7.528 14.93 14.625 22.86 22.14l.193.18c3.3 3.127 6.622 6.276 9.954 9.47.29-.26.62-.56.94-.867l32.367-31.297c28.918-27.957 58.823-56.868 88.205-85.333 33.43-32.385 60.537-58.774 85.31-83.046 1.274-1.25 2.287-3.73 2.303-5.646.103-12.646.05-25.868.004-37.532l.003.004z"
			},
			children: [
			]
		},
		{
			id: "home-plate",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M511.583 201.978c-.028-7.16-.056-14.32-.067-21.482-.05-40.5-.08-80.998-.113-121.497l-.04-52.324c0-3.687-2.987-6.675-6.674-6.675H6.91C3.397 0 .486 2.72.25 6.224.217 6.69.18 7.11.15 7.5.07 8.422 0 9.29 0 10.264l.01 15.72c.05 72.865.1 148.213.294 222.322.01 3.76 1.827 8.085 4.63 11.016 17.653 18.456 33.854 35.19 49.53 51.15l4.75 4.838c47.815 48.687 97.254 99.033 146.052 148.39 9.05 9.157 18.162 17.79 27.808 26.93 4.355 4.127 8.74 8.283 13.14 12.51 1.292 1.237 2.958 1.86 4.626 1.86 1.602 0 3.207-.574 4.48-1.727l.257-.227c.493-.434 1.282-1.127 2.04-1.858l39.104-37.81c34.94-33.777 71.068-68.704 106.565-103.092 40.44-39.175 73.196-71.064 103.093-100.356 3.076-3.015 5.168-8.04 5.204-12.51.12-15.16.06-30.555.002-45.44v-.002zm-37.376 37.47c-.044 5.442-2.523 11.355-6.308 15.068-24.794 24.29-51.922 50.697-85.368 83.1-29.387 28.468-59.293 57.382-88.216 85.34l-32.37 31.3c-.718.693-1.46 1.35-1.924 1.755l-.19.17c-2.19 1.984-5.1 3.104-8.13 3.104-3.168 0-6.17-1.207-8.454-3.4-3.567-3.428-7.122-6.795-10.653-10.143l-.192-.18c-8.01-7.59-15.578-14.762-23.174-22.444-40.036-40.492-80.602-81.803-119.836-121.75l-5.013-5.106c-13.012-13.242-26.44-27.112-41.062-42.398-3.493-3.656-5.672-8.91-5.685-13.717-.156-61.183-.2-123.393-.24-183.552l-.008-13.506c0-1.086.078-2.018.145-2.84.03-.357.056-.644.078-.958.43-6.382 5.777-11.38 12.17-11.38H461.83c6.727 0 12.2 5.474 12.2 12.2l.033 43.308c.024 33.524.05 67.047.093 100.57.008 5.92.03 11.843.056 17.763.047 11.705.1 24.97-.003 37.696h-.003z"
			},
			children: [
			]
		}
	]
},
	home: home,
	hotel: hotel,
	"arrow-down": {
	id: "arrow-down",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 470 279",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "arrow-down",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "arrow-down",
					name: "",
					type: "text",
					value: "arrow-down",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "arrow-down",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(-565 -1714)",
				fill: "#010201",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "arrow-down",
					name: "title",
					type: "element",
					value: "",
					attributes: {
					},
					children: [
						{
							id: "arrow-down",
							name: "",
							type: "text",
							value: "Arrow Down icon",
							attributes: {
							},
							children: [
							]
						}
					]
				},
				{
					id: "arrow-down",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M830.405 1979.198c-17.18 17.996-45.007 17.996-62.218 0L577.72 1779.252c-17.21-18.027-24.81-65.252 29.57-65.252h384.07c56.216 0 46.782 47.194 29.572 65.252l-190.527 199.946z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"icon-box": {
	id: "icon-box",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-box",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-box",
					name: "",
					type: "text",
					value: "icon-scores-Test",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-box",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-scores-Test",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-box",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25,7 C25.5522847,7 26,7.44771525 26,8 L26,25 C26,25.5522847 25.5522847,26 25,26 L1,26 C0.44771525,26 0,25.5522847 0,25 L0,8 C0,7.44771525 0.44771525,7 1,7 L25,7 Z M8,17.199 L1.199,17.199 L1.2,24.8 L8,24.799 L8,17.199 Z M17,17.199 L9.2,17.199 L9.2,24.799 L17,24.799 L17,17.199 Z M24.8,17.199 L18.2,17.199 L18.2,24.799 L24.8,24.8 L24.8,17.199 Z M8,8.199 L1.2,8.2 L1.199,15.999 L8,15.999 L8,8.199 Z M17,8.199 L9.2,8.199 L9.2,15.999 L17,15.999 L17,8.199 Z M24.8,8.2 L18.2,8.199 L18.2,15.999 L24.8,15.999 L24.8,8.2 Z M4.776,-0.002 C5.538,-0.002 6.06,0.49 6.06,1.228 C6.06,1.89657143 5.64094898,2.27542857 5.17275,2.37898324 L5.064,2.398 L6.09,4 L5.394,4 L4.44,2.458 L3.69,2.458 L3.69,4 L3.09,4 L3.09,-0.002 L4.776,-0.002 Z M11.893,-0.002 L11.893,1.678 L14.107,1.678 L14.107,-0.002 L14.707,-0.002 L14.707,4 L14.107,4 L14.107,2.212 L11.893,2.212 L11.893,4 L11.293,4 L11.293,-0.002 L11.893,-0.002 Z M22.913,-0.002 L22.913,0.526 L20.825,0.526 L20.825,1.696 L22.871,1.696 L22.871,2.224 L20.825,2.224 L20.825,3.472 L22.913,3.472 L22.913,4 L20.225,4 L20.225,-0.002 L22.913,-0.002 Z M4.698,0.526 L3.69,0.526 L3.69,1.93 L4.698,1.93 C5.13,1.93 5.442,1.648 5.442,1.228 C5.442,0.843 5.17983333,0.573958333 4.80338889,0.531791667 L4.698,0.526 Z",
						id: "Shape",
						fillRule: "nonzero"
					},
					children: [
					]
				}
			]
		}
	]
},
	"icon-gamestory-hollow": {
	id: "icon-gamestory-hollow",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "icon-gamestory-hollow",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-gamestory-hollow",
					name: "",
					type: "text",
					value: "Icon Gamestory Hollow",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-gamestory-hollow",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.585 18.462V5.538a.738.738 0 0 0-1.477 0v12.924a.738.738 0 0 0 1.477 0Zm-.739-14.77C.826 3.692 0 4.52 0 5.538v12.924a1.846 1.846 0 0 0 3.692 0V5.538c0-1.02-.826-1.846-1.846-1.846ZM22.892 18.462V5.538a.739.739 0 0 0-1.477 0v12.924a.738.738 0 0 0 1.477 0Zm-.738-14.77c-1.02 0-1.846.827-1.846 1.846v12.924a1.846 1.846 0 0 0 3.692 0V5.538c0-1.02-.826-1.846-1.846-1.846ZM6.725 1.846c-.613 0-1.187.536-1.187 1.292v17.724c0 .756.574 1.292 1.187 1.292h10.55c.613 0 1.187-.536 1.187-1.292V3.138c0-.756-.574-1.292-1.187-1.292H6.725Zm3.973 7.446a.185.185 0 0 0-.28.158v5.1c0 .144.157.232.28.158l4.206-2.55a.185.185 0 0 0 0-.316l-4.206-2.55Zm4.685 3.655-4.207 2.55a1.108 1.108 0 0 1-1.682-.947v-5.1c0-.863.944-1.395 1.682-.947l4.207 2.55a1.108 1.108 0 0 1 0 1.894ZM4.615 3.138c0-1.223.945-2.215 2.11-2.215h10.55c1.165 0 2.11.992 2.11 2.215v17.724c0 1.223-.945 2.215-2.11 2.215H6.725c-1.165 0-2.11-.992-2.11-2.215V3.138Z"
			},
			children: [
			]
		}
	]
},
	"icon-menu": {
	id: "icon-menu",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 32 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "icon-menu",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.61017 16.0725C7.61017 14.8543 6.62234 13.8666 5.40484 13.8666C4.18797 13.8666 3.20004 14.8542 3.20004 16.0725C3.20004 17.2901 4.18732 18.2773 5.40484 18.2773C6.62299 18.2773 7.61017 17.29 7.61017 16.0725ZM9.21017 16.0725C9.21017 13.9709 7.50625 12.2666 5.40484 12.2666C3.30386 12.2666 1.60004 13.971 1.60004 16.0725C1.60004 18.1738 3.30371 19.8773 5.40484 19.8773C7.5064 19.8773 9.21017 18.1739 9.21017 16.0725Z"
			},
			children: [
			]
		},
		{
			id: "icon-menu",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.1456 16.0725C18.1456 14.8539 17.1579 13.8666 15.9413 13.8666C14.7235 13.8666 13.7355 14.8546 13.7355 16.0725C13.7355 17.2896 14.7228 18.2773 15.9413 18.2773C17.1585 18.2773 18.1456 17.2904 18.1456 16.0725ZM19.7456 16.0725C19.7456 13.9709 18.0422 12.2666 15.9413 12.2666C13.8398 12.2666 12.1355 13.971 12.1355 16.0725C12.1355 18.1738 13.8397 19.8773 15.9413 19.8773C18.0424 19.8773 19.7456 18.1738 19.7456 16.0725Z"
			},
			children: [
			]
		},
		{
			id: "icon-menu",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M28.6815 16.0725C28.6815 14.8542 27.6936 13.8666 26.4767 13.8666C25.2592 13.8666 24.2714 14.8543 24.2714 16.0725C24.2714 17.29 25.2586 18.2773 26.4767 18.2773C27.6942 18.2773 28.6815 17.2901 28.6815 16.0725ZM30.2815 16.0725C30.2815 13.971 28.5777 12.2666 26.4767 12.2666C24.3753 12.2666 22.6714 13.9709 22.6714 16.0725C22.6714 18.1739 24.3752 19.8773 26.4767 19.8773C28.5778 19.8773 30.2815 18.1738 30.2815 16.0725Z"
			},
			children: [
			]
		}
	]
},
	"icon-gamestory": {
	id: "icon-gamestory",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "icon-gamestory",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-gamestory",
					name: "",
					type: "text",
					value: "Icon Gamestory",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-gamestory",
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				y: "3.692",
				width: "2.769",
				height: "16.615",
				rx: "1.385"
			},
			children: [
			]
		},
		{
			id: "icon-gamestory",
			name: "rect",
			type: "element",
			value: "",
			attributes: {
				x: "21.231",
				y: "3.692",
				width: "2.769",
				height: "16.615",
				rx: "1.385"
			},
			children: [
			]
		},
		{
			id: "icon-gamestory",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.725.923c-1.165 0-2.11.992-2.11 2.215v17.724c0 1.223.945 2.215 2.11 2.215h10.55c1.165 0 2.11-.992 2.11-2.215V3.138c0-1.223-.945-2.215-2.11-2.215H6.725Zm3.693 13.955L15.165 12l-4.747-2.878v5.756Z"
			},
			children: [
			]
		}
	]
},
	"icon-gameday-2": {
	id: "icon-gameday-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-gameday-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-gameday-2",
					name: "",
					type: "text",
					value: "icon-gameday",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-gameday-2",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "Master",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-gameday-2",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "Icon-List",
						transform: "translate(-423.000000, -155.000000)",
						fillRule: "nonzero"
					},
					children: [
						{
							id: "icon-gameday-2",
							name: "g",
							type: "element",
							value: "",
							attributes: {
								id: "Group",
								transform: "translate(73.000000, 44.000000)"
							},
							children: [
								{
									id: "icon-gameday-2",
									name: "g",
									type: "element",
									value: "",
									attributes: {
										transform: "translate(350.000000, 111.000000)",
										id: "icon-gameday"
									},
									children: [
										{
											id: "icon-gameday-2",
											name: "path",
											type: "element",
											value: "",
											attributes: {
												d: "M13,0.4 C19.9587878,0.4 25.6,6.04121215 25.6,13 L25.6,13 L25.6,13.2431824 L12.9924128,26.2414774 L0.4,13.2429693 L0.4,13 C0.4,6.04121215 6.04121215,0.4 13,0.4 Z M12.982,12.856 L7.299,18.641 L12.992,24.516 L18.669,18.664 L12.982,12.856 Z M13,1.6 C6.90070529,1.6 1.92016127,6.38994107 1.61483361,12.4133575 L1.61483361,12.4133575 L1.602,12.76 L6.465,17.779 L12.9837655,11.1431015 L19.505,17.803 L24.397,12.76 L24.3851664,12.4133575 C24.0847634,6.48709294 19.2587412,1.75483511 13.2942391,1.60372332 L13.2942391,1.60372332 Z",
												id: "Combined-Shape"
											},
											children: [
											]
										}
									]
								}
							]
						}
					]
				}
			]
		}
	]
},
	"icon-preview": {
	id: "icon-preview",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-preview",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-preview",
					name: "",
					type: "text",
					value: "icon-preview",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-preview",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-preview",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-preview",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						transform: "translate(0.000000, 1.000000)",
						fillRule: "nonzero"
					},
					children: [
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M24.14,2.4 C24.4713708,2.4 24.74,2.66862915 24.74,3 C24.74,3.29823376 24.5224104,3.54564675 24.2373231,3.59214701 L24.14,3.6 L7.86,3.6 C7.52862915,3.6 7.26,3.33137085 7.26,3 C7.26,2.70176624 7.47758961,2.45435325 7.76267688,2.40785299 L7.86,2.4 L24.14,2.4 Z",
								id: "Line-3"
							},
							children: [
							]
						},
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M24.14,20.4 C24.4713708,20.4 24.74,20.6686292 24.74,21 C24.74,21.2982338 24.5224104,21.5456468 24.2373231,21.592147 L24.14,21.6 L7.86,21.6 C7.52862915,21.6 7.26,21.3313708 7.26,21 C7.26,20.7017662 7.47758961,20.4543532 7.76267688,20.407853 L7.86,20.4 L24.14,20.4 Z",
								id: "Line-3-Copy"
							},
							children: [
							]
						},
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M24.14,11.4 C24.4713708,11.4 24.74,11.6686292 24.74,12 C24.74,12.2982338 24.5224104,12.5456468 24.2373231,12.592147 L24.14,12.6 L7.86,12.6 C7.52862915,12.6 7.26,12.3313708 7.26,12 C7.26,11.7017662 7.47758961,11.4543532 7.76267688,11.407853 L7.86,11.4 L24.14,11.4 Z",
								id: "Line-3-Copy-6"
							},
							children: [
							]
						},
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M3,18.4 C1.56405965,18.4 0.4,19.5640597 0.4,21 C0.4,22.4359403 1.56405965,23.6 3,23.6 C4.43594035,23.6 5.6,22.4359403 5.6,21 C5.6,19.5640597 4.43594035,18.4 3,18.4 Z M3,19.6 C3.77319865,19.6 4.4,20.2268014 4.4,21 C4.4,21.7731986 3.77319865,22.4 3,22.4 C2.22680135,22.4 1.6,21.7731986 1.6,21 C1.6,20.2268014 2.22680135,19.6 3,19.6 Z",
								id: "Oval"
							},
							children: [
							]
						},
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M3,9.4 C1.56405965,9.4 0.4,10.5640597 0.4,12 C0.4,13.4359403 1.56405965,14.6 3,14.6 C4.43594035,14.6 5.6,13.4359403 5.6,12 C5.6,10.5640597 4.43594035,9.4 3,9.4 Z M3,10.6 C3.77319865,10.6 4.4,11.2268014 4.4,12 C4.4,12.7731986 3.77319865,13.4 3,13.4 C2.22680135,13.4 1.6,12.7731986 1.6,12 C1.6,11.2268014 2.22680135,10.6 3,10.6 Z",
								id: "Oval-Copy-2"
							},
							children: [
							]
						},
						{
							id: "icon-preview",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M3,0.4 C1.56405965,0.4 0.4,1.56405965 0.4,3 C0.4,4.43594035 1.56405965,5.6 3,5.6 C4.43594035,5.6 5.6,4.43594035 5.6,3 C5.6,1.56405965 4.43594035,0.4 3,0.4 Z M3,1.6 C3.77319865,1.6 4.4,2.22680135 4.4,3 C4.4,3.77319865 3.77319865,4.4 3,4.4 C2.22680135,4.4 1.6,3.77319865 1.6,3 C1.6,2.22680135 2.22680135,1.6 3,1.6 Z",
								id: "Oval-Copy"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
},
	"icon-highlight": {
	id: "icon-highlight",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-highlight",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-highlight",
					name: "",
					type: "text",
					value: "icon-highlights",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-highlight",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-highlights-copy-2",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-highlight",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M17,2.5 C17.5522847,2.5 18,2.94771525 18,3.5 L18,19.5 C18,20.0522847 17.5522847,20.5 17,20.5 L1,20.5 C0.44771525,20.5 0,20.0522847 0,19.5 L0,3.5 C0,2.94771525 0.44771525,2.5 1,2.5 L17,2.5 Z M12,22.5 C12.2761424,22.5 12.5,22.7238576 12.5,23 L12.5,23.2 C12.5,23.4761424 12.2761424,23.7 12,23.7 L5,23.7 C4.72385763,23.7 4.5,23.4761424 4.5,23.2 L4.5,23 C4.5,22.7238576 4.72385763,22.5 5,22.5 L12,22.5 Z M25.1039537,5.97 L25.115,6.001 L25.1973231,6.00785299 C25.4824104,6.05435325 25.7,6.30176624 25.7,6.6 L25.7,16.4 C25.7,16.7313708 25.4313708,17 25.1,17 L25.017,16.993 L25.011942,17.009752 L19.8436326,15.1286412 C19.5841436,15.034195 19.4503501,14.7472738 19.5447963,14.4877848 L19.6132004,14.2998463 C19.7076466,14.0403574 19.9945678,13.9065638 20.2540567,14.0010101 L24.5,15.546 L24.5,7.466 L20.3460685,8.97874193 C20.0865795,9.07318819 19.7996583,8.93939465 19.7052121,8.67990569 L19.6368081,8.49196717 C19.5423618,8.23247822 19.6761553,7.94555704 19.9356443,7.85111079 L24.8056509,6.07704125 C24.8624513,6.04500222 24.9249944,6.02194944 24.9913508,6.00981228 L25.1039537,5.97 Z M6.61803399,8.23584892 C6.77327908,8.23584892 6.92639215,8.27199401 7.06524758,8.34142173 L11.8291796,10.7233877 C12.3231581,10.970377 12.5233825,11.57105 12.2763932,12.0650285 C12.1796295,12.2585559 12.022707,12.4154784 11.8291796,12.5122421 L7.06524758,14.8942081 C6.57126909,15.1411974 5.97059605,14.940973 5.7236068,14.4469945 C5.65417908,14.3081391 5.61803399,14.155026 5.61803399,13.9997809 L5.61803399,9.23584892 C5.61803399,8.68356417 6.06574924,8.23584892 6.61803399,8.23584892 Z M6.81803399,9.55881493 L6.81803399,13.6758149 L10.936034,11.6178149 L6.81803399,9.55881493 Z M16.8,3.7 L1.2,3.7 L1.2,19.3 L16.8,19.3 L16.8,3.7 Z",
						id: "Shape",
						fillRule: "nonzero"
					},
					children: [
					]
				}
			]
		}
	]
},
	"icon-ticket": {
	id: "icon-ticket",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-ticket",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-ticket",
					name: "",
					type: "text",
					value: "icon-ticket",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-ticket",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-ticket",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-ticket",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M4.06053046,0 L10.0038778,0.0125816321 C10.001303,0.062690007 10,0.113128172 10,0.163865546 C10,1.79287351 11.3431458,3.11344538 13,3.11344538 C14.6568542,3.11344538 16,1.79287351 16,0.163865546 L15.995,0.025 L22,0.0380591953 L21.9394695,26 L15.9997525,25.9878599 L16,25.9495798 C16,24.3205719 14.6568542,23 13,23 C11.3431458,23 10,24.3205719 10,25.9495798 L10.001,25.975 L4,25.9628691 L4.06053046,0 Z M5.257,1.202 L5.202,24.765 L8.971,24.773 L8.97818987,24.7494484 C9.48033074,23.1038861 10.9883494,21.8925383 12.7907632,21.8050661 L13,21.8 C14.8941612,21.8 16.5003561,23.0405952 17.0218101,24.7494484 L17.032,24.789 L20.742,24.797 L20.797,1.235 L17.06,1.226 L17.0218101,1.36399698 C16.5196693,3.0095593 15.0116506,4.22090711 13.2092368,4.30837929 L13,4.31344538 C11.1058388,4.31344538 9.49964385,3.07285016 8.97818987,1.36399698 L8.935,1.21 L5.257,1.202 Z M10.65,7.35 L10.65,8.65 L7.35,8.65 L7.35,7.35 L10.65,7.35 Z M14.65,7.35 L14.65,8.65 L11.35,8.65 L11.35,7.35 L14.65,7.35 Z M18.65,7.35 L18.65,8.65 L15.35,8.65 L15.35,7.35 L18.65,7.35 Z",
						id: "Shape",
						fillRule: "nonzero"
					},
					children: [
					]
				}
			]
		}
	]
},
	info: info,
	"info-fv": {
	id: "info-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 22 22",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "info-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12 9V16H10V9H12Z"
			},
			children: [
			]
		},
		{
			id: "info-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11 8C11.5522 8 12 7.55228 12 7C12 6.44772 11.5522 6 11 6C10.4478 6 10 6.44772 10 7C10 7.55228 10.4478 8 11 8Z"
			},
			children: [
			]
		},
		{
			id: "info-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22 11C22 17.0751 17.0751 22 11 22C4.92493 22 0 17.0751 0 11C0 4.92487 4.92493 0 11 0C17.0751 0 22 4.92487 22 11ZM1.71472 11C1.71472 16.1281 5.87195 20.2852 11 20.2852C16.1281 20.2852 20.2853 16.1281 20.2853 11C20.2853 5.87192 16.1281 1.71478 11 1.71478C5.87195 1.71478 1.71472 5.87192 1.71472 11Z"
			},
			children: [
			]
		}
	]
},
	info2: info2,
	"icon-wrap": {
	id: "icon-wrap",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-wrap",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-wrap",
					name: "",
					type: "text",
					value: "icon-wrap",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-wrap",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-wrap",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-wrap",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						fillRule: "nonzero"
					},
					children: [
						{
							id: "icon-wrap",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M18.4668316,0.4 C18.7650654,0.4 19.0124784,0.617589612 19.0589786,0.902676883 L19.0668316,1 L19.0667172,19.7535505 C19.1218133,22.5744288 20.0208213,23.8328613 21.801301,23.8328613 C23.5186718,23.8328613 24.3886422,22.6615687 24.4445649,20.0419625 L24.4474449,19.7751639 L24.25,7.849 L21.801301,7.85 C21.5030673,7.85 21.2556543,7.63241039 21.209154,7.34732312 L21.201301,7.25 C21.201301,6.95176624 21.4188907,6.70435325 21.7039779,6.65785299 L21.801301,6.65 L24.8409019,6.65 C25.1356631,6.65 25.3814123,6.86273476 25.4315527,7.14400573 L25.4408203,7.24010329 L25.6473632,19.7656217 C25.6455182,22.8879629 24.5578263,24.7119563 22.4125702,24.9942723 L22.374,24.998 C22.3381365,25.0112545 22.3073385,25.019081 22.2756927,25.0244319 L22.1784169,25.0328512 L16.2537771,25.0610226 L11.3721311,25.0700559 L7.24093937,25.0563692 L5.28964435,25.0327618 C2.32804819,24.9788066 0.666062767,23.3745702 0.461338588,20.3779364 L0.447363281,20.1176758 L0.447363281,1 C0.447363281,0.701766235 0.664952893,0.454353247 0.950040165,0.407852987 L1.04736328,0.4 L18.4668316,0.4 Z M17.866,1.599 L1.64689363,1.599 L1.64689363,20.0939406 C1.74321591,22.5269609 2.83662054,23.7116301 5.08301421,23.8251707 L5.54784896,23.8370233 L7.25586396,23.8564551 L10.3061871,23.8691812 L14.1343005,23.8670692 L19.04,23.849 L18.9621573,23.7546749 C18.3064463,22.9137153 17.9428356,21.6690229 17.8756163,20.0540915 L17.8668316,19.7652672 L17.866,1.599 Z",
								id: "Line-4-Copy-3"
							},
							children: [
							]
						},
						{
							id: "icon-wrap",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M14,5.4 C14.3313708,5.4 14.6,5.66862915 14.6,6 C14.6,6.29823376 14.3824104,6.54564675 14.0973231,6.59214701 L14,6.6 L5,6.6 C4.66862915,6.6 4.4,6.33137085 4.4,6 C4.4,5.70176624 4.61758961,5.45435325 4.90267688,5.40785299 L5,5.4 L14,5.4 Z",
								id: "Line-4"
							},
							children: [
							]
						},
						{
							id: "icon-wrap",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M14,11.4 C14.3313708,11.4 14.6,11.6686292 14.6,12 C14.6,12.2982338 14.3824104,12.5456468 14.0973231,12.592147 L14,12.6 L5,12.6 C4.66862915,12.6 4.4,12.3313708 4.4,12 C4.4,11.7017662 4.61758961,11.4543532 4.90267688,11.407853 L5,11.4 L14,11.4 Z",
								id: "Line-4-Copy"
							},
							children: [
							]
						},
						{
							id: "icon-wrap",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M14,17.4 C14.3313708,17.4 14.6,17.6686292 14.6,18 C14.6,18.2982338 14.3824104,18.5456468 14.0973231,18.592147 L14,18.6 L5,18.6 C4.66862915,18.6 4.4,18.3313708 4.4,18 C4.4,17.7017662 4.61758961,17.4543532 4.90267688,17.407853 L5,17.4 L14,17.4 Z",
								id: "Line-4-Copy-2"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
},
	"icon-youtube": {
	id: "icon-youtube",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "icon-youtube",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-youtube",
					name: "",
					type: "text",
					value: "YouTube icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-youtube",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M662.9 398.8s-5-35.3-20.4-50.8c-19.5-20.4-41.3-20.7-51.3-21.9-71.6-5.2-179.1-5.4-179.1-5.4h-.2s-107.5.2-179.1 5.4c-10 1.2-31.8 1.4-51.3 21.8-15.4 15.5-20.3 50.9-20.3 50.9s-5.2 41.5-5.2 82.9v38.8c0 41.4 5.1 82.9 5.1 82.9s5 35.3 20.3 50.8c19.5 20.4 45.1 19.7 56.5 21.9 41 3.9 174.1 5.1 174.1 5.1s107.6-.2 179.2-5.3c10-1.2 31.8-1.3 51.3-21.7 15.4-15.5 20.4-50.8 20.4-50.8s5.1-41.4 5.1-82.9v-38.8c0-41.4-5.1-82.9-5.1-82.9zm-303.8 169v-144L497.4 496l-138.3 71.8z"
			},
			children: [
			]
		}
	]
},
	kebab: kebab,
	instagram: instagram,
	"icon-tv": {
	id: "icon-tv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 26 26",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "icon-tv",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "icon-tv",
					name: "",
					type: "text",
					value: "icon-TV",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "icon-tv",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "icon-TV",
				stroke: "none",
				strokeWidth: "1",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "icon-tv",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "tv",
						transform: "translate(0.000000, 3.000000)",
						fillRule: "nonzero"
					},
					children: [
						{
							id: "icon-tv",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M25,0 C25.5128358,0 25.9355072,0.38604019 25.9932723,0.883378875 L26,1 L26,15 C26,15.5128358 25.6139598,15.9355072 25.1166211,15.9932723 L25,16 L1,16 C0.487164161,16 0.0644928393,15.6139598 0.00672773133,15.1166211 L0,15 L0,1 C0,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 L25,0 Z M24.8,1.2 L1.2,1.2 L1.2,14.8 L24.8,14.8 L24.8,1.2 Z",
								id: "Stroke-1"
							},
							children: [
							]
						},
						{
							id: "icon-tv",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M18,18 C18.2761424,18 18.5,18.2238576 18.5,18.5 C18.5,18.7454599 18.3231248,18.9496084 18.0898756,18.9919443 L18,19 L8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 C7.5,18.2545401 7.67687516,18.0503916 7.91012437,18.0080557 L8,18 L18,18 Z",
								id: "Stroke-3"
							},
							children: [
							]
						}
					]
				}
			]
		}
	]
},
	"link-circle": {
	id: "link-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		x: "0px",
		y: "0px",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "link-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "link-circle",
					name: "",
					type: "text",
					value: "Link circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "link-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M200,0C89.543,0,0,89.543,0,200s89.543,200,200,200s200-89.543,200-200S310.457,0,200,0z M223.152,256.964c-17.525,17.524-34.985,35.114-52.607,52.541c-9.712,9.605-21.55,14.826-35.185,15.923\tc-0.336,0.027-0.666,0.137-0.999,0.208c-2.308,0-4.615,0-6.923,0c-0.283-0.072-0.562-0.188-0.848-0.21\tc-8.564-0.647-16.606-3.056-23.979-7.446c-14.749-8.78-23.861-21.618-27.23-38.472c-0.458-2.292-0.684-4.63-1.018-6.947\tc0-2.393,0-4.786,0-7.179c0.285-2.066,0.501-4.144,0.868-6.195c2.058-11.505,7.084-21.537,15.331-29.825\tc19.349-19.447,38.68-38.914,58.226-58.161c9.494-9.349,21.2-14.378,34.506-15.317c18.009-1.27,33.24,4.822,45.843,17.71\tc2.28,2.331,4.379,4.677,5.011,7.989c1.015,5.32-0.437,9.867-4.595,13.336c-4.081,3.406-8.786,4.056-13.701,2.114\tc-1.572-0.621-3.032-1.721-4.302-2.87c-2.816-2.547-5.392-5.355-8.713-7.312c-11.629-6.854-26.042-5.249-35.669,4.272\tc-15.311,15.144-30.495,30.418-45.733,45.636c-3.749,3.744-7.531,7.456-11.242,11.238c-14.071,14.34-10.711,37.479,6.809,47.024\tc10.974,5.979,25.055,4.336,34.005-4.377c11.42-11.117,22.611-22.468,33.856-33.764c0.939-0.943,1.599-1.044,2.824-0.513\tc11.453,4.959,23.01,5.087,34.621,0.513c0.351-0.138,0.697-0.289,1.347-0.559C223.364,256.697,223.272,256.844,223.152,256.964z M325.636,134.618c-0.307,2.144-0.548,4.3-0.931,6.431c-2.103,11.697-7.398,21.745-15.783,30.145\tc-18.776,18.81-37.575,37.597-56.376,56.382c-8.964,8.956-19.71,14.555-32.269,16.168c-19.232,2.47-35.696-3.392-49.315-17.236\tc-2.056-2.09-4.062-4.164-4.835-7.1c-1.433-5.439-0.234-10.213,3.959-13.986c4.156-3.74,9.03-4.483,14.193-2.42\tc1.532,0.612,2.904,1.734,4.199,2.805c2.627,2.172,4.936,4.796,7.757,6.657c11.735,7.744,26.753,6.154,36.8-3.757\tc7.817-7.712,15.546-15.513,23.313-23.276c11.061-11.055,22.122-22.111,33.182-33.167c6.256-6.253,9.273-13.784,8.965-22.64\tc-0.462-13.276-10.495-25.1-23.563-27.549c-10.451-1.959-19.544,0.84-27.094,8.346c-11.031,10.965-22.011,21.98-32.989,32.998\tc-0.656,0.659-1.129,0.855-2.056,0.445c-11.767-5.203-23.629-5.401-35.558-0.535c-0.191,0.078-0.388,0.14-0.837,0.3\tc0.26-0.328,0.355-0.476,0.477-0.598c17.554-17.555,35.038-35.179,52.693-52.631c9.648-9.537,21.434-14.686,34.962-15.824\tc0.289-0.024,0.57-0.138,0.854-0.211c2.393,0,4.786,0,7.179,0c0.327,0.074,0.651,0.164,0.981,0.219\tc3.236,0.537,6.568,0.74,9.693,1.653c22.606,6.604,36.454,21.463,41.418,44.514c0.473,2.198,0.662,4.458,0.983,6.69\tC325.636,129.832,325.636,132.225,325.636,134.618z",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	"interpreting-services": {
	id: "interpreting-services",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 98.957 83.82"
	},
	children: [
		{
			id: "interpreting-services",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "interpreting-services",
					name: "",
					type: "text",
					value: "Interpreting Services icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "interpreting-services",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M0 40.257s6.555-.607 8.994-14.116c0 0 1.372-5.615 5.03-9.41 3.66-3.795 1.372-3.795 5.335-8.348C23.32 3.828 27.285-.422 27.742.034c.457.455 2.287 2.732-1.22 6.07 0 0-5.64 6.983-5.945 8.046-.305 1.062 8.232-5.92 10.823-6.83 2.592-.91 10.062-3.643 13.568-1.82 0 0 2.44 4.097-7.317 4.553 0 0-7.62 1.973-13.11 8.348 0 0 7.775-2.883 9.452-3.338 1.677-.455 8.384-.455 9.91 1.062 1.523 1.518 7.62 5.313 5.03 6.83-2.592 1.518-4.727-.337-7.775-2.824 0 0-8.537-2.336-15.396 6.77 0 0 5.755-2.204 8.385-2.124 3.157.096 4.116-1.062 11.28 6.68 0 0 2.896 2.124 1.372 8.803 0 0-2.134 2.276-3.963-1.367-1.83-3.643-.915-4.098-.915-4.098S38.412 33.733 35.363 31c0 0-3.506 2.43-7.774 3.34 0 0-3.482 2.618-2.808 6.62.674 4.004 2.655 3.093 4.942 6.736 0 0 7.302-1.087 9.3-.607 0 0 4.42-8.197 8.078-5.313 0 0-3.05 8.045-3.2 8.804-.153.76-1.373 3.037-11.28 5.162-11.575 2.482-.61 3.34-21.8 2.732 0 0-3.963 1.366-6.402 3.49 0 0-3.354-3.338-4.42-11.08V40.258zM98.957 43.563s-6.555.607-8.994 14.116c0 0-1.372 5.615-5.03 9.41-3.66 3.795-1.372 3.795-5.335 8.348-3.963 4.554-7.927 8.804-8.384 8.348-.457-.455-2.287-2.732 1.22-6.07 0 0 5.64-6.983 5.945-8.046.304-1.062-8.233 5.92-10.824 6.83-2.59.91-10.06 3.643-13.567 1.82 0 0-2.44-4.097 7.316-4.553 0 0 7.622-1.973 13.11-8.348 0 0-7.774 2.883-9.45 3.338-1.678.455-8.385.455-9.91-1.062-1.524-1.518-7.622-5.312-5.03-6.83 2.59-1.518 4.726.337 7.774 2.824 0 0 8.537 2.336 15.396-6.77 0 0-5.754 2.204-8.384 2.124-3.157-.096-4.116 1.062-11.28-6.68 0 0-2.896-2.124-1.372-8.803 0 0 2.134-2.276 3.963 1.367 1.83 3.643.915 4.098.915 4.098s3.506 1.062 6.555 3.795c0 0 3.506-2.43 7.774-3.34 0 0 3.482-2.618 2.81-6.62-.675-4.004-2.657-3.093-4.944-6.736 0 0-7.302 1.087-9.3.607 0 0-4.42 8.197-8.078 5.313 0 0 3.05-8.045 3.2-8.804.153-.76 1.373-3.037 11.28-5.162 11.575-2.482.61-3.34 21.8-2.732 0 0 3.963-1.366 6.402-3.49 0 0 3.354 3.338 4.42 11.08v10.627z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	link: link,
	"list-view": {
	id: "list-view",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "list-view",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "list-view",
					name: "",
					type: "text",
					value: "List View icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "list-view",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M235.8 615.3c0-34.9 28.5-63.1 63.3-63.1h624.3c35 0 63.3 28.3 63.3 63.1v35.8c0 34.9-28.5 63.1-63.3 63.1H299.1c-35 0-63.3-28.3-63.3-63.1v-35.8zM20.1 579.5c0-23.6 19.2-42.8 42.6-42.8h70.9c23.6 0 42.6 19.2 42.6 42.8V687c0 23.6-19.2 42.8-42.6 42.8h-71C39 729.8 20 710.6 20 687V579.5h.1zm215.7 302.1c0-34.9 28.5-63.1 63.3-63.1h624.3c35 0 63.3 28.3 63.3 63.1v35.8c0 34.9-28.5 63.1-63.3 63.1H299.1c-35 0-63.3-28.3-63.3-63.1v-35.8zM20.1 845.7c0-23.6 19.2-42.8 42.6-42.8h70.9c23.6 0 42.6 19.2 42.6 42.8v107.5c0 23.6-19.2 42.8-42.6 42.8h-71C39 996 20 976.8 20 953.2V845.7h.1zM235.8 83.6c0-34.9 28.5-63.1 63.3-63.1h624.3c35 0 63.3 28.3 63.3 63.1v35.8c0 34.9-28.5 63.1-63.3 63.1H299.1c-35 0-63.3-28.3-63.3-63.1V83.6zM20.1 47.8C20.1 24.2 39.2 5 62.6 5h70.9c23.6 0 42.6 19.2 42.6 42.8v107.5c0 23.6-19.2 42.8-42.6 42.8H62.6C39 198.1 20 178.9 20 155.3V47.8h.1zm215.7 301.7c0-34.9 28.5-63.1 63.3-63.1h624.3c35 0 63.3 28.3 63.3 63.1v35.8c0 34.9-28.5 63.1-63.3 63.1H299.1c-35 0-63.3-28.3-63.3-63.1v-35.8zM20.1 313.6c0-23.6 19.2-42.8 42.6-42.8h70.9c23.6 0 42.6 19.2 42.6 42.8v107.5c0 23.6-19.2 42.8-42.6 42.8h-71C39 463.9 20 444.7 20 421.1V313.6h.1z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"local-drink": {
	id: "local-drink",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "local-drink",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "local-drink",
					name: "",
					type: "text",
					value: "Local drink icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "local-drink",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M27 1.556l51.394 466.096c3.078 25.567 24.523 45.237 50.872 45.237h255.667c26.35 0 47.794-19.672 50.872-45.238L487.2 1.556H27zM257.1 436.19c-42.42 0-76.7-34.28-76.7-76.7 0-51.134 76.7-138.06 76.7-138.06s76.7 86.926 76.7 138.06c0 42.42-34.28 76.7-76.7 76.7zm161.853-281.234H95.247L83.977 52.69H429.91l-10.957 102.266z"
			},
			children: [
			]
		}
	]
},
	"line-score": {
	id: "line-score",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 1000 1000"
	},
	children: [
		{
			id: "line-score",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "line-score",
					name: "",
					type: "text",
					value: "Linescore icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "line-score",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.8 357.4h281.8v281.8H1.8zM359.1 357.4h281.8v281.8H359.1zM716.4 357.4h281.8v281.8H716.4zM1.8 688.2h281.8V970H1.8zM359.1 688.2h281.8V970H359.1zM716.4 688.2h281.8V970H716.4zM28.3 258.1V30H114c56.1 0 89.7 20 89.7 70.6 0 36.1-17 55.8-47.5 65l50.9 92.5h-53l-47.5-86h-29v86H28.3zm49.3-124.8h34.2c29 0 42.9-8.3 42.9-31.4 0-22.5-13.9-30.8-42.9-30.8H77.6v62.2zM398.4 258.1V30h50.3v88.5h89.7V30h50.2v228.1h-50.2v-97.4h-89.7v97.4h-50.3zM788.8 258.1V30h155.4v41.9H839.1v49h76.2v39.8h-76.2v56.7h110.7v40.7h-161z"
			},
			children: [
			]
		}
	]
},
	linkedin: linkedin,
	"google-plus": {
	id: "google-plus",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "google-plus",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "google-plus",
					name: "",
					type: "text",
					value: "Google Plus icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "google-plus",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M162.6 232.5v55.8h92.2c-3.7 23.9-27.9 70.2-92.2 70.2-55.5 0-100.8-46-100.8-102.7s45.3-102.7 100.8-102.7c31.6 0 52.7 13.5 64.8 25.1l44.1-42.5c-28.3-26.5-65.1-42.5-109-42.5C72.7 93.1 0 165.8 0 255.7s72.7 162.6 162.6 162.6c93.9 0 156.1-66 156.1-158.9 0-10.7-1.2-18.8-2.6-27H162.6zM464.7 232.5V186h-46.5v46.5h-46.5V279h46.5v46.4h46.5V279h46.4v-46.5z"
			},
			children: [
			]
		}
	]
},
	live: live,
	lock: lock,
	"mobile-compact": {
	id: "mobile-compact",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 16 16",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "mobile-compact",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "mobile-compact",
					name: "",
					type: "text",
					value: "Mobile Compact Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "mobile-compact",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "Favorite-Teams",
				stroke: "none",
				strokeWidth: "1",
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "mobile-compact",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "Scoreboard_Favs_MobileALT",
						transform: "translate(-314.000000, -128.000000)",
						fill: "#0048AB",
						stroke: "#0048AB"
					},
					children: [
						{
							id: "mobile-compact",
							name: "g",
							type: "element",
							value: "",
							attributes: {
								id: "compact_filled",
								transform: "translate(314.000000, 128.000000)"
							},
							children: [
								{
									id: "mobile-compact",
									name: "path",
									type: "element",
									value: "",
									attributes: {
										d: "M6.0152381,9.28171429 L1.20304762,9.28171429 C1.0092078,9.28171429 0.833632319,9.36080775 0.706407737,9.48803234 C0.579100499,9.61533957 0.5,9.79101285 0.5,9.9847619 L0.5,14.7969524 C0.500122852,14.9909006 0.578942877,15.1667415 0.706298328,15.2940164 C0.833653829,15.4212913 1.00954479,15.5 1.20380952,15.5 L6.01447619,15.5 C6.20874093,15.5 6.38463188,15.4212913 6.51198739,15.2940164 C6.63934284,15.1667415 6.71816286,14.9909006 6.71828581,14.7966359 L6.71828571,9.98552381 C6.71828571,9.79152429 6.6390926,9.61570861 6.51175231,9.48828767 C6.3844896,9.36094436 6.20891481,9.28171429 6.0152381,9.28171429 Z M14.7969524,9.28171429 L9.98552381,9.28171429 C9.79152429,9.28171429 9.61570861,9.3609074 9.48828767,9.48824769 C9.36094436,9.6155104 9.28171429,9.79108519 9.28171429,9.9847619 L9.28171429,14.7969524 C9.28183704,14.9908137 9.36058921,15.1665933 9.48785508,15.2938592 C9.61512096,15.4211251 9.79090055,15.4998772 9.98507826,15.5000001 L14.7969524,15.5 C14.9908137,15.4998772 15.1665933,15.4211251 15.2938592,15.2938592 C15.4211251,15.1665933 15.4998772,14.9908137 15.5000001,14.796636 L15.5,9.98552381 C15.5,9.79152429 15.4208069,9.61570861 15.2934666,9.48828767 C15.1662039,9.36094436 14.9906291,9.28171429 14.7969524,9.28171429 Z M6.0152381,0.5 L1.20304762,0.5 C1.00921427,0.5 0.833644197,0.579096193 0.706435388,0.706385565 C0.579066376,0.833835242 0.5,1.00974399 0.5,1.20380952 L0.5,6.01447619 C0.5,6.20882782 0.578776564,6.3847802 0.706141037,6.51214468 C0.833505509,6.63950915 1.00945789,6.71828571 1.20380952,6.71828571 L6.01447619,6.71828571 C6.20874093,6.71828571 6.38463188,6.63957701 6.51198739,6.51230211 C6.63934284,6.38502726 6.71816286,6.20918626 6.71828581,6.01492164 L6.71828571,1.20304762 C6.71828571,1.0092078 6.63919225,0.833632319 6.51196766,0.706407737 C6.38466043,0.579100499 6.20898715,0.5 6.0152381,0.5 Z M14.7975271,0.500761574 L9.98552381,0.500761905 C9.79152429,0.500761905 9.61570861,0.579955017 9.48828767,0.70729531 C9.36094436,0.834558022 9.28171429,1.01013281 9.28171429,1.20380952 L9.28171429,6.01447619 C9.28171429,6.20874093 9.36042299,6.38463188 9.48769789,6.51198739 C9.61497274,6.63934284 9.79081374,6.71816286 9.98507836,6.71828581 L14.7969524,6.71828571 C14.9908137,6.71816296 15.1665933,6.63941079 15.2938592,6.51214492 C15.4211251,6.38487904 15.4998772,6.20909945 15.5000001,6.01492174 L15.5,1.20304762 C15.5,1.00923611 15.4209333,0.833673661 15.2937096,0.706530599 C15.166534,0.579435492 14.9910588,0.500539124 14.7975271,0.500761574 Z",
										id: "Shape"
									},
									children: [
									]
								}
							]
						}
					]
				}
			]
		}
	]
},
	"low-bandwidth": {
	id: "low-bandwidth",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "low-bandwidth",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "low-bandwidth",
					name: "",
					type: "text",
					value: "Low Bandwidth icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "low-bandwidth",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21 422.5H0V507h85.1v-84.5H64M127.7 317h-21v190h85V317h-64zm43 169h-43V338.1h43V486zM277.4 211.5h-64.1V507h85V211.5h-20.9zm0 274.5h-43V232.5h43.1V486zM341 105.8h-21V507h85V105.8h-64zM384.1 486h-43V126.9h43V486zM491 0h-64v507h85V0h-21zm0 486h-43V21.1h43V486z"
			},
			children: [
			]
		}
	]
},
	microphone: microphone,
	"mobile-filters": {
	id: "mobile-filters",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 25 25"
	},
	children: [
		{
			id: "mobile-filters",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "mobile-filters",
					name: "",
					type: "text",
					value: "Mobile Filters",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "mobile-filters",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				d: "M4.167 21.875v-7.291M4.167 10.417V3.125M12.5 21.875V12.5M12.5 8.333V3.125M20.833 21.875v-5.209M20.833 12.5V3.125M1.042 14.584h6.25M9.375 8.334h6.25M17.708 16.666h6.25"
			},
			children: [
			]
		}
	]
},
	map: map,
	"mobile-expanded": {
	id: "mobile-expanded",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 15 16",
		version: "1.1",
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "mobile-expanded",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "mobile-expanded",
					name: "",
					type: "text",
					value: "Mobile Expanded Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "mobile-expanded",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				id: "Smart-Scoreboard",
				stroke: "none",
				strokeWidth: "1",
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "mobile-expanded",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						id: "Smart-Scoreboard-Mobile-Cards",
						transform: "translate(-346.000000, -128.000000)",
						fill: "#0048AB",
						stroke: "#0046B2"
					},
					children: [
						{
							id: "mobile-expanded",
							name: "g",
							type: "element",
							value: "",
							attributes: {
								id: "top",
								transform: "translate(0.000000, 100.000000)"
							},
							children: [
								{
									id: "mobile-expanded",
									name: "g",
									type: "element",
									value: "",
									attributes: {
										id: "card",
										transform: "translate(314.000000, 28.000000)"
									},
									children: [
										{
											id: "mobile-expanded",
											name: "path",
											type: "element",
											value: "",
											attributes: {
												d: "M45.7983135,0.500000418 L33.202987,0.500000708 C33.0092602,0.500000708 32.8337105,0.579178162 32.7064743,0.70643151 C32.5791737,0.833749214 32.5,1.00940672 32.5,1.20314964 L32.5,14.7961368 C32.5,14.9904581 32.5786467,15.1664166 32.7058716,15.2938148 C32.8329649,15.4210814 33.0085466,15.4998777 33.2025429,15.5000008 L45.7977744,15.5000007 C45.9913667,15.4998778 46.166887,15.4211494 46.2939714,15.2939723 C46.4211872,15.1666638 46.4998773,14.9908167 46.5000001,14.7965826 L46.5,1.2023877 C46.5,1.00851811 46.420994,0.832887212 46.2938203,0.705696385 C46.1668184,0.578677449 45.9915907,0.499792005 45.7983135,0.500000418 Z",
												id: "Shape-Copy-2"
											},
											children: [
											]
										}
									]
								}
							]
						}
					]
				}
			]
		}
	]
},
	mastercard: mastercard,
	"mobile-phone": {
	id: "mobile-phone",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "mobile-phone",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "mobile-phone",
					name: "",
					type: "text",
					value: "Mobile Phone icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "mobile-phone",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M381.1 256.6v216.5c0 13.8-6 24.3-17.8 31.4-5.4 3.2-11.4 4.6-17.7 4.6h-178c-17.8 0-31.6-11.4-35.2-28.8-.5-2.3-.5-4.6-.5-7 0-144.5.1-289-.1-433.5 0-18.8 15-36.1 36.1-36.1 59.1.3 118.3.2 177.5.2 20.5 0 35.7 15.3 35.7 35.7v217zm-236-3.1v193c0 4.5-.4 4.4 4.3 4.4h212.5c1.2 0 2.3-.1 3.5 0 2 .1 2.7-.8 2.5-2.7-.1-1 0-2 0-3V62.7c0-6.4.8-5.7-5.5-5.7H150.9c-6.6 0-5.8-.9-5.8 5.9v190.6zm112.1 207.6c-9.2-.1-17 7.5-17.1 16.7-.1 9.2 7.5 17 16.7 17.1 9.2.1 17-7.5 17.1-16.7.1-9.2-7.5-16.9-16.7-17.1zm-.7-430h-16c-1 0-2.2 0-2.3 1.3 0 1.4 1.2 1.4 2.2 1.4h32c1 0 2.2 0 2.3-1.3 0-1.4-1.2-1.4-2.2-1.4h-16zm-33.9 4.7c1.7-.3 2.9-1.2 3.1-3.1.2-1.7-1.5-3.7-3.3-3.5-1.8.1-3 1.2-3.3 3.1-.1 1.7 1.7 3.5 3.5 3.5z"
			},
			children: [
			]
		}
	]
},
	"more-options": {
	id: "more-options",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 368 74",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "more-options",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "more-options",
					name: "",
					type: "text",
					value: "More Options icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "more-options",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "more-options",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.535 74h73.498V.503H.535z"
					},
					children: [
					]
				},
				{
					id: "more-options",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M73.498 74H0V.503h73.498z"
					},
					children: [
					]
				},
				{
					id: "more-options",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M.53 74h73.498V.503H.53V74z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "more-options",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "more-options",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M183.284 0c-20.327 0-36.75 16.422-36.75 36.75 0 20.325 16.423 36.748 36.75 36.748s36.75-16.423 36.75-36.75C220.033 16.423 203.61 0 183.283 0M330.28 0c-20.328 0-36.75 16.422-36.75 36.75 0 20.325 16.422 36.748 36.75 36.748 20.326 0 36.748-16.423 36.748-36.75C367.028 16.423 350.606 0 330.278 0M36.75 0C16.42 0 0 16.422 0 36.75c0 20.325 16.422 36.748 36.75 36.748 20.326 0 36.748-16.423 36.748-36.75C73.498 16.423 56.96 0 36.748 0",
						fill: "#000"
					},
					children: [
					]
				}
			]
		}
	]
},
	more: more,
	"my-location": {
	id: "my-location",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 511"
	},
	children: [
		{
			id: "my-location",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "my-location",
					name: "",
					type: "text",
					value: "My location icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "my-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M506.16 227h-41.657c-6.16-46-27.086-87.774-59.524-120.204C372.55 74.373 329 53.196 285 47.014V5.406C285 2.172 282.115 0 278.882 0h-45.455C230.194 0 227 2.172 227 5.406v41.656c-45 6.16-87.377 27.304-119.807 59.74C74.77 139.233 53.993 181 47.81 227H6.2C2.968 227 0 229.45 0 232.683v45.455C0 281.37 2.968 284 6.202 284h41.655c6.16 44 26.906 87.66 59.343 120.09 32.43 32.422 74.8 53.484 119.8 59.667v41.607c0 3.233 3.245 5.637 6.478 5.637h45.455c3.233 0 6.067-2.402 6.067-5.636v-41.656c44-6.158 87.556-27.188 119.987-59.625C437.41 371.653 458.367 328 464.55 284h41.61c3.232 0 5.84-2.68 5.84-5.913v-45.455c0-3.234-2.608-5.632-5.84-5.632zm-96.716 28.385c0 84.48-68.73 153.213-153.212 153.213S103.02 339.868 103.02 255.385c0-84.482 68.73-153.213 153.212-153.213s153.212 68.73 153.212 153.213z"
			},
			children: [
			]
		},
		{
			id: "my-location",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M256.18 201.068c-30.04 0-54.478 24.44-54.478 54.48s24.44 54.478 54.48 54.478c30.038 0 54.478-24.44 54.478-54.48s-24.44-54.478-54.48-54.478z"
			},
			children: [
			]
		}
	]
},
	"move-down": {
	id: "move-down",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 18 13"
	},
	children: [
		{
			id: "move-down",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "move-down",
					name: "",
					type: "text",
					value: "Move Down icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "move-down",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.54 0v13h2.27V0H4.54zM0 0h2.27v13H0V0zm12.908 1.982H8.936V.032h5.96V9.04h2.979l-3.972 3.9L9.93 9.038h2.979V1.982h-.001z"
			},
			children: [
			]
		}
	]
},
	login: login,
	"move-up": {
	id: "move-up",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 18 13"
	},
	children: [
		{
			id: "move-up",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "move-up",
					name: "",
					type: "text",
					value: "Move Up icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "move-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M4.54 13V0h2.27v13H4.54zM0 13h2.27V0H0v13zm12.908-1.982H8.936v1.95h5.96V3.96h2.979L13.903.06 9.93 3.962h2.979v7.057h-.001z"
			},
			children: [
			]
		}
	]
},
	"my-location2": {
	id: "my-location2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 366.711 512.459"
	},
	children: [
		{
			id: "my-location2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "my-location2",
					name: "",
					type: "text",
					value: "My location icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "my-location2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M179.278.017c95.872-1.355 186.704 77.376 187.428 175.228.453 61.143-33.318 118.21-63.737 169.18-35.24 59.046-76.878 113.973-119.228 168.033-39.917-53.412-80.66-106.19-115.718-163.02-30.037-48.69-66.954-107.096-68-165.972C-1.66 88.548 83.41.016 179.28.016zm2.522 307.477c66.743 1.214 126.308-60.323 124.65-126.562-1.605-64.115-56.963-118.493-121.258-118.817-64.46-.325-122.955 57.757-124.197 121.997C59.712 250.507 116.07 306.3 181.8 307.494c64.054 1.166-67.458-1.227 0 0z"
			},
			children: [
			]
		},
		{
			id: "my-location2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M183.874 255.722c-21.42-.013-42.846.273-64.252-.25-4.396-.106-10.294-2.125-12.55-5.335-1.664-2.365.513-8.672 2.62-12.258 35.27-60.046 113.83-59.5 148.986.89 6.275 10.777 3.09 16.82-9.286 16.918-21.838.173-43.678.047-65.518.034zM183.635 173.432c-23.173-.083-41.71-18.497-41.755-41.48-.045-22.734 18.735-41.804 41.474-42.115 23.135-.316 42.717 19.307 42.37 42.458-.346 23.123-18.862 41.22-42.09 41.137z"
			},
			children: [
			]
		}
	]
},
	parking: parking,
	news: news,
	"night-games": {
	id: "night-games",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 30 30"
	},
	children: [
		{
			id: "night-games",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "night-games",
					name: "",
					type: "text",
					value: "Night Games",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "night-games",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18.251 22.763c-2.409-.752-4.908-2.029-6.705-4.312-1.798-2.283-2.384-4.927-2.468-7.342-.084-2.402.326-4.74.668-6.52l.018-.093c-4.217 3.332-6.23 6.561-6.846 9.428-.672 3.126.241 6.171 2.433 8.956 2.192 2.784 5.004 4.472 8.342 4.732 3.06.238 6.876-.7 11.412-3.626l-.098-.01c-1.889-.184-4.359-.464-6.756-1.213Zm7.601-.814c-3.768-.359-9.515-.906-12.546-4.757-3.03-3.85-1.974-9.26-1.281-12.81.618-3.168.947-4.852-2.185-2.613-10.896 7.79-11.23 16.043-6.25 22.37 4.98 6.326 13.388 8.33 24.284.54 3.132-2.239 1.344-2.41-2.022-2.73Z",
				clipRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"partial-tickets": {
	id: "partial-tickets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 1001 799",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "partial-tickets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "partial-tickets",
					name: "",
					type: "text",
					value: "Partial Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "partial-tickets",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "partial-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M722.745 264.53c29.63 14.663 63.19 16.92 94.5 6.355 22.75-7.675 42.303-21.476 56.93-39.79-3.79-8.723-10.404-15.753-18.947-19.993l-.042-.02-67.476-33.392c-19.28 30.307-48.1 52.96-82.63 64.61-3.475 1.172-6.978 2.176-10.49 3.102 8.324 7.505 17.706 13.943 28.02 19.062.044.02.088.043.135.066zM476.74 68.943c6.613-13.358 16.727-23.847 28.68-30.95L438.394 4.826c-19.93-9.863-44.164-1.685-54.02 18.23L.905 797.955l115.058.04L476.74 68.942z"
					},
					children: [
					]
				},
				{
					id: "partial-tickets",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M996.64 326.22c4.748-9.59 5.453-20.51 1.988-30.752-3.46-10.226-10.64-18.475-20.22-23.23l-.042-.02-66.848-33.08-.628-.31c-5.297 8.324-11.337 16.048-17.993 23.15-9 9.6-19.165 18.014-30.31 25.078-10.62 6.73-22.107 12.257-34.327 16.38-40.008 13.5-82.89 10.615-120.75-8.12-.056-.03-.116-.06-.172-.087-21.685-10.763-40.205-26.01-54.623-44.585-4.4-5.67-8.438-11.635-12.043-17.897-3.43-5.96-6.452-12.192-9.112-18.63-1.34-3.244-2.617-6.524-3.753-9.88-11.683-34.52-11.155-71.172 1.246-104.882l-67.48-33.393c-8.81-4.36-18.457-5.183-27.335-3.036-7.356 1.778-14.177 5.6-19.555 11.16-2.815 2.912-5.24 6.29-7.13 10.107l-10.727 21.673-342.512 692.14 608.755.213 233.57-472zm-482.477-5.62c-6.475 13.09-22.495 18.496-35.598 12.012l-27.14-13.43c-13.103-6.484-18.52-22.5-12.04-35.588l.967-1.962c6.48-13.09 22.5-18.494 35.602-12.013l27.14 13.43c13.1 6.485 18.52 22.5 12.043 35.59l-.974 1.96zm86.385 72.377l-27.14-13.43c-13.103-6.485-18.522-22.5-12.043-35.59l.97-1.96c6.475-13.09 22.498-18.498 35.598-12.012l27.138 13.43c13.105 6.485 18.524 22.5 12.044 35.588l-.968 1.963c-6.48 13.088-22.5 18.493-35.598 12.01zm121.978 60.363l-27.14-13.43c-13.103-6.485-18.522-22.5-12.042-35.588l.97-1.962c6.478-13.09 22.498-18.495 35.6-12.013l27.14 13.433c13.1 6.482 18.52 22.497 12.043 35.588l-.97 1.96c-6.478 13.09-22.497 18.496-35.6 12.012zm121.983 60.364l-27.14-13.43c-13.104-6.484-18.522-22.5-12.044-35.59l.97-1.96c6.48-13.092 22.498-18.498 35.598-12.012l27.14 13.43c13.103 6.484 18.522 22.5 12.043 35.59l-.97 1.96c-6.477 13.088-22.5 18.495-35.598 12.012z"
					},
					children: [
					]
				}
			]
		}
	]
},
	pdf: pdf,
	photo: photo,
	periscope: periscope,
	pet: pet,
	pinterest: pinterest,
	"pip-view-mode": {
	id: "pip-view-mode",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "pip-view-mode",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pip-view-mode",
					name: "",
					type: "text",
					value: "PIP view icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pip-view-mode",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M469.3,85.3H319.9h-42.7v42.7H42.6H-0.1v42.7v213.3v42.7h42.7h384h42.7v-42.7v-128h42.7v-42.7v-85.3V85.3H469.3\r\n  z M426.6,383.9h-384V170.6h234.7v42.7v42.7h42.7h106.7V383.9z M469.3,213.3h-42.7H319.9v-42.7v-42.7h149.3V213.3z"
			},
			children: [
			]
		}
	]
},
	"pip-view": {
	id: "pip-view",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "pip-view",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "pip-view",
					name: "",
					type: "text",
					value: "PIP View icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "pip-view",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M469.3 85.3H277.2V128H-.1v298.7h469.4V256H512V85.3h-42.7zm-42.7 298.6h-384V170.6h234.7V256h149.4v127.9zm42.7-170.6H319.9v-85.4h149.3v85.4z"
			},
			children: [
			]
		}
	]
},
	plane: plane,
	"play-button": {
	id: "play-button",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink",
		viewBox: "0 0 42 42"
	},
	children: [
		{
			id: "play-button",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play-button",
					name: "",
					type: "text",
					value: "Play Button icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "play-button",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play-button",
					name: "filter",
					type: "element",
					value: "",
					attributes: {
						id: "play-button-a",
						width: "275%",
						height: "275%",
						x: "-87.5%",
						y: "-77.5%",
						filterUnits: "objectBoundingBox"
					},
					children: [
						{
							id: "play-button",
							name: "feMorphology",
							type: "element",
							value: "",
							attributes: {
								"in": "SourceAlpha",
								operator: "dilate",
								radius: "2",
								result: "shadowSpreadOuter1"
							},
							children: [
							]
						},
						{
							id: "play-button",
							name: "feOffset",
							type: "element",
							value: "",
							attributes: {
								dy: "2",
								"in": "shadowSpreadOuter1",
								result: "shadowOffsetOuter1"
							},
							children: [
							]
						},
						{
							id: "play-button",
							name: "feGaussianBlur",
							type: "element",
							value: "",
							attributes: {
								"in": "shadowOffsetOuter1",
								result: "shadowBlurOuter1",
								stdDeviation: "3.5"
							},
							children: [
							]
						},
						{
							id: "play-button",
							name: "feComposite",
							type: "element",
							value: "",
							attributes: {
								"in": "shadowBlurOuter1",
								in2: "SourceAlpha",
								operator: "out",
								result: "shadowBlurOuter1"
							},
							children: [
							]
						},
						{
							id: "play-button",
							name: "feColorMatrix",
							type: "element",
							value: "",
							attributes: {
								"in": "shadowBlurOuter1",
								values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.262237762 0"
							},
							children: [
							]
						}
					]
				},
				{
					id: "play-button",
					name: "circle",
					type: "element",
					value: "",
					attributes: {
						id: "play-button-b",
						cx: "10",
						cy: "10",
						r: "10"
					},
					children: [
					]
				}
			]
		},
		{
			id: "play-button",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "none",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "play-button",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						transform: "translate(11 9)"
					},
					children: [
						{
							id: "play-button",
							name: "use",
							type: "element",
							value: "",
							attributes: {
								fill: "#000",
								filter: "url(#play-button-a)",
								xlinkHref: "#play-button-b"
							},
							children: [
							]
						},
						{
							id: "play-button",
							name: "use",
							type: "element",
							value: "",
							attributes: {
								fill: "#FFF",
								fillOpacity: ".8",
								xlinkHref: "#play-button-b"
							},
							children: [
							]
						}
					]
				},
				{
					id: "play-button",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						fill: "#222",
						d: "M25.18 18.621c.453.32.454.837 0 1.158l-5.16 3.642c-.453.32-.82.129-.82-.412V15.39c0-.547.366-.733.82-.412l5.16 3.642z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"play-circle": {
	id: "play-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 16 16"
	},
	children: [
		{
			id: "play-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play-circle",
					name: "",
					type: "text",
					value: "Play Circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "play-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#57606C",
				d: "M10.14 7.404 6.966 5.816A.667.667 0 0 0 6 6.412v3.176c0 .495.522.818.965.596l3.176-1.588a.667.667 0 0 0 0-1.192Z"
			},
			children: [
			]
		},
		{
			id: "play-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#57606C",
				fillRule: "evenodd",
				d: "M15.334 8A7.333 7.333 0 1 1 .667 8a7.333 7.333 0 0 1 14.667 0Zm-1.5 0A5.833 5.833 0 1 1 2.167 8a5.833 5.833 0 0 1 11.667 0Z",
				clipRule: "evenodd"
			},
			children: [
			]
		}
	]
},
	"play-ball": {
	id: "play-ball",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32"
	},
	children: [
		{
			id: "play-ball",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play-ball",
					name: "",
					type: "text",
					value: "PlayBall Icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M22.338 30.861h.164l-.081-.52-.083.52zm-9.943.167h-.385v.153h.385c.036 0 .051-.047.051-.079 0-.034-.017-.074-.051-.074zm-4.004-.198c0-.034-.018-.075-.052-.075h-.371v.153h.371c.038.001.052-.046.052-.078zm.788-.046c-.002-.003-.004-.003-.006-.003h-.01c-.002 0-.004 0-.006.003-.002.001-.002.006-.002.01l-.123.224c-.002.008-.006.015-.004.02.002.006.008.008.014.008h.243c.004 0 .01 0 .012-.004.004-.006.004-.013.002-.02l-.117-.227c-.001-.005-.001-.01-.003-.011zm-.828.244h-.383v.153h.383c.036 0 .053-.047.053-.079 0-.034-.019-.074-.053-.074zm4.084-.198c0-.034-.018-.075-.052-.075h-.373v.153h.373c.036.001.052-.046.052-.078zm.772-.046c0-.003-.003-.003-.004-.003h-.01c-.002 0-.004 0-.006.003-.002.001-.002.006-.002.01l-.123.224c-.002.008-.006.015-.004.02.002.006.006.008.014.008h.244c.004 0 .008 0 .012-.004.004-.006.004-.013.002-.02l-.119-.227-.004-.011zm-.017-1.577h.925l-.482-1.185-.443 1.185zm.826-.06h-.075l-.344-.846.036-.095.383.941zm6.866-.907v-.11h-.141v.077l.141.033zm-.138.744v.246h.126v-.216l-.126-.03zm-7.7-6.599h1.272l-.636-3.181-.636 3.181zm8.343 7.994v.246h.177l.038-.038v-.168l-.04-.04h-.175zm-2.586.012l-.045.044v.608l.045.045h.129l.046-.045v-.608l-.046-.044h-.129zm2.586.442v.265h.177l.038-.038v-.189l-.038-.038h-.177z",
				fill: "#fff"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M20.702 4.913c0-.017-.021-.017-.037-.017h-.037v.039h.045c.018-.001.029-.005.029-.022z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M20.659 5.068c.066 0 .119-.052.119-.121s-.054-.12-.119-.12c-.066 0-.119.051-.119.12s.053.121.119.121zm-.064-.201h.078c.037 0 .062.007.062.049 0 .03-.015.046-.043.047l.039.064h-.037l-.037-.064h-.028v.064h-.033l-.001-.16z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M19.583 8.714l-.635 3.181h1.272l-.637-3.181zM5.205 22.385h2.016v1.74H5.205v-1.74zm0-3.71h2.016v1.741H5.205v-1.741zm-.019-10.49h1.997v1.844H5.186V8.185z",
				fill: "#fff"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M16.079 15.598h2.002l.474-2.369h2.056l.474 2.369h2.002l-2.124-9.376h-2.76l-2.124 9.376zm3.504-6.884l.636 3.18h-1.272l.636-3.18zM5.187 11.991h2.686l1.272-1.13V7.346L7.873 6.222H3.225v9.376h1.961l.001-3.607zm-.001-3.806h1.997v1.844H5.186V8.185zm5.207-1.963v9.376h4.865v-1.963h-2.896V6.222h-1.969zm16.291 9.376v-3.291l2.415-6.085h-2.084l-1.319 3.959-1.34-3.959H22.34l2.354 6.071v3.305h1.99zM9.19 24.978v-2.647l-.758-.941.758-.92v-2.641l-1.259-1.116H3.243v9.376h4.688l1.259-1.111zm-1.969-.853H5.205v-1.74h2.016v1.74zm0-3.71H5.205v-1.741h2.016v1.741zm5.079-3.703l-2.125 9.376h2.002l.474-2.369h2.056l.474 2.369h2.002l-2.124-9.376H12.3zm.744 5.673l.636-3.18.636 3.18h-1.272zm5.383-5.673v9.376h4.865v-1.963h-2.896v-7.413h-1.969zm11.183 7.413h-2.895v-7.413h-1.97v9.376h4.865v-1.963zM7.68 2.591c.045.117.044.138-.097.192-.118.045-.249.011-.37.091.063.097.294.04.195.24-.139.28-.153.587-.214.879-.066.317-.145.676.115.96.154-.139.293-.286.39-.47.225-.426.197-.889.292-1.332.034-.158.105-.225.233-.244.354-.051.707-.06 1.05.02.067.015.146.041.1.133-.122.244-.125.508-.177.761-.074.363-.158.739.01 1.091.051.106.108.103.158.025.107-.164.26-.293.335-.48.169-.42.223-.854.295-1.287.023-.139.078-.244.225-.25.281-.012.267-.172.217-.356-.018-.065-.045-.127-.069-.189-.161-.404-.449-.725-.681-1.082a.92.92 0 0 0-.618-.407c-.064.376.075.675.247.959.112.184.223.367.288.575.023.075.016.155-.047.217-.061.061-.137.045-.191.008-.048-.033-.401-.048-.457.147 0 .001-.07-.01-.106-.019a.487.487 0 0 1-.317-.257 6.324 6.324 0 0 0-.597-.923c-.193-.245-.347-.518-.653-.653-.124-.055-.168-.057-.188.099-.024.186.034.343.103.497.159.36.386.685.529 1.055zm14.489-.022c.008.035.051.086.017.102-.216.099-.166.303-.238.461-.177.387-.238.784-.285 1.135-.001.233-.057.415.028.589.088.182.17.205.295.023.147-.213.291-.436.342-.691.071-.355.162-.709.188-1.069.008-.105.056-.167.153-.173.296-.018.596-.125.887-.017.095.035.231-.014.304.063.107.114-.077.198-.083.305-.026.425-.183.843-.16 1.272.007.13.025.251.083.366.038.076.082.078.139.019.217-.223.381-.487.465-.77.096-.326.137-.666.171-1.003.017-.17.095-.221.238-.256.31-.076.362-.187.205-.454-.228-.388-.454-.777-.702-1.151a1.048 1.048 0 0 0-.514-.402c-.092-.033-.118-.012-.131.085-.043.318.104.571.236.82.13.249.26.496.345.768.017.054.046.111-.043.111-.181-.001-.657-.112-.669.035-.005.061-.035.07-.069.059-.141-.042-.294-.135-.352-.228-.225-.364-.459-.721-.685-1.084a1.417 1.417 0 0 0-.581-.544c-.105-.053-.157-.064-.169.09-.023.299.103.542.236.776.138.244.284.482.349.763zm5.442-1.091c.077.27.234.493.367.732.246.444.222.499-.31.696.218.05.2.163.138.299-.121.269-.142.56-.19.837-.039.227-.099.473-.039.706.026.1.031.241.134.265.11.025.183-.099.244-.191.056-.085.116-.164.163-.257.222-.435.239-.9.303-1.354.029-.208.122-.265.303-.31.339-.085.649.005.971.035.177.016.16.099.118.233a5.39 5.39 0 0 0-.253 1.501.36.36 0 0 0 .088.245c.049.06.101.064.153.003.1-.118.22-.212.298-.359.24-.449.238-.929.31-1.399.026-.176.103-.242.258-.272.292-.056.339-.152.19-.412-.171-.3-.341-.602-.527-.892-.147-.228-.264-.487-.56-.586-.077-.026-.152-.142-.228-.081-.067.055-.071.181-.042.278.072.234.131.471.266.678.137.21.243.437.313.685.048.171-.053.217-.18.195-.128-.021-.293.067-.381-.099-.024-.045-.05.027-.076.05-.144.131-.425.101-.489-.073-.127-.347-.344-.634-.553-.924-.175-.242-.312-.525-.62-.641-.06-.023-.112-.11-.178-.061-.071.054-.072.154-.06.235.016.082.046.159.069.238zM5.702 2.599c.017.052.047.115-.02.137-.246.083-.23.274-.282.472a9.446 9.446 0 0 0-.233 1.325c.005.108.006.232.068.351.065.127.13.134.215.021.094-.124.212-.228.277-.381.179-.426.225-.871.293-1.311.036-.232.14-.311.345-.321.175-.009.225-.074.168-.25-.165-.516-.511-.91-.815-1.333A1.339 1.339 0 0 0 5.24.923c-.091-.048-.13-.05-.164.085-.086.336.116.561.248.801.141.256.286.507.378.79zm-3.974-.256c.164.421.162.424-.347.549.128.067.235.109.168.25-.124.26-.159.541-.202.811-.05.319-.144.654.011.963.048.097.111.109.167.028.107-.154.253-.277.334-.457.189-.418.22-.854.271-1.285.023-.202.111-.258.283-.279.217-.027.285-.122.208-.324-.212-.552-.548-1.026-.916-1.475-.11-.135-.32-.283-.425-.199-.159.125-.043.345.018.521.108.318.308.586.43.897zm2.033.211c.021.085.019.167-.052.203-.145.074-.157.165-.185.319-.074.413-.247.809-.267 1.237-.01.209-.009.395.065.587.053.137.111.098.168.02.165-.226.356-.443.413-.725.073-.355.153-.711.215-1.068.023-.133.069-.185.206-.2.276-.029.358-.159.248-.397-.099-.212-.188-.428-.329-.621-.133-.183-.27-.364-.395-.555-.144-.221-.333-.422-.645-.459-.092.368.081.651.228.934.122.236.264.459.33.725zm22.383-.004c.068.184-.015.221-.148.276a.253.253 0 0 1-.2.005c-.085-.034-.146-.02-.184.091.069.013.133.027.201.035.09.01.123.059.081.139-.13.252-.134.524-.202.786a2.416 2.416 0 0 0-.049.864c.009.09.054.221.119.242.101.035.159-.1.219-.18.069-.093.157-.167.203-.284.161-.419.237-.85.282-1.284.021-.204.101-.301.309-.33.236-.035.246-.102.173-.325-.122-.374-.359-.671-.566-.988-.196-.297-.409-.577-.796-.676-.102.381.077.674.235.955.123.218.235.436.323.674zm-7.078.167l.067.095v.09l.081.014.071.1v.086l.081.014s.081.085.081.09v.195s.176.161.333.223c.109.043.124.219.186.314.086.133.2.19.176.266-.057.205-.266.547-.461.566h-.771v.329h.964a.506.506 0 0 0 .505-.505v-3.47a.505.505 0 0 0-.506-.504h-2.171l1.249 2.084.115.013zm-7.462 1.879V1.124v3.472zm.148.357a.502.502 0 0 0 .357.148h3.153-3.153a.498.498 0 0 1-.357-.148z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.604 4.596a.507.507 0 0 0 .504.505h3.153l-.195-.327h-.375c-.001-.932.318-1.451.693-1.551.052-.01.028-.266-.038-.342 0 0-.181.005-.219-.005-.048-.014-.014-.062-.014-.062l.176-.381-.024-.104h-.652c-.01 0 .537-.376.537-.376.028-.989 1.041-1.066 1.655-.657.362.243.39.718.362 1.051-.005.019-.095.005-.095.005s-.062.362.1.361h.714c.29-.01.571.185.571.185l.071-.247L16.963.62H12.11a.512.512 0 0 0-.253.07.488.488 0 0 0-.252.435l-.001 3.471zm1.044-.903a.347.347 0 1 1 0 .694.347.347 0 0 1 0-.694zm8.011 1.408a.152.152 0 0 0 .152-.152v-.002a.153.153 0 0 0-.305 0 .153.153 0 0 0 .152.154h.001zm0-.274c.066 0 .119.051.119.12.009.066-.038.126-.104.134a.12.12 0 0 1-.134-.135c0-.068.053-.119.119-.119z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M20.629 4.963h.028l.037.064h.037l-.039-.064c.028-.002.043-.018.043-.047 0-.042-.025-.049-.062-.049h-.078v.16h.033l.001-.064zm0-.067h.037c.016 0 .037 0 .037.017 0 .018-.011.021-.029.021h-.045v-.038zm10.292 25.907c-.126-.403-.408-.719-.545-1.125-.087-.257.061-.202.156-.245a.729.729 0 0 1 .341-.018l.015-.014a.283.283 0 0 0-.032-.037c-.053-.082-.273-.028-.197-.199.114-.257.104-.525.163-.785.075-.333.148-.684-.003-1.017-.063-.139-.113-.079-.174-.018-.176.18-.332.394-.387.623-.091.379-.203.761-.211 1.151-.004.152-.072.222-.219.245-.292.047-.313.089-.198.366.184.441.454.828.71 1.222.142.219.359.359.626.43.073-.215.013-.394-.045-.579zm-2.39-.814c-.212-.479-.198-.509.302-.614-.005-.092-.183-.045-.139-.162.091-.245.051-.506.133-.744.132-.354.144-.741.035-1.102-.035-.113-.093-.106-.153-.023-.095.133-.202.257-.274.407-.195.407-.273.838-.322 1.268-.027.229-.116.334-.337.355-.131.013-.189.071-.141.212.024.067.028.141.058.211.138.33.337.619.539.908.177.254.357.499.65.637.128.061.165.039.18-.111.017-.171-.055-.305-.097-.453-.085-.298-.312-.512-.434-.789zm-24.775-.221c-.082-.236-.023-.335.234-.346.044-.001.09.019.12-.045-.022-.066-.154-.076-.104-.188.099-.216.064-.462.152-.668.138-.327.023-.634.061-.949.009-.075-.063-.138-.12-.171-.059-.035-.104.052-.146.089-.18.162-.302.364-.353.595-.077.345-.154.691-.199 1.037-.025.198-.119.22-.284.257-.326.073-.62-.068-.938-.032-.091.011-.184-.036-.123-.168.122-.265.141-.55.19-.825.057-.318.104-.645-.037-.954-.063-.137-.131-.109-.189-.022-.094.142-.219.266-.281.429a5.064 5.064 0 0 0-.317 1.318c-.014.149-.067.24-.218.244-.144.004-.179.085-.199.206-.022.132.029.237.077.344.149.332.401.599.57.917.155.294.602.539.654.486.216-.084-.003-.615-.177-.889a3.418 3.418 0 0 1-.357-.68c-.058-.163.002-.251.171-.301.332-.096.621.024.919.103.028.009.051.051.063.084.141.41.383.758.645 1.092.165.211.277.472.56.571l.056.02.001-.001c.043.029.089.049.112.018.034-.047.066-.116.048-.181.004-.009.011-.016.013-.027l.004-.008c.015-.248-.111-.446-.223-.637-.138-.234-.294-.455-.385-.718zm2.105-.345c.202-.003.402 0 .62 0-.119-.12-.287-.128-.417-.155-.175-.037-.207.005-.163-.15.127-.453.18-.912.223-1.373a.658.658 0 0 0-.072-.367c-.065-.134-.108-.097-.193-.013a1.537 1.537 0 0 0-.41.793c-.064.3-.121.6-.183.9-.036.175-.086.326-.322.293-.053-.007-.21-.002-.157.13.04.102.058.21.101.313.148.351.369.649.586.954.17.24.34.471.623.591.102.044.148.057.166-.097.034-.305-.114-.539-.24-.767-.134-.245-.305-.464-.394-.738-.084-.257-.057-.309.232-.314zm20.659 0c.202-.003.402 0 .62 0-.119-.12-.287-.128-.417-.155-.175-.037-.207.005-.163-.15.127-.453.18-.912.223-1.373a.658.658 0 0 0-.072-.367c-.065-.134-.108-.097-.193-.013a1.537 1.537 0 0 0-.41.793c-.064.3-.121.6-.183.9-.036.175-.086.326-.322.293-.053-.007-.21-.002-.157.13.04.102.058.21.101.313.148.351.369.649.586.954.17.24.34.471.623.591.102.044.148.057.166-.097.034-.305-.114-.539-.24-.767-.134-.245-.305-.464-.394-.738-.084-.257-.057-.309.232-.314zm-15.871.65l.089.056-.039-.099.083-.068-.107.006-.038-.098-.029.102-.106.007.09.058-.028.102.085-.066zm.252.179l-.109.007-.038-.101-.027.103-.106.007.088.057-.026.104.083-.068.09.058-.04-.1.085-.067zm-.335-.584l-.038-.098-.028.102-.107.007.091.058-.029.104.085-.069.089.06-.039-.102.083-.069-.107.007zm-.296.2l.075.046-.033-.081.067-.057-.087.007-.029-.08-.023.082-.087.005.073.048-.022.084.066-.054zm-.235.02l-.025-.067-.018.069-.07.003.058.039-.018.068.054-.044.061.036-.026-.063.054-.044-.07.003zm.374.189l-.032-.081-.022.085-.087.004.075.048-.022.083.066-.054.073.046-.031-.081.067-.054-.087.004zm.411-.405l.101.065-.042-.11.09-.073-.119.006-.042-.112-.03.115-.117.007.099.064-.031.115.091-.077zm.115.298l.099.065-.043-.111.091-.075-.117.008-.044-.11-.029.114-.118.007.098.064-.027.113.09-.075zm.155.19l-.043-.111-.03.114-.116.006.098.065-.03.115.093-.075.099.063-.043-.109.091-.074-.119.006z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.811 27.707v1.331c0 .383-.228.535-.627.535l-.038-.002-.036.002h-.036c.015 0 .028-.003.043-.003-.353-.018-.558-.172-.558-.532v-1.331c0-.046.064-.141.189-.152H7.624c.125.01.189.106.189.152v1.331c0 .874.612 1.162 1.371 1.162.242 0 .465-.028.663-.095l.046-.136-.111-.122.123-.011.047-.075.199-.029.038-.1.226-.023.044-.042c.067-.168.1-.348.097-.529v-.479l-.103-.513a.24.24 0 0 1 .103-.251v-.087c0-.046.064-.141.189-.152H9.624c.123.009.187.105.187.151zm-1.349 3.27c0-.014.036-.014.056-.05a.279.279 0 0 0 .018-.121c0-.048 0-.083-.028-.119-.034-.044-.112-.044-.187-.044h-.494v.665h.502c.067 0 .147 0 .181-.033.042-.042.044-.091.044-.152a.17.17 0 0 0-.034-.115c-.02-.025-.058-.019-.058-.031zm-.494-.222h.371c.035 0 .052.04.052.075 0 .032-.014.079-.052.079h-.371v-.154zm.383.426h-.383v-.153h.383c.035 0 .053.04.053.074 0 .032-.017.079-.053.079zm4.153-.204c0-.014.036-.014.058-.05a.293.293 0 0 0 .016-.121c0-.048 0-.083-.028-.119-.032-.044-.112-.044-.185-.044h-.495v.665h.503c.065 0 .147 0 .181-.033.04-.042.044-.091.044-.152 0-.049-.006-.077-.036-.115-.018-.025-.058-.019-.058-.031zm-.494-.222h.373c.034 0 .052.04.052.075 0 .032-.016.079-.052.079h-.373v-.154zm.385.426h-.385v-.153h.385c.034 0 .051.04.051.074 0 .032-.015.079-.051.079zm-3.319-.538l-.377.665h.173l.077-.133h.422l.073.133h.176l-.363-.665h-.181zm.222.399c-.002.004-.008.004-.012.004h-.244c-.006 0-.012-.002-.014-.008-.002-.005.002-.011.004-.02l.123-.224c0-.004 0-.009.002-.01.002-.003.004-.003.006-.003h.01c.002 0 .004 0 .006.003.002.001.002.006.004.01l.117.227c.002.007.002.015-.002.021zm3.808-.399l-.377.665h.172l.078-.133h.423l.071.133h.176l-.361-.665h-.182zm.221.399c-.004.004-.008.004-.012.004h-.244c-.008 0-.012-.002-.014-.008-.002-.005.002-.011.004-.02l.123-.224c0-.004 0-.009.002-.01.002-.003.004-.003.006-.003h.01c.002 0 .004 0 .004.003.002.001.003.006.003.01l.119.227a.018.018 0 0 1-.001.021zm-2.447.266h.693v-.14h-.512c-.004 0-.01 0-.012-.004-.005-.002-.006-.01-.006-.016v-.094c0-.006.001-.011.004-.015.004-.004.008-.004.014-.004h.296v-.126h-.294c-.006 0-.008 0-.012-.004a.02.02 0 0 1-.006-.014v-.093c0-.006.002-.013.006-.016a.02.02 0 0 1 .014-.006h.512v-.133h-.697v.665zm3.169-.665h-.164v.665h.663v-.158h-.499v-.507zm.885 0h-.163v.665h.663v-.158h-.5v-.507zm-4.563.24c-.101 0-.391-.012-.391-.023v-.089c0-.022.008-.028.024-.028h.389c.008 0 .02 0 .02.012v.066l.135-.043v-.046c0-.049-.046-.109-.131-.109h-.445c-.086 0-.129.056-.129.109v.166c0 .044.033.113.125.113h.412c.045 0 .042.016.042.032v.097c0 .014-.01.026-.028.026H9.99c-.024 0-.028-.011-.028-.029v-.061l-.149.047v.066c0 .056.063.112.115.112h.471c.139 0 .157-.085.157-.135v-.18c0-.081-.082-.103-.185-.103zm2.358-2.546a.64.64 0 0 0 0-1.28c-.212 0-.4.106-.516.266.004.001.008.003.013.003l.006.052.012-.019-.004-.029.022.006a.59.59 0 0 1 .964.679l-.006.011h-.001c-.008.012-.019.023-.028.034v.002h-.001a.58.58 0 0 1-.775.133c-.013-.006-.023-.014-.034-.022l-.015-.01.001-.001a.59.59 0 0 1-.173-.718l-.015-.004.036-.034.007-.013a.047.047 0 0 0-.015-.006l-.052.047-.007-.003a.642.642 0 0 0-.06.266c.001.354.289.64.641.64z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.737 29.038v-1.331c0-.046-.065-.141-.19-.152h-.074c.125.01.189.106.189.152v1.331c0 .356-.198.511-.545.532l.03.002c.375-.01.59-.164.59-.534z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.11 29.573l.036-.002a.302.302 0 0 1-.03-.002c-.015.001-.028.003-.043.003h.037v.001zm2.81.596h.074c.051-.009.107-.056.146-.11a1.348 1.348 0 0 1-.111.044.224.224 0 0 1-.109.066zm-2.884.031h.038c-.743-.01-1.335-.302-1.335-1.162v-1.331c0-.046-.064-.141-.19-.152h-.074c.125.01.19.106.19.152v1.331c-.001.874.611 1.162 1.371 1.162zm4.905-1.053h.075l-.383-.941-.036.095.344.846zm-1.236-.738c-.108.287-.234.613-.34.895.008.035.016.079.024.13l.393-1.027c-.018.002-.034.002-.053.002h-.024zm1.416 1.76h.074c.069-.004.143-.088.143-.118 0-.016-.099-.258-.145-.383h-.075c.047.125.145.367.145.383.001.03-.074.114-.142.118z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.232 30.087a.542.542 0 0 1-.074-.125c-.308-.755-.919-2.242-.919-2.282 0-.05.085-.119.139-.125h-.951a.71.71 0 0 1-.553.838l-.017.003c-.149.395-.331.868-.457 1.197a.685.685 0 0 1-.024.211.366.366 0 0 1-.129.187c0 .002 0 .004-.002.004-.028.081-.109.16-.177.173h.979c-.071 0-.139-.078-.139-.108 0-.031.028-.095.159-.458h1.176c.02.064.169.427.169.447 0 .03-.075.115-.143.118h1.078c-.029 0-.062-.021-.095-.056h-.021l.001-.024zm-2.042-.88l.443-1.185.482 1.185h-.925zm-2.074-1.198c-.111.03-.346.107-.189.184.111.054.222.078.298.105 0-.008-.048-.045.014-.077.07-.034.475-.127.854-.205a.7.7 0 0 1-.07-.236c-.401.087-.838.2-.907.229zm.202 1.231s.207-.071.294-.121c.086-.05.046-.095-.048-.123-.113-.034-.612-.181-.739-.22a.255.255 0 0 1-.149-.116c.004.017.03.223.088.296.051.062.117.078.161.093 0 0 .385.119.419.128.012.008.012.032-.026.063zm.823-1.14c-.192.042-.37.084-.514.114-.133.032-.407.072-.184.153.117.042.256.082.332.111-.014-.036.049-.046.091-.058.157-.047.317-.087.477-.122a.776.776 0 0 1-.202-.198zm-.254.8c.049-.115-.135-.181-.197-.205l-.91-.304c-.058-.028-.141-.056-.181-.119 0 0 .034.189.046.232a.229.229 0 0 0 .175.163c.034.011.84.257.876.276.076.044.054.065.04.11a.48.48 0 0 0 .151-.153z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M10.915 28.341l.759.251c.042.018.177.06.246.111.121.09.09.221.012.312-.167.21-.989.457-1.031.467l.181.052-.107.166c.028-.014.801-.277.954-.354.185-.094.264-.217.274-.33.004-.066.052-.292-.517-.463l-.76-.252c-.096-.033-.231-.133-.107-.264.107-.113.727-.258 1.199-.359a.682.682 0 0 1 .05-.248c-.377.081-.915.203-1.166.297-.742.275-.211.558.013.614zm1.357 1.486c.037-.066.042-.163.028-.32 0 0-.018.135-.199.216-.25.108-.647.249-.937.33l.159.056-.084.149c.103-.017.646-.188.876-.295a.295.295 0 0 0 .157-.136z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M11.374 29.898s.397-.137.691-.262c.296-.139.211-.304.175-.485-.004.033-.02.133-.171.229-.121.076-.296.15-1.035.4l.169.056-.091.146.262-.084zm.992-1.734l.015.01-.014-.011-.001.001zm.826-.101v-.002l-.001.001.001.001zm.029-.036l.006-.011h-.001l-.005.011zm.036-.073c-.007-.002-.02-.008-.042-.014l-.053.046-.02-.006.049-.048-.044-.012-.049.046-.03-.006.046-.049-.049-.008-.044.048c-.011-.002-.021-.004-.032-.004l.044-.048c-.014-.002-.03-.005-.048-.005l-.044.049c-.01-.002-.02-.002-.032-.002l.047-.048h-.053l-.046.05h-.018l.044-.05-.055.004-.044.052-.014.002-.016.002.036-.051h-.014l-.04.008-.038.056-.028.008.026-.054c-.016.003-.034.009-.05.013l-.03.058c-.006.005-.014.008-.022.011l.02-.057-.048.02-.02.061-.022.013.012-.057c-.016.007-.03.016-.045.024l-.012.06a.086.086 0 0 0-.014.013l.002-.059c-.013.01-.026.02-.04.028l-.002.06-.016.015-.006-.056a.347.347 0 0 1-.037.03l.006.06-.003.003.014.011c.011.008.023.014.034.021a.08.08 0 0 0 .013-.013l-.042-.022.018-.018.042.026a.38.38 0 0 0 .04-.03l-.045-.028.022-.018.042.034c.012-.008.027-.019.042-.026l-.042-.037c.008-.003.016-.01.027-.015l.038.039c.014-.005.03-.014.046-.019l-.042-.042.028-.014.036.046.048-.016-.038-.049.038-.012.032.053a.647.647 0 0 1 .047-.011h.004l-.034-.054c.011 0 .018-.002.028-.004l.026.055a.281.281 0 0 1 .05-.004l-.026-.057c.008-.002.016-.002.026-.002l.02.056.05-.001-.022-.057h.026l.016.058c.018 0 .034 0 .05.003l-.016-.059c.01.002.019.002.028.005l.015.058.05.006-.014-.059.026.006.01.059a.215.215 0 0 1 .05.012l-.01-.059.018.006.005.057a.368.368 0 0 1 .047.015l.001-.001-.004-.054.032.02.006-.011a.16.16 0 0 1-.022-.013l.054-.047zm-.842.241l-.034-.022a.246.246 0 0 0 .034.022zm-.218-.877l-.018.022.002.027c-.008-.004-.014-.006-.016-.009 0 .003-.003.005-.004.006l-.002.004.006.002-.018.017c-.006.012-.014.023-.02.036.007.004.014.006.021.008a.662.662 0 0 1 .064-.109l-.015-.004zm.043.012l.004.028c.005-.008.012-.014.018-.022l-.022-.006zm-.06.11l.015.004c.006-.013.014-.026.021-.038l-.036.034z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.208 27.387l.015.006c.003-.005.005-.011.009-.016l-.006-.052c-.005 0-.009-.002-.013-.003a.662.662 0 0 0-.064.109l.007.003.052-.047z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.228 27.395l-.012.011c-.007.013-.015.025-.021.038l.029.008.049-.047.03.006-.044.048.046.009.045-.048c.012.002.022.004.034.004h-.002l-.044.048a.26.26 0 0 0 .048.005l.044-.048.032.001-.046.048h.054l.044-.05h.018l-.044.05.055-.004.046-.053c.004 0 .008 0 .012-.002l.016-.002-.036.053c.004-.002.01-.002.014-.002.014-.002.026-.006.041-.009l.038-.056a.07.07 0 0 0 .028-.009l-.026.055c.016-.005.035-.008.05-.015l.03-.058.022-.011-.02.057c.018-.006.032-.014.048-.02l.02-.06.022-.013-.012.057.044-.025.012-.06c.004-.005.011-.008.014-.013l-.002.059.041-.028.002-.06a.107.107 0 0 1 .016-.014l.006.057a.26.26 0 0 1 .036-.03l-.006-.054c-.017-.012-.034-.024-.052-.034l-.006.006.042.023c-.004.004-.01.011-.018.017l-.043-.025a.38.38 0 0 1-.04.03l.044.028-.022.018-.04-.034c-.014.009-.028.018-.044.026l.044.036c-.01.004-.018.01-.028.015l-.039-.04c-.014.006-.03.014-.046.019l.043.043c-.01.003-.018.009-.029.014l-.036-.046c-.014.006-.03.009-.048.016l.038.049-.038.012-.032-.053a.18.18 0 0 1-.046.01H12.6l.032.054c-.01.002-.018.004-.028.004l-.027-.055c-.018.002-.034.004-.05.004l.026.059h-.023l-.022-.055-.05.001.022.056h-.026l-.016-.056c-.018-.001-.035-.001-.051-.005l.016.059-.026-.002-.016-.059c-.018-.002-.034-.006-.05-.007l.014.058-.026-.006-.008-.056-.028-.008c-.006.008-.013.014-.018.022l.004.03-.016-.006-.001-.005c-.003.005-.005.011-.009.016.002.003.003.003.005.004zm3.218 2.553h.049v.165h.033v-.165h.064v-.027h-.146v.027z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.435 29.921h-.037l-.056.137-.057-.137h-.052v.166c.007.009.013.018.021.026h.012v-.165l.065.165h.02l.064-.165v.165h.032v-.165h-.011v-.027h-.001zm-.203.192h.021c-.007-.007-.014-.017-.021-.026v.026zm1.104-2.606h.149v3.873h-.149v-3.873zm3.292 1.984v-2.084h-.968v1.824h-.166v-1.824h-.968v2.084c0 .142.095.212.136.241l.173.122.033.023a.425.425 0 0 0 .254.077h.91a.425.425 0 0 0 .254-.077l.031-.022.175-.123c.04-.03.136-.099.136-.241zm-.15.077a.144.144 0 0 1-.022.027l-.005.006a.288.288 0 0 1-.034.027l-.175.123-.018.013-.012.008c-.01.007-.021.01-.032.016a.302.302 0 0 1-.15.039h-.91a.305.305 0 0 1-.145-.036c-.012-.006-.025-.01-.036-.018l-.031-.022-.002-.001-.172-.121a.216.216 0 0 1-.033-.027l-.006-.006a.144.144 0 0 1-.022-.027l-.003-.004h.001a.143.143 0 0 1-.02-.073v-1.957h.714v1.822l.023.002h.373c.008 0 .015 0 .023-.002v-1.822h.716v1.957c0 .03-.008.053-.02.073l.001.001-.003.002zm1.764.386a.425.425 0 0 0 .254-.077l.03-.021.176-.124a.283.283 0 0 0 .136-.241v-.777a.309.309 0 0 0-.161-.271h.173v-.573a.283.283 0 0 0-.136-.241l-.172-.121-.034-.024a.425.425 0 0 0-.254-.077h-.884c-.1 0-.178.024-.254.077l-.038.027-.168.119a.283.283 0 0 0-.136.241v.627c0 .177.146.292.291.327l.332.078h-.62v.588c0 .143.095.212.136.241l.139.098.067.048a.425.425 0 0 0 .254.077l.869-.001zm-1.012-.161c-.013-.007-.026-.01-.039-.019l-.068-.048-.035-.025-.056-.04-.034-.024-.011-.008c-.012-.009-.024-.018-.035-.029l-.007-.007a.166.166 0 0 1-.022-.03l-.004-.006.001-.001a.138.138 0 0 1-.017-.066v-.462h.714v.326l.023.002h.333c.008 0 .015 0 .023-.002l-.001-.442-.228-.054-.675-.159c-.096-.023-.193-.095-.193-.204v-.625c0-.072.041-.108.084-.138l.167-.118.038-.026a.286.286 0 0 1 .181-.054h.884c.073 0 .127.016.181.054l.029.021.176.124c.042.031.083.067.083.138v.445h-.714v-.31l-.023-.002h-.348c-.008 0-.015 0-.023.002v.303c.206.047.866.199.912.211.161.04.186.139.186.195v.777a.15.15 0 0 1-.016.066h.001l-.003.004a.2.2 0 0 1-.024.033l-.005.005a.26.26 0 0 1-.036.03l-.178.125-.027.019a.286.286 0 0 1-.181.054h-.87a.308.308 0 0 1-.143-.035zm.514-.563v-.246l.125.03v.216h-.125zm.138-1.1v.109l-.141-.032v-.077h.141zm2.189.154l-.143.62h.291l-.148-.62z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M22.508 27.395l-.703 2.57h.962l.126-.46h.364l.126.46h.962l-.703-2.57h-1.134zm1.67 2.444h-.698l-.126-.46h-.557l-.126.46h-.698l.633-2.316h.94l.632 2.316zm-4.757-2.235h-.555v1.756c0 .04-.031.067-.103.067h-.373c-.071 0-.103-.027-.103-.067v-1.756h-.555v1.886a.074.074 0 0 0 .022.056l.005.006a.199.199 0 0 0 .027.022l.204.143a.317.317 0 0 0 .041.021c.029.013.06.019.091.018h.909c.041 0 .07-.009.097-.021a.231.231 0 0 0 .035-.018l.204-.143a.199.199 0 0 0 .027-.022l.005-.005a.082.082 0 0 0 .022-.056v-1.887zm2.21 1.109c0-.085-.074-.113-.127-.126l-.97-.224V28c0-.017.007-.032.02-.043l-.001-.001.002-.001a.075.075 0 0 1 .025-.013c.003-.001.005-.003.008-.003a.176.176 0 0 1 .046-.006h.351l.012.001c.013.001.025.001.035.004l.006.003c.01.003.02.007.026.012a.055.055 0 0 1 .024.048v.245h.555v-.376c0-.037-.015-.055-.054-.083l-.204-.144a.207.207 0 0 0-.132-.039h-.884a.214.214 0 0 0-.132.039c-.02.014-.164.115-.203.144-.04.029-.054.047-.054.083v.627c0 .082.086.123.134.135l.675.159.287.068.001.502c0 .04-.031.067-.103.067h-.334c-.071 0-.103-.027-.103-.067V29.1h-.555v.391c0 .011.002.02.005.029a.079.079 0 0 0 .014.023l.005.006a.181.181 0 0 0 .03.025l.084.059.083.058.037.026a.317.317 0 0 0 .041.021c.029.013.06.019.091.018h.87a.247.247 0 0 0 .132-.039l.204-.143a.181.181 0 0 0 .03-.025l.005-.005a.097.097 0 0 0 .015-.024.087.087 0 0 0 .005-.028v-.779h-.002z",
				fill: "#444"
			},
			children: [
			]
		},
		{
			id: "play-ball",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M23.416 29.296l.126.46h.528l-.589-2.152h-.815l-.589 2.152h.529l.126-.46h.684zm-.346-1.371l.254 1.061h-.498l.244-1.061zm-5.229 2.692l-.028-.028v-.165l.036-.037h.129l.038.038v.106h.281v-.21l-.152-.152h-.459l-.155.156v.403l.13.128h.329l.028.028v.169l-.036.036h-.138l-.036-.036v-.106h-.282v.21l.153.152h.466l.155-.155v-.408l-.13-.129h-.329zm.791-.448l-.158.159v.822l.158.158h.466l.159-.158v-.822l-.159-.159h-.466zm.344.874l-.046.044h-.129l-.045-.044v-.608l.045-.044h.129l.046.044v.608zm.477.266h.282v-.433h.313v-.231h-.313v-.243h.349v-.233h-.631v1.14zm.742-.895h.237v.895h.281v-.895h.238v-.244h-.756v.244zm1.688.191v-.284l-.15-.152h-.626v1.14h.626l.152-.152v-.307l-.124-.122.122-.123zm-.281.455l-.038.038h-.177v-.264h.177l.038.038v.188zm0-.473l-.038.038h-.177v-.246h.175l.04.04v.168zm.616-.418l-.216 1.14h.266l.036-.228h.231l.036.228h.286l-.218-1.14h-.421zm.12.692l.082-.52.081.52h-.163zm.945-.692h-.282v1.14h.589v-.238h-.307v-.902zm.755 0h-.283v1.14h.59v-.238h-.307v-.902zm6.649-4.081v-.387h-.097l-.113.275-.114-.275h-.106v.387h.066v-.331l.13.331h.04l.129-.331v.331h.065zm-.622 0v-.331h.128v-.056h-.314v.056h.12v.331h.066z",
				fill: "#444"
			},
			children: [
			]
		}
	]
},
	"play-overlay": {
	id: "play-overlay",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "play-overlay",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "play-overlay",
					name: "",
					type: "text",
					value: "Play Overlay icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "play-overlay",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M255.4 511.1c-68.2 0-132.4-26.6-180.6-74.8S0 323.9 0 255.6 26.6 123.3 74.8 75 187.2.2 255.4.2 387.8 26.8 436 75s74.8 112.4 74.8 180.6S484.3 388 436 436.2s-112.3 74.9-180.6 74.9zm0-499c-65 0-126.2 25.3-172.2 71.3-46 46-71.3 107.2-71.3 172.2s25.3 126.2 71.3 172.2c46 46 107.2 71.3 172.2 71.3s126.2-25.3 172.2-71.3c46-46 71.3-107.2 71.3-172.2s-25.3-126.2-71.3-172.2c-46-46-107.1-71.3-172.2-71.3z"
			},
			children: [
			]
		},
		{
			id: "play-overlay",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M182.5 155.8c0-16 11.3-22.5 25.1-14.5l173 99.8c13.8 8 13.8 21 0 29L207.7 370c-13.8 8-25.1 1.5-25.1-14.5l-.1-199.7z"
			},
			children: [
			]
		}
	]
},
	player: player,
	play: play,
	"premium-seat": {
	id: "premium-seat",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "premium-seat",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "premium-seat",
					name: "",
					type: "text",
					value: "Premium Seating icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "premium-seat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M521.9 353.4c2.8.2 26.9-.8 40.3.2 29.5 2.1 43.4 16.4 44.4 45.9.8 24 .2 48.1.3 72.1v90.5h587.3v-90.5c0-24-.6-48.1.3-72.1 1-29.5 14.9-43.7 44.4-45.9 13.5-1 37.6 0 40.3-.2h3.7s1.6-162.9-.6-240.5c-1.5-55.5-46-91.9-108.3-92.2-5.5 0-11 0-16.5-.1-4.4-.3-8.9-.5-13.5-.4l-22.8.3c-73.5-.2-147.1 0-220.6 0s-147.1-.2-220.6 0l-22.8-.3c-.7 0-1.3.1-1.8.4-9.4 0-18.8 0-28.2.1-62.3.4-106.9 36.7-108.4 92.1-2.2 77.6-.6 240.5-.6 240.5l3.7.1zm340.5-178.3l40.2-81.5 40.2 81.5 89.9 13.1-65.1 63.4 15.4 89.5-80.4-42.3-80.4 42.3 15.4-89.5-65.1-63.4 89.9-13.1zM1208.4 600.1c-8.3-7.2-20.5-14.4-31-14.4-69.9-.3-168.7-.1-265.2.7-1 0-1.9-.1-2.9-.1-102.8-.8-211-1.2-286-.8-10.4 0-22.7 7.2-31 14.4-53.7 46.5-45.2 108.4-42.1 168.1 1 19.8 18.7 21.3 35.8 21.3 99.6-.2 199.2-.1 298.8-.1 2 .1 4 .3 6 .3h17.6c102.1 0 204.2-.1 306.4.1 17.1 0 34.7-1.4 35.8-21.3 3-59.9 11.5-121.7-42.2-168.2z"
			},
			children: [
			]
		},
		{
			id: "premium-seat",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M571.4 597.3c6.1-5.1 13.6-13.1 13.7-19.9 1-59.3 1.1-118.6-.4-177.8-.2-7.5-10.6-20.7-17.2-21.2-30.8-2.5-62-2.9-92.9-.9-9.6.6-22.7 9-27.1 17.5-21.3 42.4-48.1 82.8-47.5 133.9 1.2 107.4.3 214.7.4 322.1 0 8.4.8 16.8 1.2 25.3 12.4.9 21.7 1.6 34 2.6 0 17.7-.3 34.3.1 50.9 1.1 51.8-10.4 47 49.7 47.4 14.3.1 20.2-5.3 19.8-19.9-.7-25.5-.2-51-.2-79.7 0 0 22.3-9.5 22.2-24-.2-55.3 1.5-110.6-.6-165.8-1.6-39.7 16.5-66.8 44.8-90.5zM1400 528.9c.6-51.1-26.2-91.5-47.7-134-4.3-8.5-17.5-16.9-27.1-17.5-30.8-2-62-1.6-92.9.9-6.5.5-17 13.7-17.2 21.2-1.5 59.2-1.4 118.6-.4 177.8.1 6.8 7.7 14.8 13.7 19.9 28.4 23.7 46.4 50.8 44.9 90.5-2.2 55.2-.4 110.5-.6 165.8-.1 14.5 22.2 24 22.2 24 0 28.7.5 54.2-.2 79.7-.4 14.6 5.6 20 19.8 19.9 60-.4 48.6 4.4 49.7-47.4.3-16.6.1-33.2.1-50.9 12.3-.9 21.6-1.6 34-2.6.4-8.5 1.2-16.9 1.2-25.3.2-107.3-.7-214.6.5-322z"
			},
			children: [
			]
		}
	]
},
	preview: preview,
	printer: printer,
	"profile-arrow-left": {
	id: "profile-arrow-left",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-arrow-left",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-arrow-left",
					name: "",
					type: "text",
					value: "Profile Arrow Left icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-arrow-left",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.788 14.61c0-.073.025-.145.07-.194l5.424-5.98c.086-.095.218-.085.294.023a.303.303 0 01-.018.366l-5.247 5.785 5.247 5.786c.087.096.095.26.018.367-.076.108-.208.118-.294.022l-5.424-5.98a.29.29 0 01-.07-.194",
				stroke: "#3C3C43",
				strokeWidth: "1.2",
				strokeOpacity: ".75"
			},
			children: [
			]
		}
	]
},
	"profile-arrow-right": {
	id: "profile-arrow-right",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-arrow-right",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-arrow-right",
					name: "",
					type: "text",
					value: "Profile Arrow Right icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-arrow-right",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.212 15.39a.293.293 0 01-.07.194l-5.424 5.98c-.086.095-.218.085-.294-.023a.303.303 0 01.018-.366l5.247-5.785-5.247-5.786a.305.305 0 01-.018-.367c.076-.108.208-.118.294-.022l5.424 5.98a.29.29 0 01.07.194",
				stroke: "#222",
				strokeWidth: "1.2"
			},
			children: [
			]
		}
	]
},
	"profile-billing": {
	id: "profile-billing",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-billing",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-billing",
					name: "",
					type: "text",
					value: "Billing icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-billing",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M23.487 27.802h-4.995c-.138 0-.28.009-.415-.01a.754.754 0 01-.64-.727c0-.344.293-.649.67-.69.107-.012.216-.006.324-.006h10.22c.107 0 .217-.007.323.008.354.05.621.34.636.676a.732.732 0 01-.621.736c-.151.023-.308.014-.462.014h-5.04m-17.18-5.866c.09-.006.156.004.212-.015.91-.325 1.834-.614 2.719-.995.5-.216.69-.81.525-1.324a19.377 19.377 0 00-.591-1.619c-.26-.612-.877-.9-1.518-.696-.79.252-1.572.53-2.344.831-.623.243-.916.871-.714 1.488.174.531.373 1.056.585 1.574.205.498.606.742 1.126.756zm20.36 12.049c-3.345 0-6.69-.034-10.035.014-1.7.024-3.278-1.216-3.26-3.236.034-3.673.006-7.347.014-11.02 0-.375.021-.762.116-1.122.354-1.338 1.54-2.23 2.955-2.23 6.814-.005 13.628-.006 20.442-.001 1.758.001 3.085 1.283 3.09 2.999.014 3.854.014 7.709.004 11.564-.005 1.769-1.324 3.027-3.152 3.03-3.391.005-6.783.002-10.174.002zm-11.193-9.53c0 2.233-.006 4.408.006 6.583a.836.836 0 00.572.81c.224.08.482.095.725.095 6.598.006 13.196.007 19.794.006.184 0 .37-.008.552-.034a.855.855 0 00.712-.577c.07-.194.079-.416.08-.625.005-1.95.003-3.9.002-5.85 0-.132-.02-.263-.031-.407H15.474zm-.001-3.725h22.445c0-.36-.017-.704.003-1.047.049-.814-.37-1.263-1.282-1.255-3.422.028-6.844.011-10.266.011-3.253 0-6.506-.001-9.759.001-.693 0-1.101.325-1.136.923-.026.435-.006.873-.006 1.367zm11.836-6.007H23c-2.22 0-4.44-.021-6.66.01-2.186.032-3.999 1.478-4.508 3.56a5.948 5.948 0 00-.149 1.3c-.02 1.148-.007 2.296-.007 3.479-.773.277-1.536.552-2.299.824-.694.248-1.391.488-2.083.743-.528.194-.735.638-.515 1.073.19.376.57.493 1.073.316 1.087-.383 2.17-.773 3.256-1.158.17-.061.345-.114.55-.182v4.657c-1.283.448-2.55.972-3.864 1.328-1.531.415-3.022-.435-3.581-1.918-.646-1.712-1.273-3.432-1.91-5.148-.69-1.857-1.385-3.713-2.072-5.571-.655-1.77.12-3.402 1.929-4.048 6.303-2.254 12.609-4.505 18.915-6.753 1.86-.663 3.508.098 4.188 1.923.644 1.729 1.285 3.46 1.926 5.19.037.098.065.198.121.375z"
			},
			children: [
			]
		}
	]
},
	"profile-account": {
	id: "profile-account",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-account",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-account",
					name: "",
					type: "text",
					value: "Profile Account icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-account",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-account",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M36.158 20.5c0-8.648-7.01-15.658-15.658-15.658S4.842 11.852 4.842 20.5s7.01 15.658 15.658 15.658 15.658-7.01 15.658-15.658zm1.842 0C38 30.165 30.165 38 20.5 38S3 30.165 3 20.5 10.835 3 20.5 3 38 10.835 38 20.5z"
					},
					children: [
					]
				},
				{
					id: "profile-account",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M27.937 36.003c-2.202 1.147-4.694 1.835-7.424 1.835-2.743 0-5.237-.688-7.435-1.835-1.326-.692-2.268-1.391-2.786-1.878a.937.937 0 01-.292-.683v-1.455c0-2.276.14-3.782.685-5.294.83-2.301 2.475-3.662 5-3.662h10.23c3.075 0 4.574 2.096 4.982 5.467.113.933.136 1.703.13 3.109v1.835c0 .261-.108.51-.296.685-.52.487-1.466 1.185-2.794 1.876zm-1.12-18.525c0 3.578-2.822 6.478-6.304 6.478-3.48 0-6.303-2.9-6.303-6.478S17.032 11 20.513 11c3.482 0 6.303 2.9 6.303 6.478z"
					},
					children: [
					]
				}
			]
		}
	]
},
	popcorn: popcorn,
	"profile-arrow-up": {
	id: "profile-arrow-up",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-arrow-up",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-arrow-up",
					name: "",
					type: "text",
					value: "Profile Arrow Up icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-arrow-up",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.89 12.288c.073 0 .145.025.194.07l5.98 5.424c.095.086.085.218-.023.294a.303.303 0 01-.366-.018l-5.785-5.247-5.786 5.247a.305.305 0 01-.367.018c-.108-.076-.118-.208-.022-.294l5.98-5.424a.29.29 0 01.194-.07",
				stroke: "#222",
				strokeWidth: "1.2"
			},
			children: [
			]
		}
	]
},
	"profile-correct": {
	id: "profile-correct",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-correct",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-correct",
					name: "",
					type: "text",
					value: "Profile Correct icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-correct",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M15.728 30.627a1 1 0 01-1.414 0l-.01-.012L3.706 20.021a1 1 0 111.414-1.414l9.901 9.9 19.798-19.8a1 1 0 111.414 1.414L15.728 30.627z"
			},
			children: [
			]
		}
	]
},
	"profile-newsletters": {
	id: "profile-newsletters",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		xmlnsXlink: "http://www.w3.org/1999/xlink"
	},
	children: [
		{
			id: "profile-newsletters",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-newsletters",
					name: "",
					type: "text",
					value: "Profile Newsletters icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-newsletters",
			name: "defs",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-newsletters",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						id: "profile-newsletters-a",
						d: "M0 0h30v27.5H0z"
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-newsletters",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 6)"
			},
			children: [
				{
					id: "profile-newsletters",
					name: "mask",
					type: "element",
					value: "",
					attributes: {
						id: "profile-newsletters-b"
					},
					children: [
						{
							id: "profile-newsletters",
							name: "use",
							type: "element",
							value: "",
							attributes: {
								xlinkHref: "#profile-newsletters-a"
							},
							children: [
							]
						}
					]
				},
				{
					id: "profile-newsletters",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M19.539 10.991l-.027.012-4.5 2.13-4.056-1.92L2.45 6.937V2.62h25.102v4.373l-8.012 4zm2.268 1.755l5.744-2.864V21.98l-5.744-9.234zM2.45 21.98V9.831l5.756 2.896-5.756 9.252zm8.01-8.186L13.99 15.6c.325.162.674.259 1.023.259.349 0 .697-.073 1.021-.236l3.541-1.823 6.928 11.08H3.524l6.935-11.088zM30 1.964C30 .884 29.174 0 28.163 0H1.837C.827 0 0 .884 0 1.964v23.572C0 26.62.822 27.5 1.837 27.5h26.326c1.015 0 1.837-.88 1.837-1.964V1.964z",
						mask: "url(#profile-newsletters-b)"
					},
					children: [
					]
				}
			]
		}
	]
},
	"public-transportation": {
	id: "public-transportation",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 417.623 510.967"
	},
	children: [
		{
			id: "public-transportation",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "public-transportation",
					name: "",
					type: "text",
					value: "Public Transportation icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "public-transportation",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M.002 446.383c0-2.516-.006-4.32.001-6.123.265-70.599.229-141.202 1.039-211.795.172-15.016 3.27-30.018 5.296-44.99 4.504-33.282 9.151-66.545 13.81-99.807 1.442-10.294 2.58-20.636 8.934-29.558 5.152-7.234 11.156-13.329 18.786-17.95 20.233-12.252 42.39-19.144 65.284-24.279C150.529 3.498 188.235-1.788 226.605.559c42.586 2.605 84.388 9.631 124.369 25.214 11.162 4.35 21.442 10.322 30.413 18.462 10.864 9.858 15.089 22.533 16.926 36.613 6.213 47.626 12.691 95.218 19.039 142.827.243 1.825.261 3.689.261 5.535.013 70.6.011 141.2.011 211.799v5.273c-7.957 0-15.622-.068-23.286.017-9.662.108-9.803.152-10.452 9.811-.63 9.384-1.298 18.791-1.297 28.188.001 20.055-22.016 31.239-39.984 24.89-10.933-3.863-17.973-11.079-18.48-23.196-.407-9.736-.322-19.492-.628-29.234-.286-9.108-.464-9.425-9.31-9.85-9.564-.46-19.151-.601-28.729-.607-54.631-.032-109.261-.008-163.892.071-6.549.009-13.098.655-19.647.645-4.689-.008-6.149 2.354-6.212 6.552-.154 10.25-.155 20.513-.71 30.745-.793 14.627-9.047 23.568-23.379 26.018-15.3 2.615-28.227-3.711-33.638-16.768-1.126-2.718-1.572-5.845-1.729-8.815a1109.277 1109.277 0 0 1-1.205-31.743c-.114-4.764-1.975-6.851-6.965-6.702-9.065.274-18.143.079-28.079.079zm208.736-198.792v.735c27.399 0 54.798.1 82.196-.03 24.708-.117 49.416-.431 74.123-.769 10.548-.144 14.91-4.106 16.328-14.575.311-2.295.361-4.703.05-6.993-3.791-27.956-7.535-55.92-11.592-83.838-1.809-12.447-3.892-24.885-6.606-37.161-2.132-9.645-6.96-13.153-16.665-13.79-6.872-.451-13.76-.925-20.642-.93-79.674-.052-159.348-.028-239.022.02-5.205.003-10.419.232-15.612.593-7.24.503-12.266 4.437-14.995 10.983-1.402 3.363-2.329 7.029-2.831 10.647A27401.729 27401.729 0 0 0 37.615 228.78c-1.598 11.915 4.318 18.76 16.316 18.778 51.603.076 103.205.033 154.807.033zm.977-207.753v-.03c-29.049 0-58.097-.065-87.146.047-6.903.027-11.031 3.839-11.688 9.97-.723 6.747 3.076 12.603 9.554 13.905 3.914.786 7.99 1.049 11.994 1.053 40.133.046 80.267.049 120.4-.07 14.272-.043 28.543-.412 42.813-.717 6.16-.132 10.274-3.184 11.75-8.411 2.39-8.463-2.707-15.665-11.539-15.702-28.712-.12-57.425-.045-86.138-.045zM37.247 350.104c-.032 16.905 11.746 28.679 28.816 28.803 15.626.114 28.444-12.799 28.356-28.565-.092-16.463-12.749-29.022-29.169-28.943-15.952.077-27.972 12.398-28.003 28.705zm315.659 28.849c16.022-.059 29.074-12.894 29.101-28.618.027-15.77-13.584-29.096-29.5-28.884-15.788.21-27.981 12.526-27.958 28.24.025 17.211 11.763 29.323 28.357 29.262z"
			},
			children: [
			]
		}
	]
},
	promo: promo,
	prohibited: prohibited,
	"profile-wrong": {
	id: "profile-wrong",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-wrong",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-wrong",
					name: "",
					type: "text",
					value: "Profile Wrong icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-wrong",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-wrong",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.524 10.476a.673.673 0 010 .953L11.429 29.524a.673.673 0 11-.953-.953l18.095-18.095a.673.673 0 01.953 0z"
					},
					children: [
					]
				},
				{
					id: "profile-wrong",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M29.524 30.524a.673.673 0 01-.953 0L10.476 12.429a.673.673 0 11.953-.953l18.095 18.095a.673.673 0 010 .953z"
					},
					children: [
					]
				}
			]
		}
	]
},
	recap: recap,
	recycling: recycling,
	"quad-view": {
	id: "quad-view",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "quad-view",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "quad-view",
					name: "",
					type: "text",
					value: "Quad View Mode icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "quad-view",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101"
			},
			children: [
				{
					id: "quad-view",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M200.5 311.7H156v178h244.8v-178H200.5zm155.8 133.6H200.5v-89h155.8v89zM623.4 311.7H423.1v178h244.8v-178h-44.5zm0 133.6H467.6v-89h155.8v89zM200.5 512.1H156v178h244.8v-178H200.5zm155.8 133.5H200.5v-89h155.8v89zM467.6 512.1h-44.5v178h244.8v-178H467.6zm155.8 133.5H467.6v-89h155.8v89z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"profile-favorites": {
	id: "profile-favorites",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "profile-favorites",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "profile-favorites",
					name: "",
					type: "text",
					value: "Profile Favorites icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "profile-favorites",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M18.39 6.994L14.73 14.38 6.536 15.57c-1.469.212-2.057 2.014-.992 3.046l5.927 5.747-1.402 8.119c-.252 1.467 1.301 2.566 2.602 1.88L20 30.53l7.329 3.833c1.3.68 2.854-.413 2.602-1.88l-1.402-8.119 5.927-5.747c1.065-1.032.477-2.834-.992-3.046L25.27 14.38l-3.662-7.387c-.656-1.317-2.557-1.334-3.218 0z"
			},
			children: [
			]
		}
	]
},
	reddit: reddit,
	reels: reels,
	repeat: repeat,
	restrooms: restrooms,
	rewards: rewards,
	"ribbon-award": {
	id: "ribbon-award",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "ribbon-award",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M12.220 0.358 C 11.814 0.459,11.638 0.610,11.099 1.315 C 10.879 1.602,10.682 1.837,10.660 1.838 C 10.638 1.839,10.323 1.719,9.960 1.570 C 9.323 1.310,9.288 1.300,8.960 1.300 C 8.551 1.300,8.322 1.394,8.036 1.681 C 7.786 1.930,7.708 2.164,7.597 2.991 C 7.514 3.618,7.497 3.684,7.423 3.701 C 7.377 3.711,7.070 3.756,6.740 3.801 C 6.008 3.901,5.909 3.926,5.671 4.077 C 5.294 4.316,5.041 4.844,5.093 5.282 C 5.106 5.394,5.234 5.777,5.377 6.133 C 5.520 6.489,5.642 6.800,5.649 6.825 C 5.655 6.850,5.413 7.062,5.112 7.296 C 4.811 7.531,4.501 7.796,4.424 7.887 C 4.078 8.290,4.056 8.956,4.372 9.433 C 4.420 9.507,4.733 9.781,5.067 10.043 L 5.674 10.520 5.388 11.210 C 5.116 11.867,5.102 11.915,5.101 12.220 C 5.100 12.634,5.225 12.909,5.546 13.195 L 5.767 13.392 4.356 16.606 C 2.830 20.082,2.839 20.057,2.978 20.420 C 3.074 20.670,3.347 20.902,3.619 20.963 C 3.822 21.009,3.892 20.997,5.206 20.705 C 5.961 20.537,6.585 20.414,6.591 20.432 C 6.597 20.450,6.868 21.003,7.194 21.662 C 7.822 22.932,7.908 23.057,8.221 23.160 C 8.551 23.269,8.996 23.141,9.203 22.877 C 9.263 22.802,9.891 21.444,10.599 19.860 C 11.307 18.276,11.899 16.967,11.914 16.951 C 11.929 16.936,12.013 16.948,12.101 16.980 C 12.314 17.056,12.675 17.054,12.902 16.977 C 13.004 16.943,13.097 16.924,13.109 16.936 C 13.121 16.947,13.721 18.274,14.442 19.883 C 15.283 21.758,15.794 22.851,15.865 22.925 C 16.219 23.294,16.867 23.285,17.185 22.906 C 17.243 22.838,17.549 22.251,17.866 21.604 C 18.182 20.956,18.447 20.420,18.453 20.413 C 18.460 20.406,19.077 20.537,19.823 20.703 C 21.260 21.024,21.343 21.032,21.634 20.883 C 21.947 20.722,22.145 20.363,22.108 20.023 C 22.091 19.874,21.710 18.967,20.669 16.600 L 19.252 13.380 19.464 13.189 C 19.774 12.908,19.900 12.628,19.899 12.220 C 19.898 11.915,19.884 11.867,19.612 11.210 L 19.326 10.520 19.873 10.096 C 20.482 9.623,20.610 9.496,20.723 9.253 C 20.966 8.731,20.865 8.151,20.464 7.769 C 20.374 7.683,20.084 7.445,19.820 7.241 C 19.556 7.036,19.345 6.849,19.351 6.825 C 19.358 6.800,19.481 6.487,19.624 6.129 C 19.779 5.744,19.895 5.392,19.908 5.266 C 19.952 4.841,19.709 4.333,19.346 4.091 C 19.105 3.929,19.004 3.902,18.260 3.801 C 17.930 3.756,17.623 3.711,17.577 3.701 C 17.503 3.684,17.486 3.618,17.403 2.991 C 17.292 2.164,17.214 1.930,16.964 1.681 C 16.678 1.394,16.449 1.300,16.040 1.300 C 15.712 1.300,15.677 1.310,15.040 1.570 C 14.677 1.719,14.362 1.839,14.340 1.838 C 14.318 1.837,14.129 1.611,13.920 1.335 C 13.427 0.685,13.228 0.504,12.892 0.400 C 12.625 0.318,12.430 0.306,12.220 0.358 M12.934 2.668 C 13.337 3.187,13.497 3.330,13.800 3.445 C 14.167 3.583,14.460 3.541,15.176 3.245 C 15.504 3.110,15.776 3.004,15.780 3.010 C 15.784 3.015,15.827 3.308,15.876 3.660 C 15.977 4.388,16.058 4.611,16.316 4.867 C 16.575 5.125,16.770 5.199,17.473 5.304 C 17.818 5.356,18.121 5.399,18.146 5.399 C 18.172 5.400,18.079 5.680,17.931 6.045 C 17.696 6.625,17.669 6.718,17.671 6.962 C 17.672 7.167,17.698 7.291,17.779 7.471 C 17.901 7.743,18.056 7.903,18.620 8.340 C 18.840 8.510,19.020 8.667,19.020 8.688 C 19.020 8.710,18.786 8.910,18.500 9.135 C 17.917 9.592,17.757 9.800,17.688 10.193 C 17.633 10.504,17.676 10.700,17.939 11.351 C 18.061 11.650,18.160 11.915,18.160 11.940 C 18.160 11.968,17.911 12.018,17.513 12.071 C 16.753 12.173,16.540 12.257,16.262 12.567 C 16.038 12.816,15.952 13.084,15.857 13.830 C 15.820 14.122,15.776 14.360,15.760 14.360 C 15.744 14.360,15.463 14.249,15.135 14.114 C 14.589 13.888,14.515 13.868,14.240 13.867 C 13.927 13.866,13.691 13.941,13.438 14.122 C 13.372 14.168,13.135 14.442,12.911 14.730 L 12.503 15.253 12.395 15.117 C 12.335 15.041,12.136 14.791,11.953 14.560 C 11.661 14.192,11.587 14.124,11.349 14.003 C 11.109 13.881,11.044 13.865,10.769 13.867 C 10.483 13.868,10.416 13.886,9.865 14.114 C 9.537 14.249,9.256 14.360,9.240 14.360 C 9.224 14.360,9.180 14.122,9.143 13.830 C 9.048 13.084,8.962 12.816,8.738 12.567 C 8.460 12.257,8.247 12.173,7.487 12.071 C 7.089 12.018,6.840 11.968,6.840 11.940 C 6.840 11.915,6.939 11.650,7.061 11.351 C 7.324 10.700,7.367 10.504,7.312 10.193 C 7.243 9.800,7.083 9.592,6.500 9.135 C 6.214 8.910,5.980 8.710,5.980 8.688 C 5.980 8.667,6.160 8.510,6.380 8.340 C 6.944 7.903,7.099 7.743,7.220 7.472 C 7.303 7.288,7.327 7.171,7.327 6.957 C 7.327 6.709,7.300 6.614,7.067 6.040 C 6.920 5.678,6.828 5.400,6.854 5.399 C 6.879 5.399,7.182 5.356,7.527 5.304 C 8.230 5.199,8.425 5.125,8.684 4.867 C 8.942 4.611,9.023 4.388,9.124 3.660 C 9.173 3.308,9.216 3.015,9.220 3.010 C 9.224 3.004,9.496 3.110,9.824 3.245 C 10.542 3.542,10.833 3.584,11.203 3.444 C 11.507 3.329,11.683 3.168,12.121 2.601 C 12.415 2.221,12.505 2.128,12.541 2.169 C 12.566 2.197,12.743 2.422,12.934 2.668 M11.144 6.196 L 10.268 7.073 10.663 7.496 C 10.881 7.729,11.071 7.920,11.087 7.920 C 11.102 7.920,11.264 7.758,11.447 7.560 C 11.629 7.362,11.792 7.200,11.809 7.200 C 11.826 7.200,11.840 8.280,11.840 9.600 L 11.840 12.000 12.560 12.000 L 13.280 12.000 13.270 8.670 L 13.260 5.340 12.640 5.329 L 12.020 5.318 11.144 6.196 M7.605 14.432 C 7.725 15.289,7.794 15.473,8.099 15.755 C 8.303 15.942,8.455 16.018,8.758 16.083 C 9.037 16.143,9.278 16.085,10.025 15.777 C 10.624 15.530,10.719 15.508,10.721 15.612 C 10.721 15.683,8.513 20.600,8.481 20.600 C 8.465 20.600,8.230 20.141,7.958 19.580 C 7.585 18.809,7.449 18.564,7.402 18.577 C 7.113 18.659,5.075 19.088,5.058 19.071 C 5.040 19.054,7.221 14.026,7.366 13.750 C 7.460 13.571,7.502 13.691,7.605 14.432 M18.821 16.378 C 19.468 17.851,19.989 19.065,19.978 19.075 C 19.964 19.089,17.891 18.649,17.639 18.577 C 17.593 18.564,17.447 18.823,17.061 19.599 C 16.777 20.171,16.541 20.634,16.537 20.629 C 16.532 20.624,16.021 19.488,15.402 18.105 C 14.743 16.634,14.289 15.575,14.310 15.554 C 14.331 15.533,14.606 15.625,14.972 15.776 C 15.722 16.085,15.962 16.143,16.242 16.083 C 16.545 16.018,16.697 15.942,16.901 15.755 C 17.206 15.473,17.275 15.289,17.395 14.430 C 17.489 13.756,17.508 13.678,17.573 13.689 C 17.628 13.697,17.934 14.358,18.821 16.378 "
			},
			children: [
			]
		}
	]
},
	replay: replay,
	"rewind-10": {
	id: "rewind-10",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "rewind-10",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "rewind-10",
					name: "",
					type: "text",
					value: "Rewind 10 Seconds icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "rewind-10",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M411.4 245c-66.2 0-128.9 25.5-176.1 70.7V268c0-12.7-10.3-23-23-23s-23 10.3-23 23v110.6c0 12.7 10.3 23 23 23h110.6c12.7 0 23-10.3 23-23s-10.3-23-23-23h-62.6c16.2-16.9 35.3-31.1 56.1-41.8 29.6-15.1 61.6-22.8 95-22.8 115.4 0 209.3 93.9 209.3 209.3s-93.9 209.3-209.3 209.3-209.3-93.8-209.3-209.2c0-12.7-10.3-23-23-23s-23 10.3-23 23c0 140.8 114.6 255.4 255.4 255.4s255.4-114.6 255.4-255.4C666.7 359.6 552.2 245 411.4 245z"
			},
			children: [
			]
		},
		{
			id: "rewind-10",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M337.8 438.9c-8.4 6-21 9.9-37.7 11.8v16.9h31.5v104.9h-31v22.7h91.2v-22.7h-31V438.9h-23zM451 592c7.8 4.1 17.5 6.1 28.9 6.1s21.1-2 29-6.1 13.9-10 18.1-17.8c4.1-7.8 7.1-16.2 8.8-25.4 1.7-9.1 2.6-19.8 2.6-31.9 0-12.1-.9-22.8-2.6-31.9s-4.6-17.6-8.8-25.4c-4.1-7.8-10.2-13.7-18.1-17.9-7.9-4.1-17.6-6.2-29-6.2s-21 2.1-28.9 6.2c-7.8 4.1-13.8 10.1-18 17.9-4.1 7.8-7.1 16.2-8.8 25.4-1.7 9.1-2.6 19.8-2.6 31.9 0 12.1.9 22.8 2.6 31.9 1.7 9.1 4.6 17.6 8.8 25.4 4.1 7.8 10.1 13.7 18 17.8zm1.8-106.9c1.5-8.1 4.5-14.6 8.9-19.5 4.4-4.8 10.5-7.3 18.2-7.3 11.3 0 19 4.8 23.2 14.3 4.2 9.6 6.3 24.3 6.3 44.3s-2.1 34.7-6.3 44.3c-4.2 9.6-12 14.3-23.2 14.3-11.3 0-19-4.8-23.1-14.3-4.1-9.6-6.2-22.6-6.2-39.2 0-16.4.7-28.8 2.2-36.9z"
			},
			children: [
			]
		}
	]
},
	rewind: rewind,
	"running-bases": {
	id: "running-bases",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 402.024 507.911"
	},
	children: [
		{
			id: "running-bases",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "running-bases",
					name: "",
					type: "text",
					value: "Running bases icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "running-bases",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M348.914 464.012c-23.993-6.642-47.96-13.375-71.957-20.005-1.3-.36-2.872-.313-4.182.042-8.497 2.3-16.957 4.742-25.43 7.136-15.485 4.375-30.96 8.78-46.466 13.082-1.982.55-2.692 1.428-2.556 3.484.216 3.258.25 6.54.14 9.803-.066 1.946.716 2.742 2.486 3.393 24.003 8.833 47.967 17.776 71.98 26.577 1.414.518 3.342.512 4.758 0 12.63-4.575 25.2-9.315 37.786-14.013 11.235-4.194 22.45-8.44 33.713-12.556 1.924-.703 2.92-1.582 2.673-3.745-.18-1.575-.035-3.188-.035-4.785h.03c0-1.52-.17-3.065.037-4.557.335-2.42-.85-3.267-2.978-3.856zM400.976 92.027c-2.234-6.718-6.31-11.716-13.487-13.197-6.995-1.443-12.173 1.766-16.658 6.993-12.68 14.777-25.55 29.39-38.352 44.062-.872 1-1.783 1.963-2.84 3.122-1.076-1.2-1.98-2.183-2.855-3.19-16.08-18.475-32.22-36.9-48.198-55.462-5.244-6.092-11.546-8.956-19.615-8.898-25.472.185-50.947.232-76.42.05-7.556-.055-12.976 2.78-17.476 8.786-18.867 25.187-37.95 50.212-56.963 75.29-5.8 7.65-5.658 18.965.364 26.294 6.562 7.986 17.493 8.19 24.308.432.887-1.01 1.672-2.113 2.482-3.19 15.616-20.738 31.364-41.38 46.732-62.3 3.23-4.402 6.44-6.425 12.01-6 7.374.563 14.823.14 23.09.14-1.328 1.88-2.11 3.055-2.955 4.18-36.89 49.176-73.8 98.334-110.625 147.556-1.798 2.403-3.61 3.405-6.655 3.377-24.492-.22-48.986-.3-73.48-.337-10.84-.016-18.605 5.79-21.944 16.116-.445 1.378-.958 2.735-1.44 4.102v8.82c.7 2.07 1.325 4.167 2.11 6.203 3.62 9.38 11.118 14.696 21.12 14.693 31.213-.007 62.428-.047 93.64-.207 10.757-.055 19.46-4.06 26.175-13.004 12.86-17.125 26.255-33.85 39.435-50.735.81-1.036 1.68-2.023 3.06-3.674.83 1.172 1.38 2.126 2.098 2.93 15.906 17.796 31.807 35.598 47.79 53.325 1.656 1.836 2.042 3.497 1.562 5.92-6.897 34.8-13.68 69.625-20.497 104.442-1.957 9.997-.385 19.17 7.283 26.327 2.755 2.57 6.596 3.978 9.94 5.916h7.35c11.893-3.786 16.502-12.77 18.703-24.363 8.38-44.14 17.256-88.185 25.81-132.292 2.19-11.282.05-21.378-8.05-30.307-13.74-15.147-26.934-30.788-40.354-46.226-.87-1-1.7-2.03-2.672-3.192l50.223-66.797c1.107 1.214 2.006 2.157 2.858 3.14 9.305 10.737 18.597 21.486 27.906 32.22 8.813 10.162 19.106 10.637 28.365.763 7.618-8.124 14.696-16.756 21.988-25.185 9.937-11.485 19.99-22.875 29.682-34.566 2.73-3.292 4.362-7.493 6.498-11.277v-8.085c-.35-.902-.74-1.795-1.047-2.715z"
			},
			children: [
			]
		},
		{
			id: "running-bases",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M340.493 89.865c20.005-6.56 33.12-23.87 33.148-45.08-.145-1.36-.24-4.07-.75-6.7-5.82-30.192-39.37-46.672-68.13-33.51C279.9 15.95 270.063 45.1 283.31 68.138c11.228 19.53 35.62 28.798 57.183 21.727z"
			},
			children: [
			]
		}
	]
},
	pause: pause,
	"schedule-tickets": {
	id: "schedule-tickets",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	},
	children: [
		{
			id: "schedule-tickets",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "schedule-tickets",
					name: "",
					type: "text",
					value: "Schedule Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "schedule-tickets",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "m10.308 4.13-.2 1.26-1.36.27a1.85 1.85 0 0 1-1.35 1.12 1.34 1.34 0 0 1-.35 0 1.87 1.87 0 0 1-1.32-.56l-1.44.33 2.48 12.49 1.24-.24-.14.88a1.15 1.15 0 0 0 0 .37l-1.35.27h-.12a.81.81 0 0 1-.73-.7L3.038 6.43a.79.79 0 0 1 .53-1l2.75-.54a.81.81 0 0 0 .73.7h.12a.79.79 0 0 0 .52-1l2.62-.46ZM12.128 4.25l2.06.3a2 2 0 0 0 1.54 1.26h.29a2 2 0 0 0 1.55-.75l2.1.37-2.45 15.42-2.07-.3a1.999 1.999 0 0 0-1.54-1.26h-.29a2.001 2.001 0 0 0-1.55.75l-2.1-.37.11-.68 2.14-13.44.2-1.27v-.03h.01Zm-.3-1.25a1 1 0 0 0-.87.87v.26l-.2 1.26-2.09 13.41-.14.88a1.15 1.15 0 0 0 0 .37.87.87 0 0 0 .67.75l3.29.51a1 1 0 0 1 .87-.87h.11a.93.93 0 0 1 .63 1.11l3.29.52h.11a1 1 0 0 0 .87-.87l2.48-15.78a.94.94 0 0 0-.67-1.12l-3.29-.51a1 1 0 0 1-.87.87h-.11a.93.93 0 0 1-.67-1.11l-3.29-.52-.12-.03Z"
			},
			children: [
			]
		}
	]
},
	search: search,
	"search-ad": {
	id: "search-ad",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "400 0 1000 1000"
	},
	children: [
		{
			id: "search-ad",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "search-ad",
					name: "",
					type: "text",
					value: "Search Ad icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "search-ad",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1034.2 556.7c0 48.2 17.3 81.3 56.4 81.3 22.2 0 42.3-13.5 56.4-28.2V503c-19-17.9-34.7-26.6-57.5-26.6-36.4.1-55.3 27.7-55.3 80.3z"
			},
			children: [
			]
		},
		{
			id: "search-ad",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M899.2 9C627.6 9 407.4 229.2 407.4 500.8s220.2 491.8 491.8 491.8S1391 772.4 1391 500.8 1170.8 9 899.2 9zm-61.3 690.2l-29.8-89.4H671.5l-30.9 89.4h-81.3l142-402.7h84l142 402.7h-89.4zm315.5 0c-3.8-7-6.5-28.7-6.5-43.4-19 26-46.1 47.7-88.9 47.7-65.6 0-111.1-46.6-111.1-146.3s46.1-152.8 112.2-152.8c39 0 67.2 14.1 87.8 42.3V298.1h87.3v330.6c0 34.7 2.2 55.8 8.7 70.5h-89.5z"
			},
			children: [
			]
		},
		{
			id: "search-ad",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M740.4 409.3l-47.2 136.5h94.3l-46-136.5"
			},
			children: [
			]
		}
	]
},
	scissors: scissors,
	"share-square-2": {
	id: "share-square-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "share-square-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "share-square-2",
					name: "",
					type: "text",
					value: "Share square icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "share-square-2",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M9.9 2.8 7.86 4.84l.53.53.53.53 1.14-1.14 1.14-1.139V15.16h1.52V3.621l1.14 1.139L15 5.9l.53-.53.53-.53-2.04-2.04A150.796 150.796 0 0 0 11.96.76c-.011 0-.938.918-2.06 2.04M3.76 14.9v8.22h16.4V6.68h-6.32V8.2h4.8v13.44H5.28V8.2h4.88V6.68h-6.4v8.22"
			},
			children: [
			]
		}
	]
},
	"service-animals": {
	id: "service-animals",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 510.831 372.199"
	},
	children: [
		{
			id: "service-animals",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "service-animals",
					name: "",
					type: "text",
					value: "Service Animals icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "service-animals",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M510.831 254.529c-39.958.429-50.414-33.533-72.378-56.848 0 18.762-.602 37.551.216 56.277.528 12.104 9.279 20.333 18.164 27.176 9.529 7.339 13.504 15.753 12.436 27.907-1.156 13.15.199 26.505-.596 39.707-1.157 19.228-16.861 28.382-34.492 20.781-5.373-2.316-6.21-10.312.461-14.018 14.47-8.039 8.525-21.097 9.964-32.304 1.236-9.622-6.162-14.667-12.336-19.751-13.096-10.784-27.896-19.816-39.609-31.883-14.762-15.208-28.21-32.006-40.086-49.566-5.738-8.484-10.553-10.781-19.412-7.829-23.142 7.712-46.148 15.908-69.551 22.737-18.459 5.387-37.423 9.047-56.172 13.435-6.288 1.471-9.414-.329-9.361-7.568.24-32.948-.037-65.901.32-98.847.038-3.536 2.958-7.057 4.629-10.543.268-.56 1.09-.828 1.499-1.353 18.047-23.191 40.69-31.467 70.571-27.923 32.912 3.904 66.578 1.224 99.583 4.631 39.001 4.027 67.442 25.734 83.696 61.607 9.385 20.712 20.943 39.387 37.789 54.88 7.973 7.333 13.927 16.397 14.665 29.295zM80.818 95.243c-18.161-.835-34.421-2.167-50.683-2.185C9.196 93.035 1.335 74.57.008 59.789c-.179-1.988 2.788-5.06 5.032-6.285 3.819-2.085 8.216-3.118 12.38-4.563 10.691-3.71 21.068-6.195 25.463-19.912 2.065-6.445 11.84-13.025 19.183-14.602 12.98-2.787 26.899-3.088 40.167-1.792 5.902.576 11.943 6.84 16.593 11.774 13.709 14.547 26.692 29.775 40.113 44.598 2.661 2.939 6.006 5.257 9.683 8.418 22.336-20.291 44.813-39.415 65.683-60.155C246.742 4.911 259.538-1.96 277.35.493c8.996 1.239 18.353-.345 27.451.446 4.846.421 9.488 3.182 14.223 4.887-2.32 4.143-3.78 9.216-7.095 12.285-30.132 27.892-60.585 55.439-90.951 83.078-20.833 18.963-41.491 38.126-62.685 56.676-3.888 3.403-9.878 5.701-15.067 6.061-12.502.866-25.129-.196-37.657.46-7.461.39-9.846-2.564-11.246-9.396-4.073-19.867-8.891-39.582-13.505-59.747zm212.664-79.909c-9.39 0-15.863.576-22.191-.136-9.281-1.044-15.862 2.501-22.467 8.811-18.169 17.354-36.042 35.255-55.867 50.563-15.285 11.802-12.13 25.683-11.252 42.551L293.482 15.334zM84.17 80.799l-.898-1.998c-1.45.608-2.909 1.197-4.35 1.827-14.691 6.426-16.795 5.216-18.026-10.476-.185-2.354-.455-4.765-.162-7.084 1.592-12.615 3.349-25.208 5.049-37.809-6.618 15.702-7.784 32.165-6.735 48.911.779 12.434 4.612 15.029 16.171 10.888 3.094-1.108 5.973-2.823 8.951-4.259zM102.031 182.546h78.684c0 21.527.027 42.478-.074 63.429-.006 1.151-.851 3.081-1.691 3.326-11.396 3.323-8.964 13.374-9.487 21.045-1.411 20.654-1.579 41.39-2.465 62.084-.691 16.125-11.777 26.873-22.748 35.682-5.226 4.197-16.705 2.981-24.472.913-6.583-1.753-3.08-8.575.918-10.966 14.942-8.936 17.742-23.231 17.527-38.505-.344-24.434-1.61-48.855-2.383-73.284-.258-8.16-3.127-14.678-9.018-20.691-11.513-11.754-19.623-25.763-24.791-43.033z"
			},
			children: [
			]
		},
		{
			id: "service-animals",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M306.72 227.211c10.153-2.569 20.231-5.555 30.513-7.418 2.614-.474 7.317 1.827 8.618 4.195 15.731 28.612 37.708 51.341 64.657 69.336 6.783 4.529 9.082 9.76 8.529 17.762-.818 11.832-.091 23.763-.612 35.626-.943 21.465-13.101 29.652-33.65 23.081-6.005-1.921-6.234-8.938-.481-14.771 15.553-15.77 15.147-36.74-1.752-51.093-13.696-11.632-28.938-21.532-42.02-33.776-12.952-12.123-24.059-26.218-35.975-39.448l2.173-3.494zM182.432 257.636c1.19-.147 2.813-.511 4.439-.521 8.716-.058 17.433-.027 26.933-.027-1.199 27.029-.723 54.246-4.425 80.882-1.458 10.489-10.979 21.012-19.303 28.914-4.263 4.047-13.966 2.798-21.238 3.014-2.695.08-7.536-2.249-7.735-3.917-.32-2.684 1.63-7.005 3.962-8.415 14.487-8.757 16.922-22.898 17.252-37.705.455-20.305.115-40.627.115-62.225z"
			},
			children: [
			]
		}
	]
},
	security: security,
	settings: settings,
	"share-square": {
	id: "share-square",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		x: "0px",
		y: "0px",
		viewBox: "0 0 714 982"
	},
	children: [
		{
			id: "share-square",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "share-square",
					name: "",
					type: "text",
					value: "Share square icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "share-square",
			name: "g",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "share-square",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M0,309.96c0.642-2.911,1.193-5.847,1.94-8.731c4.92-18.979,21.996-33.118,41.402-33.198 c58.989-0.245,117.98-0.124,176.97-0.136c0.797,0,1.594,0.132,2.63,0.224c0,14.702,0,29.129,0,44.142 c-59.138,0-118.195,0-177.596,0c0,208.295,0,416.007,0,624c207.812,0,415.527,0,623.443,0c0-207.882,0-415.464,0-623.649 c-59.258,0-118.31,0-177.682,0c0-15.03,0-29.461,0-44.731c1.632,0,3.374,0,5.116,0c56.491,0,112.982-0.015,169.473,0.006 c26.413,0.01,43.094,14.146,47.599,40.226c0.166,0.961,0.466,1.899,0.704,2.847c0,209.012,0,418.025,0,627.037 c-1.144,4.821-1.79,9.829-3.518,14.431c-6.876,18.307-23.24,28.643-44.808,28.643c-205.776,0.008-411.553,0.005-617.329,0.002 c-1.666,0-3.333-0.019-4.998-0.071C24.168,980.4,7.018,966.813,2.041,948.216c-0.813-3.037-1.367-6.144-2.041-9.218 C0,729.318,0,519.639,0,309.96z"
					},
					children: [
					]
				},
				{
					id: "share-square",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M379.216,77.734c0,2.133,0,4.266,0,6.399c0,170.495,0,340.99-0.001,511.486 c0,2.167,0.029,4.334-0.022,6.5c-0.327,13.836-8.725,22.184-22.263,22.155c-13.512-0.029-21.846-8.413-22.13-22.283 c-0.044-2.166-0.016-4.333-0.016-6.5c0-170.662,0-341.324,0-511.986c0-1.944,0-3.888,0-7.194c-2.148,2.031-3.428,3.185-4.646,4.402 c-30.174,30.162-60.348,60.325-90.506,90.503c-6.238,6.242-13.546,9.226-22.234,6.551c-8.432-2.596-13.893-8.45-15.85-17.104 c-1.861-8.231,1.206-14.985,7.007-20.772c18.17-18.126,36.304-36.288,54.452-54.436c25.571-25.573,51.124-51.165,76.725-76.709 c7.358-7.341,16.035-9.941,26.002-6.228c2.397,0.893,4.733,2.489,6.555,4.306c44.487,44.368,88.916,88.793,133.311,133.252 c8.034,8.045,9.572,17.915,4.487,26.864c-5.263,9.262-14.988,13.916-24.965,10.819c-4.215-1.308-8.284-4.301-11.485-7.471 c-29.957-29.671-59.722-59.536-89.484-89.403c-1.263-1.268-1.957-3.104-2.916-4.675C380.563,76.716,379.89,77.225,379.216,77.734z"
					},
					children: [
					]
				}
			]
		}
	]
},
	share: share,
	shoe: shoe,
	"shopping-cart": {
	id: "shopping-cart",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "shopping-cart",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "shopping-cart",
					name: "",
					type: "text",
					value: "Shopping Cart icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "shopping-cart",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101"
			},
			children: [
				{
					id: "shopping-cart",
					name: "circle",
					type: "element",
					value: "",
					attributes: {
						cx: "587.7",
						cy: "678",
						r: "38.6"
					},
					children: [
					]
				},
				{
					id: "shopping-cart",
					name: "circle",
					type: "element",
					value: "",
					attributes: {
						cx: "312.4",
						cy: "678",
						r: "38.6"
					},
					children: [
					]
				},
				{
					id: "shopping-cart",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M646 322H278.3l-4.3-20.5c-.5-2.1-1.3-4.3-2.4-6-2.8-7.2-9.8-12.5-18-12.5h-78.5c-10.7 0-19.1 8.7-19.1 19.3v.1c0 10.7 8.4 19.6 19.1 19.6H239l53.3 249.2-16.2 38c-.4.9-.7 1.7-1 2.6-.1.3-.1.5-.2.8 0 .1 0 .2-.1.3-.4 1.6-.6 3.2-.6 4.9 0 10.6 8.6 19.3 19.3 19.3h314.9c10.6 0 19.3-8.9 19.3-19.5s-8.6-19.5-19.3-19.5H323.6l5.9-16.5c1.4-2.9 2-5.9 1.9-8.9 0-1.5-.1-2.9-.4-4.4l-2.6-12 317.9-37.4c11.8 0 21.7-9.6 21.7-21.4V343.1c0-11.8-10.1-21.1-22-21.1z"
					},
					children: [
					]
				}
			]
		}
	]
},
	sheraton: sheraton,
	"single-view": {
	id: "single-view",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "single-view",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "single-view",
					name: "",
					type: "text",
					value: "Single View Mode icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "single-view",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				fill: "#010101",
				d: "M621.3 336.2H156.1V665.7h511.6V336.2h-46.4zm0 282.4H202.6V383.3h418.6l.1 235.3z"
			},
			children: [
			]
		}
	]
},
	snapchat: snapchat,
	"sold-out": {
	id: "sold-out",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512.293 200.812"
	},
	children: [
		{
			id: "sold-out",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "sold-out",
					name: "",
					type: "text",
					value: "Sold Out icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "sold-out",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M482.293 200.812H30c-16.542 0-30-13.458-30-30V30C0 13.458 13.458 0 30 0h452.293c16.542 0 30 13.458 30 30v140.812c0 16.542-13.458 30-30 30zM30 20c-5.514 0-10 4.486-10 10v140.812c0 5.514 4.486 10 10 10h452.293c5.514 0 10-4.486 10-10V30c0-5.514-4.486-10-10-10H30z",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "sold-out",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M69.13 73.298c-3.11 1.066-5.813 3.36-5.813 6.716 0 4.013 2.212 6.47 11.957 10.237 14.495 5.57 17.77 13.27 17.77 20.8 0 12.697-10.563 20.968-22.684 21.214v-4.75c3.93-1.23 7.29-3.03 7.452-7.534.164-5.16-5.896-7.29-9.827-9.01-10.318-4.34-19.9-9.007-19.9-21.864 0-12.448 9.01-20.146 21.047-20.555v4.75l-.002-.002zM48.084 112.69c0-1.72.328-4.013 2.62-4.013 1.64 0 2.785 1.31 3.03 2.702 1.147 6.55 5.733 14.66 12.94 16.13v4.75c-7.125-.163-8.682-3.03-11.63-3.03-2.62 0-2.374 2.703-4.422 2.703-2.54 0-2.54-3.03-2.54-3.44V112.69h.002zm42.75-26.45c0 1.882-.328 3.93-2.703 3.93-1.963 0-2.7-1.556-2.945-3.194-.9-6.06-5.98-12.284-12.366-13.676v-4.75c5.16.082 10.645 3.194 11.546 3.194 2.13 0 1.966-2.948 4.095-2.948 2.54 0 2.375 2.784 2.375 3.44V86.24zm32.842-12.942c-3.85 1.394-4.176 3.85-4.176 5.897v42.42c0 2.05.327 4.505 4.176 5.897v4.75c-17.36-1.556-25.47-15.56-25.47-31.856 0-16.297 8.108-30.3 25.47-31.857v4.748zm3.685 54.215c3.85-1.393 4.18-3.85 4.18-5.896V79.195c0-2.047-.33-4.504-4.177-5.896v-4.75c17.362 1.554 25.47 15.56 25.47 31.855s-8.107 30.3-25.47 31.855v-4.75.003h-.002zm55.2 3.522h-21.62c-.325 0-3.027-.164-3.027-2.54 0-1.145.736-1.882 1.802-2.21 2.866-.9 2.784-1.392 2.784-4.422V78.95c0-3.03.08-3.52-2.785-4.422-1.065-.328-1.802-1.064-1.802-2.21 0-2.376 2.702-2.54 3.03-2.54h23.176c.326 0 3.03.164 3.03 2.54 0 1.145-.738 1.882-1.803 2.21-2.867.9-2.785 1.392-2.785 4.422v52.085zm3.688-4.75c6.634-.9 10.4-6.633 12.12-14.25.41-1.8 1.393-2.292 3.112-2.292 1.882 0 2.045 1.556 2.045 3.11v18.182h-17.28v-4.75h.002zm44.06 4.75h-20.8c-1.8 0-3.85-.164-3.85-2.54 0-1.145.737-1.882 1.802-2.21 2.864-.9 2.782-1.392 2.782-4.422V78.95c0-1.23.164-3.44-1.392-3.93-1.638-.574-3.193-.82-3.193-2.867 0-2.13 2.048-2.375 3.686-2.375h20.965v61.257zm3.686-61.257c13.922-.164 25.55 9.5 26.534 30.63.9 19.244-12.94 30.627-26.534 30.627v-4.75c4.996-.655 5.24-5.323 5.24-8.435V82.963c0-3.112-.244-7.78-5.24-8.435v-4.75zm84.192 3.52c-3.85 1.394-4.177 3.85-4.177 5.897v42.42c0 2.05.327 4.505 4.176 5.897v4.75c-17.36-1.556-25.47-15.56-25.47-31.856 0-16.297 8.108-30.3 25.47-31.857v4.748zm3.686 54.215c3.85-1.393 4.18-3.85 4.18-5.896V79.195c0-2.047-.33-4.504-4.178-5.896v-4.75c17.362 1.554 25.47 15.56 25.47 31.855s-8.107 30.3-25.47 31.855v-4.75.003h-.002zm60.934 4.75c-6.47 0-11.465-.082-17.115-3.194-7.372-4.096-8.355-7.207-8.355-11.3V78.95c0-3.03.082-3.52-2.784-4.422-1.062-.328-1.8-1.064-1.8-2.21 0-2.376 2.7-2.54 3.03-2.54h23.176c.327 0 3.03.164 3.03 2.54 0 1.145-.737 1.882-1.802 2.21-2.866.9-2.785 1.392-2.785 4.422v39.39c0 .82-.737 7.29 5.404 9.09v4.833h.002zm14.66-49.546c-1.312-10.238-6.553-7.044-6.553-10.565 0-2.54 3.36-2.375 4.26-2.375h9.337c.9 0 4.26-.164 4.26 2.375 0 3.52-5.242.328-6.553 10.564v30.873c-.655 13.51-10.4 18.424-15.724 18.506v-4.83c7.533-2.294 10.48-6.552 10.973-13.84v-30.71zm15.726-12.94h11.793v4.75c-4.26 3.03-5.405 8.436-6.143 12.776-.245 1.802-.655 3.93-2.948 3.93-2.457 0-2.702-2.046-2.702-2.374V69.776zm15.478 0h20.064v52.086c0 3.03-.082 3.52 2.784 4.422 1.064.328 1.802 1.064 1.802 2.21 0 2.376-2.702 2.54-3.03 2.54h-23.176c-.327 0-3.03-.164-3.03-2.54 0-1.145.737-1.882 1.802-2.21 2.866-.9 2.784-1.392 2.784-4.422V69.778zm35.542 19.08c0 .33-.245 2.377-2.702 2.377-2.293 0-2.702-2.13-2.948-3.93-.737-4.34-1.884-9.746-6.142-12.776v-4.75h11.792v19.08z"
			},
			children: [
			]
		}
	]
},
	spotify: spotify,
	standings: standings,
	sort: sort,
	stadium: stadium,
	stats: stats,
	stories: stories,
	student: student,
	star: star,
	subway: subway,
	"scrub-head": {
	id: "scrub-head",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "scrub-head",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "scrub-head",
					name: "",
					type: "text",
					value: "Scrub Head icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "scrub-head",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "412",
				cy: "501",
				r: "256"
			},
			children: [
			]
		}
	]
},
	"sad-baseball": {
	id: "sad-baseball",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 57 57",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "sad-baseball",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "sad-baseball",
					name: "",
					type: "text",
					value: "Sad Baseball icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "sad-baseball",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(1 1)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "sad-baseball",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M0 25c7.468.313 12-3 17-8s6-8 8-17",
						fill: "none",
						stroke: "#DDD",
						strokeLinejoin: "round"
					},
					children: [
					]
				},
				{
					id: "sad-baseball",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						stroke: "#DDD",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					},
					children: [
						{
							id: "sad-baseball",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M16 15l3.175 3.175M18 12l3.488 2.817M20 9l3.756 2.415M22 5l3.98 2.057M23 2l4.203 1.565M13 18l2.817 3.488M10 20l2.415 3.756M6 22l2.057 3.98M2 23l1.565 4.203"
							},
							children: [
							]
						}
					]
				},
				{
					id: "sad-baseball",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M55.51 30.14c-7.468-.313-12 3-17 8s-6 8-8 17",
						fill: "none",
						stroke: "#DDD",
						strokeLinejoin: "round"
					},
					children: [
					]
				},
				{
					id: "sad-baseball",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						stroke: "#DDD",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					},
					children: [
						{
							id: "sad-baseball",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M39.51 40.14l-3.175-3.175M37.51 43.14l-3.488-2.818M35.51 46.14l-3.756-2.415M33.51 50.14l-3.98-2.057M32.51 53.14l-4.204-1.566M42.51 37.14l-2.817-3.488M45.51 35.14l-2.415-3.757M49.51 33.14l-2.057-3.98M53.51 32.14l-1.565-4.204"
							},
							children: [
							]
						}
					]
				},
				{
					id: "sad-baseball",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M25 37c.571-1.333 1.571-2 3-2s2.429.667 3 2",
						fill: "none",
						stroke: "#666",
						strokeWidth: "1.5",
						strokeLinecap: "round"
					},
					children: [
					]
				},
				{
					id: "sad-baseball",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						stroke: "transparent",
						d: "M19.5 27c-1.372 0-2.5-1.395-2.5-3.094-.004-.322.133-.622.358-.784a.605.605 0 0 1 .728 0c.225.162.362.462.358.784 0 .733.464 1.307 1.056 1.307.592 0 1.056-.574 1.056-1.307-.004-.322.133-.622.358-.784a.605.605 0 0 1 .728 0c.225.162.362.462.358.784C22 25.605 20.872 27 19.5 27zM36.5 27c-1.372 0-2.5-1.395-2.5-3.094-.004-.322.133-.622.358-.784a.605.605 0 0 1 .728 0c.225.162.362.462.358.784 0 .733.464 1.307 1.056 1.307.592 0 1.056-.574 1.056-1.307-.004-.322.133-.622.358-.784a.605.605 0 0 1 .728 0c.225.162.362.462.358.784C39 25.605 37.872 27 36.5 27z",
						fill: "#666"
					},
					children: [
					]
				},
				{
					id: "sad-baseball",
					name: "circle",
					type: "element",
					value: "",
					attributes: {
						fill: "none",
						stroke: "#AAA",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						cx: "27.724",
						cy: "27.724",
						r: "27.724"
					},
					children: [
					]
				}
			]
		}
	]
},
	support: support,
	taxi: taxi,
	swap: swap,
	teams: teams,
	"t-shirt": {
	id: "t-shirt",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 547.108 504.576"
	},
	children: [
		{
			id: "t-shirt",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "t-shirt",
					name: "",
					type: "text",
					value: "T-Shirt icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "t-shirt",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M536.566 93.644c-8.815-6.737-17.723-13.37-26.82-19.718-15.37-10.725-30.755-21.442-46.447-31.68-12.464-8.132-25.632-15.077-39.555-20.495-14.67-5.707-29.408-11.264-43.92-17.35-10.944-4.59-21.73-5.373-33.11-1.838-12.41 3.855-24.898 7.565-37.543 10.522-17.737 4.148-35.882 4.11-53.897 2.644-18.586-1.513-36.51-6.404-54.045-12.787-8.978-3.267-18.277-4.21-27.484-.77-13.335 4.984-26.586 10.19-39.88 15.28-19.13 7.323-37.446 16.274-54.436 27.756C64.832 55.07 50.308 65.052 35.942 75.25c-9.445 6.707-18.88 13.502-27.713 20.975-8.203 6.94-10.362 17.497-6.08 27.322 4.17 9.572 8.974 18.873 13.63 28.228 7.774 15.618 15.454 31.288 23.594 46.715 2.783 5.274 6.23 10.484 10.43 14.66 7.28 7.236 16.606 6.964 25.67 4.126 8.78-2.75 17.34-6.227 25.927-9.57 10.17-3.957 12.67-.535 14.217 8.63.08.482.026.99.03 1.484.22 23.02.514 46.04.645 69.06.33 57.98.567 115.963.895 173.945.038 6.8.43 13.596.63 20.395.353 11.897 13.594 23.49 25.244 23.355 42.995-.496 86-.197 129-.197v-.192c43.37 0 86.742.02 130.114-.043 2.802-.004 5.7-.274 8.388-1.02 12.782-3.55 19.227-12.246 19.456-26.682.4-25.133.62-50.27.778-75.407.113-17.952-.085-35.907.012-53.86.23-42.872.51-85.744.934-128.615.03-3.1.95-6.382 2.27-9.2.697-1.49 3.075-2.842 4.825-3.027 2.188-.23 4.576.604 6.764 1.323 10.84 3.56 21.49 7.822 32.503 10.69 9.465 2.465 17.937-1.104 23.205-9.28 5.837-9.057 10.778-18.72 15.712-28.325 8.873-17.272 17.43-34.707 26.158-52.053 6.323-12.57 5.632-25.683-6.612-35.04zM219.7 25.224c17.907 3.887 35.91 6.76 54.252 6.754 18.208-.006 36.07-2.962 54.8-6.987-3.358 8.613-8.65 13.785-14.918 18.022-9.606 6.493-20.417 9.153-31.873 10.293-13.656 1.36-26.777-.263-39.415-5.426-8.857-3.62-16.315-9.16-21.386-17.497-.748-1.228-1.336-2.552-1.998-3.832.18-.44.358-.883.537-1.325zm53.744 463.586c-42.622 0-85.244.003-127.866-.002 42.622.005 85.244.002 127.866.002 42.873 0 85.746.005 128.62-.004-42.874.01-85.747.004-128.62.004z"
			},
			children: [
			]
		}
	]
},
	"telephone-tty": {
	id: "telephone-tty",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 71 80"
	},
	children: [
		{
			id: "telephone-tty",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "telephone-tty",
					name: "",
					type: "text",
					value: "Telephone TTY icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "telephone-tty",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M63.5 78.49c0 .834-.672 1.51-1.5 1.51H9c-.828 0-1.5-.676-1.5-1.51v-6.037c0-.834.672-1.51 1.5-1.51h53c.828 0 1.5.677 1.5 1.51v6.038zM41 65.912c0 .834-.672 1.51-1.5 1.51h-8c-.83 0-1.5-.677-1.5-1.51v-6.038c0-.833.67-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM26 65.912c0 .834-.67 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.83 0 1.5.677 1.5 1.51v6.038zM11 65.912c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM56 65.912c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM71 65.912c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM48.5 53.333c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM33.5 53.333c0 .834-.672 1.51-1.5 1.51h-8c-.83 0-1.5-.677-1.5-1.51v-6.038c0-.833.67-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM18.5 53.333c0 .834-.67 1.51-1.5 1.51H9c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.83 0 1.5.677 1.5 1.51v6.038zM63.5 53.333c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM41 40.755c0 .834-.672 1.51-1.5 1.51h-8c-.83 0-1.5-.677-1.5-1.51v-6.038c0-.833.67-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM26 40.755c0 .834-.67 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.83 0 1.5.677 1.5 1.51v6.038zM11 40.755c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM56 40.755c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM71 40.755c0 .834-.672 1.51-1.5 1.51h-8c-.828 0-1.5-.677-1.5-1.51v-6.038c0-.833.672-1.51 1.5-1.51h8c.828 0 1.5.677 1.5 1.51v6.038zM35.5 10.063c8.283 0 12.5 1.42 12.5 5.03h22.5C70.5 5.924 56.21 0 35.5 0S.5 5.924.5 15.094H23c0-3.612 4.216-5.03 12.5-5.03M48 17.107v5.03c0 .834.672 1.51 1.5 1.51H69c.828 0 1.5-.676 1.5-1.51v-5.03H48zM.5 17.107v5.03c0 .834.67 1.51 1.5 1.51h19.5c.83 0 1.5-.676 1.5-1.51v-5.03H.5z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	telephone: telephone,
	tickets: tickets,
	"tickets-2": {
	id: "tickets-2",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "tickets-2",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tickets-2",
					name: "",
					type: "text",
					value: "Tickets icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tickets-2",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(9 4)",
				fillRule: "evenodd"
			},
			children: [
				{
					id: "tickets-2",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.0676533.0000302L7.5979531.014595c.2736752 1.2598814 1.4324482 2.2060391 2.8204108 2.2060391 1.3831432 0 2.5386857-.9395985 2.8175279-2.1929267l6.5098044.0134698.1166481.0069473c.4972076.0588817.8822949.4824187.8811041.9952532l-.0652801 29.0737477c-.0013361.5522456-.4499969.9989391-1.0022431.9978483l-6.4372699-.0151675c-.2738924-1.2596072-1.4325305-2.2054901-2.8202914-2.2054901-1.3833402 0-2.5390149.9398661-2.817647 2.1934621l-6.6028342-.0129479-.116702-.0068938c-.4972072-.0588816-.882291-.4824186-.8810505-.9952529L.0654105.9978248C.0666928.445558.5153863-.0011441 1.0676533.0000302z",
						opacity: ".2983863"
					},
					children: [
					]
				},
				{
					id: "tickets-2",
					name: "g",
					type: "element",
					value: "",
					attributes: {
						transform: "translate(3.771429 6.6)",
						fill: "#666"
					},
					children: [
						{
							id: "tickets-2",
							name: "path",
							type: "element",
							value: "",
							attributes: {
								d: "M0 1.7004272l3.2992908.0124018.0015024-1.7004272L.0030048 0zM5.1575921 1.708695l3.299696.0137799.0010973-1.6976713L5.1597868.0124018zM10.3151842 1.7252308l3.2977885.0110239.0030048-1.7018052-3.2992909-.0096459z"
							},
							children: [
							]
						}
					]
				},
				{
					id: "tickets-2",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M1.0676083 1.0023204L1.002141 31.5489006l5.8801905.0124257c.2512383-.5579443.6284956-1.0457426 1.0950635-1.4262824.6672262-.5441997 1.516299-.869807 2.440597-.869807.9274944 0 1.7792463.327859 2.4475142.8754621.4678877.3834042.845434.8748997 1.0954062 1.4368446l5.7143366.013439.0654675-30.5455686-5.7871228-.0132777c-.2512384.5578899-.6284733 1.0456418-1.0950048 1.4261519-.6672262.5441997-1.516299.869807-2.4405969.869807-.9274945 0-1.7792464-.327859-2.4475143-.875462-.4678818-.3833995-.8454245-.8748876-1.0953969-1.4368237l-5.8074725-.013489z",
						fillOpacity: "0.25",
						strokeWidth: "2"
					},
					children: [
					]
				}
			]
		}
	]
},
	"traffic-light": {
	id: "traffic-light",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 454.663 511.647"
	},
	children: [
		{
			id: "traffic-light",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "traffic-light",
					name: "",
					type: "text",
					value: "Traffic light icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "traffic-light",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M85.246 255.814c0-66.01-.02-132.02.013-198.03.01-19.935 8.21-35.82 24.328-47.465C118.988 3.526 129.68.077 141.282.063c57.34-.07 114.682-.095 172.023-.005 28.16.043 52.13 21.622 55.624 49.8.313 2.528.463 5.094.463 7.643.022 132.233.024 264.466.015 396.698-.002 27.695-18.78 50.83-45.79 56.297-3.663.74-7.466 1.092-11.205 1.096-56.702.067-113.403.063-170.105.04-28.172-.012-51.94-20.242-56.393-48.025-.514-3.208-.64-6.506-.643-9.763-.035-66.012-.026-132.022-.026-198.03zm85.292-.094c-.013 31.473 25.362 56.902 56.785 56.906 31.233.004 56.757-25.376 56.8-56.48.042-31.637-25.29-57.106-56.797-57.104-31.344.003-56.775 25.384-56.788 56.678zm56.865 199.103c31.344-.066 56.785-25.66 56.72-57.06-.067-31.347-25.647-56.74-57.077-56.66-31.193.078-56.552 25.668-56.508 57.023.044 31.233 25.65 56.762 56.865 56.697zm-.01-397.977c-31.14-.056-56.765 25.408-56.855 56.497-.09 31.586 25.293 57.188 56.737 57.223 31.248.035 56.786-25.426 56.847-56.677.06-31.408-25.378-56.988-56.73-57.044zM397.97 144.583v-87.76h2.38c12.01 0 24.02.16 36.023-.046 11.696-.2 18.893 10.506 18.138 20.054-.19 2.408-1.537 4.854-2.797 7.024-6.057 10.43-13.68 19.735-21.86 28.507-9.775 10.483-20.037 20.51-30.098 30.727-.476.484-1.043.88-1.785 1.496zM56.722 341.102v87.86c-2.175-2.007-4.092-3.728-5.958-5.503-15.4-14.655-29.98-30.054-42.553-47.252-1.963-2.686-3.755-5.51-5.453-8.375-3.926-6.62-3.483-13.47 1.167-19.63 3.564-4.723 8.2-7.183 14.242-7.132 12.005.104 24.01.03 36.016.03.774.002 1.546.002 2.54.002zM398.03 341.102h23.34c4.9 0 9.814.213 14.702-.044 10.494-.55 17.388 8.27 18.486 16.74.492 3.793-.81 6.958-2.645 10.056-6.07 10.254-13.477 19.53-21.588 28.173-10.24 10.914-20.93 21.408-31.43 32.078-.19.192-.438.325-.865.636v-87.638zM56.67 286.85c-3.386-3.164-6.58-6.043-9.653-9.045-12.863-12.565-25.166-25.647-36.045-39.994-2.91-3.837-5.478-7.936-8.182-11.93-5.235-7.73-2.168-15.484 1.57-20.337 3.148-4.087 7.303-6.498 12.587-6.51 12.86-.03 25.72-.01 38.578-.005.342 0 .685.062 1.144.106v87.717zM397.98 286.75v-87.73h2.183c12.148 0 24.303.244 36.443-.073 11.05-.288 19.118 10.4 17.79 20.227-.51 3.773-2.958 7.486-5.17 10.79-10.393 15.52-22.997 29.197-36.14 42.388-4.408 4.425-8.998 8.67-13.51 12.99-.443.425-.92.814-1.596 1.41zM56.668 144.76c-1.777-1.82-3.24-3.318-4.706-4.814-13.366-13.635-26.692-27.32-38.457-42.39-4.045-5.18-7.808-10.652-11.08-16.347C-2.332 72.924.59 63.63 9.122 59.176c2.435-1.27 5.35-2.2 8.064-2.25 12.778-.23 25.563-.103 38.346-.098.342 0 .683.054 1.138.092v87.837z"
			},
			children: [
			]
		}
	]
},
	tiktok: tiktok,
	"ticket-exchange": {
	id: "ticket-exchange",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "156 245 512 512"
	},
	children: [
		{
			id: "ticket-exchange",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "ticket-exchange",
					name: "",
					type: "text",
					value: "Ticket Exchange icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "ticket-exchange",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M612.1 359.5H277.7l68.2-68.2c10.6-10.6 10.6-27.8 0-38.4-10.6-10.6-27.8-10.6-38.4 0L192.9 367.4c-.6.6-1.2 1.3-1.8 2 0 .1-.1.1-.1.2-.5.6-1 1.3-1.5 2-.1.1-.1.2-.2.3-.4.7-.8 1.3-1.2 2-.1.1-.1.2-.2.3-.4.7-.7 1.4-1 2.1v.1c0 .1 0 .1-.1.2-.3.7-.6 1.5-.8 2.3 0 .1 0 .1-.1.2l-.6 2.4v.2c-.2.8-.3 1.6-.4 2.4v.1c-.1.8-.1 1.7-.1 2.5s0 1.7.1 2.5v.1c.1.8.2 1.6.4 2.4v.2l.6 2.4v.2c.2.8.5 1.5.8 2.3 0 .1.1.2.1.3.3.7.6 1.4 1 2.1.1.1.1.2.2.3.4.7.8 1.4 1.2 2 .1.1.1.2.2.3.5.7.9 1.3 1.5 2 0 .1.1.1.1.2.6.7 1.2 1.4 1.8 2l114.5 114.5c10.6 10.6 27.8 10.6 38.4 0 10.6-10.6 10.6-27.8 0-38.4l-68.2-68.2h334.4c15 0 27.1-12.1 27.1-27.1.2-15.2-11.9-27.3-26.9-27.3zM639.1 613.1c-.1-.9-.2-1.7-.4-2.5v-.2l-.6-2.4c0-.1 0-.1-.1-.2-.2-.8-.5-1.5-.8-2.3 0-.1 0-.1-.1-.2v-.1c-.3-.7-.6-1.4-1-2.1-.1-.1-.1-.2-.2-.3-.4-.7-.8-1.4-1.2-2-.1-.1-.1-.2-.2-.3-.5-.7-.9-1.3-1.5-2 0-.1-.1-.1-.1-.2-.6-.7-1.2-1.4-1.8-2L516.8 481.9c-10.6-10.6-27.8-10.6-38.4 0-10.6 10.6-10.6 27.8 0 38.4l68.2 68.2H212.1c-15 0-27.1 12.2-27.1 27.1 0 15 12.1 27.1 27.1 27.1h334.4l-68.2 68.2c-10.6 10.6-10.6 27.8 0 38.4 10.6 10.6 27.8 10.6 38.4 0l114.5-114.5c.6-.6 1.2-1.3 1.8-2 0-.1.1-.1.1-.2.5-.6 1-1.3 1.5-2 .1-.1.1-.2.2-.3.4-.7.8-1.3 1.2-2 .1-.1.1-.2.2-.3.4-.7.7-1.4 1-2.1 0-.1.1-.2.1-.3.3-.7.6-1.5.8-2.3v-.2l.6-2.4v-.2c.2-.8.3-1.6.4-2.4v-.1c.1-.8.1-1.7.1-2.5s0-1.6-.1-2.4z"
			},
			children: [
			]
		}
	]
},
	transactions: transactions,
	"trash-can": {
	id: "trash-can",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 10 14"
	},
	children: [
		{
			id: "trash-can",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "trash-can",
					name: "",
					type: "text",
					value: "Trash can icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "trash-can",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M.714 12.056A1.44 1.44 0 002.143 13.5h5.714a1.44 1.44 0 001.429-1.444V3.389H.714v8.667zM10 1.222H7.5L6.786.5H3.214l-.714.722H0v1.445h10V1.222z"
			},
			children: [
			]
		}
	]
},
	train: train,
	trash: trash,
	trolley: trolley,
	tumblr: tumblr,
	trophy: trophy,
	"tv-live": {
	id: "tv-live",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "tv-live",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tv-live",
					name: "",
					type: "text",
					value: "TV Live icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tv-live",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 8)",
				fillRule: "nonzero"
			},
			children: [
				{
					id: "tv-live",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M2.2181112 19.1228954c-.5877773 0-1.064265-.457801-1.064265-1.0225271V2.1763733c0-.5647262.4764877-1.0225271 1.064265-1.0225271h25.2879402c.5877774 0 1.0642651.457801 1.0642651 1.022527v15.9239951c0 .5647261-.4764877 1.0225271-1.0642651 1.0225271H2.2181112z",
						opacity: ".3037342"
					},
					children: [
					]
				},
				{
					id: "tv-live",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.2307692 21.9230769v2.3076923H5.7692308v-2.3076923h18.4615384zM28.5703167 0c.6372517 0 1.1538462.5165945 1.1538462 1.1538461V19.122896c0 .6372517-.5165945 1.1538462-1.1538462 1.1538462H1.1538462C.5165944 20.2767421 0 19.7601476 0 19.1228959V1.1538462C0 .5165944.5165945 0 1.1538461 0h27.4164706zm-1.1538461 2.3076923H2.3076923v15.6613575h25.1087783V2.3076923z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"tv-archive": {
	id: "tv-archive",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 40 40"
	},
	children: [
		{
			id: "tv-archive",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "tv-archive",
					name: "",
					type: "text",
					value: "TV Archive icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "tv-archive",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				transform: "translate(5 8)",
				fillRule: "nonzero"
			},
			children: [
				{
					id: "tv-archive",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						opacity: ".15",
						d: "M27.4164706 17.9690498V2.3076923H2.3076923v15.6613575z"
					},
					children: [
					]
				},
				{
					id: "tv-archive",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M24.2307692 21.9230769v2.3076923H5.7692308v-2.3076923h18.4615384zM28.5703167 0c.6372517 0 1.1538462.5165945 1.1538462 1.1538461V19.122896c0 .6372517-.5165945 1.1538462-1.1538462 1.1538462H1.1538462C.5165944 20.2767421 0 19.7601476 0 19.1228959V1.1538462C0 .5165944.5165945 0 1.1538461 0h27.4164706zm-1.1538461 2.3076923H2.3076923v15.6613575h25.1087783V2.3076923z"
					},
					children: [
					]
				}
			]
		}
	]
},
	"twitter-circle": {
	id: "twitter-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "twitter-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "twitter-circle",
					name: "",
					type: "text",
					value: "Twitter circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "twitter-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M400 200c0 110.5-89.5 200-200 200S0 310.5 0 200 89.5 0 200 0s200 89.5 200 200zM163.4 305.5c88.7 0 137.2-73.5 137.2-137.2 0-2.1 0-4.2-.1-6.2 9.4-6.8 17.6-15.3 24.1-25-8.6 3.8-17.9 6.4-27.7 7.6 10-6 17.6-15.4 21.2-26.7-9.3 5.5-19.6 9.5-30.6 11.7-8.8-9.4-21.3-15.2-35.2-15.2-26.6 0-48.2 21.6-48.2 48.2 0 3.8.4 7.5 1.3 11-40.1-2-75.6-21.2-99.4-50.4-4.1 7.1-6.5 15.4-6.5 24.2 0 16.7 8.5 31.5 21.5 40.1-7.9-.2-15.3-2.4-21.8-6v.6c0 23.4 16.6 42.8 38.7 47.3-4 1.1-8.3 1.7-12.7 1.7-3.1 0-6.1-.3-9.1-.9 6.1 19.2 23.9 33.1 45 33.5-16.5 12.9-37.3 20.6-59.9 20.6-3.9 0-7.7-.2-11.5-.7 21.1 13.8 46.5 21.8 73.7 21.8",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	twitch: twitch,
	"twitter-circle-logo": {
	id: "twitter-circle-logo",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "twitter-circle-logo",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "twitter-circle-logo",
					name: "",
					type: "text",
					value: "Twitter Social Icon Circle Color",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "twitter-circle-logo",
			name: "circle",
			type: "element",
			value: "",
			attributes: {
				cx: "200",
				cy: "200",
				r: "200",
				fill: "#1da1f2"
			},
			children: [
			]
		},
		{
			id: "twitter-circle-logo",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M163.4 305.5c88.7 0 137.2-73.5 137.2-137.2 0-2.1 0-4.2-.1-6.2 9.4-6.8 17.6-15.3 24.1-25-8.6 3.8-17.9 6.4-27.7 7.6 10-6 17.6-15.4 21.2-26.7-9.3 5.5-19.6 9.5-30.6 11.7-8.8-9.4-21.3-15.2-35.2-15.2-26.6 0-48.2 21.6-48.2 48.2 0 3.8.4 7.5 1.3 11-40.1-2-75.6-21.2-99.4-50.4-4.1 7.1-6.5 15.4-6.5 24.2 0 16.7 8.5 31.5 21.5 40.1-7.9-.2-15.3-2.4-21.8-6v.6c0 23.4 16.6 42.8 38.7 47.3-4 1.1-8.3 1.7-12.7 1.7-3.1 0-6.1-.3-9.1-.9 6.1 19.2 23.9 33.1 45 33.5-16.5 12.9-37.3 20.6-59.9 20.6-3.9 0-7.7-.2-11.5-.7 21.1 13.8 46.5 21.8 73.7 21.8",
				fill: "#fff"
			},
			children: [
			]
		}
	]
},
	twitter: twitter,
	"video-fv": {
	id: "video-fv",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 31.5 18.5",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "video-fv",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "video-fv",
					name: "",
					type: "text",
					value: "Field Vision Video icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "video-fv",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M1.75 0C.793 0 0 .793 0 1.75v15c0 .957.793 1.75 1.75 1.75h21c.957 0 1.75-.793 1.75-1.75v-2.678l5.973 2.375a.75.75 0 0 0 1.027-.697v-13a.75.75 0 0 0-1.027-.697L24.5 4.428V1.75C24.5.794 23.707 0 22.75 0zm0 1.5h21c.151 0 .25.099.25.25v15c0 .151-.099.25-.25.25h-21c-.151 0-.25-.099-.25-.25v-15c0-.151.099-.25.25-.25zM30 3.856v10.788l-5.5-2.187V6.043zM4.25 13.75c-1 0-1 1.5 0 1.5h16.332c1 0 1-1.5 0-1.5z"
			},
			children: [
			]
		}
	]
},
	video: video,
	upgrade: upgrade,
	uber: uber,
	"volume-control": {
	id: "volume-control",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "312 559 511.5 374"
	},
	children: [
		{
			id: "volume-control",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "volume-control",
					name: "",
					type: "text",
					value: "Volume Control icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "volume-control",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M548.3 578.7v334.7c0 5.3-1.9 9.9-5.8 13.8-3.9 3.9-8.5 5.8-13.8 5.8s-9.9-1.9-13.8-5.8L412.3 824.8h-80.6c-5.3 0-9.9-1.9-13.8-5.8-3.9-4-5.9-8.6-5.9-13.9V687c0-5.3 1.9-9.9 5.8-13.8 3.9-3.9 8.5-5.8 13.8-5.8h80.6l102.6-102.6c3.9-3.9 8.5-5.8 13.8-5.8s9.9 1.9 13.8 5.8c4 3.9 5.9 8.5 5.9 13.9zM703.2 746c0 15.6-4.4 30.1-13.1 43.6s-20.2 23-34.6 28.8c-2 1-4.6 1.5-7.7 1.5-5.3 0-9.9-1.9-13.8-5.7-3.9-3.8-5.8-8.4-5.8-14 0-4.3 1.2-7.9 3.7-10.9s5.5-5.5 8.9-7.7c3.5-2.2 6.9-4.5 10.5-7.1 3.5-2.5 6.5-6.2 8.9-10.9 2.5-4.7 3.7-10.6 3.7-17.5s-1.2-12.8-3.7-17.5c-2.5-4.7-5.5-8.4-8.9-10.9-3.5-2.5-6.9-4.9-10.5-7.1-3.5-2.2-6.5-4.7-8.9-7.7-2.4-3-3.7-6.6-3.7-10.9 0-5.5 1.9-10.2 5.8-14 3.9-3.8 8.5-5.7 13.8-5.7 3.1 0 5.6.5 7.7 1.5 14.3 5.5 25.9 15.1 34.6 28.6 8.7 13.4 13.1 28.1 13.1 43.6z"
			},
			children: [
			]
		},
		{
			id: "volume-control",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M702 915.6c-7.9 0-15.5-4.8-18.6-12.6-4.1-10.3.9-21.9 11.2-26 25.9-10.4 48.1-28 64-51.1 16.3-23.6 24.9-51.3 24.9-80.1s-8.6-56.5-24.9-80.1c-15.9-23.1-38.1-40.8-64-51.1-10.3-4.1-15.3-15.7-11.2-26s15.7-15.3 26-11.2c33.3 13.3 61.7 36 82.1 65.6 20.9 30.3 32 65.9 32 102.9s-11.1 72.5-32 102.9c-20.4 29.6-48.8 52.3-82.1 65.6-2.4.8-4.9 1.2-7.4 1.2z"
			},
			children: [
			]
		}
	]
},
	"volume-muted": {
	id: "volume-muted",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		viewBox: "0 0 512 375",
		xmlns: "http://www.w3.org/2000/svg"
	},
	children: [
		{
			id: "volume-muted",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "volume-muted",
					name: "",
					type: "text",
					value: "Volume Muted icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "volume-muted",
			name: "g",
			type: "element",
			value: "",
			attributes: {
				fillRule: "evenodd"
			},
			children: [
				{
					id: "volume-muted",
					name: "path",
					type: "element",
					value: "",
					attributes: {
						d: "M440.9 188.744l65.89-62.51c3.034-2.88 4.707-6.726 4.71-10.832.002-4.113-1.67-7.968-4.71-10.86-6.157-5.84-16.173-5.842-22.33 0l-66.157 62.762-66.156-62.762c-6.15-5.835-16.165-5.836-22.334.003-3.038 2.89-4.71 6.745-4.707 10.857.003 4.106 1.676 7.953 4.71 10.833l65.89 62.51-65.89 62.508c-3.037 2.882-4.71 6.734-4.71 10.847 0 4.112 1.673 7.964 4.714 10.85 6.162 5.832 16.18 5.83 22.328-.004l66.155-62.763 66.156 62.763c3.077 2.92 7.12 4.38 11.165 4.38 4.043 0 8.087-1.46 11.165-4.38 3.037-2.882 4.71-6.734 4.71-10.846 0-4.113-1.673-7.965-4.71-10.847l-65.89-62.51zM236.38 19.7c0-5.336-1.948-9.953-5.847-13.85-3.9-3.9-8.515-5.85-13.85-5.85-5.335 0-9.952 1.95-13.85 5.85L100.338 108.34H19.7c-5.336 0-9.953 1.95-13.852 5.848C1.95 118.088 0 122.705 0 128.04v118.19c0 5.336 1.95 9.952 5.848 13.85 3.9 3.9 8.516 5.85 13.85 5.85h80.64L202.833 368.42c3.9 3.9 8.516 5.848 13.85 5.848 5.336 0 9.952-1.95 13.85-5.848 3.9-3.898 5.85-8.515 5.85-13.85V19.7z"
					},
					children: [
					]
				}
			]
		}
	]
},
	vip: vip,
	visa: visa,
	threads: threads,
	watch: watch,
	vote: vote,
	"wheelchair-storage": {
	id: "wheelchair-storage",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 65.208 71.032"
	},
	children: [
		{
			id: "wheelchair-storage",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "wheelchair-storage",
					name: "",
					type: "text",
					value: "Wheelchair Storage icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "wheelchair-storage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M34.597 48.928c-.958 4.845-5.255 8.513-10.4 8.513-5.85 0-10.607-4.733-10.607-10.552 0-3.043 1.303-5.788 3.38-7.716v-3.336c-3.627 2.356-6.03 6.43-6.03 11.052 0 7.274 5.946 13.192 13.256 13.192 5.47 0 10.175-3.316 12.196-8.034l-1.795-3.118z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "wheelchair-storage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M50.085 27.054h-.473V22.82c0-2.52-2.052-4.57-4.574-4.57s-4.574 2.05-4.574 4.57v4.234h-.626c-.626 0-1.132.508-1.132 1.134v8.917c0 .624.507 1.134 1.132 1.134h10.246c.626 0 1.132-.51 1.132-1.135v-8.917c0-.625-.506-1.134-1.13-1.134zm-7.95-4.235c0-1.598 1.303-2.897 2.903-2.897s2.902 1.3 2.902 2.896v4.234h-5.804V22.82zm3.522 10.77v1.86c0 .382-.308.692-.695.692-.384 0-.695-.315-.695-.693v-1.86c-.254-.206-.417-.52-.417-.874 0-.618.498-1.118 1.112-1.118.614 0 1.112.5 1.112 1.118 0 .353-.163.668-.417.873z",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "wheelchair-storage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M40.586 53.66l-5.43-7.347-14.67.245c-.347.01-.693-.13-.946-.376s-.398-.584-.404-.94l-.263-15.982c-.012-.738.572-1.346 1.305-1.36.745 0 1.337.585 1.35 1.315l.24 14.647 14.025-.234c.43-.014.832.193 1.086.538l5.835 7.896c.438.592.316 1.43-.272 1.87-.238.178-.516.264-.79.264-.406.002-.806-.184-1.067-.537z",
				fillRule: "evenodd",
				clipRule: "evenodd",
				fill: "#010101"
			},
			children: [
			]
		},
		{
			id: "wheelchair-storage",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M61.593 71.032H3.613C1.622 71.032 0 69.412 0 67.42V18.667c0-1.627 1.053-3.34 2.503-4.072L30.413.503c1.335-.672 3.264-.67 4.59.002L62.72 14.597c1.442.733 2.488 2.444 2.488 4.07V67.42c0 1.992-1.622 3.612-3.615 3.612zM4.18 66.852h56.848V18.667c-.012-.087-.137-.294-.226-.356L33.11 4.233c-.17-.075-.64-.075-.816.004L4.387 18.326c-.063.048-.187.25-.207.36v48.166z",
				fill: "#010101"
			},
			children: [
			]
		}
	]
},
	"wifi-off": {
	id: "wifi-off",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 511.744 388.876"
	},
	children: [
		{
			id: "wifi-off",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "wifi-off",
					name: "",
					type: "text",
					value: "Wi-fi off icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "wifi-off",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M214.188 64.89c13.7-2.065 27.623-3.145 41.684-3.145 82.794 0 161.025 36.577 214.61 100.32 4.628 5.5 11.247 8.334 17.915 8.334 5.312 0 10.64-1.793 15.016-5.485 9.876-8.287 11.156-23.04 2.85-32.897C443.768 57.648 352.5 15.013 255.874 15.013c-29.83 0-59.146 4.07-87.264 11.874l45.578 38.002zM431.87 224.95c9.89-8.303 11.167-23.054 2.866-32.916-42.296-50.293-103-80.252-167.94-83.284l97.454 81.253c7.516 5.375 14.665 11.327 21.385 17.83l26.54 22.126c1.54.31 3.107.474 4.677.474 5.312 0 10.64-1.792 15.02-5.484zM66.305 75.77C44.007 91.7 23.54 110.53 5.477 132.02c-8.303 9.874-7.024 24.61 2.868 32.913 4.376 3.675 9.688 5.483 15 5.483 6.667 0 13.287-2.835 17.914-8.334 18.205-21.66 39.26-40.175 62.368-55.193L66.305 75.77zM255.872 295.41c-25.797 0-46.733 20.936-46.733 46.733s20.935 46.733 46.73 46.733c25.797 0 46.734-20.936 46.734-46.733s-20.936-46.733-46.732-46.732zM141.52 138.48c-24.204 13.646-46.096 31.673-64.495 53.558-8.302 9.874-7.024 24.612 2.868 32.914 4.376 3.674 9.703 5.482 15.016 5.482 6.667 0 13.29-2.835 17.9-8.334 18.73-22.292 41.986-39.588 67.825-51.008l-39.114-32.61zM276.456 250.982l-53.97-44.996c-28.59 7.022-54.51 22.976-73.927 46.088-8.305 9.874-7.03 24.612 2.864 32.914 4.377 3.676 9.704 5.483 15.016 5.483 6.668 0 13.288-2.834 17.9-8.333 17.868-21.264 43.944-33.46 71.532-33.46 6.995 0 13.892.788 20.584 2.305z"
			},
			children: [
			]
		},
		{
			id: "wifi-off",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				stroke: "#000",
				strokeWidth: "12.00048",
				strokeLinejoin: "round",
				strokeMiterlimit: "10",
				d: "M71.628 47.468l34.583-41.48 333.42 277.987-34.583 41.48z"
			},
			children: [
			]
		}
	]
},
	wifi: wifi,
	wrap: wrap,
	"water-fountain": {
	id: "water-fountain",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 422.489 512.877"
	},
	children: [
		{
			id: "water-fountain",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "water-fountain",
					name: "",
					type: "text",
					value: "Water Fountain icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "water-fountain",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M267.076 104.155c28.67 0 51.96-23.29 52.083-52.067C319.036 23.403 295.746.108 267.076 0c-28.798.108-52.088 23.403-52.073 52.088-.015 28.778 23.275 52.067 52.073 52.067zM147.606 62.392c29.47-15.191 70.664 12.673 71.013 43.164v99.155l47.072 52.078c21.633 24.239-12.607 57.601-36.491 33.414l-53.185-58.766c-3.431-3.267-5.908-7.155-5.852-16.151v-47.354L77.137 218.06v252.054c.026 56.93-77.08 56.919-77.137.549V171.83c.056-16.648 6.652-32.85 23.11-42.328l124.496-67.11z"
			},
			children: [
			]
		},
		{
			id: "water-fountain",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M340.602 318.046h81.886V169.045l-164.875-.282c-21.064-.005-28.988 23.885-15.868 39.004l98.857 110.279zM293.254 162.09c3.462-.036 6.308-2.887 6.406-6.406-.097-3.518-2.944-6.365-6.406-6.411-3.559.051-6.406 2.893-6.406 6.411 0 3.519 2.841 6.37 6.406 6.406zM310.245 163.198c3.508-.041 6.349-2.887 6.406-6.396-.056-3.513-2.898-6.365-6.406-6.411-3.523.051-6.37 2.903-6.411 6.411.041 3.508 2.893 6.355 6.411 6.396zM311.358 144.273c3.488.082 6.329-2.77 6.406-6.139-.077-3.647-2.918-6.483-6.406-6.411-3.534-.077-6.38 2.764-6.406 6.411.026 3.369 2.872 6.221 6.406 6.139zM294.372 143.144c3.508.041 6.349-2.816 6.411-6.401-.062-3.436-2.903-6.283-6.411-6.411-3.518.128-6.365 2.975-6.401 6.411.036 3.586 2.887 6.442 6.401 6.401zM299.941 125.886c3.616-.133 6.611-3.123 6.688-6.688-.077-3.811-3.072-6.806-6.688-6.683-3.754-.123-6.739 2.872-6.693 6.683-.046 3.565 2.939 6.555 6.693 6.688zM320.554 129.23c3.708-.144 6.703-3.129 6.683-6.698.021-3.811-2.975-6.806-6.683-6.667-3.667-.133-6.657 2.857-6.683 6.667.026 3.569 3.016 6.554 6.683 6.698zM313.322 111.951c3.77-.077 6.914-3.205 6.955-6.949-.046-4.006-3.185-7.15-6.955-7.252-3.975.103-7.108 3.247-6.97 7.252-.138 3.749 2.99 6.872 6.97 6.949zM337.253 123.096c3.816-.077 6.944-3.221 6.965-6.965-.02-4.006-3.149-7.139-6.965-7.232-3.934.097-7.078 3.226-6.955 7.232-.122 3.744 3.022 6.893 6.955 6.965zM329.463 105.832c3.97-.087 7.114-3.216 7.252-6.97-.138-3.99-3.282-7.139-7.252-7.232-3.765.097-6.924 3.241-6.96 7.232.041 3.755 3.195 6.888 6.96 6.97zM348.403 105.832c4.339-.051 7.801-3.523 7.801-7.801 0-4.247-3.462-7.714-7.801-7.801-4.2.092-7.662 3.554-7.801 7.801.139 4.278 3.596 7.75 7.801 7.801zM354.527 129.789c4.2-.062 7.662-3.529 7.791-7.796-.123-4.262-3.585-7.729-7.791-7.801-4.339.077-7.791 3.539-7.791 7.801 0 4.267 3.452 7.729 7.791 7.796zM366.216 115.028c4.56-.103 8.191-3.729 8.088-8.088.103-4.601-3.529-8.232-8.088-8.345-4.406.113-8.042 3.744-8.062 8.345.02 4.36 3.656 7.986 8.062 8.088zM381.817 130.62c4.693.031 8.509-3.785 8.642-8.36-.128-4.836-3.949-8.642-8.642-8.621-4.724-.021-8.534 3.785-8.632 8.621.098 4.575 3.909 8.391 8.632 8.36zM367.057 145.652c4.744.031 8.545-3.775 8.647-8.35-.103-4.831-3.903-8.663-8.647-8.632-4.677-.031-8.493 3.8-8.339 8.632-.155 4.576 3.661 8.381 8.339 8.35z"
			},
			children: [
			]
		}
	]
},
	facebook: facebook,
	"facebook-watch": {
	id: "facebook-watch",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 75.2 71.7"
	},
	children: [
		{
			id: "facebook-watch",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "facebook-watch",
					name: "",
					type: "text",
					value: "Facebook Watch icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "facebook-watch",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M65 59.5H10.2C4.6 59.5 0 54.9 0 49.3V10.2C0 4.6 4.6 0 10.2 0H65c5.6 0 10.2 4.6 10.2 10.2v39.1c-.1 5.6-4.6 10.2-10.2 10.2zM10.2 4.7c-3 0-5.5 2.5-5.5 5.5v39.1c0 3 2.5 5.5 5.5 5.5H65c3 0 5.5-2.5 5.5-5.5V10.2c0-3-2.5-5.5-5.5-5.5H10.2z"
			},
			children: [
			]
		},
		{
			id: "facebook-watch",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M34 68h6.3V57H34z"
			},
			children: [
			]
		},
		{
			id: "facebook-watch",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M58.6 71.7H16.3c-1.3 0-2.3-1.1-2.3-2.3 0-1.3 1-2.3 2.3-2.3h42.3c1.3 0 2.3 1.1 2.3 2.3.1 1.2-1 2.3-2.3 2.3M28 40.2V17.6c0-1.2 1.3-2 2.4-1.3l18.9 11.3c1 .6 1 2.1 0 2.7L30.4 41.6c-1.1.6-2.4-.2-2.4-1.4"
			},
			children: [
			]
		}
	]
},
	"medium-bandwidth": {
	id: "medium-bandwidth",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512"
	},
	children: [
		{
			id: "medium-bandwidth",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "medium-bandwidth",
					name: "",
					type: "text",
					value: "Medium Bandwidth icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "medium-bandwidth",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M21 422.5H0V507h85.1v-84.5H64M127.7 317h-21v190h85.1V317h-21.1M277.4 211.5h-64.1V507h85.1V211.5M341 105.8h-21V507h85V105.8h-64zM384.1 486h-43V126.9h43V486zM491 0h-64v507h85V0h-21zm0 486h-43V21.1h43V486z"
			},
			children: [
			]
		}
	]
},
	"ws-trophy": {
	id: "ws-trophy",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 252.747 495.791"
	},
	children: [
		{
			id: "ws-trophy",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "ws-trophy",
					name: "",
					type: "text",
					value: "World Series Trophy icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "ws-trophy",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M29.523 51.004c-3.326-3.3-7.743-4.243-11.62-6.166l.052-.385c1.187-.417 2.36-.89 3.565-1.24 3.64-1.06 6.917-2.87 10.207-4.695 1.692-.938 3.548-1.58 5.59-2.47-2.26-.653-4.32-1.175-6.332-1.85-2.91-.977-5.79-2.05-8.665-3.127-.363-.135-.622-.552-.93-.84.328-.25.62-.62.988-.732 3.902-1.165 7.81-2.31 11.73-3.416 2.44-.688 4.906-1.298 7.655-2.02l-3.717-1.293c0-.156-.002-.31-.003-.467 6.824-2 13.648-4 20.43-5.99-.207-2.456.375-3.664 1.852-4.098 1.568-.46 2.573.134 3.897 2.423 3.717-1.18 7.485-2.353 11.232-3.586 1-.33 1.32-1.406.83-2.318-.752-1.4-.552-2.8.526-3.694 1.142-.948 2.483-.95 3.604-.004 1.08.91 1.212 2.253.545 3.7-.25.536-.155 1.23-.24 2.088 1.594-.418 2.94-.732 4.26-1.125 3.1-.924 6.203-1.847 9.28-2.843C96 6.294 96.2 5.703 95.44 4.09c-.593-1.257-.243-2.797.81-3.57 1-.735 2.547-.685 3.465.11 1.072.93 1.278 2.325.633 3.598-.2.397-.193.918-.21 1.384-.025.638.028 1.28.03 1.918.008 1.232.003 2.465.003 3.872 2.333-.633 4.528-1.17 6.686-1.828 2.75-.84 5.48-1.745 8.197-2.682 1.57-.542 1.73-1.06.96-2.485-.698-1.287-.47-2.662.59-3.588.874-.762 2.418-.838 3.362-.167 1.13.803 1.437 2.185.966 3.534-.242.698-.265 1.496-.272 2.25-.03 2.8-.01 5.6-.008 8.4v1.49c1.585-.458 3.038-.848 4.47-1.3 3.657-1.154 7.31-2.314 10.95-3.518 1.117-.37 1.362-1.264.763-2.32-.756-1.334-.546-2.74.55-3.693.9-.78 2.52-.815 3.463-.074 1.078.85 1.304 2.37.755 3.703-.255.62-.188 1.393-.19 2.097-.013 3.96-.002 7.92 0 11.88v1.68c1.657-.487 3.19-.86 4.67-1.388 3.42-1.22 6.82-2.492 10.21-3.797 1.007-.388 1.29-1.476.768-2.418-.76-1.372-.577-2.775.485-3.7 1.002-.875 2.627-.88 3.65-.015 1.06.898 1.24 2.348.54 3.717-.163.32-.113.76-.124 1.147-.012.398.035.797.035 1.197.003 6.32.002 12.64.003 18.96v1.427c1.937-.74 3.754-1.435 5.57-2.132 2.61-1.002 5.228-1.98 7.822-3.023 1.017-.41 1.333-1.614.78-2.575-.736-1.277-.502-2.762.582-3.692.98-.84 2.544-.854 3.534-.032 1.13.94 1.352 2.347.653 3.68-.177.335-.192.773-.212 1.167-.024.477.042.957.043 1.436.005 6.44.004 12.88.004 19.32v1.665c1.458-.54 2.8-.922 4.04-1.515 2.406-1.152 4.796-2.353 7.116-3.67 1.248-.707 1.485-2.205.802-3.463-.65-1.196-.416-2.583.59-3.496.91-.824 2.28-.928 3.345-.253 1.107.702 1.71 2.15 1.078 3.346-.474.893-.395 1.694-.333 2.578.042.597.016 1.2.016 1.8v24.56c2.715-1.64 5.416-3.275 8.124-4.9 1.093-.658 1.533-2.2.923-3.306-.73-1.323-.497-2.767.594-3.693.925-.786 2.47-.82 3.466-.075 1.08.808 1.38 2.37.785 3.69-.187.418-.212.928-.23 1.4-.028.677.03 1.358.03 2.038.004 8.36.003 16.72.003 25.08v1.454c2.302-.913 4.15-2.154 5.635-3.916.162-.192.28-.52.247-.763-.214-1.61.508-3.255-.4-4.875-.55-.982.097-2.377 1.05-3.063.928-.67 2.34-.666 3.27.006.947.685 1.563 2.08 1.02 3.068-.57 1.04-.38 2.032-.38 3.07.004 9.12.003 18.24.004 27.358v1.986c.39-.76.808-1.512 1.16-2.292.157-.348.222-.753.255-1.138.095-1.105.18-2.213.206-3.32.008-.278-.187-.574-.334-.837-.662-1.184-.49-2.617.443-3.53.964-.944 2.273-1.106 3.41-.423 1.14.684 1.806 2.102 1.2 3.306-.505 1.003-.354 1.933-.352 2.918.007 3.76.005 7.52.006 11.28 0 .92.022 1.84-.006 2.76-.03 1-.08 1.813 1.16 2.37 1.356.61 1.594 2.35.95 3.788-.194.437-.234.986-.204 1.475.137 2.224.438 4.444.47 6.67.075 4.918.057 9.84 0 14.758-.015 1.383-.248 2.77-.464 4.143-.214 1.363.457 2 1.613 2.513 2.52 1.115 4.996 2.327 7.48 3.52.574.277 1.09.67 1.663.95 1.826.893 1.972 4.845-.183 5.722-2.55 1.037-5 2.318-7.542 3.373-2.994 1.242-3.017 1.186-3.017 4.41 0 1.08.08 2.166-.017 3.237-.19 2.08.91 3.422 2.482 4.447 1.1.716 2.32 1.247 3.48 1.87.513.274 1.014.57 1.757.992-.562.36-.886.612-1.245.792-1.25.626-2.553 1.158-3.76 1.856-1.75 1.012-2.957 2.372-2.722 4.636.136 1.306.057 2.64.012 3.957-.026.75.195 1.088.97 1.343 2.502.82 4.986 1.714 7.415 2.726.773.322 1.355 1.103 2.024 1.674-.676.608-1.253 1.455-2.044 1.778-2.288.934-4.64 1.733-7.012 2.43-1.096.322-1.367.825-1.367 1.92.03 45.84.026 91.68.026 137.518 0 20.68 0 41.36-.023 62.04 0 .916.115 1.41 1.19 1.593 1.803.308 1.98.658 1.98 2.473 0 1.8.062 3.603-.022 5.4-.05 1.064.27 1.426 1.366 1.52 4.1.353 8.192.82 12.286 1.256.354.038.712.123 1.046.246 1.04.383 1.654.945 1.65 2.256-.046 17.24-.024 34.48-.05 51.72 0 .878.145 1.37 1.102 1.6.746.182 1.486.58 1.54 1.602.014.245.52.43.706.706.314.46.755.957.792 1.464.156 2.11.074 2.423-2 2.823-3.996.77-8.022 1.482-12.07 1.87-15.334 1.478-30.724 2.01-46.116 2.478-34.51 1.047-69.027 1.27-103.543.6-19.79-.384-39.58-1.09-59.357-1.954-8.335-.364-16.636-1.496-24.95-2.308-.868-.085-1.73-.32-2.57-.57-2.066-.617-2.164-.787-2.064-2.952.01-.2-.04-.518.06-.578 1.312-.785 1.435-2.76 3.072-3.152.937-.225 1.012-.765 1.01-1.554-.015-14.28-.01-28.56-.01-42.84 0-2.88.07-5.76-.027-8.638-.055-1.693.315-2.295 2.21-2.656 2.822-.537 5.7-.786 8.56-1.103 1.818-.202 3.648-.306 5.588-.463 0-2.436.013-4.75-.007-7.06-.006-.787-.028-1.475.91-1.853.275-.112.455-.78.458-1.196.028-4.28.006-8.56.006-12.84-.002-97.478-.006-194.955.026-292.433 0-1.298-.403-2.007-1.52-2.634-1.843-1.034-3.615-2.21-5.336-3.438-2.48-1.77-2.287-5.823.337-7.352 1.76-1.024 3.57-1.965 5.396-2.865.772-.38 1.123-.812 1.126-1.724.005-1.58-.06-2.973-1.347-4.233-.622-.61-.908-1.94-.777-2.865.37-2.617-.856-4.108-2.966-5.273-1.447-.8-1.395-1.163.048-1.936.21-.114.408-.26.63-.35 1.65-.675 2.56-1.748 2.26-3.675-.21-1.352.46-2.395 1.576-3.144 1.06-.71 2.148-1.386 3.186-2.13.288-.205.62-.602.607-.896-.013-.25-.456-.582-.774-.7-4.12-1.53-8.28-2.956-12.363-4.576-1.566-.62-3.038-1.566-4.41-2.56-.976-.707-.923-1.56.16-2.074 2.224-1.053 4.523-1.97 6.85-2.77 4.57-1.57 9.18-3.017 13.77-4.526.37-.118.715-.317 1.19-.534zm107.43 173.25v-1.525-95.742c0-28.994-.004-57.988.025-86.983 0-1.067-.28-1.53-1.357-1.775-2.803-.64-5.57-1.435-8.358-2.15-2.152-.55-4.312-1.07-6.61-1.64v1.803c0 60.148 0 120.296.002 180.444 0 .36-.06.734.022 1.075.063.264.254.637.47.705 2.882.902 5.78 1.76 8.718 2.64.033-.23.066-.34.062-.45-.07-1.764.423-2.698 1.708-3.222 1.187-.484 2.412-.203 3.27.75.918 1.02.96 2.28.125 3.757-.49.864-.276 1.488.658 1.875.357.15.732.255 1.266.438zM100.176 27.203v64.495c0 37.474.006 74.948-.028 112.42 0 1.133.33 1.562 1.405 1.876 2.72.794 5.396 1.735 8.066 2.682.47.167.827.653 1.236.992-.378.315-.71.736-1.14.925-1.634.716-3.3 1.358-5.13 2.1l3.698 1.23c.296-.38.507-.67.737-.943.827-.983 1.923-1.16 3.052-.793 1.157.377 1.805 1.28 1.91 2.515.126 1.48.334 1.678 2.184 1.868v-1.658-180.45c0-.32 0-.64-.002-.96-.013-1.118-.29-1.917-1.622-2.184-1.44-.29-2.806-.922-4.227-1.325-3.3-.936-6.615-1.824-10.14-2.79zm41.24 12.525v117.346c0 22.394.013 44.788-.035 67.182-.003 1.303.383 1.844 1.61 2.102 1.52.32 3.005.818 4.51 1.225 1.37.37 2.748.723 4.283 1.126 0-1.895-.043-3.608.018-5.317.03-.835.03-1.577-.404-2.366-.55-.995-.158-2.404.733-3.166.924-.79 1.987-1.002 3.127-.483 1.59.724 2.12 2.482 1.266 4.146-.508.99-.338 1.778.618 2.256v-5.538c0-54.585-.004-109.17.032-163.755 0-1.195-.41-1.698-1.47-2.03-3.773-1.183-7.527-2.424-11.283-3.656-.38-.125-.73-.342-1.094-.516l.007-.332c3.673-1.36 7.347-2.717 11.02-4.076l-.007-.45c-4.236-1.212-8.47-2.42-12.932-3.695zm-60.482-12.94V200.13c1.91.592 3.882 1.233 5.874 1.808 1.013.292 2 .577 3.14.277.6-.158 1.41.333 2.082.63 1.153.51 2.273 1.097 3.637 1.764v-1.848-128.15c0-14 .008-28-.02-41.998-.002-.364-.31-.955-.61-1.058-4.632-1.61-9.286-3.154-14.104-4.77zM161.65 63.86v1.59c.002 52.866.002 105.733.003 158.6 0 .32-.063.657.022.953.075.26.27.624.487.688 3.096.914 6.205 1.783 9.483 2.712v-1.425c0-2.72-.024-5.44.017-8.158.016-1.07.164-2.055-.377-3.14-.314-.63.022-1.82.445-2.532.77-1.297 1.98-1.42 4.182-.717v-1.572c0-46.868-.008-93.737.038-140.605 0-1.413-.462-1.862-1.735-2.227-4.173-1.195-8.484-1.993-12.564-4.166zM63.4 31.78v1.733c0 43.99.005 87.978-.023 131.967 0 1.373.014 2.52 1.63 2.95.394.103.736.477 1.05.78.754.724.868 1.567.11 2.313-.588.577-1.364.956-1.984 1.506-.34.3-.74.766-.75 1.167-.066 2.558-.06 5.118 0 7.676.01.35.375.877.7 1.008 2.44.98 4.546 2.454 6.634 4.028 1.626 1.226 3.495 2.13 5.257 3.175l.303-.303v-1.533V93.11c0-18.555-.01-37.11.028-55.666.002-1.065-.31-1.552-1.308-1.866-3.81-1.2-7.597-2.47-11.647-3.8zm129.188 170.074v-1.203c0-37.874-.005-75.748.022-113.623 0-1.1-.224-1.778-1.358-2.113-.824-.244-1.58-.718-2.366-1.09.016-.14.03-.278.047-.417.905-.477 1.787-1.007 2.723-1.414.738-.32.98-.776.95-1.568-.062-1.557-.054-3.12-.003-4.678.025-.764-.153-1.312-.887-1.64-1.712-.76-3.383-1.626-5.13-2.3-1.96-.756-3.984-1.348-6.158-2.07v148.976c0 .12.02.243-.003.36-.203 1.083.337 1.56 1.328 1.846 1.995.573 3.962 1.248 5.946 1.862.474.147.973.218 1.587.35v-3.992c0-3.48-.015-6.96.017-10.438.01-.94.163-1.804-.37-2.75-.617-1.097-.075-2.6 1.035-3.24.72-.413 1.605-.54 2.618-.858zm-40.873 43.316c-.528.128-.91.21-1.284.312-2.62.717-5.227 1.482-7.862 2.136-.92.228-1.173.64-1.173 1.56.02 45.103.018 90.206.02 135.31 0 .422.04.845.062 1.268l10.238 1.27V245.17zm-21.412 139.907V239.78c-2.835.785-5.512 1.582-8.222 2.247-1.068.262-1.457.662-1.456 1.833.035 46.626.03 93.25.03 139.877v1.34h9.65zm31.346 2.756l9.922 2.348V245.49c-2.902.81-5.686 1.64-8.5 2.35-1.133.286-1.45.82-1.448 1.978.032 45.502.026 91.004.025 136.506v1.51zm27.553 8.304V240.41c-2.518.778-4.896 1.585-7.316 2.233-1.18.316-1.492.867-1.49 2.074.035 46.707.03 93.415.028 140.123 0 2.44-.03 4.88.03 7.317.01.406.338 1.04.67 1.165 2.608.973 5.254 1.846 8.078 2.815zm-80.467-166.414c-2.57.816-4.946 1.638-7.366 2.306-.963.265-1.217.673-1.217 1.64.024 50.677.02 101.354.024 152.03 0 .425.04.85.065 1.367l8.495-1.133v-156.21zm-49.81-63.71v-1.554V47.35c0-3.744.023-3.8-3.392-5.335-2.09-.94-4.272-1.68-6.592-2.58v121.542c0 .32-.074.663.02.952.11.328.304.786.57.88 3.044 1.075 6.107 2.09 9.395 3.202zm21.91 224.252c1.49-.392 2.826-.783 4.182-1.083.607-.134 1.404-.736 1.767.39.35-.14.787-.197 1.017-.447.162-.176.048-.612.048-.93l.002-169.53v-1.506c-2.037.656-3.832 1.32-5.676 1.797-1.114.288-1.363.826-1.362 1.92.028 55.99.024 111.98.023 167.97v1.418zm123.136-153.772c-1.866.485-3.616 1.022-5.402 1.375-1.235.244-1.52.83-1.52 2.04.034 52.478.032 104.954.007 157.43 0 1.253.02 2.308 1.5 2.644.142.033.297.148.386.27 1.24 1.688 3.313 1.547 5.03 2.595V236.493zm2.29-46.453v-1.39-45.946c0-10.797-.01-21.594.023-32.39.003-.897-.226-1.364-1.095-1.666-1.203-.418-2.364-.967-3.52-1.51-1.147-.542-1.732-1.404-1.674-2.763.087-2.033 1.557-2.937 3.07-3.42 2.774-.888 3.753-2.584 3.2-5.334-.014-.076.028-.175-.006-.236-.215-.376-.354-.92-.682-1.086-2.818-1.42-5.67-2.773-8.496-4.136v118.864c0 .2-.062.43.015.593.137.288.303.685.553.778 2.05.764 4.12 1.468 6.395 2.263v-1.607c0-4.68-.006-9.357.01-14.036.002-.647.345-1.38.14-1.926-1.09-2.875-.726-3.908 2.067-5.05zM63.396 395.778c1.35-.483 2.446-.99 3.6-1.254 1.17-.268 1.45-.855 1.45-2.003-.028-63.82-.025-127.64-.025-191.462v-1.368c-1.406.71-2.603 1.44-3.893 1.923-.996.374-1.144.963-1.144 1.893.016 63.58.014 127.162.013 190.743v1.528zm151.49 12.303V233.527c-.872.244-1.624.55-2.404.653-1.464.194-1.742.985-1.74 2.37.036 54.358.03 108.716.03 163.074 0 1.84-.024 3.68.013 5.52.007.35.144.868.394 1.013 1.16.677 2.38 1.25 3.707 1.924zM44.407 160.085v-1.45-98.598c0-.36.043-.728-.02-1.077-.043-.246-.176-.59-.365-.675-2.165-.966-4.35-1.89-6.696-2.9v1.55c0 10.754-.005 21.51.002 32.265.01 18.752.03 37.503.038 56.255 0 .7.024 1.292.726 1.747 2.395 1.553 2.41 1.62.12 3.26-.956.688-1.015 1.448-.708 2.567.238-.253.368-.388.495-.526 1.263-1.374 2.705-1.595 4.043-.62 1.253.915 1.5 2.374.67 3.945-.707 1.337.035 3.383 1.696 4.254zm4.536 241.207c2.792-.844 2.793-.844 2.793-3.48V180.98v-3.17c-2.792.634-2.792.634-2.792 3.426V401.29zm27.383-180.166c-.624.31-.993.563-1.4.686-1.51.456-1.853 1.444-1.852 2.975.042 55.278.035 110.555.035 165.833v1.78c.492-.103.837-.164 1.177-.248 2.04-.506 2.04-.508 2.04-2.59V222.887v-1.763zm-17.397-16.91c-2.524.582-2.575.643-2.575 2.947V398.15c2.398-.274 2.575-.46 2.575-2.583V205.632v-1.418zm155.994-3.46c.026-.574.055-.926.055-1.277.003-6.477.006-12.955 0-19.432 0-1.1.206-2.16-.35-3.287-.587-1.19.05-2.587 1.28-3.252.653-.353.787-.756.78-1.41-.03-2.16-.012-4.318-.012-6.477 0-16.674.004-33.347-.017-50.02 0-.557-.072-1.297-.42-1.64-1.484-1.468-3.314-2.406-5.466-3.135v64.399c0 7.437-.007 14.874.017 22.31 0 .473.1 1.19.404 1.374 1.144.688 2.39 1.204 3.728 1.847zM95.615 233.88c-.722.25-1.34.52-1.987.677-.896.218-1.106.72-1.105 1.625.026 50.04.023 100.08.024 150.118v1.32h3.07c-.002-51.153-.002-102.376-.002-153.74zM44.407 181.5c-1.23.735-1.795 1.444-1.794 2.723.03 72.917.025 145.834.028 218.752 0 .415.04.83.062 1.29 1.21-.272 1.74-.746 1.74-2.042-.037-73.037-.034-146.074-.034-219.112v-1.61zm71.697 62.452c-.698.273-1.202.512-1.73.667-.733.214-.927.642-.926 1.406.022 45.914.02 91.827.02 137.74v1.768l2.636-.224V243.952zm20.778 5.6c-1.807.418-1.806.418-1.806 2.238v133.526h1.806V249.553zM37.39 407.135c.163.02.326.04.49.062.047-.572.138-1.144.138-1.717.007-81.512.006-163.023.015-244.533 0-1.47.15-2.94.14-4.41-.003-.36-.36-.72-.552-1.077l-.23.127v251.547zM29.865 70.727c-.094.288-.117.325-.117.363-.01 16.227-.02 32.455-.017 48.682 0 .285.095.7.294.833.81.544 1.68 1.002 2.67 1.574.033-.42.068-.647.068-.874.003-15.79.006-31.577-.016-47.366 0-.435-.168-.99-.464-1.28-.7-.68-1.525-1.236-2.417-1.933zM221.93 224.184l-.47-.097c-.08.435-.228.87-.23 1.306-.017 4.52-.015 9.04-.01 13.558.068 58.703.137 117.406.214 176.108 0 .416.11.83.167 1.247l.33-.042v-192.08zm-64.932 163.113V249.745c-.322.34-.552.468-.552.597-.015 45.434-.014 90.868 0 136.303.002.13.213.26.552.652zm64.222-251.58v44.177c0 .32-.064.664.033.95.083.247.356.43.786.906v-1.83c0-7.035 0-14.07.005-21.103 0-1.15.15-2.25-.405-3.418-.297-.626.285-1.684.508-2.536.125-.476.47-.93.475-1.398.038-4.156.032-8.313.005-12.47-.003-.4-.2-.818-.372-1.198-.323-.71-.694-1.4-1.036-2.08zM171.974 58.22l-10.237-3.253v7.325l10.237-4.073zM58.854 175.395c-1.368.185-2.635 1.378-2.712 2.5-.103 1.515.58 2.205 2.71 2.682v-5.182zm156.068 51.258l-4.123 1.988.027.29 4.095 1.254v-3.532zM76.235 198.408v-4.083c-.965.46-1.79.828-2.593 1.24-.84.433-.732 1-.045 1.437.792.503 1.657.89 2.638 1.406zM221.95 216.72c-1.066.79-.655 1.68-.705 2.412-.02.314.226.646.352.97l.352-.104v-3.277zm-91.567 7.047l.065-1.467-2.02.667-.007.234 1.963.567z"
			},
			children: [
			]
		}
	]
},
	"x-circle": {
	id: "x-circle",
	name: "svg",
	type: "element",
	value: "",
	attributes: {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 400 400"
	},
	children: [
		{
			id: "x-circle",
			name: "title",
			type: "element",
			value: "",
			attributes: {
			},
			children: [
				{
					id: "x-circle",
					name: "",
					type: "text",
					value: "X circle icon",
					attributes: {
					},
					children: [
					]
				}
			]
		},
		{
			id: "x-circle",
			name: "polygon",
			type: "element",
			value: "",
			attributes: {
				points: "201.903 182.483 151.103 105.138 124.001 105.138 186.95 200.977 194.862 213.021 194.862 213.027 248.747 295.066 275.846 295.066 209.813 194.529 201.903 182.483"
			},
			children: [
			]
		},
		{
			id: "x-circle",
			name: "path",
			type: "element",
			value: "",
			attributes: {
				d: "M 200 0 C 89.543 0 0 89.543 0 200 C 0 310.457 89.543 400 200 400 C 310.457 400 400 310.457 400 200 C 400 89.543 310.457 0 200 0 Z M 240.445 308.56 L 185.916 224.089 L 117.645 308.56 L 100 308.56 L 178.08 211.957 L 100 91 L 159.556 91 L 211.19 170.988 L 275.837 91 L 293.481 91 L 219.027 183.122 L 219.023 183.122 L 300 308.56 L 240.445 308.56 Z"
			},
			children: [
			]
		}
	]
},
	x: x,
	youtube: youtube
};

exports.accessibility = accessibility;
exports.android = android;
exports.apps = apps;
exports.atm = atm;
exports.audio = audio;
exports.ballpark = ballpark;
exports.baseball = baseball;
exports.bike = bike;
exports.billing = billing;
exports.binoculars = binoculars;
exports.blackout = blackout;
exports.blog = blog;
exports.boat = boat;
exports.box = box;
exports.bus = bus;
exports.calendar = calendar;
exports.camera = camera;
exports.car = car;
exports.channels = channels;
exports.checkmark = checkmark;
exports.cheer = cheer;
exports.close = close;
exports.cocktail = cocktail;
exports.comments = comments;
exports.community = community;
exports.copyright = copyright;
exports.default = icons;
exports.desktop = desktop;
exports.discover = discover;
exports.download = download;
exports.drag = drag;
exports.elevators = elevators;
exports.email = email;
exports.embed = embed;
exports.es = es;
exports.exclaimation = exclaimation;
exports.explosion = explosion;
exports.facebook = facebook;
exports.family = family;
exports.fans = fans;
exports.fantasy = fantasy;
exports.fantasy2 = fantasy2;
exports.favorite = favorite;
exports.filter = filter;
exports.fx = fx;
exports.gameday = gameday;
exports.gavel = gavel;
exports.gift = gift;
exports.globe = globe;
exports.glove = glove;
exports.grid = grid;
exports.group = group;
exports.highlight = highlight;
exports.home = home;
exports.hotel = hotel;
exports.info = info;
exports.info2 = info2;
exports.instagram = instagram;
exports.kebab = kebab;
exports.link = link;
exports.linkedin = linkedin;
exports.live = live;
exports.lock = lock;
exports.login = login;
exports.map = map;
exports.mastercard = mastercard;
exports.microphone = microphone;
exports.more = more;
exports.news = news;
exports.parking = parking;
exports.pause = pause;
exports.pdf = pdf;
exports.periscope = periscope;
exports.pet = pet;
exports.photo = photo;
exports.pinterest = pinterest;
exports.plane = plane;
exports.play = play;
exports.player = player;
exports.popcorn = popcorn;
exports.preview = preview;
exports.printer = printer;
exports.prohibited = prohibited;
exports.promo = promo;
exports.recap = recap;
exports.recycling = recycling;
exports.reddit = reddit;
exports.reels = reels;
exports.repeat = repeat;
exports.replay = replay;
exports.restrooms = restrooms;
exports.rewards = rewards;
exports.rewind = rewind;
exports.scissors = scissors;
exports.search = search;
exports.security = security;
exports.settings = settings;
exports.share = share;
exports.sheraton = sheraton;
exports.shoe = shoe;
exports.snapchat = snapchat;
exports.sort = sort;
exports.spotify = spotify;
exports.stadium = stadium;
exports.standings = standings;
exports.star = star;
exports.stats = stats;
exports.stories = stories;
exports.student = student;
exports.subway = subway;
exports.support = support;
exports.swap = swap;
exports.taxi = taxi;
exports.teams = teams;
exports.telephone = telephone;
exports.threads = threads;
exports.tickets = tickets;
exports.tiktok = tiktok;
exports.train = train;
exports.transactions = transactions;
exports.trash = trash;
exports.trolley = trolley;
exports.trophy = trophy;
exports.tumblr = tumblr;
exports.twitch = twitch;
exports.twitter = twitter;
exports.uber = uber;
exports.upgrade = upgrade;
exports.video = video;
exports.vip = vip;
exports.visa = visa;
exports.vote = vote;
exports.watch = watch;
exports.wifi = wifi;
exports.wrap = wrap;
exports.x = x;
exports.youtube = youtube;
